// import { _converse, api, converse } from '@converse/headless';
// import { CustomElement } from 'shared/components/element.js';
// import { __ } from 'i18n';
// import tplChatboxHead from './templates/chat-head.js';
// import 'shared/modals/user-details.js';

// import './styles/chat-head.scss';

// const { Strophe } = converse.env;

// export default class ChatHeading extends CustomElement {
//     constructor() {
//         super();
//         this.jid = null;
//     }

//     static get properties() {
//         return {
//             jid: { type: String },
//         };
//     }

//     initialize() {
//         const { chatboxes } = _converse.state;
//         this.model = chatboxes.get(this.jid);
//         this.listenTo(this.model, 'change:status', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:add', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:change', () => this.requestUpdate());
//         if (this.model.contact) {
//             this.listenTo(this.model.contact, 'destroy', () => this.requestUpdate());
//         }
//         this.model.rosterContactAdded?.then(() => {
//             this.listenTo(this.model.contact, 'change:nickname', () => this.requestUpdate());
//             this.requestUpdate();
//         });
//         this.requestUpdate();
//     }

//     render() {
//         return tplChatboxHead(this);
//     }

//     /**
//      * @param {Event} ev
//      */
//     showUserDetailsModal(ev) {
//         ev.preventDefault();
//         if (this.model?.contact instanceof _converse.exports.Profile) {
//             api.modal.show('converse-profile-modal', { model: this.model }, ev);
//         } else {
//             api.modal.show('converse-user-details-modal', { model: this.model }, ev);
//         }
//     }

//     /**
//      * @param {Event} ev
//      */
//     close(ev) {
//         ev.preventDefault();
//         this.model.close();
//     }

//     /**
//      * Returns a list of objects which represent buttons for the chat's header.
//      * @emits _converse#getHeadingButtons
//      * @returns {Promise<Array.<import('./types').HeadingButtonAttributes>>}
//      */
//     async getHeadingButtons() {
//         const buttons = [
//             /** @type {import('./types').HeadingButtonAttributes} */
//             {
//                 a_class: 'show-user-details-modal',
//                 handler: /** @param {Event} ev */ (ev) => this.showUserDetailsModal(ev),
//                 i18n_text: __('Details'),
//                 i18n_title: __('See more information about this person'),
//                 icon_class: 'fa-id-card',
//                 name: 'details',
//                 standalone: false,
//             },
//         ];

//         const domain = _converse.session.get('domain');
//         if (domain && (await api.disco.supports(Strophe.NS.BLOCKING, domain))) {
//             const blocklist = await api.blocklist.get();
//             if (blocklist.get(this.model.get('jid'))) {
//                 buttons.push({
//                     a_class: 'unblock-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Unblock user'), [
//                             __('Are you sure you want to unblock this user?'),
//                         ]);
//                         if (result) {
//                             api.blocklist.remove(this.model.get('jid'));
//                         }
//                     },
//                     i18n_text: __('Unblock this user'),
//                     i18n_title: __('Allow this user to send you messages'),
//                     icon_class: 'fa-check',
//                     name: 'unblock',
//                     standalone: false,
//                 });
//             } else {
//                 buttons.push({
//                     a_class: 'block-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Block user'), [
//                             __(
//                                 'Are you sure you want to prevent %1$s from contacting you further?',
//                                 this.model.getDisplayName(),
//                             ),
//                         ]);
//                         if (result) {
//                             const jid = this.model.get('jid');
//                             api.blocklist.add(jid);
//                             api.contacts.remove(jid, true);
//                             this.model.close();
//                         }
//                     },
//                     i18n_text: __('Block this user'),
//                     i18n_title: __('Prevent this user from sending you any further messages'),
//                     icon_class: 'fa-trash',
//                     name: 'block',
//                     standalone: false,
//                 });
//             }
//         }

//         if (!api.settings.get('singleton')) {
//             buttons.push({
//                 a_class: 'close-chatbox-button',
//                 handler: /** @param {Event} ev */ (ev) => this.close(ev),
//                 i18n_text: __('Close'),
//                 i18n_title: __('Close and end this conversation'),
//                 icon_class: 'fa-times',
//                 name: 'close',
//                 standalone: api.settings.get('view_mode') === 'overlayed',
//             });
//         }
//         const { chatboxviews } = _converse.state;
//         const el = chatboxviews.get(this.getAttribute('jid'));
//         if (el) {
//             /**
//              * *Hook* which allows plugins to add more buttons to a chat's heading.
//              *
//              * Note: This hook is fired for both 1 on 1 chats and groupchats.
//              * If you only care about one, you need to add a check in your code.
//              *
//              * @event _converse#getHeadingButtons
//              * @param { HTMLElement } el
//              *      The `converse-chat` (or `converse-muc`) DOM element that represents the chat
//              * @param { Array.<import('./types').HeadingButtonAttributes> }
//              *      An array of the existing buttons. New buttons may be added,
//              *      and existing ones removed or modified.
//              * @example
//              *  api.listen.on('getHeadingButtons', (el, buttons) => {
//              *      buttons.push({
//              *          'i18n_title': __('Foo'),
//              *          'i18n_text': __('Foo Bar'),
//              *          'handler': ev => alert('Foo!'),
//              *          'a_class': 'toggle-foo',
//              *          'icon_class': 'fa-foo',
//              *          'name': 'foo'
//              *      });
//              *      return buttons;
//              *  });
//              */
//             return _converse.api.hook('getHeadingButtons', el, buttons);
//         } else {
//             return buttons; // Happens during tests
//         }
//     }
// }

// api.elements.define('converse-chat-heading', ChatHeading);

//working outgoing и вход

// import { _converse, api, converse } from '@converse/headless';
// import { CustomElement } from 'shared/components/element.js';
// import { __ } from 'i18n';
// import tplChatboxHead from './templates/chat-head.js';
// import 'shared/modals/user-details.js';

// import './styles/chat-head.scss';

// const { Strophe, $iq, $msg, sizzle } = converse.env;

// const NS_JINGLE = 'urn:xmpp:jingle:1';
// const NS_JINGLE_ICE = 'urn:xmpp:jingle:transports:ice-udp:1';
// const NS_JINGLE_RTP = 'urn:xmpp:jingle:apps:rtp:1';
// const NS_DTLS = 'urn:xmpp:jingle:apps:dtls:0';
// const NS_JINGLE_MSG = 'urn:xmpp:jingle-message:0';

// export default class ChatHeading extends CustomElement {
//     // Static reference to the ChatHeading instance that owns the active call.
//     // Incoming Jingle stanzas are routed here regardless of which instance's
//     // handler fires (every open chat registers its own handler).
//     static activeCall = null;

//     // Guard so the Strophe IQ handler and message listener are registered
//     // only ONCE, not per-instance. Multiple registrations cause Strophe to
//     // fire every handler per incoming stanza, breaking the pc state machine.
//     static _jingleHandlersRegistered = false;

//     // Tracks whether the Strophe-level IQ handler is currently attached.
//     // Separate from _jingleHandlersRegistered because connection lost / reconnect
//     // can detach the handler while the static-listener side stays put.
//     static _stropheHandlerAttached = false;

//     // Pending incoming call (showing modal). Used so <retract> can cancel the modal.
//     static _pendingIncomingSid = null;
//     static _pendingIncomingFrom = null;
//     // Callback set while modal is shown — call it to close the modal externally.
//     static _closeIncomingModal = null;

//     constructor() {
//         super();
//         this.jid = null;

//         // --- Call state (per-instance) ---
//         // NOTE: keeping these on the instance means every open chat has its own
//         // pc / localStream. If multiple chats are open and the user triggers
//         // calls in parallel, they won't interfere — but the *incoming* Jingle
//         // handlers below register once per ChatHeading instance, so every open
//         // chat will receive and try to handle every incoming Jingle stanza.
//         // That is the known bug we accepted.
//         this.pc = null;
//         this.localStream = null;
//         this.iceCandidatesQueue = [];
//         this.currentSid = null;
//         this.isIncoming = false; // true if this is a callee-side call
//         this.remoteFullJid = null; // full JID of remote peer for incoming
//     }

//     static get properties() {
//         return {
//             jid: { type: String },
//         };
//     }

//     initialize() {
//         const { chatboxes } = _converse.state;
//         this.model = chatboxes.get(this.jid);
//         this.listenTo(this.model, 'change:status', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:add', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:change', () => this.requestUpdate());
//         if (this.model.contact) {
//             this.listenTo(this.model.contact, 'destroy', () => this.requestUpdate());
//         }
//         this.model.rosterContactAdded?.then(() => {
//             this.listenTo(this.model.contact, 'change:nickname', () => this.requestUpdate());
//             this.requestUpdate();
//         });

//         // --- Wire up Jingle handlers on this instance ---
//         // BUG WARNING: registered per ChatHeading. With N open chats, every
//         // incoming Jingle IQ fires N times. Same for the 'message' (proceed)
//         // listener and the 'connected' event.
//         this._registerJingleHandlers();

//         this.requestUpdate();
//     }

//     render() {
//         return tplChatboxHead(this);
//     }

//     /**
//      * @param {Event} ev
//      */
//     showUserDetailsModal(ev) {
//         ev.preventDefault();
//         if (this.model?.contact instanceof _converse.exports.Profile) {
//             api.modal.show('converse-profile-modal', { model: this.model }, ev);
//         } else {
//             api.modal.show('converse-user-details-modal', { model: this.model }, ev);
//         }
//     }

//     /**
//      * @param {Event} ev
//      */
//     close(ev) {
//         ev.preventDefault();
//         this.model.close();
//     }

//     // ========================================================================
//     // CALL LOGIC (moved from sonata-p2p-init plugin)
//     // ========================================================================

//     _registerJingleHandlers() {
//         // Register the Strophe IQ handler and message listener EXACTLY ONCE
//         // across all ChatHeading instances. Without this guard, every open
//         // chat registers its own handler, and Strophe fires ALL of them per
//         // incoming stanza — resulting in N calls to setRemoteDescription /
//         // addIceCandidate on the same pc, which breaks the RTCPeerConnection
//         // state machine and ICE never completes.
//         if (ChatHeading._jingleHandlersRegistered) return;
//         ChatHeading._jingleHandlersRegistered = true;

//         console.log('=== [ChatHeading] Registering Jingle handlers (once globally) ===');

//         const self = this;

//         // Wait for Strophe connection, then attach raw IQ handler for Jingle.
//         // The plugin used `_converse.on('connected', ...)` which fires once at
//         // login. But ChatHeading.initialize() runs PER CHAT OPEN, which may be
//         // AFTER 'connected' has already fired (event missed). So we try all
//         // three paths: immediate (if connection exists), 'connected' listener,
//         // AND a polling fallback. Whichever wins, the static guard inside
//         // attach() prevents double-registration on Strophe.
//         const attach = () => {
//             if (ChatHeading._stropheHandlerAttached) return;
//             const connection = _converse.connection || api.connection?.get?.();
//             if (!connection || !connection.addHandler) {
//                 console.log('[ChatHeading] No Strophe connection yet, will retry');
//                 return false;
//             }

//             ChatHeading._stropheHandlerAttached = true;
//             console.log('[ChatHeading] ✓ Strophe Jingle IQ handler attached');

//             connection.addHandler(
//                 (stanza) => {
//                     const jingle = sizzle(`jingle[xmlns="${NS_JINGLE}"]`, stanza).pop();
//                     if (!jingle) return true;

//                     const action = jingle.getAttribute('action');
//                     const from = stanza.getAttribute('from');
//                     const id = stanza.getAttribute('id');
//                     const sid = jingle.getAttribute('sid');

//                     console.log(
//                         `%c [JINGLE RECEIVE] Action: ${action} from ${from} sid=${sid} `,
//                         'background: #222; color: #bada55; padding: 2px;',
//                     );

//                     // ACK the IQ immediately
//                     connection.send($iq({ type: 'result', to: from, id: id }).tree());

//                     const target = ChatHeading.activeCall;
//                     if (!target) {
//                         console.warn('[JINGLE RECEIVE] No active call; ignoring', action);
//                         return true;
//                     }
//                     if (!target.pc) {
//                         console.warn(
//                             '[JINGLE RECEIVE] Active call has no pc yet; action=' + action,
//                             '— may be timing issue',
//                         );
//                         // For transport-info we can queue. For session-initiate
//                         // (incoming call) we create the pc inside the handler.
//                         // For session-accept we can't do much without pc — skip.
//                         if (action === 'transport-info' || action === 'session-initiate') {
//                             // ok, let it through
//                         } else {
//                             return true;
//                         }
//                     }

//                     switch (action) {
//                         case 'session-initiate': {
//                             // Incoming call: we are the callee. Parse offer SDP from XML
//                             // and create answer. This is called AFTER we sent <proceed>
//                             // (i.e. user accepted the propose modal and we pre-warmed mic).
//                             console.log('[JINGLE RECEIVE] session-initiate (we are callee)');
//                             const transport = sizzle('transport', jingle).pop();
//                             const fingerprintElem = sizzle('fingerprint', transport).pop();
//                             target.handleSessionInitiate(from, sid, {
//                                 ufrag: transport?.getAttribute('ufrag'),
//                                 pwd: transport?.getAttribute('pwd'),
//                                 fingerprint: fingerprintElem?.textContent,
//                                 setup: fingerprintElem?.getAttribute('setup') || 'actpass',
//                             });
//                             break;
//                         }
//                         case 'session-accept': {
//                             const transport = sizzle('transport', jingle).pop();
//                             const fingerprintElem = sizzle('fingerprint', transport).pop();
//                             target.handleSessionAccept({
//                                 ufrag: transport?.getAttribute('ufrag'),
//                                 pwd: transport?.getAttribute('pwd'),
//                                 fingerprint: fingerprintElem?.textContent,
//                                 setup: fingerprintElem?.getAttribute('setup') || 'active',
//                                 sid: sid,
//                             });
//                             break;
//                         }
//                         case 'transport-info':
//                             target.handleIncomingCandidates(jingle);
//                             break;
//                         case 'session-terminate':
//                             console.warn('[JINGLE RECEIVE] Remote terminated the call');
//                             target.terminateCall();
//                             break;
//                         case 'session-info':
//                             // ringing / on_hold / etc — informational only
//                             console.log('[JINGLE RECEIVE] session-info (informational):', jingle.innerHTML);
//                             break;
//                         default:
//                             console.log('[JINGLE RECEIVE] Unhandled action:', action);
//                     }

//                     return true;
//                 },
//                 NS_JINGLE,
//                 'iq',
//                 'set',
//             );
//             return true;
//         };

//         // Path 1: connection already exists at registration time
//         if (_converse.connection && _converse.connection.addHandler) {
//             attach();
//         }

//         // Path 2: listen for 'connected' event (covers logout/reconnect cycles)
//         api.listen.on('connected', () => {
//             console.log('[ChatHeading] connected event fired');
//             ChatHeading._stropheHandlerAttached = false; // re-attach after reconnect
//             attach();
//         });

//         // Path 3: polling fallback. ChatHeading.initialize() may run AFTER
//         // 'connected' has already fired (because user opened a chat after
//         // login). In that case neither Path 1 nor Path 2 catches it. Poll
//         // until connection becomes available, then stop.
//         const pollInterval = setInterval(() => {
//             if (ChatHeading._stropheHandlerAttached) {
//                 clearInterval(pollInterval);
//                 return;
//             }
//             if (attach()) {
//                 clearInterval(pollInterval);
//             }
//         }, 500);
//         // Stop polling after 30s no matter what to avoid leaks
//         setTimeout(() => clearInterval(pollInterval), 30000);

//         // Listen for Jingle Message Initiation on regular messages:
//         //   <propose> — incoming call (we are callee)
//         //   <retract> — caller cancelled before we picked up
//         //   <proceed> — callee accepted our call (we are caller)
//         //   <ringing>, <received>, <reject>, <accept> — info
//         _converse.on('message', (data) => {
//             const stanza = data.stanza;
//             const from = stanza.getAttribute('from');
//             const bare_jid = _converse.bare_jid;
//             const fromBare = from?.split('/')[0];

//             // Ignore our own carbons (echoes of stanzas we sent)
//             const isOwnCarbon = fromBare === bare_jid;

//             // Look for any JMI element
//             const propose = sizzle(`propose[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const retract = sizzle(`retract[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const proceed = sizzle(`proceed[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const ringing = sizzle(`ringing[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const received = sizzle(`received[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const reject = sizzle(`reject[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const accept = sizzle(`accept[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();

//             // --- INCOMING CALL: <propose> ---
//             if (propose && !isOwnCarbon) {
//                 const sid = propose.getAttribute('id');
//                 const description = sizzle('description', propose).pop();
//                 const media = description?.getAttribute('media') || 'audio';
//                 console.log(
//                     `%c [JMI INCOMING] propose from ${from} sid=${sid} media=${media} `,
//                     'background: #1e9652; color: white; padding: 2px;',
//                 );
//                 ChatHeading.handleIncomingPropose(from, sid, media);
//                 return;
//             }

//             // --- CALLER CANCELLED: <retract> ---
//             if (retract && !isOwnCarbon) {
//                 const sid = retract.getAttribute('id');
//                 console.warn(`[JMI INCOMING] retract from ${from} sid=${sid} (caller cancelled)`);
//                 ChatHeading.handleRetract(sid);
//                 return;
//             }

//             if (ringing) {
//                 console.log('[JMI] ringing from', from);
//                 return;
//             }
//             if (received) {
//                 console.log('[JMI] received (delivery ack) from', from);
//                 return;
//             }
//             if (reject) {
//                 console.warn('[JMI] reject from', from, '— remote declined');
//                 const t = ChatHeading.activeCall;
//                 if (t) t.terminateCall();
//                 return;
//             }
//             if (accept) {
//                 console.log('[JMI] accept seen (carbon echo from another device)');
//                 return;
//             }

//             // --- OUR OUTGOING CALL WAS ACCEPTED: <proceed> ---
//             if (proceed) {
//                 console.log('=== [JMI] proceed from', from, '===');
//                 const target = ChatHeading.activeCall;
//                 if (!target) {
//                     console.warn('[ChatHeading] proceed received but no active call');
//                     return;
//                 }
//                 if (target.pc) {
//                     console.log('[ChatHeading] Already have pc, ignoring duplicate proceed');
//                     return;
//                 }
//                 console.log('=== [ChatHeading] Starting WebRTC (sendJingleInitiate) ===');
//                 const sid = proceed.getAttribute('id');
//                 target.sendJingleInitiate(from, sid);
//             }
//         });
//     }

//     /**
//      * Called from chat-head.js template button (@click → el.initiateCall()).
//      * Sends Jingle Message Initiation "propose" to the contact.
//      */
//     async initiateCall() {
//         if (!this.model) {
//             console.warn('[ChatHeading] No model, cannot initiate call');
//             return;
//         }

//         // PRE-WARM the microphone BEFORE sending <propose>.
//         // The mic permission prompt blocks for seconds on first use. If we
//         // wait until <proceed> arrives to call getUserMedia, the prompt
//         // appears too late — the remote side has already accepted and is
//         // waiting for session-initiate, and the second call "works" only
//         // because the browser remembers permission. Asking up front makes
//         // the first call behave like the second.
//         try {
//             console.log('[ChatHeading] Pre-warming microphone...');
//             this.localStream = await navigator.mediaDevices.getUserMedia({ audio: true });
//         } catch (err) {
//             console.error('[ChatHeading] Mic permission denied / unavailable:', err);
//             this.model.createMessage({
//                 message: '❌ Не вдалося отримати доступ до мікрофона',
//                 type: 'info',
//             });
//             return;
//         }

//         const jid = this.model.get('jid');
//         const sid = crypto.randomUUID().toUpperCase();
//         const stanzaId = crypto.randomUUID().toUpperCase();
//         const myNick = _converse.xmppstatus.get('fullname') || _converse.bare_jid;

//         this.currentSid = sid;
//         ChatHeading.activeCall = this;

//         console.log(`[ChatHeading] Proposing call to ${jid}, SID: ${sid}`);

//         const msg = $msg({ to: jid, type: 'chat', id: stanzaId })
//             .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: stanzaId })
//             .up()
//             .c('propose', { xmlns: NS_JINGLE_MSG, id: sid })
//             .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//             .up()
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' })
//             .up()
//             .c('x', { xmlns: 'p1:push:custom', key: 'aps.mutable-content', value: '1' })
//             .up()
//             .c('x', { xmlns: 'p1:push:custom', key: 'type', value: 'call' })
//             .up()
//             .c('customize', { xmlns: 'p1:push:customize', nick: myNick })
//             .c('body')
//             .t('Вхідний дзвінок')
//             .up()
//             .up();

//         api.send(msg);
//         this.model.createMessage({ message: '📞 Виклик (очікування відповіді...)', type: 'info' });
//     }

//     async sendJingleInitiate(fullJid, sid) {
//         console.log('[ChatHeading] >>> sendJingleInitiate START', { fullJid, sid });
//         this.iceCandidatesQueue = [];
//         this.currentSid = sid;

//         try {
//             // Reuse pre-warmed stream from initiateCall(). Only fall back to
//             // getUserMedia if there isn't one (e.g. incoming-direction calls
//             // that bypass our initiateCall — currently none, but safe).
//             if (!this.localStream) {
//                 console.log('[ChatHeading] No pre-warmed stream, requesting media...');
//                 this.localStream = await navigator.mediaDevices.getUserMedia({ audio: true });
//                 console.log('[ChatHeading] Got media stream:', this.localStream);
//             } else {
//                 console.log('[ChatHeading] Reusing pre-warmed microphone stream');
//             }

//             console.log('[ChatHeading] Creating RTCPeerConnection...');
//             this.pc = new RTCPeerConnection({
//                 iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
//                 bundlePolicy: 'max-bundle',
//                 rtcpMuxPolicy: 'require',
//             });
//             console.log('[ChatHeading] RTCPeerConnection created');

//             this.pc.oniceconnectionstatechange = () => {
//                 console.log(`%c [ICE] state=${this.pc.iceConnectionState} `, 'color: orange; font-weight: bold;');
//                 if (this.pc.iceConnectionState === 'failed') {
//                     console.error('[ICE] Connection FAILED. Check network / TURN server.');
//                 }
//                 if (this.pc.iceConnectionState === 'connected') {
//                     console.log('%c [ICE] ✅ CONNECTED ', 'background: green; color: white;');
//                 }
//             };

//             this.pc.onconnectionstatechange = () => {
//                 console.log(`[PC] connectionState=${this.pc.connectionState}`);
//             };

//             this.pc.onsignalingstatechange = () => {
//                 console.log(`[PC] signalingState=${this.pc.signalingState}`);
//             };

//             this.pc.ontrack = (event) => {
//                 console.log('[ChatHeading] Remote track received');
//                 let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
//                 el.id = 'sonata-audio-remote';
//                 el.autoplay = true;
//                 if (!el.parentElement) document.body.appendChild(el);
//                 el.srcObject = event.streams[0];
//             };

//             this.pc.onicecandidate = (event) => {
//                 if (event.candidate) {
//                     const c = event.candidate;
//                     console.log('[ChatHeading] Local candidate:', c.candidate);
//                     const iq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                         .c('jingle', {
//                             xmlns: NS_JINGLE,
//                             action: 'transport-info',
//                             initiator: _converse.jid,
//                             sid: sid,
//                         })
//                         .c('content', { creator: 'initiator', name: '0' })
//                         .c('transport', { xmlns: NS_JINGLE_ICE })
//                         .c('candidate', {
//                             component: '1',
//                             foundation: c.foundation,
//                             generation: '0',
//                             ip: c.address || c.ip,
//                             port: c.port,
//                             priority: c.priority,
//                             protocol: (c.protocol || 'udp').toLowerCase(),
//                             type: c.type,
//                         });
//                     api.sendIQ(iq);
//                 }
//             };

//             this.localStream.getTracks().forEach((track) => this.pc.addTrack(track, this.localStream));

//             const offer = await this.pc.createOffer();
//             await this.pc.setLocalDescription(offer);

//             const sdp = this.pc.localDescription.sdp;
//             const ufrag = sdp.match(/a=ice-ufrag:(.*)\r/)[1];
//             const pwd = sdp.match(/a=ice-pwd:(.*)\r/)[1];
//             const fingerprint = sdp.match(/a=fingerprint:sha-256 (.*)\r/)[1];

//             console.log('[ChatHeading] Sending session-initiate...');
//             const initiateIq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                 .c('jingle', {
//                     xmlns: NS_JINGLE,
//                     action: 'session-initiate',
//                     initiator: _converse.jid,
//                     sid: sid,
//                 })
//                 .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                 .c('content', { name: '0' })
//                 .up()
//                 .up()
//                 .c('content', { creator: 'initiator', name: '0' })
//                 .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                 .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                 .c('parameter', { name: 'minptime', value: '10' })
//                 .up()
//                 .c('parameter', { name: 'useinbandfec', value: '1' })
//                 .up()
//                 .up()
//                 .c('rtcp-mux')
//                 .up()
//                 .up()
//                 .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                 .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                 .t(fingerprint)
//                 .up()
//                 .up()
//                 .up();

//             api.sendIQ(initiateIq);
//             console.log('[ChatHeading] >>> sendJingleInitiate DONE (session-initiate sent)');
//         } catch (err) {
//             console.error('[ChatHeading] WebRTC Error in sendJingleInitiate:', err);
//             console.error('[ChatHeading] Stack:', err?.stack);
//         }
//     }

//     handleSessionAccept(remoteData) {
//         console.log('[ChatHeading] >>> handleSessionAccept START', remoteData);
//         if (!this.pc) {
//             console.error('[ChatHeading] handleSessionAccept: NO PC! Cannot proceed.');
//             return;
//         }
//         console.log('[ChatHeading] pc signaling state:', this.pc.signalingState);

//         const mid = '0';

//         const remoteSdp =
//             [
//                 'v=0',
//                 'o=- 1234567890 2 IN IP4 0.0.0.0',
//                 's=-',
//                 't=0 0',
//                 `a=group:BUNDLE ${mid}`,
//                 'a=msid-semantic: WMS',
//                 `m=audio 9 RTP/SAVPF 111`,
//                 'c=IN IP4 0.0.0.0',
//                 `a=ice-ufrag:${remoteData.ufrag}`,
//                 `a=ice-pwd:${remoteData.pwd}`,
//                 `a=fingerprint:sha-256 ${remoteData.fingerprint}`,
//                 'a=setup:active',
//                 `a=mid:${mid}`,
//                 'a=rtcp-mux',
//                 'a=rtpmap:111 opus/48000/2',
//                 'a=fmtp:111 minptime=10;useinbandfec=1',
//                 'a=sendrecv',
//             ].join('\r\n') + '\r\n';

//         console.log('[ChatHeading] Setting remote description (manual SDP)...');
//         console.log('[ChatHeading] SDP preview:\n', remoteSdp);

//         this.pc
//             .setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp: remoteSdp }))
//             .then(() => {
//                 console.log('%c ✅ BUNDLE accepted! Remote description SET. ', 'color: white; background: green;');
//                 console.log('[ChatHeading] pc signaling state after SRD:', this.pc.signalingState);
//                 console.log('[ChatHeading] Queued candidates to flush:', this.iceCandidatesQueue.length);
//                 while (this.iceCandidatesQueue.length > 0) {
//                     const cand = this.iceCandidatesQueue.shift();
//                     this.pc
//                         .addIceCandidate(cand)
//                         .then(() => console.log('[ChatHeading] Flushed candidate OK'))
//                         .catch((e) => console.warn('[ChatHeading] Flush candidate failed:', e));
//                 }
//             })
//             .catch((err) => {
//                 console.error('[ChatHeading] SDP finalize FAILED:', err);
//                 console.log('[ChatHeading] DUMP SDP FOR DEBUG:\n', remoteSdp);
//             });
//     }

//     handleIncomingCandidates(jingle) {
//         const candidateElems = sizzle('candidate', jingle);

//         candidateElems.forEach((el) => {
//             const foundation = el.getAttribute('foundation');
//             const component = el.getAttribute('component') || '1';
//             const protocol = el.getAttribute('protocol') || 'udp';
//             const priority = el.getAttribute('priority');
//             const ip = el.getAttribute('ip');
//             const port = el.getAttribute('port');
//             const type = el.getAttribute('type') || 'host';

//             const candidateStr = `candidate:${foundation} ${component} ${protocol} ${priority} ${ip} ${port} typ ${type}`;
//             console.log('[ChatHeading] Incoming remote candidate:', candidateStr);

//             const iceCandidate = new RTCIceCandidate({
//                 candidate: candidateStr,
//                 sdpMid: '0',
//                 sdpMLineIndex: 0,
//             });

//             if (this.pc && this.pc.remoteDescription && this.pc.remoteDescription.type) {
//                 this.pc.addIceCandidate(iceCandidate).catch((e) => console.warn('AddIceCandidate error:', e));
//             } else {
//                 console.log('[ChatHeading] PC not ready, queuing candidate');
//                 this.iceCandidatesQueue.push(iceCandidate);
//             }
//         });
//     }

//     terminateCall() {
//         if (this.pc) {
//             console.log('[ChatHeading] Closing PeerConnection');
//             this.pc.close();
//             this.pc = null;
//         }
//         if (this.localStream) {
//             this.localStream.getTracks().forEach((t) => t.stop());
//             this.localStream = null;
//         }
//         const el = document.getElementById('sonata-audio-remote');
//         if (el) el.srcObject = null;
//         this.currentSid = null;
//         this.isIncoming = false;
//         this.remoteFullJid = null;
//         if (ChatHeading.activeCall === this) {
//             ChatHeading.activeCall = null;
//         }
//         console.log('=== [ChatHeading] Call terminated ===');
//     }

//     // ========================================================================
//     // INCOMING CALL HANDLING (callee side)
//     // ========================================================================

//     /**
//      * Static: called when <propose> arrives. Shows modal asking user to accept
//      * or reject. If accepted, picks the matching ChatHeading instance (by JID)
//      * and runs accept flow. If no chat is open for that contact, falls back to
//      * using/creating a chat first.
//      */
//     static async handleIncomingPropose(fullFromJid, sid, media) {
//         const bareFrom = fullFromJid?.split('/')[0];

//         // If there's already an active call, ask the user.
//         if (ChatHeading.activeCall) {
//             const confirmed = window.confirm(
//                 `Вхідний дзвінок від ${bareFrom}. У вас вже триває розмова. Завершити поточну та прийняти новий?`,
//             );
//             if (!confirmed) {
//                 // Auto-reject the new call
//                 ChatHeading._sendJmiReject(fullFromJid, sid);
//                 return;
//             }
//             // Terminate the current call before accepting new
//             ChatHeading.activeCall.terminateCall();
//         }

//         // Track this pending incoming call so <retract> can cancel its modal.
//         ChatHeading._pendingIncomingSid = sid;
//         ChatHeading._pendingIncomingFrom = fullFromJid;

//         const accepted = await ChatHeading._showIncomingCallModal(bareFrom, fullFromJid, sid, media);

//         // Clear pending tracking
//         if (ChatHeading._pendingIncomingSid === sid) {
//             ChatHeading._pendingIncomingSid = null;
//             ChatHeading._pendingIncomingFrom = null;
//         }

//         if (!accepted) {
//             console.log('[ChatHeading] User rejected incoming call');
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         console.log('[ChatHeading] User accepted incoming call. Finding chat heading...');

//         // Find existing ChatHeading instance for this contact, or open a chat first.
//         let headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);
//         if (!headingEl) {
//             console.log('[ChatHeading] No open chat for', bareFrom, '— opening one');
//             try {
//                 await api.chats.open(bareFrom);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not open chat:', e);
//             }
//             // Wait a tick for the heading element to render
//             await new Promise((r) => setTimeout(r, 200));
//             headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);
//         }

//         if (!headingEl) {
//             console.error('[ChatHeading] Could not find/create chat heading for', bareFrom);
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         await headingEl.acceptIncomingCall(fullFromJid, sid, media);
//     }

//     /**
//      * Static: <retract> arrived — caller cancelled before we picked up.
//      * Close the modal if it's showing for this sid.
//      */
//     static handleRetract(sid) {
//         if (ChatHeading._pendingIncomingSid === sid && ChatHeading._closeIncomingModal) {
//             console.log('[ChatHeading] Closing incoming-call modal (caller retracted)');
//             ChatHeading._closeIncomingModal(false);
//         }
//     }

//     /**
//      * Static helper: send JMI <reject> message.
//      */
//     static _sendJmiReject(toFullJid, sid) {
//         const bareJid = toFullJid?.split('/')[0];
//         const msg = $msg({ to: bareJid, type: 'chat', id: crypto.randomUUID() })
//             .c('reject', { xmlns: NS_JINGLE_MSG, id: sid })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' });
//         api.send(msg);
//         console.log('[ChatHeading] Sent JMI reject for sid', sid);
//     }

//     /**
//      * Static: builds the incoming-call modal. Returns a Promise<boolean>:
//      * true=accepted, false=rejected/closed.
//      */
//     static _showIncomingCallModal(callerName, fullFromJid, sid, media) {
//         return new Promise((resolve) => {
//             // Inject CSS once
//             if (!document.getElementById('sonata-incall-style')) {
//                 const style = document.createElement('style');
//                 style.id = 'sonata-incall-style';
//                 style.textContent = `
//                     .sonata-incall-overlay {
//                         position: fixed; inset: 0; z-index: 99999;
//                         background: rgba(0,0,0,0.55);
//                         display: flex; align-items: center; justify-content: center;
//                         font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     }
//                     .sonata-incall-card {
//                         background: #fff; border-radius: 16px; padding: 28px 32px;
//                         min-width: 320px; max-width: 90vw; text-align: center;
//                         box-shadow: 0 20px 60px rgba(0,0,0,0.4);
//                         animation: sonata-incall-pop 0.25s ease-out;
//                     }
//                     @keyframes sonata-incall-pop {
//                         from { transform: scale(0.85); opacity: 0; }
//                         to { transform: scale(1); opacity: 1; }
//                     }
//                     .sonata-incall-icon {
//                         font-size: 48px; margin-bottom: 12px;
//                         animation: sonata-incall-ring 1s ease-in-out infinite;
//                     }
//                     @keyframes sonata-incall-ring {
//                         0%, 100% { transform: rotate(0); }
//                         25% { transform: rotate(-15deg); }
//                         75% { transform: rotate(15deg); }
//                     }
//                     .sonata-incall-name {
//                         font-size: 20px; font-weight: 600; color: #222; margin-bottom: 4px;
//                     }
//                     .sonata-incall-sub {
//                         font-size: 13px; color: #888; margin-bottom: 24px;
//                     }
//                     .sonata-incall-actions {
//                         display: flex; gap: 16px; justify-content: center;
//                     }
//                     .sonata-incall-btn {
//                         border: none; border-radius: 50%; width: 56px; height: 56px;
//                         font-size: 22px; cursor: pointer; color: white;
//                         display: inline-flex; align-items: center; justify-content: center;
//                         transition: transform 0.15s;
//                     }
//                     .sonata-incall-btn:hover { transform: scale(1.08); }
//                     .sonata-incall-btn.accept { background: #1e9652; }
//                     .sonata-incall-btn.reject { background: #d33; }
//                 `;
//                 document.head.appendChild(style);
//             }

//             const overlay = document.createElement('div');
//             overlay.className = 'sonata-incall-overlay';
//             overlay.innerHTML = `
//                 <div class="sonata-incall-card">
//                     <div class="sonata-incall-icon">📞</div>
//                     <div class="sonata-incall-name">${callerName}</div>
//                     <div class="sonata-incall-sub">Вхідний ${media === 'video' ? 'відео' : 'аудіо'} дзвінок</div>
//                     <div class="sonata-incall-actions">
//                         <button class="sonata-incall-btn reject" title="Відхилити">✕</button>
//                         <button class="sonata-incall-btn accept" title="Прийняти">✓</button>
//                     </div>
//                 </div>
//             `;
//             document.body.appendChild(overlay);

//             // Play ringtone via Web Audio (simple beeping). Skip if AudioContext unavailable.
//             let ringInterval = null;
//             try {
//                 const ctx = new (window.AudioContext || window.webkitAudioContext)();
//                 const beep = () => {
//                     const osc = ctx.createOscillator();
//                     const gain = ctx.createGain();
//                     osc.frequency.value = 480;
//                     gain.gain.value = 0.08;
//                     osc.connect(gain).connect(ctx.destination);
//                     osc.start();
//                     setTimeout(() => osc.stop(), 400);
//                 };
//                 beep();
//                 ringInterval = setInterval(beep, 1500);
//             } catch (e) {
//                 /* no-op */
//             }

//             const cleanup = (result) => {
//                 if (ringInterval) clearInterval(ringInterval);
//                 if (overlay.parentElement) overlay.parentElement.removeChild(overlay);
//                 ChatHeading._closeIncomingModal = null;
//                 resolve(result);
//             };

//             // Expose closer so retract can cancel the modal externally
//             ChatHeading._closeIncomingModal = cleanup;

//             overlay.querySelector('.accept').addEventListener('click', () => cleanup(true));
//             overlay.querySelector('.reject').addEventListener('click', () => cleanup(false));

//             // Auto-reject after 45s (typical ring timeout)
//             setTimeout(() => {
//                 if (overlay.parentElement) cleanup(false);
//             }, 45000);
//         });
//     }

//     /**
//      * Instance: user accepted the incoming-call modal. Pre-warm mic, send
//      * <proceed>, mark this instance as the active call, and wait for the
//      * remote's session-initiate.
//      */
//     async acceptIncomingCall(fullFromJid, sid, media) {
//         console.log('[ChatHeading] >>> acceptIncomingCall', { fullFromJid, sid, media });

//         // Pre-warm microphone BEFORE sending <proceed>.
//         // If we send proceed first, the caller immediately sends session-initiate.
//         // getUserMedia prompt can take seconds on first use — causing session-initiate
//         // to arrive before pc is created. Get mic first, then proceed.
//         try {
//             console.log('[ChatHeading] Pre-warming mic before sending proceed...');
//             this.localStream = await navigator.mediaDevices.getUserMedia({ audio: true });
//             console.log('[ChatHeading] Mic ready for incoming call');
//         } catch (err) {
//             console.error('[ChatHeading] Mic permission denied for incoming call:', err);
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         this.isIncoming = true;
//         this.remoteFullJid = fullFromJid;
//         this.currentSid = sid;
//         ChatHeading.activeCall = this;

//         // Send JMI <proceed> to the caller's FULL JID (including resource).
//         // The original propose came from their full JID — we must reply to it.
//         // Sending to bare JID means the server can't route session-initiate back
//         // to us because the caller doesn't know which resource accepted.
//         const proceedId = crypto.randomUUID();
//         const proceedMsg = $msg({ to: fullFromJid, type: 'chat', id: proceedId })
//             .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: proceedId })
//             .up()
//             .c('proceed', { xmlns: NS_JINGLE_MSG, id: sid })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' });
//         api.send(proceedMsg);
//         console.log(
//             '[ChatHeading] Sent JMI proceed sid=',
//             sid,
//             'to FULL JID=',
//             fullFromJid,
//             '| our full JID:',
//             _converse.jid,
//         );

//         this.model?.createMessage({ message: '📞 Вхідний виклик прийнято', type: 'info' });
//         // Now we wait for session-initiate via the Strophe handler → handleSessionInitiate().
//     }

//     /**
//      * Instance: <session-initiate> arrived from remote (caller). We are the
//      * callee. Create pc, add tracks, set remote offer SDP, create answer,
//      * send session-accept.
//      */
//     async handleSessionInitiate(fullFromJid, sid, remoteData) {
//         console.log('[ChatHeading] >>> handleSessionInitiate', { fullFromJid, sid, remoteData });
//         this.iceCandidatesQueue = [];

//         try {
//             // localStream should already exist from acceptIncomingCall
//             if (!this.localStream) {
//                 console.log('[ChatHeading] No stream yet, getting now...');
//                 this.localStream = await navigator.mediaDevices.getUserMedia({ audio: true });
//             }

//             this.pc = new RTCPeerConnection({
//                 iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
//                 bundlePolicy: 'max-bundle',
//                 rtcpMuxPolicy: 'require',
//             });

//             this.pc.oniceconnectionstatechange = () => {
//                 console.log(`%c [ICE] state=${this.pc.iceConnectionState} `, 'color: orange; font-weight: bold;');
//                 if (this.pc.iceConnectionState === 'connected') {
//                     console.log('%c [ICE] ✅ CONNECTED (incoming) ', 'background: green; color: white;');
//                 }
//             };
//             this.pc.onconnectionstatechange = () => console.log(`[PC] connectionState=${this.pc.connectionState}`);
//             this.pc.onsignalingstatechange = () => console.log(`[PC] signalingState=${this.pc.signalingState}`);

//             this.pc.ontrack = (event) => {
//                 console.log('[ChatHeading] Remote track received (incoming)');
//                 let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
//                 el.id = 'sonata-audio-remote';
//                 el.autoplay = true;
//                 if (!el.parentElement) document.body.appendChild(el);
//                 el.srcObject = event.streams[0];
//             };

//             this.pc.onicecandidate = (event) => {
//                 if (event.candidate) {
//                     const c = event.candidate;
//                     console.log('[ChatHeading] Local candidate (incoming):', c.candidate);
//                     // As responder, creator='responder' and we are not the initiator.
//                     const iq = $iq({ type: 'set', to: fullFromJid, id: crypto.randomUUID().toLowerCase() })
//                         .c('jingle', {
//                             xmlns: NS_JINGLE,
//                             action: 'transport-info',
//                             initiator: fullFromJid,
//                             responder: _converse.jid,
//                             sid: sid,
//                         })
//                         .c('content', { creator: 'initiator', name: '0' })
//                         .c('transport', { xmlns: NS_JINGLE_ICE })
//                         .c('candidate', {
//                             component: '1',
//                             foundation: c.foundation,
//                             generation: '0',
//                             ip: c.address || c.ip,
//                             port: c.port,
//                             priority: c.priority,
//                             protocol: (c.protocol || 'udp').toLowerCase(),
//                             type: c.type,
//                         });
//                     api.sendIQ(iq);
//                 }
//             };

//             this.localStream.getTracks().forEach((t) => this.pc.addTrack(t, this.localStream));

//             // Build remote offer SDP from Jingle XML
//             const mid = '0';
//             const remoteOfferSdp =
//                 [
//                     'v=0',
//                     'o=- 1234567890 2 IN IP4 0.0.0.0',
//                     's=-',
//                     't=0 0',
//                     `a=group:BUNDLE ${mid}`,
//                     'a=msid-semantic: WMS',
//                     'm=audio 9 RTP/SAVPF 111',
//                     'c=IN IP4 0.0.0.0',
//                     `a=ice-ufrag:${remoteData.ufrag}`,
//                     `a=ice-pwd:${remoteData.pwd}`,
//                     `a=fingerprint:sha-256 ${remoteData.fingerprint}`,
//                     `a=setup:${remoteData.setup || 'actpass'}`,
//                     `a=mid:${mid}`,
//                     'a=rtcp-mux',
//                     'a=rtpmap:111 opus/48000/2',
//                     'a=fmtp:111 minptime=10;useinbandfec=1',
//                     'a=sendrecv',
//                 ].join('\r\n') + '\r\n';

//             console.log('[ChatHeading] Setting remote OFFER...\n', remoteOfferSdp);
//             await this.pc.setRemoteDescription(new RTCSessionDescription({ type: 'offer', sdp: remoteOfferSdp }));
//             console.log('[ChatHeading] Remote offer set, creating answer...');

//             const answer = await this.pc.createAnswer();
//             await this.pc.setLocalDescription(answer);

//             const sdp = this.pc.localDescription.sdp;
//             const ufrag = sdp.match(/a=ice-ufrag:(.*)\r/)[1];
//             const pwd = sdp.match(/a=ice-pwd:(.*)\r/)[1];
//             const fingerprint = sdp.match(/a=fingerprint:sha-256 (.*)\r/)[1];

//             // Flush queued ICE candidates that arrived before SRD
//             while (this.iceCandidatesQueue.length > 0) {
//                 const cand = this.iceCandidatesQueue.shift();
//                 this.pc.addIceCandidate(cand).catch((e) => console.warn('Queued cand failed:', e));
//             }

//             console.log('[ChatHeading] Sending session-accept...');
//             const acceptIq = $iq({ type: 'set', to: fullFromJid, id: crypto.randomUUID().toLowerCase() })
//                 .c('jingle', {
//                     xmlns: NS_JINGLE,
//                     action: 'session-accept',
//                     initiator: fullFromJid,
//                     responder: _converse.jid,
//                     sid: sid,
//                 })
//                 .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                 .c('content', { name: '0' })
//                 .up()
//                 .up()
//                 .c('content', { creator: 'initiator', name: '0' })
//                 .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                 .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                 .c('parameter', { name: 'minptime', value: '10' })
//                 .up()
//                 .c('parameter', { name: 'useinbandfec', value: '1' })
//                 .up()
//                 .up()
//                 .c('rtcp-mux')
//                 .up()
//                 .up()
//                 .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                 .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'active' })
//                 .t(fingerprint)
//                 .up()
//                 .up()
//                 .up();

//             api.sendIQ(acceptIq);
//             console.log('[ChatHeading] >>> handleSessionInitiate DONE (session-accept sent)');
//         } catch (err) {
//             console.error('[ChatHeading] handleSessionInitiate error:', err);
//             console.error('[ChatHeading] Stack:', err?.stack);
//         }
//     }

//     // ========================================================================
//     // END CALL LOGIC
//     // ========================================================================

//     /**
//      * Returns a list of objects which represent buttons for the chat's header.
//      * @emits _converse#getHeadingButtons
//      * @returns {Promise<Array.<import('./types').HeadingButtonAttributes>>}
//      */
//     async getHeadingButtons() {
//         const buttons = [
//             /** @type {import('./types').HeadingButtonAttributes} */
//             {
//                 a_class: 'show-user-details-modal',
//                 handler: /** @param {Event} ev */ (ev) => this.showUserDetailsModal(ev),
//                 i18n_text: __('Details'),
//                 i18n_title: __('See more information about this person'),
//                 icon_class: 'fa-id-card',
//                 name: 'details',
//                 standalone: false,
//             },
//         ];

//         const domain = _converse.session.get('domain');
//         if (domain && (await api.disco.supports(Strophe.NS.BLOCKING, domain))) {
//             const blocklist = await api.blocklist.get();
//             if (blocklist.get(this.model.get('jid'))) {
//                 buttons.push({
//                     a_class: 'unblock-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Unblock user'), [
//                             __('Are you sure you want to unblock this user?'),
//                         ]);
//                         if (result) {
//                             api.blocklist.remove(this.model.get('jid'));
//                         }
//                     },
//                     i18n_text: __('Unblock this user'),
//                     i18n_title: __('Allow this user to send you messages'),
//                     icon_class: 'fa-check',
//                     name: 'unblock',
//                     standalone: false,
//                 });
//             } else {
//                 buttons.push({
//                     a_class: 'block-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Block user'), [
//                             __(
//                                 'Are you sure you want to prevent %1$s from contacting you further?',
//                                 this.model.getDisplayName(),
//                             ),
//                         ]);
//                         if (result) {
//                             const jid = this.model.get('jid');
//                             api.blocklist.add(jid);
//                             api.contacts.remove(jid, true);
//                             this.model.close();
//                         }
//                     },
//                     i18n_text: __('Block this user'),
//                     i18n_title: __('Prevent this user from sending you any further messages'),
//                     icon_class: 'fa-trash',
//                     name: 'block',
//                     standalone: false,
//                 });
//             }
//         }

//         if (!api.settings.get('singleton')) {
//             buttons.push({
//                 a_class: 'close-chatbox-button',
//                 handler: /** @param {Event} ev */ (ev) => this.close(ev),
//                 i18n_text: __('Close'),
//                 i18n_title: __('Close and end this conversation'),
//                 icon_class: 'fa-times',
//                 name: 'close',
//                 standalone: api.settings.get('view_mode') === 'overlayed',
//             });
//         }
//         const { chatboxviews } = _converse.state;
//         const el = chatboxviews.get(this.getAttribute('jid'));
//         if (el) {
//             /**
//              * *Hook* which allows plugins to add more buttons to a chat's heading.
//              *
//              * Note: This hook is fired for both 1 on 1 chats and groupchats.
//              * If you only care about one, you need to add a check in your code.
//              *
//              * @event _converse#getHeadingButtons
//              * @param { HTMLElement } el
//              *      The `converse-chat` (or `converse-muc`) DOM element that represents the chat
//              * @param { Array.<import('./types').HeadingButtonAttributes> }
//              *      An array of the existing buttons. New buttons may be added,
//              *      and existing ones removed or modified.
//              * @example
//              *  api.listen.on('getHeadingButtons', (el, buttons) => {
//              *      buttons.push({
//              *          'i18n_title': __('Foo'),
//              *          'i18n_text': __('Foo Bar'),
//              *          'handler': ev => alert('Foo!'),
//              *          'a_class': 'toggle-foo',
//              *          'icon_class': 'fa-foo',
//              *          'name': 'foo'
//              *      });
//              *      return buttons;
//              *  });
//              */
//             return _converse.api.hook('getHeadingButtons', el, buttons);
//         } else {
//             return buttons; // Happens during tests
//         }
//     }
// }

// api.elements.define('converse-chat-heading', ChatHeading);
// import { _converse, api, converse } from '@converse/headless';
// import { CustomElement } from 'shared/components/element.js';
// import { __ } from 'i18n';
// import tplChatboxHead from './templates/chat-head.js';
// import 'shared/modals/user-details.js';

// import './styles/chat-head.scss';

// const { Strophe, $iq, $msg, sizzle } = converse.env;

// const NS_JINGLE = 'urn:xmpp:jingle:1';
// const NS_JINGLE_ICE = 'urn:xmpp:jingle:transports:ice-udp:1';
// const NS_JINGLE_RTP = 'urn:xmpp:jingle:apps:rtp:1';
// const NS_DTLS = 'urn:xmpp:jingle:apps:dtls:0';
// const NS_JINGLE_MSG = 'urn:xmpp:jingle-message:0';

// export default class ChatHeading extends CustomElement {
//     // Static reference to the ChatHeading instance that owns the active call.
//     // Incoming Jingle stanzas are routed here regardless of which instance's
//     // handler fires (every open chat registers its own handler).
//     static activeCall = null;

//     // Guard so the Strophe IQ handler and message listener are registered
//     // only ONCE, not per-instance. Multiple registrations cause Strophe to
//     // fire every handler per incoming stanza, breaking the pc state machine.
//     static _jingleHandlersRegistered = false;

//     // Tracks whether the Strophe-level IQ handler is currently attached.
//     // Separate from _jingleHandlersRegistered because connection lost / reconnect
//     // can detach the handler while the static-listener side stays put.
//     static _stropheHandlerAttached = false;

//     // Pending incoming call (showing modal). Used so <retract> can cancel the modal.
//     static _pendingIncomingSid = null;
//     static _pendingIncomingFrom = null;
//     // Callback set while modal is shown — call it to close the modal externally.
//     static _closeIncomingModal = null;

//     // Timer interval for the call panel
//     static _callTimerInterval = null;

//     constructor() {
//         super();
//         this.jid = null;

//         // --- Call state (per-instance) ---
//         // NOTE: keeping these on the instance means every open chat has its own
//         // pc / localStream. If multiple chats are open and the user triggers
//         // calls in parallel, they won't interfere — but the *incoming* Jingle
//         // handlers below register once per ChatHeading instance, so every open
//         // chat will receive and try to handle every incoming Jingle stanza.
//         // That is the known bug we accepted.
//         this.pc = null;
//         this.localStream = null;
//         this.iceCandidatesQueue = [];
//         this.currentSid = null;
//         this.isIncoming = false; // true if this is a callee-side call
//         this.remoteFullJid = null; // full JID of remote peer for incoming
//     }

//     static get properties() {
//         return {
//             jid: { type: String },
//         };
//     }

//     initialize() {
//         const { chatboxes } = _converse.state;
//         this.model = chatboxes.get(this.jid);
//         this.listenTo(this.model, 'change:status', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:add', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:change', () => this.requestUpdate());
//         if (this.model.contact) {
//             this.listenTo(this.model.contact, 'destroy', () => this.requestUpdate());
//         }
//         this.model.rosterContactAdded?.then(() => {
//             this.listenTo(this.model.contact, 'change:nickname', () => this.requestUpdate());
//             this.requestUpdate();
//         });

//         // --- Wire up Jingle handlers on this instance ---
//         // BUG WARNING: registered per ChatHeading. With N open chats, every
//         // incoming Jingle IQ fires N times. Same for the 'message' (proceed)
//         // listener and the 'connected' event.
//         this._registerJingleHandlers();

//         this.requestUpdate();
//     }

//     render() {
//         return tplChatboxHead(this);
//     }

//     /**
//      * @param {Event} ev
//      */
//     showUserDetailsModal(ev) {
//         ev.preventDefault();
//         if (this.model?.contact instanceof _converse.exports.Profile) {
//             api.modal.show('converse-profile-modal', { model: this.model }, ev);
//         } else {
//             api.modal.show('converse-user-details-modal', { model: this.model }, ev);
//         }
//     }

//     /**
//      * @param {Event} ev
//      */
//     close(ev) {
//         ev.preventDefault();
//         this.model.close();
//     }

//     // ========================================================================
//     // CALL LOGIC (moved from sonata-p2p-init plugin)
//     // ========================================================================

//     _registerJingleHandlers() {
//         // Register the Strophe IQ handler and message listener EXACTLY ONCE
//         // across all ChatHeading instances. Without this guard, every open
//         // chat registers its own handler, and Strophe fires ALL of them per
//         // incoming stanza — resulting in N calls to setRemoteDescription /
//         // addIceCandidate on the same pc, which breaks the RTCPeerConnection
//         // state machine and ICE never completes.
//         if (ChatHeading._jingleHandlersRegistered) return;
//         ChatHeading._jingleHandlersRegistered = true;

//         console.log('=== [ChatHeading] Registering Jingle handlers (once globally) ===');

//         const self = this;

//         // Wait for Strophe connection, then attach raw IQ handler for Jingle.
//         // The plugin used `_converse.on('connected', ...)` which fires once at
//         // login. But ChatHeading.initialize() runs PER CHAT OPEN, which may be
//         // AFTER 'connected' has already fired (event missed). So we try all
//         // three paths: immediate (if connection exists), 'connected' listener,
//         // AND a polling fallback. Whichever wins, the static guard inside
//         // attach() prevents double-registration on Strophe.
//         const attach = () => {
//             if (ChatHeading._stropheHandlerAttached) return;
//             const connection = _converse.connection || api.connection?.get?.();
//             if (!connection || !connection.addHandler) {
//                 console.log('[ChatHeading] No Strophe connection yet, will retry');
//                 return false;
//             }

//             ChatHeading._stropheHandlerAttached = true;
//             console.log('[ChatHeading] ✓ Strophe Jingle IQ handler attached');

//             connection.addHandler(
//                 (stanza) => {
//                     const jingle = sizzle(`jingle[xmlns="${NS_JINGLE}"]`, stanza).pop();
//                     if (!jingle) return true;

//                     const action = jingle.getAttribute('action');
//                     const from = stanza.getAttribute('from');
//                     const id = stanza.getAttribute('id');
//                     const sid = jingle.getAttribute('sid');

//                     console.log(
//                         `%c [JINGLE RECEIVE] Action: ${action} from ${from} sid=${sid} `,
//                         'background: #222; color: #bada55; padding: 2px;',
//                     );

//                     // ACK the IQ immediately
//                     connection.send($iq({ type: 'result', to: from, id: id }).tree());

//                     const target = ChatHeading.activeCall;
//                     if (!target) {
//                         console.warn('[JINGLE RECEIVE] No active call; ignoring', action);
//                         return true;
//                     }
//                     if (!target.pc) {
//                         console.warn(
//                             '[JINGLE RECEIVE] Active call has no pc yet; action=' + action,
//                             '— may be timing issue',
//                         );
//                         // For transport-info we can queue. For session-initiate
//                         // (incoming call) we create the pc inside the handler.
//                         // For session-accept we can't do much without pc — skip.
//                         if (action === 'transport-info' || action === 'session-initiate') {
//                             // ok, let it through
//                         } else {
//                             return true;
//                         }
//                     }

//                     switch (action) {
//                         case 'session-initiate': {
//                             // Incoming call: we are the callee. Parse offer SDP from XML
//                             // and create answer. This is called AFTER we sent <proceed>
//                             // (i.e. user accepted the propose modal and we pre-warmed mic).
//                             console.log('[JINGLE RECEIVE] session-initiate (we are callee)');
//                             const transport = sizzle('transport', jingle).pop();
//                             const fingerprintElem = sizzle('fingerprint', transport).pop();
//                             target.handleSessionInitiate(from, sid, {
//                                 ufrag: transport?.getAttribute('ufrag'),
//                                 pwd: transport?.getAttribute('pwd'),
//                                 fingerprint: fingerprintElem?.textContent,
//                                 setup: fingerprintElem?.getAttribute('setup') || 'actpass',
//                             });
//                             break;
//                         }
//                         case 'session-accept': {
//                             const transport = sizzle('transport', jingle).pop();
//                             const fingerprintElem = sizzle('fingerprint', transport).pop();
//                             target.handleSessionAccept({
//                                 ufrag: transport?.getAttribute('ufrag'),
//                                 pwd: transport?.getAttribute('pwd'),
//                                 fingerprint: fingerprintElem?.textContent,
//                                 setup: fingerprintElem?.getAttribute('setup') || 'active',
//                                 sid: sid,
//                             });
//                             break;
//                         }
//                         case 'transport-info':
//                             target.handleIncomingCandidates(jingle);
//                             break;
//                         case 'session-terminate':
//                             console.warn('[JINGLE RECEIVE] Remote terminated the call');
//                             target.terminateCall(false); // don't echo terminate back
//                             break;
//                         case 'session-info':
//                             // ringing / on_hold / etc — informational only
//                             console.log('[JINGLE RECEIVE] session-info (informational):', jingle.innerHTML);
//                             break;
//                         default:
//                             console.log('[JINGLE RECEIVE] Unhandled action:', action);
//                     }

//                     return true;
//                 },
//                 NS_JINGLE,
//                 'iq',
//                 'set',
//             );
//             return true;
//         };

//         // Path 1: connection already exists at registration time
//         if (_converse.connection && _converse.connection.addHandler) {
//             attach();
//         }

//         // Path 2: listen for 'connected' event (covers logout/reconnect cycles)
//         api.listen.on('connected', () => {
//             console.log('[ChatHeading] connected event fired');
//             ChatHeading._stropheHandlerAttached = false; // re-attach after reconnect
//             attach();
//         });

//         // Path 3: polling fallback. ChatHeading.initialize() may run AFTER
//         // 'connected' has already fired (because user opened a chat after
//         // login). In that case neither Path 1 nor Path 2 catches it. Poll
//         // until connection becomes available, then stop.
//         const pollInterval = setInterval(() => {
//             if (ChatHeading._stropheHandlerAttached) {
//                 clearInterval(pollInterval);
//                 return;
//             }
//             if (attach()) {
//                 clearInterval(pollInterval);
//             }
//         }, 500);
//         // Stop polling after 30s no matter what to avoid leaks
//         setTimeout(() => clearInterval(pollInterval), 30000);

//         // Listen for Jingle Message Initiation on regular messages:
//         //   <propose> — incoming call (we are callee)
//         //   <retract> — caller cancelled before we picked up
//         //   <proceed> — callee accepted our call (we are caller)
//         //   <ringing>, <received>, <reject>, <accept> — info
//         _converse.on('message', (data) => {
//             const stanza = data.stanza;
//             const from = stanza.getAttribute('from');
//             const bare_jid = _converse.bare_jid;
//             const fromBare = from?.split('/')[0];

//             // Ignore our own carbons (echoes of stanzas we sent)
//             const isOwnCarbon = fromBare === bare_jid;

//             // Look for any JMI element
//             const propose = sizzle(`propose[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const retract = sizzle(`retract[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const proceed = sizzle(`proceed[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const ringing = sizzle(`ringing[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const received = sizzle(`received[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const reject = sizzle(`reject[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const accept = sizzle(`accept[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();

//             // --- INCOMING CALL: <propose> ---
//             if (propose && !isOwnCarbon) {
//                 const sid = propose.getAttribute('id');
//                 const description = sizzle('description', propose).pop();
//                 const media = description?.getAttribute('media') || 'audio';
//                 console.log(
//                     `%c [JMI INCOMING] propose from ${from} sid=${sid} media=${media} `,
//                     'background: #1e9652; color: white; padding: 2px;',
//                 );
//                 ChatHeading.handleIncomingPropose(from, sid, media);
//                 return;
//             }

//             // --- CALLER CANCELLED: <retract> ---
//             if (retract && !isOwnCarbon) {
//                 const sid = retract.getAttribute('id');
//                 console.warn(`[JMI INCOMING] retract from ${from} sid=${sid} (caller cancelled)`);
//                 ChatHeading.handleRetract(sid);
//                 return;
//             }

//             // --- CALL ENDED BY REMOTE: <finish> (XEP-0272 / Sonata extension) ---
//             const finish = sizzle(`finish[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             if (finish && !isOwnCarbon) {
//                 const sid = finish.getAttribute('id');
//                 console.warn(`[JMI] finish from ${from} sid=${sid} — remote ended call`);
//                 const t = ChatHeading.activeCall;
//                 if (t) t.terminateCall(false); // remote already ended, don't echo
//                 return;
//             }

//             if (ringing) {
//                 console.log('[JMI] ringing from', from);
//                 return;
//             }
//             if (received) {
//                 console.log('[JMI] received (delivery ack) from', from);
//                 return;
//             }
//             if (reject) {
//                 console.warn('[JMI] reject from', from, '— remote declined');
//                 const t = ChatHeading.activeCall;
//                 if (t) t.terminateCall(false);
//                 return;
//             }
//             if (accept) {
//                 console.log('[JMI] accept seen (carbon echo from another device)');
//                 return;
//             }

//             // --- OUR OUTGOING CALL WAS ACCEPTED: <proceed> ---
//             if (proceed) {
//                 console.log('=== [JMI] proceed from', from, '===');
//                 const target = ChatHeading.activeCall;
//                 if (!target) {
//                     console.warn('[ChatHeading] proceed received but no active call');
//                     return;
//                 }
//                 if (target.pc) {
//                     console.log('[ChatHeading] Already have pc, ignoring duplicate proceed');
//                     return;
//                 }
//                 console.log('=== [ChatHeading] Starting WebRTC (sendJingleInitiate) ===');
//                 const sid = proceed.getAttribute('id');
//                 target.sendJingleInitiate(from, sid);
//             }
//         });
//     }

//     /**
//      * Called from chat-head.js template button (@click → el.initiateCall()).
//      * Sends Jingle Message Initiation "propose" to the contact.
//      */
//     async initiateCall() {
//         if (!this.model) {
//             console.warn('[ChatHeading] No model, cannot initiate call');
//             return;
//         }

//         // PRE-WARM the microphone BEFORE sending <propose>.
//         // The mic permission prompt blocks for seconds on first use. If we
//         // wait until <proceed> arrives to call getUserMedia, the prompt
//         // appears too late — the remote side has already accepted and is
//         // waiting for session-initiate, and the second call "works" only
//         // because the browser remembers permission. Asking up front makes
//         // the first call behave like the second.
//         try {
//             console.log('[ChatHeading] Pre-warming microphone...');
//             this.localStream = await navigator.mediaDevices.getUserMedia({ audio: true });
//         } catch (err) {
//             console.error('[ChatHeading] Mic permission denied / unavailable:', err);
//             this.model.createMessage({
//                 message: '❌ Не вдалося отримати доступ до мікрофона',
//                 type: 'info',
//             });
//             return;
//         }

//         const jid = this.model.get('jid');
//         const sid = crypto.randomUUID().toUpperCase();
//         const stanzaId = `jm-propose-${sid}`; // iOS push filters on this prefix
//         const myNick = _converse.xmppstatus.get('fullname') || _converse.bare_jid;

//         this.currentSid = sid;
//         ChatHeading.activeCall = this;

//         console.log(`[ChatHeading] Proposing call to ${jid}, SID: ${sid}`);

//         const msg = $msg({ to: jid, type: 'chat', id: stanzaId })
//             .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: stanzaId })
//             .up()
//             .c('propose', { xmlns: NS_JINGLE_MSG, id: sid })
//             .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//             .up()
//             .up()
//             .c('request', { xmlns: 'urn:xmpp:receipts' })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' })
//             .up()
//             .c('x', { xmlns: 'p1:push:custom', key: 'type', value: 'call' })
//             .up()
//             .c('x', { xmlns: 'p1:push:custom', key: 'aps.mutable-content', value: '1' })
//             .up()
//             .c('customize', { xmlns: 'p1:push:customize', nick: myNick })
//             .c('body')
//             .t('Incoming call')
//             .up()
//             .up();

//         api.send(msg);
//         this.model.createMessage({ message: '📞 Виклик (очікування відповіді...)', type: 'info' });
//         ChatHeading._showOutgoingCallPanel(this);
//     }

//     async sendJingleInitiate(fullJid, sid) {
//         console.log('[ChatHeading] >>> sendJingleInitiate START', { fullJid, sid });
//         this.iceCandidatesQueue = [];
//         this.currentSid = sid;
//         this.remoteFullJid = fullJid; // needed for terminateCall to send session-terminate

//         try {
//             // Reuse pre-warmed stream from initiateCall(). Only fall back to
//             // getUserMedia if there isn't one (e.g. incoming-direction calls
//             // that bypass our initiateCall — currently none, but safe).
//             if (!this.localStream) {
//                 console.log('[ChatHeading] No pre-warmed stream, requesting media...');
//                 this.localStream = await navigator.mediaDevices.getUserMedia({ audio: true });
//                 console.log('[ChatHeading] Got media stream:', this.localStream);
//             } else {
//                 console.log('[ChatHeading] Reusing pre-warmed microphone stream');
//             }

//             console.log('[ChatHeading] Creating RTCPeerConnection...');
//             this.pc = new RTCPeerConnection({
//                 iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
//                 bundlePolicy: 'max-bundle',
//                 rtcpMuxPolicy: 'require',
//             });
//             console.log('[ChatHeading] RTCPeerConnection created');

//             this.pc.oniceconnectionstatechange = () => {
//                 console.log(`%c [ICE] state=${this.pc.iceConnectionState} `, 'color: orange; font-weight: bold;');
//                 if (this.pc.iceConnectionState === 'failed') {
//                     console.error('[ICE] Connection FAILED. Check network / TURN server.');
//                 }
//                 if (this.pc.iceConnectionState === 'connected') {
//                     console.log('%c [ICE] ✅ CONNECTED ', 'background: green; color: white;');
//                     ChatHeading._showCallPanel(this);
//                 }
//             };

//             this.pc.onconnectionstatechange = () => {
//                 console.log(`[PC] connectionState=${this.pc.connectionState}`);
//             };

//             this.pc.onsignalingstatechange = () => {
//                 console.log(`[PC] signalingState=${this.pc.signalingState}`);
//             };

//             this.pc.ontrack = (event) => {
//                 console.log('[ChatHeading] Remote track received');
//                 let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
//                 el.id = 'sonata-audio-remote';
//                 el.autoplay = true;
//                 if (!el.parentElement) document.body.appendChild(el);
//                 el.srcObject = event.streams[0];
//             };

//             this.pc.onicecandidate = (event) => {
//                 if (event.candidate) {
//                     const c = event.candidate;
//                     console.log('[ChatHeading] Local candidate:', c.candidate);
//                     const iq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                         .c('jingle', {
//                             xmlns: NS_JINGLE,
//                             action: 'transport-info',
//                             initiator: _converse.jid,
//                             sid: sid,
//                         })
//                         .c('content', { creator: 'initiator', name: '0' })
//                         .c('transport', { xmlns: NS_JINGLE_ICE })
//                         .c('candidate', {
//                             component: '1',
//                             foundation: c.foundation,
//                             generation: '0',
//                             ip: c.address || c.ip,
//                             port: c.port,
//                             priority: c.priority,
//                             protocol: (c.protocol || 'udp').toLowerCase(),
//                             type: c.type,
//                         });
//                     api.sendIQ(iq);
//                 }
//             };

//             this.localStream.getTracks().forEach((track) => this.pc.addTrack(track, this.localStream));

//             const offer = await this.pc.createOffer();
//             await this.pc.setLocalDescription(offer);

//             const sdp = this.pc.localDescription.sdp;
//             const ufrag = sdp.match(/a=ice-ufrag:(.*)\r/)[1];
//             const pwd = sdp.match(/a=ice-pwd:(.*)\r/)[1];
//             const fingerprint = sdp.match(/a=fingerprint:sha-256 (.*)\r/)[1];

//             console.log('[ChatHeading] Sending session-initiate...');
//             const initiateIq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                 .c('jingle', {
//                     xmlns: NS_JINGLE,
//                     action: 'session-initiate',
//                     initiator: _converse.jid,
//                     sid: sid,
//                 })
//                 .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                 .c('content', { name: '0' })
//                 .up()
//                 .up()
//                 .c('content', { creator: 'initiator', name: '0' })
//                 .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                 .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                 .c('parameter', { name: 'minptime', value: '10' })
//                 .up()
//                 .c('parameter', { name: 'useinbandfec', value: '1' })
//                 .up()
//                 .up()
//                 .c('rtcp-mux')
//                 .up()
//                 .up()
//                 .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                 .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                 .t(fingerprint)
//                 .up()
//                 .up()
//                 .up();

//             api.sendIQ(initiateIq);
//             console.log('[ChatHeading] >>> sendJingleInitiate DONE (session-initiate sent)');
//         } catch (err) {
//             console.error('[ChatHeading] WebRTC Error in sendJingleInitiate:', err);
//             console.error('[ChatHeading] Stack:', err?.stack);
//         }
//     }

//     handleSessionAccept(remoteData) {
//         console.log('[ChatHeading] >>> handleSessionAccept START', remoteData);
//         if (!this.pc) {
//             console.error('[ChatHeading] handleSessionAccept: NO PC! Cannot proceed.');
//             return;
//         }
//         console.log('[ChatHeading] pc signaling state:', this.pc.signalingState);

//         const mid = '0';

//         const remoteSdp =
//             [
//                 'v=0',
//                 'o=- 1234567890 2 IN IP4 0.0.0.0',
//                 's=-',
//                 't=0 0',
//                 `a=group:BUNDLE ${mid}`,
//                 'a=msid-semantic: WMS',
//                 `m=audio 9 RTP/SAVPF 111`,
//                 'c=IN IP4 0.0.0.0',
//                 `a=ice-ufrag:${remoteData.ufrag}`,
//                 `a=ice-pwd:${remoteData.pwd}`,
//                 `a=fingerprint:sha-256 ${remoteData.fingerprint}`,
//                 'a=setup:active',
//                 `a=mid:${mid}`,
//                 'a=rtcp-mux',
//                 'a=rtpmap:111 opus/48000/2',
//                 'a=fmtp:111 minptime=10;useinbandfec=1',
//                 'a=sendrecv',
//             ].join('\r\n') + '\r\n';

//         console.log('[ChatHeading] Setting remote description (manual SDP)...');
//         console.log('[ChatHeading] SDP preview:\n', remoteSdp);

//         this.pc
//             .setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp: remoteSdp }))
//             .then(() => {
//                 console.log('%c ✅ BUNDLE accepted! Remote description SET. ', 'color: white; background: green;');
//                 console.log('[ChatHeading] pc signaling state after SRD:', this.pc.signalingState);
//                 console.log('[ChatHeading] Queued candidates to flush:', this.iceCandidatesQueue.length);
//                 while (this.iceCandidatesQueue.length > 0) {
//                     const cand = this.iceCandidatesQueue.shift();
//                     this.pc
//                         .addIceCandidate(cand)
//                         .then(() => console.log('[ChatHeading] Flushed candidate OK'))
//                         .catch((e) => console.warn('[ChatHeading] Flush candidate failed:', e));
//                 }
//             })
//             .catch((err) => {
//                 console.error('[ChatHeading] SDP finalize FAILED:', err);
//                 console.log('[ChatHeading] DUMP SDP FOR DEBUG:\n', remoteSdp);
//             });
//     }

//     handleIncomingCandidates(jingle) {
//         const candidateElems = sizzle('candidate', jingle);

//         candidateElems.forEach((el) => {
//             const foundation = el.getAttribute('foundation');
//             const component = el.getAttribute('component') || '1';
//             const protocol = el.getAttribute('protocol') || 'udp';
//             const priority = el.getAttribute('priority');
//             const ip = el.getAttribute('ip');
//             const port = el.getAttribute('port');
//             const type = el.getAttribute('type') || 'host';

//             const candidateStr = `candidate:${foundation} ${component} ${protocol} ${priority} ${ip} ${port} typ ${type}`;
//             console.log('[ChatHeading] Incoming remote candidate:', candidateStr);

//             const iceCandidate = new RTCIceCandidate({
//                 candidate: candidateStr,
//                 sdpMid: '0',
//                 sdpMLineIndex: 0,
//             });

//             if (this.pc && this.pc.remoteDescription && this.pc.remoteDescription.type) {
//                 this.pc.addIceCandidate(iceCandidate).catch((e) => console.warn('AddIceCandidate error:', e));
//             } else {
//                 console.log('[ChatHeading] PC not ready, queuing candidate');
//                 this.iceCandidatesQueue.push(iceCandidate);
//             }
//         });
//     }

//     terminateCall(sendTerminate = true) {
//         // Send session-terminate + JMI <finish> if we still have an active call
//         if (sendTerminate && this.remoteFullJid && this.currentSid) {
//             const sid = this.currentSid;
//             const remote = this.remoteFullJid;
//             console.log('[ChatHeading] Sending session-terminate + finish to', remote);

//             // Jingle session-terminate IQ
//             try {
//                 const terminateIq = $iq({ type: 'set', to: remote, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', {
//                         xmlns: NS_JINGLE,
//                         action: 'session-terminate',
//                         sid: sid,
//                     })
//                     .c('reason')
//                     .c('success');
//                 api.sendIQ(terminateIq);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not send session-terminate:', e);
//             }

//             // JMI <finish> message (Sonata extension — iOS/Android use this)
//             try {
//                 const bareRemote = remote.split('/')[0];
//                 const finishMsg = $msg({ to: bareRemote, type: 'chat', id: crypto.randomUUID() })
//                     .c('finish', { xmlns: NS_JINGLE_MSG, id: sid })
//                     .c('reason', { xmlns: NS_JINGLE })
//                     .c('success')
//                     .up()
//                     .up()
//                     .up()
//                     .c('store', { xmlns: 'urn:xmpp:hints' });
//                 api.send(finishMsg);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not send finish:', e);
//             }
//         }

//         if (this.pc) {
//             console.log('[ChatHeading] Closing PeerConnection');
//             this.pc.close();
//             this.pc = null;
//         }
//         if (this.localStream) {
//             this.localStream.getTracks().forEach((t) => t.stop());
//             this.localStream = null;
//         }
//         const el = document.getElementById('sonata-audio-remote');
//         if (el) el.srcObject = null;
//         this.currentSid = null;
//         this.isIncoming = false;
//         this.remoteFullJid = null;
//         if (ChatHeading.activeCall === this) {
//             ChatHeading.activeCall = null;
//         }
//         ChatHeading._hideCallPanel();
//         console.log('=== [ChatHeading] Call terminated ===');
//     }

//     // ========================================================================
//     // INCOMING CALL HANDLING (callee side)
//     // ========================================================================

//     /**
//      * Static: called when <propose> arrives. Shows modal asking user to accept
//      * or reject. If accepted, picks the matching ChatHeading instance (by JID)
//      * and runs accept flow. If no chat is open for that contact, falls back to
//      * using/creating a chat first.
//      */
//     static async handleIncomingPropose(fullFromJid, sid, media) {
//         const bareFrom = fullFromJid?.split('/')[0];

//         // Resolve display name — same approach as the call panel and ChatHeading template.
//         // Try roster contact first, then chatbox model, then fall back to bare JID.
//         let displayName = bareFrom;
//         try {
//             const contact = await api.contacts.get(bareFrom);
//             if (contact) {
//                 displayName = contact.get('nickname') || contact.get('fullname') || contact.get('name') || bareFrom;
//             }
//             // Also try an open chatbox model in case vcard is loaded there
//             if (displayName === bareFrom) {
//                 const chatbox = _converse.state?.chatboxes?.get(bareFrom);
//                 if (chatbox) {
//                     const fromModel = chatbox.getDisplayName?.();
//                     if (fromModel && fromModel !== bareFrom) displayName = fromModel;
//                 }
//             }
//         } catch (e) {
//             // non-fatal — fall back to bare JID
//         }

//         // If there's already an active call, ask the user.
//         if (ChatHeading.activeCall) {
//             const confirmed = window.confirm(
//                 `Вхідний дзвінок від ${bareFrom}. У вас вже триває розмова. Завершити поточну та прийняти новий?`,
//             );
//             if (!confirmed) {
//                 // Auto-reject the new call
//                 ChatHeading._sendJmiReject(fullFromJid, sid);
//                 return;
//             }
//             // Terminate the current call before accepting new
//             ChatHeading.activeCall.terminateCall();
//         }

//         // Track this pending incoming call so <retract> can cancel its modal.
//         ChatHeading._pendingIncomingSid = sid;
//         ChatHeading._pendingIncomingFrom = fullFromJid;

//         const accepted = await ChatHeading._showIncomingCallModal(displayName, fullFromJid, sid, media);

//         // Clear pending tracking
//         if (ChatHeading._pendingIncomingSid === sid) {
//             ChatHeading._pendingIncomingSid = null;
//             ChatHeading._pendingIncomingFrom = null;
//         }

//         if (!accepted) {
//             console.log('[ChatHeading] User rejected incoming call');
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         console.log('[ChatHeading] User accepted incoming call. Finding chat heading...');

//         // Find existing ChatHeading instance for this contact, or open a chat first.
//         let headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);
//         if (!headingEl) {
//             console.log('[ChatHeading] No open chat for', bareFrom, '— opening one');
//             try {
//                 await api.chats.open(bareFrom);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not open chat:', e);
//             }
//             // Wait a tick for the heading element to render
//             await new Promise((r) => setTimeout(r, 200));
//             headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);
//         }

//         if (!headingEl) {
//             console.error('[ChatHeading] Could not find/create chat heading for', bareFrom);
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         await headingEl.acceptIncomingCall(fullFromJid, sid, media);
//     }

//     /**
//      * Static: <retract> arrived — caller cancelled before we picked up.
//      * Close the modal if it's showing for this sid.
//      */
//     static handleRetract(sid) {
//         if (ChatHeading._pendingIncomingSid === sid && ChatHeading._closeIncomingModal) {
//             console.log('[ChatHeading] Closing incoming-call modal (caller retracted)');
//             ChatHeading._closeIncomingModal(false);
//         }
//     }

//     /**
//      * Static helper: send JMI <reject> message.
//      */
//     static _sendJmiReject(toFullJid, sid) {
//         const bareJid = toFullJid?.split('/')[0];
//         const msg = $msg({ to: bareJid, type: 'chat', id: crypto.randomUUID() })
//             .c('reject', { xmlns: NS_JINGLE_MSG, id: sid })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' });
//         api.send(msg);
//         console.log('[ChatHeading] Sent JMI reject for sid', sid);
//     }

//     /**
//      * Static: builds the incoming-call modal. Returns a Promise<boolean>:
//      * true=accepted, false=rejected/closed.
//      */
//     static _showIncomingCallModal(callerName, fullFromJid, sid, media) {
//         return new Promise((resolve) => {
//             // Inject CSS once
//             if (!document.getElementById('sonata-incall-style')) {
//                 const style = document.createElement('style');
//                 style.id = 'sonata-incall-style';
//                 style.textContent = `
//                     .sonata-incall-overlay {
//                         position: fixed; inset: 0; z-index: 99999;
//                         background: rgba(0,0,0,0.55);
//                         display: flex; align-items: center; justify-content: center;
//                         font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     }
//                     .sonata-incall-card {
//                         background: #fff; border-radius: 16px; padding: 28px 32px;
//                         min-width: 320px; max-width: 90vw; text-align: center;
//                         box-shadow: 0 20px 60px rgba(0,0,0,0.4);
//                         animation: sonata-incall-pop 0.25s ease-out;
//                     }
//                     @keyframes sonata-incall-pop {
//                         from { transform: scale(0.85); opacity: 0; }
//                         to { transform: scale(1); opacity: 1; }
//                     }
//                     .sonata-incall-icon {
//                         font-size: 48px; margin-bottom: 12px;
//                         animation: sonata-incall-ring 1s ease-in-out infinite;
//                     }
//                     @keyframes sonata-incall-ring {
//                         0%, 100% { transform: rotate(0); }
//                         25% { transform: rotate(-15deg); }
//                         75% { transform: rotate(15deg); }
//                     }
//                     .sonata-incall-name {
//                         font-size: 20px; font-weight: 600; color: #222; margin-bottom: 4px;
//                     }
//                     .sonata-incall-sub {
//                         font-size: 13px; color: #888; margin-bottom: 24px;
//                     }
//                     .sonata-incall-actions {
//                         display: flex; gap: 16px; justify-content: center;
//                     }
//                     .sonata-incall-btn {
//                         border: none; border-radius: 50%; width: 56px; height: 56px;
//                         font-size: 22px; cursor: pointer; color: white;
//                         display: inline-flex; align-items: center; justify-content: center;
//                         transition: transform 0.15s;
//                     }
//                     .sonata-incall-btn:hover { transform: scale(1.08); }
//                     .sonata-incall-btn.accept { background: #1e9652; }
//                     .sonata-incall-btn.reject { background: #d33; }
//                 `;
//                 document.head.appendChild(style);
//             }

//             const overlay = document.createElement('div');
//             overlay.className = 'sonata-incall-overlay';
//             overlay.innerHTML = `
//                 <div class="sonata-incall-card">
//                     <div class="sonata-incall-icon">📞</div>
//                     <div class="sonata-incall-name">${callerName}</div>
//                     <div class="sonata-incall-sub">Вхідний ${media === 'video' ? 'відео' : 'аудіо'} дзвінок</div>
//                     <div class="sonata-incall-actions">
//                         <button class="sonata-incall-btn reject" title="Відхилити">✕</button>
//                         <button class="sonata-incall-btn accept" title="Прийняти">✓</button>
//                     </div>
//                 </div>
//             `;
//             document.body.appendChild(overlay);

//             // Play ringtone via Web Audio (simple beeping). Skip if AudioContext unavailable.
//             let ringInterval = null;
//             try {
//                 const ctx = new (window.AudioContext || window.webkitAudioContext)();
//                 const beep = () => {
//                     const osc = ctx.createOscillator();
//                     const gain = ctx.createGain();
//                     osc.frequency.value = 480;
//                     gain.gain.value = 0.08;
//                     osc.connect(gain).connect(ctx.destination);
//                     osc.start();
//                     setTimeout(() => osc.stop(), 400);
//                 };
//                 beep();
//                 ringInterval = setInterval(beep, 1500);
//             } catch (e) {
//                 /* no-op */
//             }

//             const cleanup = (result) => {
//                 if (ringInterval) clearInterval(ringInterval);
//                 if (overlay.parentElement) overlay.parentElement.removeChild(overlay);
//                 ChatHeading._closeIncomingModal = null;
//                 resolve(result);
//             };

//             // Expose closer so retract can cancel the modal externally
//             ChatHeading._closeIncomingModal = cleanup;

//             overlay.querySelector('.accept').addEventListener('click', () => cleanup(true));
//             overlay.querySelector('.reject').addEventListener('click', () => cleanup(false));

//             // Auto-reject after 45s (typical ring timeout)
//             setTimeout(() => {
//                 if (overlay.parentElement) cleanup(false);
//             }, 45000);
//         });
//     }

//     /**
//      * Instance: user accepted the incoming-call modal. Pre-warm mic, send
//      * <proceed>, mark this instance as the active call, and wait for the
//      * remote's session-initiate.
//      */
//     async acceptIncomingCall(fullFromJid, sid, media) {
//         console.log('[ChatHeading] >>> acceptIncomingCall', { fullFromJid, sid, media });

//         // Pre-warm microphone BEFORE sending <proceed>.
//         // If we send proceed first, the caller immediately sends session-initiate.
//         // getUserMedia prompt can take seconds on first use — causing session-initiate
//         // to arrive before pc is created. Get mic first, then proceed.
//         try {
//             console.log('[ChatHeading] Pre-warming mic before sending proceed...');
//             this.localStream = await navigator.mediaDevices.getUserMedia({ audio: true });
//             console.log('[ChatHeading] Mic ready for incoming call');
//         } catch (err) {
//             console.error('[ChatHeading] Mic permission denied for incoming call:', err);
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         this.isIncoming = true;
//         this.remoteFullJid = fullFromJid;
//         this.currentSid = sid;
//         ChatHeading.activeCall = this;

//         // Send JMI <proceed> to the caller's FULL JID (including resource).
//         // The original propose came from their full JID — we must reply to it.
//         // Sending to bare JID means the server can't route session-initiate back
//         // to us because the caller doesn't know which resource accepted.
//         const proceedId = crypto.randomUUID();
//         const proceedMsg = $msg({ to: fullFromJid, type: 'chat', id: proceedId })
//             .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: proceedId })
//             .up()
//             .c('proceed', { xmlns: NS_JINGLE_MSG, id: sid })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' });
//         api.send(proceedMsg);
//         console.log(
//             '[ChatHeading] Sent JMI proceed sid=',
//             sid,
//             'to FULL JID=',
//             fullFromJid,
//             '| our full JID:',
//             _converse.jid,
//         );

//         this.model?.createMessage({ message: '📞 Вхідний виклик прийнято', type: 'info' });
//         // Now we wait for session-initiate via the Strophe handler → handleSessionInitiate().
//     }

//     /**
//      * Instance: <session-initiate> arrived from remote (caller). We are the
//      * callee. Create pc, add tracks, set remote offer SDP, create answer,
//      * send session-accept.
//      */
//     async handleSessionInitiate(fullFromJid, sid, remoteData) {
//         console.log('[ChatHeading] >>> handleSessionInitiate', { fullFromJid, sid, remoteData });
//         this.iceCandidatesQueue = [];

//         try {
//             // localStream should already exist from acceptIncomingCall
//             if (!this.localStream) {
//                 console.log('[ChatHeading] No stream yet, getting now...');
//                 this.localStream = await navigator.mediaDevices.getUserMedia({ audio: true });
//             }

//             this.pc = new RTCPeerConnection({
//                 iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
//                 bundlePolicy: 'max-bundle',
//                 rtcpMuxPolicy: 'require',
//             });

//             this.pc.oniceconnectionstatechange = () => {
//                 console.log(`%c [ICE] state=${this.pc.iceConnectionState} `, 'color: orange; font-weight: bold;');
//                 if (this.pc.iceConnectionState === 'connected') {
//                     console.log('%c [ICE] ✅ CONNECTED (incoming) ', 'background: green; color: white;');
//                     ChatHeading._showCallPanel(this);
//                 }
//             };
//             this.pc.onconnectionstatechange = () => console.log(`[PC] connectionState=${this.pc.connectionState}`);
//             this.pc.onsignalingstatechange = () => console.log(`[PC] signalingState=${this.pc.signalingState}`);

//             this.pc.ontrack = (event) => {
//                 console.log('[ChatHeading] Remote track received (incoming)');
//                 let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
//                 el.id = 'sonata-audio-remote';
//                 el.autoplay = true;
//                 if (!el.parentElement) document.body.appendChild(el);
//                 el.srcObject = event.streams[0];
//             };

//             this.pc.onicecandidate = (event) => {
//                 if (event.candidate) {
//                     const c = event.candidate;
//                     console.log('[ChatHeading] Local candidate (incoming):', c.candidate);
//                     // As responder, creator='responder' and we are not the initiator.
//                     const iq = $iq({ type: 'set', to: fullFromJid, id: crypto.randomUUID().toLowerCase() })
//                         .c('jingle', {
//                             xmlns: NS_JINGLE,
//                             action: 'transport-info',
//                             initiator: fullFromJid,
//                             responder: _converse.jid,
//                             sid: sid,
//                         })
//                         .c('content', { creator: 'initiator', name: '0' })
//                         .c('transport', { xmlns: NS_JINGLE_ICE })
//                         .c('candidate', {
//                             component: '1',
//                             foundation: c.foundation,
//                             generation: '0',
//                             ip: c.address || c.ip,
//                             port: c.port,
//                             priority: c.priority,
//                             protocol: (c.protocol || 'udp').toLowerCase(),
//                             type: c.type,
//                         });
//                     api.sendIQ(iq);
//                 }
//             };

//             this.localStream.getTracks().forEach((t) => this.pc.addTrack(t, this.localStream));

//             // Build remote offer SDP from Jingle XML
//             const mid = '0';
//             const remoteOfferSdp =
//                 [
//                     'v=0',
//                     'o=- 1234567890 2 IN IP4 0.0.0.0',
//                     's=-',
//                     't=0 0',
//                     `a=group:BUNDLE ${mid}`,
//                     'a=msid-semantic: WMS',
//                     'm=audio 9 RTP/SAVPF 111',
//                     'c=IN IP4 0.0.0.0',
//                     `a=ice-ufrag:${remoteData.ufrag}`,
//                     `a=ice-pwd:${remoteData.pwd}`,
//                     `a=fingerprint:sha-256 ${remoteData.fingerprint}`,
//                     `a=setup:${remoteData.setup || 'actpass'}`,
//                     `a=mid:${mid}`,
//                     'a=rtcp-mux',
//                     'a=rtpmap:111 opus/48000/2',
//                     'a=fmtp:111 minptime=10;useinbandfec=1',
//                     'a=sendrecv',
//                 ].join('\r\n') + '\r\n';

//             console.log('[ChatHeading] Setting remote OFFER...\n', remoteOfferSdp);
//             await this.pc.setRemoteDescription(new RTCSessionDescription({ type: 'offer', sdp: remoteOfferSdp }));
//             console.log('[ChatHeading] Remote offer set, creating answer...');

//             const answer = await this.pc.createAnswer();
//             await this.pc.setLocalDescription(answer);

//             const sdp = this.pc.localDescription.sdp;
//             const ufrag = sdp.match(/a=ice-ufrag:(.*)\r/)[1];
//             const pwd = sdp.match(/a=ice-pwd:(.*)\r/)[1];
//             const fingerprint = sdp.match(/a=fingerprint:sha-256 (.*)\r/)[1];

//             // Flush queued ICE candidates that arrived before SRD
//             while (this.iceCandidatesQueue.length > 0) {
//                 const cand = this.iceCandidatesQueue.shift();
//                 this.pc.addIceCandidate(cand).catch((e) => console.warn('Queued cand failed:', e));
//             }

//             console.log('[ChatHeading] Sending session-accept...');
//             const acceptIq = $iq({ type: 'set', to: fullFromJid, id: crypto.randomUUID().toLowerCase() })
//                 .c('jingle', {
//                     xmlns: NS_JINGLE,
//                     action: 'session-accept',
//                     initiator: fullFromJid,
//                     responder: _converse.jid,
//                     sid: sid,
//                 })
//                 .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                 .c('content', { name: '0' })
//                 .up()
//                 .up()
//                 .c('content', { creator: 'initiator', name: '0' })
//                 .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                 .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                 .c('parameter', { name: 'minptime', value: '10' })
//                 .up()
//                 .c('parameter', { name: 'useinbandfec', value: '1' })
//                 .up()
//                 .up()
//                 .c('rtcp-mux')
//                 .up()
//                 .up()
//                 .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                 .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'active' })
//                 .t(fingerprint)
//                 .up()
//                 .up()
//                 .up();

//             api.sendIQ(acceptIq);
//             console.log('[ChatHeading] >>> handleSessionInitiate DONE (session-accept sent)');
//         } catch (err) {
//             console.error('[ChatHeading] handleSessionInitiate error:', err);
//             console.error('[ChatHeading] Stack:', err?.stack);
//         }
//     }

//     // ========================================================================
//     // CALL PANEL UI
//     // ========================================================================

//     /**
//      * Static: show "calling..." panel while waiting for remote to answer.
//      * Replaced by _showCallPanel once ICE connects.
//      */
//     static _showOutgoingCallPanel(instance) {
//         ChatHeading._hideCallPanel();

//         if (!document.getElementById('sonata-callpanel-style')) {
//             // CSS will be injected by _showCallPanel when connected; inject minimal now
//             const style = document.createElement('style');
//             style.id = 'sonata-callpanel-style';
//             style.textContent = `
//                 .sonata-callpanel {
//                     position: fixed; top: 0; left: 50%; transform: translateX(-50%);
//                     z-index: 99998; background: #1a1a2e; color: #fff;
//                     border-radius: 0 0 24px 24px; padding: 12px 20px 14px 24px;
//                     display: flex; align-items: center; gap: 16px;
//                     box-shadow: 0 4px 24px rgba(0,0,0,0.45);
//                     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     animation: sonata-panel-slide 0.3s cubic-bezier(.22,.68,0,1.2);
//                     min-width: 260px;
//                 }
//                 @keyframes sonata-panel-slide {
//                     from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
//                     to   { opacity: 1; transform: translateX(-50%) translateY(0); }
//                 }
//                 .sonata-callpanel-dot {
//                     width: 10px; height: 10px; border-radius: 50%;
//                     background: #1e9652;
//                     box-shadow: 0 0 0 0 rgba(30,150,82,0.6);
//                     animation: sonata-dot-pulse 1.5s ease-out infinite;
//                     flex-shrink: 0;
//                 }
//                 @keyframes sonata-dot-pulse {
//                     0%   { box-shadow: 0 0 0 0 rgba(30,150,82,0.6); }
//                     70%  { box-shadow: 0 0 0 8px rgba(30,150,82,0); }
//                     100% { box-shadow: 0 0 0 0 rgba(30,150,82,0); }
//                 }
//                 .sonata-callpanel-info {
//                     display: flex; flex-direction: column; gap: 2px; flex: 1;
//                 }
//                 .sonata-callpanel-name {
//                     font-size: 14px; font-weight: 600; color: #fff;
//                     white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//                     max-width: 160px;
//                 }
//                 .sonata-callpanel-timer {
//                     font-size: 13px; color: #aaa; font-variant-numeric: tabular-nums;
//                     letter-spacing: 0.03em;
//                 }
//                 .sonata-callpanel-hangup {
//                     background: #e53935; border: none; border-radius: 50%;
//                     width: 40px; height: 40px; cursor: pointer; color: #fff;
//                     display: inline-flex; align-items: center; justify-content: center;
//                     font-size: 18px; flex-shrink: 0;
//                     transition: background 0.15s, transform 0.15s;
//                 }
//                 .sonata-callpanel-hangup:hover { background: #b71c1c; transform: scale(1.08); }
//             `;
//             document.head.appendChild(style);
//         }

//         const displayName = instance.model?.getDisplayName?.() || instance.model?.get('jid') || '...';

//         const panel = document.createElement('div');
//         panel.id = 'sonata-callpanel';
//         panel.className = 'sonata-callpanel';
//         panel.innerHTML = `
//             <div class="sonata-callpanel-dot" style="background:#f59e0b; box-shadow: 0 0 0 0 rgba(245,158,11,0.6);"></div>
//             <div class="sonata-callpanel-info">
//                 <div class="sonata-callpanel-name">${displayName}</div>
//                 <div class="sonata-callpanel-timer" id="sonata-callpanel-timer">Виклик...</div>
//             </div>
//             <button class="sonata-callpanel-hangup" title="Скасувати дзвінок">📵</button>
//         `;
//         document.body.appendChild(panel);

//         // Animated dots on "Виклик..."
//         const timerEl = panel.querySelector('#sonata-callpanel-timer');
//         let dots = 0;
//         ChatHeading._callTimerInterval = setInterval(() => {
//             dots = (dots + 1) % 4;
//             if (timerEl) timerEl.textContent = 'Виклик' + '.'.repeat(dots);
//         }, 600);

//         panel.querySelector('.sonata-callpanel-hangup').addEventListener('click', () => {
//             console.log('[ChatHeading] User cancelled outgoing call');
//             const t = ChatHeading.activeCall;
//             if (t) {
//                 // Send JMI <retract> to cancel the propose
//                 const jid = t.model?.get('jid');
//                 if (jid && t.currentSid) {
//                     const retractMsg = $msg({ to: jid, type: 'chat', id: crypto.randomUUID() })
//                         .c('retract', { xmlns: NS_JINGLE_MSG, id: t.currentSid })
//                         .up()
//                         .c('store', { xmlns: 'urn:xmpp:hints' });
//                     api.send(retractMsg);
//                     console.log('[ChatHeading] Sent JMI retract for sid', t.currentSid);
//                 }
//                 t.terminateCall(false); // no session-terminate needed, call never connected
//             }
//         });
//     }

//     /**
//      * Static: show active call panel with timer and hang-up button.
//      * Called when ICE reaches 'connected' state.
//      */
//     static _showCallPanel(instance) {
//         // Remove outgoing panel (replaces it with the connected one)
//         ChatHeading._hideCallPanel();

//         // Inject CSS if not already present (outgoing panel may have done it)
//         if (!document.getElementById('sonata-callpanel-style')) {
//             const style = document.createElement('style');
//             style.id = 'sonata-callpanel-style';
//             style.textContent = `
//                 .sonata-callpanel {
//                     position: fixed; top: 0; left: 50%; transform: translateX(-50%);
//                     z-index: 99998; background: #1a1a2e; color: #fff;
//                     border-radius: 0 0 24px 24px; padding: 12px 20px 14px 24px;
//                     display: flex; align-items: center; gap: 16px;
//                     box-shadow: 0 4px 24px rgba(0,0,0,0.45);
//                     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     animation: sonata-panel-slide 0.3s cubic-bezier(.22,.68,0,1.2);
//                     min-width: 260px;
//                 }
//                 @keyframes sonata-panel-slide {
//                     from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
//                     to   { opacity: 1; transform: translateX(-50%) translateY(0); }
//                 }
//                 .sonata-callpanel-dot {
//                     width: 10px; height: 10px; border-radius: 50%;
//                     background: #1e9652;
//                     box-shadow: 0 0 0 0 rgba(30,150,82,0.6);
//                     animation: sonata-dot-pulse 1.5s ease-out infinite;
//                     flex-shrink: 0;
//                 }
//                 @keyframes sonata-dot-pulse {
//                     0%   { box-shadow: 0 0 0 0 rgba(30,150,82,0.6); }
//                     70%  { box-shadow: 0 0 0 8px rgba(30,150,82,0); }
//                     100% { box-shadow: 0 0 0 0 rgba(30,150,82,0); }
//                 }
//                 .sonata-callpanel-info {
//                     display: flex; flex-direction: column; gap: 2px; flex: 1;
//                 }
//                 .sonata-callpanel-name {
//                     font-size: 14px; font-weight: 600; color: #fff;
//                     white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//                     max-width: 160px;
//                 }
//                 .sonata-callpanel-timer {
//                     font-size: 13px; color: #aaa; font-variant-numeric: tabular-nums;
//                     letter-spacing: 0.03em;
//                 }
//                 .sonata-callpanel-hangup {
//                     background: #e53935; border: none; border-radius: 50%;
//                     width: 40px; height: 40px; cursor: pointer; color: #fff;
//                     display: inline-flex; align-items: center; justify-content: center;
//                     font-size: 18px; flex-shrink: 0;
//                     transition: background 0.15s, transform 0.15s;
//                 }
//                 .sonata-callpanel-hangup:hover {
//                     background: #b71c1c; transform: scale(1.08);
//                 }
//             `;
//             document.head.appendChild(style);
//         }

//         // Resolve display name from instance model
//         const displayName = instance.model?.getDisplayName?.() || instance.remoteFullJid?.split('/')[0] || 'Unknown';

//         const panel = document.createElement('div');
//         panel.id = 'sonata-callpanel';
//         panel.className = 'sonata-callpanel';
//         panel.innerHTML = `
//             <div class="sonata-callpanel-dot"></div>
//             <div class="sonata-callpanel-info">
//                 <div class="sonata-callpanel-name">${displayName}</div>
//                 <div class="sonata-callpanel-timer" id="sonata-callpanel-timer">00:00</div>
//             </div>
//             <button class="sonata-callpanel-hangup" title="Завершити дзвінок">📵</button>
//         `;
//         document.body.appendChild(panel);

//         // Start timer
//         let seconds = 0;
//         const timerEl = panel.querySelector('#sonata-callpanel-timer');
//         ChatHeading._callTimerInterval = setInterval(() => {
//             seconds++;
//             const m = String(Math.floor(seconds / 60)).padStart(2, '0');
//             const s = String(seconds % 60).padStart(2, '0');
//             if (timerEl) timerEl.textContent = `${m}:${s}`;
//         }, 1000);

//         // Hang-up button
//         panel.querySelector('.sonata-callpanel-hangup').addEventListener('click', () => {
//             console.log('[ChatHeading] User clicked hang-up');
//             const t = ChatHeading.activeCall;
//             if (t) t.terminateCall(true);
//         });
//     }

//     static _hideCallPanel() {
//         if (ChatHeading._callTimerInterval) {
//             clearInterval(ChatHeading._callTimerInterval);
//             ChatHeading._callTimerInterval = null;
//         }
//         const panel = document.getElementById('sonata-callpanel');
//         if (panel) panel.parentElement?.removeChild(panel);
//     }

//     // ========================================================================
//     // END CALL PANEL UI
//     // ========================================================================

//     // ========================================================================
//     // END CALL LOGIC
//     // ========================================================================

//     /**
//      * Returns a list of objects which represent buttons for the chat's header.
//      * @emits _converse#getHeadingButtons
//      * @returns {Promise<Array.<import('./types').HeadingButtonAttributes>>}
//      */
//     async getHeadingButtons() {
//         const buttons = [
//             /** @type {import('./types').HeadingButtonAttributes} */
//             {
//                 a_class: 'show-user-details-modal',
//                 handler: /** @param {Event} ev */ (ev) => this.showUserDetailsModal(ev),
//                 i18n_text: __('Details'),
//                 i18n_title: __('See more information about this person'),
//                 icon_class: 'fa-id-card',
//                 name: 'details',
//                 standalone: false,
//             },
//         ];

//         const domain = _converse.session.get('domain');
//         if (domain && (await api.disco.supports(Strophe.NS.BLOCKING, domain))) {
//             const blocklist = await api.blocklist.get();
//             if (blocklist.get(this.model.get('jid'))) {
//                 buttons.push({
//                     a_class: 'unblock-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Unblock user'), [
//                             __('Are you sure you want to unblock this user?'),
//                         ]);
//                         if (result) {
//                             api.blocklist.remove(this.model.get('jid'));
//                         }
//                     },
//                     i18n_text: __('Unblock this user'),
//                     i18n_title: __('Allow this user to send you messages'),
//                     icon_class: 'fa-check',
//                     name: 'unblock',
//                     standalone: false,
//                 });
//             } else {
//                 buttons.push({
//                     a_class: 'block-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Block user'), [
//                             __(
//                                 'Are you sure you want to prevent %1$s from contacting you further?',
//                                 this.model.getDisplayName(),
//                             ),
//                         ]);
//                         if (result) {
//                             const jid = this.model.get('jid');
//                             api.blocklist.add(jid);
//                             api.contacts.remove(jid, true);
//                             this.model.close();
//                         }
//                     },
//                     i18n_text: __('Block this user'),
//                     i18n_title: __('Prevent this user from sending you any further messages'),
//                     icon_class: 'fa-trash',
//                     name: 'block',
//                     standalone: false,
//                 });
//             }
//         }

//         if (!api.settings.get('singleton')) {
//             buttons.push({
//                 a_class: 'close-chatbox-button',
//                 handler: /** @param {Event} ev */ (ev) => this.close(ev),
//                 i18n_text: __('Close'),
//                 i18n_title: __('Close and end this conversation'),
//                 icon_class: 'fa-times',
//                 name: 'close',
//                 standalone: api.settings.get('view_mode') === 'overlayed',
//             });
//         }
//         const { chatboxviews } = _converse.state;
//         const el = chatboxviews.get(this.getAttribute('jid'));
//         if (el) {
//             /**
//              * *Hook* which allows plugins to add more buttons to a chat's heading.
//              *
//              * Note: This hook is fired for both 1 on 1 chats and groupchats.
//              * If you only care about one, you need to add a check in your code.
//              *
//              * @event _converse#getHeadingButtons
//              * @param { HTMLElement } el
//              *      The `converse-chat` (or `converse-muc`) DOM element that represents the chat
//              * @param { Array.<import('./types').HeadingButtonAttributes> }
//              *      An array of the existing buttons. New buttons may be added,
//              *      and existing ones removed or modified.
//              * @example
//              *  api.listen.on('getHeadingButtons', (el, buttons) => {
//              *      buttons.push({
//              *          'i18n_title': __('Foo'),
//              *          'i18n_text': __('Foo Bar'),
//              *          'handler': ev => alert('Foo!'),
//              *          'a_class': 'toggle-foo',
//              *          'icon_class': 'fa-foo',
//              *          'name': 'foo'
//              *      });
//              *      return buttons;
//              *  });
//              */
//             return _converse.api.hook('getHeadingButtons', el, buttons);
//         } else {
//             return buttons; // Happens during tests
//         }
//     }
// }

// api.elements.define('converse-chat-heading', ChatHeading);
//android from web to android works
// import { _converse, api, converse } from '@converse/headless';
// import { CustomElement } from 'shared/components/element.js';
// import { __ } from 'i18n';
// import tplChatboxHead from './templates/chat-head.js';
// import 'shared/modals/user-details.js';

// import './styles/chat-head.scss';

// const { Strophe, $iq, $msg, sizzle } = converse.env;

// const NS_JINGLE = 'urn:xmpp:jingle:1';
// const NS_JINGLE_ICE = 'urn:xmpp:jingle:transports:ice-udp:1';
// const NS_JINGLE_RTP = 'urn:xmpp:jingle:apps:rtp:1';
// const NS_DTLS = 'urn:xmpp:jingle:apps:dtls:0';
// const NS_JINGLE_MSG = 'urn:xmpp:jingle-message:0';

// export default class ChatHeading extends CustomElement {
//     // Static reference to the ChatHeading instance that owns the active call.
//     // Incoming Jingle stanzas are routed here regardless of which instance's
//     // handler fires (every open chat registers its own handler).
//     static activeCall = null;

//     // Guard so the Strophe IQ handler and message listener are registered
//     // only ONCE, not per-instance. Multiple registrations cause Strophe to
//     // fire every handler per incoming stanza, breaking the pc state machine.
//     static _jingleHandlersRegistered = false;

//     // Tracks whether the Strophe-level IQ handler is currently attached.
//     // Separate from _jingleHandlersRegistered because connection lost / reconnect
//     // can detach the handler while the static-listener side stays put.
//     static _stropheHandlerAttached = false;

//     // Pending incoming call (showing modal). Used so <retract> can cancel the modal.
//     static _pendingIncomingSid = null;
//     static _pendingIncomingFrom = null;
//     // Callback set while modal is shown — call it to close the modal externally.
//     static _closeIncomingModal = null;

//     // Timer interval for the call panel
//     static _callTimerInterval = null;

//     // Remote video stream received before PiP was created — flushed in _showCallPanel
//     static _pendingRemoteVideoStream = null;

//     static _iceServersCache = null;
//     static _iceServersCacheExpiry = 0;

//     /**
//      * Request a keyframe from remote video senders and poll readyState.
//      * Chrome needs an IDR (keyframe) to start decoding H264. If iOS doesn't
//      * send one immediately, readyState stays 0 despite live tracks arriving.
//      */
//     static _requestKeyframeAndPollVideo(pc) {
//         if (!pc) return;
//         try {
//             pc.getReceivers().forEach((receiver) => {
//                 if (receiver.track?.kind === 'video') {
//                     console.log('[ChatHeading] Video receiver readyState:', receiver.track.readyState);
//                     if (typeof receiver.jitterBufferTarget !== 'undefined') {
//                         receiver.jitterBufferTarget = 0;
//                     }
//                 }
//             });
//         } catch (e) {
//             /* ignore */
//         }

//         let attempts = 0;
//         const poll = setInterval(async () => {
//             attempts++;
//             const vid = document.getElementById('sonata-video-remote');
//             if (!vid) {
//                 clearInterval(poll);
//                 return;
//             }
//             const rs = vid.readyState;
//             console.log(`[ChatHeading] Video poll ${attempts}: readyState=${rs} paused=${vid.paused}`);
//             if (rs >= 2) {
//                 console.log('%c [VIDEO] ✅ Playing! readyState=' + rs, 'background: green; color: white;');
//                 clearInterval(poll);
//                 return;
//             }
//             if (vid.paused && vid.srcObject) {
//                 vid.play().catch(() => {});
//             }
//             // At 2s: check RTP stats — are packets even arriving?
//             if (attempts === 4) {
//                 try {
//                     const stats = await pc.getStats();
//                     stats.forEach((report) => {
//                         if (report.type === 'inbound-rtp' && report.kind === 'video') {
//                             console.log(
//                                 `[VIDEO STATS] packetsReceived=${report.packetsReceived} framesReceived=${report.framesReceived || 0} framesDecoded=${report.framesDecoded || 0} framesDropped=${report.framesDropped || 0} decoderImpl=${report.decoderImplementation || '?'}`,
//                             );
//                         }
//                         if (report.type === 'codec' && report.mimeType?.toLowerCase().includes('h264')) {
//                             console.log(`[VIDEO STATS] codec: ${report.mimeType} fmtp=${report.sdpFmtpLine}`);
//                         }
//                     });
//                 } catch (e) {
//                     console.warn('[VIDEO STATS] getStats failed:', e.message);
//                 }
//             }
//             // Re-attach stream after 3s to force a new decoder init + keyframe request
//             if (attempts === 6 && rs === 0 && vid.srcObject) {
//                 console.warn('[ChatHeading] No frames after 3s — cycling srcObject to force keyframe');
//                 const stream = vid.srcObject;
//                 vid.srcObject = null;
//                 setTimeout(() => {
//                     vid.srcObject = stream;
//                     vid.play().catch(() => {});
//                 }, 150);
//             }
//             if (attempts >= 20) {
//                 clearInterval(poll);
//             }
//         }, 500);
//     }

//     /**
//      * Fetch ICE servers via XEP-0215 external service discovery.
//      * Queries the XMPP server (not the remote peer). Cached after first call.
//      */
//     static async _getIceServers() {
//         if (ChatHeading._iceServersCache && Date.now() < ChatHeading._iceServersCacheExpiry) {
//             return ChatHeading._iceServersCache;
//         }
//         const fallback = [{ urls: 'stun:stun.l.google.com:19302' }];
//         try {
//             // Always query our own server domain, never a peer JID
//             const domain =
//                 _converse.domain || (_converse.bare_jid || '').split('@')[1] || (_converse.jid || '').split('@')[1];
//             if (!domain) {
//                 console.warn('[ChatHeading] No domain for XEP-0215');
//                 return fallback;
//             }
//             console.log('[ChatHeading] Querying XEP-0215 TURN from domain:', domain);

//             let services = null;
//             for (const xmlns of ['urn:xmpp:extdisco:2', 'urn:xmpp:extdisco:1']) {
//                 try {
//                     const iq = $iq({ type: 'get', to: domain }).c('services', { xmlns });
//                     const result = await new Promise((resolve, reject) => {
//                         const timer = setTimeout(() => reject(new Error('timeout')), 5000);
//                         _converse.api
//                             .sendIQ(iq)
//                             .then((res) => {
//                                 clearTimeout(timer);
//                                 resolve(res);
//                             })
//                             .catch((err) => {
//                                 clearTimeout(timer);
//                                 reject(err);
//                             });
//                     });
//                     const found = result.querySelectorAll('service');
//                     if (found.length) {
//                         services = found;
//                         console.log(`[ChatHeading] XEP-0215 ${xmlns}: got ${found.length} services`);
//                         break;
//                     }
//                 } catch (e) {
//                     console.log(`[ChatHeading] XEP-0215 ${xmlns} failed:`, e.message);
//                 }
//             }

//             if (!services || !services.length) {
//                 console.warn('[ChatHeading] XEP-0215 returned no TURN services');
//                 ChatHeading._iceServersCache = fallback;
//                 return fallback;
//             }

//             const iceServers = [{ urls: 'stun:stun.l.google.com:19302' }];
//             services.forEach((svc) => {
//                 const type = svc.getAttribute('type');
//                 const host = svc.getAttribute('host');
//                 const port = svc.getAttribute('port');
//                 const user = svc.getAttribute('username');
//                 const pass = svc.getAttribute('password');
//                 const transport = svc.getAttribute('transport') || 'udp';
//                 if (!host) return;
//                 if (type === 'stun') {
//                     iceServers.push({ urls: `stun:${host}${port ? ':' + port : ''}` });
//                 } else if (type === 'turn') {
//                     const url = `turn:${host}${port ? ':' + port : ''}?transport=${transport}`;
//                     const entry = { urls: url };
//                     if (user) entry.username = user;
//                     if (pass) entry.credential = pass;
//                     iceServers.push(entry);
//                     console.log(`[ChatHeading] TURN: ${url} user=${user}`);
//                 }
//             });
//             console.log('[ChatHeading] ICE servers:', JSON.stringify(iceServers));
//             ChatHeading._iceServersCache = iceServers;
//             // TURN credentials expire at the timestamp in username (unix seconds).
//             // Refresh 5 minutes before expiry.
//             const turnEntry = iceServers.find((s) => s.urls?.startsWith?.('turn:') && s.username);
//             if (turnEntry) {
//                 const expireTs = parseInt(turnEntry.username.split(':')[0], 10) * 1000;
//                 ChatHeading._iceServersCacheExpiry = expireTs - 5 * 60 * 1000;
//             } else {
//                 ChatHeading._iceServersCacheExpiry = Date.now() + 3600 * 1000;
//             }
//             return iceServers;
//         } catch (e) {
//             console.warn('[ChatHeading] _getIceServers error:', e.message);
//             return fallback;
//         }
//     }

//     constructor() {
//         super();
//         this.jid = null;

//         // --- Call state (per-instance) ---
//         // NOTE: keeping these on the instance means every open chat has its own
//         // pc / localStream. If multiple chats are open and the user triggers
//         // calls in parallel, they won't interfere — but the *incoming* Jingle
//         // handlers below register once per ChatHeading instance, so every open
//         // chat will receive and try to handle every incoming Jingle stanza.
//         // That is the known bug we accepted.
//         this.pc = null;
//         this.localStream = null;
//         this.iceCandidatesQueue = [];
//         this.currentSid = null;
//         this.isIncoming = false;
//         this.remoteFullJid = null;
//         this.isVideo = false; // true when this is a video call
//     }

//     static get properties() {
//         return {
//             jid: { type: String },
//         };
//     }

//     initialize() {
//         const { chatboxes } = _converse.state;
//         this.model = chatboxes.get(this.jid);
//         this.listenTo(this.model, 'change:status', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:add', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:change', () => this.requestUpdate());
//         if (this.model.contact) {
//             this.listenTo(this.model.contact, 'destroy', () => this.requestUpdate());
//         }
//         this.model.rosterContactAdded?.then(() => {
//             this.listenTo(this.model.contact, 'change:nickname', () => this.requestUpdate());
//             this.requestUpdate();
//         });

//         // --- Wire up Jingle handlers on this instance ---
//         // BUG WARNING: registered per ChatHeading. With N open chats, every
//         // incoming Jingle IQ fires N times. Same for the 'message' (proceed)
//         // listener and the 'connected' event.
//         this._registerJingleHandlers();

//         this.requestUpdate();
//     }

//     render() {
//         return tplChatboxHead(this);
//     }

//     /**
//      * @param {Event} ev
//      */
//     showUserDetailsModal(ev) {
//         ev.preventDefault();
//         if (this.model?.contact instanceof _converse.exports.Profile) {
//             api.modal.show('converse-profile-modal', { model: this.model }, ev);
//         } else {
//             api.modal.show('converse-user-details-modal', { model: this.model }, ev);
//         }
//     }

//     /**
//      * @param {Event} ev
//      */
//     close(ev) {
//         ev.preventDefault();
//         this.model.close();
//     }

//     // ========================================================================
//     // CALL LOGIC (moved from sonata-p2p-init plugin)
//     // ========================================================================

//     _registerJingleHandlers() {
//         // Register the Strophe IQ handler and message listener EXACTLY ONCE
//         // across all ChatHeading instances. Without this guard, every open
//         // chat registers its own handler, and Strophe fires ALL of them per
//         // incoming stanza — resulting in N calls to setRemoteDescription /
//         // addIceCandidate on the same pc, which breaks the RTCPeerConnection
//         // state machine and ICE never completes.
//         if (ChatHeading._jingleHandlersRegistered) return;
//         ChatHeading._jingleHandlersRegistered = true;

//         console.log('=== [ChatHeading] Registering Jingle handlers (once globally) ===');

//         const self = this;

//         // Wait for Strophe connection, then attach raw IQ handler for Jingle.
//         // The plugin used `_converse.on('connected', ...)` which fires once at
//         // login. But ChatHeading.initialize() runs PER CHAT OPEN, which may be
//         // AFTER 'connected' has already fired (event missed). So we try all
//         // three paths: immediate (if connection exists), 'connected' listener,
//         // AND a polling fallback. Whichever wins, the static guard inside
//         // attach() prevents double-registration on Strophe.
//         const attach = () => {
//             if (ChatHeading._stropheHandlerAttached) return;
//             const connection = _converse.connection || api.connection?.get?.();
//             if (!connection || !connection.addHandler) {
//                 console.log('[ChatHeading] No Strophe connection yet, will retry');
//                 return false;
//             }

//             ChatHeading._stropheHandlerAttached = true;
//             console.log('[ChatHeading] ✓ Strophe Jingle IQ handler attached');

//             connection.addHandler(
//                 (stanza) => {
//                     const jingle = sizzle(`jingle[xmlns="${NS_JINGLE}"]`, stanza).pop();
//                     if (!jingle) return true;

//                     const action = jingle.getAttribute('action');
//                     const from = stanza.getAttribute('from');
//                     const id = stanza.getAttribute('id');
//                     const sid = jingle.getAttribute('sid');

//                     console.log(
//                         `%c [JINGLE RECEIVE] Action: ${action} from ${from} sid=${sid} `,
//                         'background: #222; color: #bada55; padding: 2px;',
//                     );

//                     // ACK the IQ immediately
//                     connection.send($iq({ type: 'result', to: from, id: id }).tree());

//                     const target = ChatHeading.activeCall;
//                     if (!target) {
//                         console.warn('[JINGLE RECEIVE] No active call; ignoring', action);
//                         return true;
//                     }
//                     if (!target.pc) {
//                         console.warn(
//                             '[JINGLE RECEIVE] Active call has no pc yet; action=' + action,
//                             '— may be timing issue',
//                         );
//                         // For transport-info we can queue. For session-initiate
//                         // (incoming call) we create the pc inside the handler.
//                         // For session-accept we can't do much without pc — skip.
//                         if (action === 'transport-info' || action === 'session-initiate') {
//                             // ok, let it through
//                         } else {
//                             return true;
//                         }
//                     }

//                     switch (action) {
//                         case 'session-initiate': {
//                             console.log('[JINGLE RECEIVE] session-initiate (we are callee)');
//                             const transport = sizzle('transport', jingle).pop();
//                             const fingerprintElem = sizzle('fingerprint', transport).pop();
//                             const hasVideo = sizzle('description[media="video"]', jingle).length > 0;

//                             // Read actual video payload-types from the offer so we
//                             // negotiate the codec the caller actually supports (H264 on iOS,
//                             // VP8 on Android) rather than hardcoding our preference.
//                             const videoDesc = sizzle('description[media="video"]', jingle).pop();
//                             const videoPayloads = videoDesc
//                                 ? sizzle('payload-type', videoDesc).map((pt) => {
//                                       // Collect <parameter name="..." value="..."/> children as fmtp string
//                                       const params = sizzle('parameter', pt);
//                                       const fmtp =
//                                           params.length > 0
//                                               ? params
//                                                     .map((p) => `${p.getAttribute('name')}=${p.getAttribute('value')}`)
//                                                     .join(';')
//                                               : null;
//                                       return {
//                                           id: pt.getAttribute('id'),
//                                           name: pt.getAttribute('name'),
//                                           clockrate: pt.getAttribute('clockrate') || '90000',
//                                           fmtp,
//                                       };
//                                   })
//                                 : [];
//                             console.log('[JINGLE RECEIVE] video payloads from caller:', videoPayloads);

//                             target.handleSessionInitiate(from, sid, {
//                                 ufrag: transport?.getAttribute('ufrag'),
//                                 pwd: transport?.getAttribute('pwd'),
//                                 fingerprint: fingerprintElem?.textContent,
//                                 setup: fingerprintElem?.getAttribute('setup') || 'actpass',
//                                 hasVideo,
//                                 videoPayloads,
//                             });
//                             break;
//                         }
//                         case 'session-accept': {
//                             const transport = sizzle('transport', jingle).pop();
//                             const fingerprintElem = sizzle('fingerprint', transport).pop();
//                             target.handleSessionAccept({
//                                 ufrag: transport?.getAttribute('ufrag'),
//                                 pwd: transport?.getAttribute('pwd'),
//                                 fingerprint: fingerprintElem?.textContent,
//                                 setup: fingerprintElem?.getAttribute('setup') || 'active',
//                                 sid: sid,
//                             });
//                             break;
//                         }
//                         case 'transport-info':
//                             target.handleIncomingCandidates(jingle);
//                             break;
//                         case 'session-terminate':
//                             console.warn('[JINGLE RECEIVE] Remote terminated the call');
//                             console.warn('[JINGLE RECEIVE] session-terminate reason XML:', jingle.outerHTML);
//                             target.terminateCall(false);
//                             break;
//                         case 'session-info':
//                             // ringing / on_hold / etc — informational only
//                             console.log('[JINGLE RECEIVE] session-info (informational):', jingle.innerHTML);
//                             break;
//                         default:
//                             console.log('[JINGLE RECEIVE] Unhandled action:', action);
//                     }

//                     return true;
//                 },
//                 NS_JINGLE,
//                 'iq',
//                 'set',
//             );
//             return true;
//         };

//         // Path 1: connection already exists at registration time
//         if (_converse.connection && _converse.connection.addHandler) {
//             attach();
//         }

//         // Path 2: listen for 'connected' event (covers logout/reconnect cycles)
//         api.listen.on('connected', () => {
//             console.log('[ChatHeading] connected event fired');
//             ChatHeading._stropheHandlerAttached = false; // re-attach after reconnect
//             attach();
//         });

//         // Path 3: polling fallback. ChatHeading.initialize() may run AFTER
//         // 'connected' has already fired (because user opened a chat after
//         // login). In that case neither Path 1 nor Path 2 catches it. Poll
//         // until connection becomes available, then stop.
//         const pollInterval = setInterval(() => {
//             if (ChatHeading._stropheHandlerAttached) {
//                 clearInterval(pollInterval);
//                 return;
//             }
//             if (attach()) {
//                 clearInterval(pollInterval);
//             }
//         }, 500);
//         // Stop polling after 30s no matter what to avoid leaks
//         setTimeout(() => clearInterval(pollInterval), 30000);

//         // Listen for Jingle Message Initiation on regular messages:
//         //   <propose> — incoming call (we are callee)
//         //   <retract> — caller cancelled before we picked up
//         //   <proceed> — callee accepted our call (we are caller)
//         //   <ringing>, <received>, <reject>, <accept> — info
//         _converse.on('message', (data) => {
//             const stanza = data.stanza;
//             const from = stanza.getAttribute('from');
//             const bare_jid = _converse.bare_jid;
//             const fromBare = from?.split('/')[0];

//             // Ignore our own carbons (echoes of stanzas we sent)
//             const isOwnCarbon = fromBare === bare_jid;

//             // Look for any JMI element
//             const propose = sizzle(`propose[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const retract = sizzle(`retract[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const proceed = sizzle(`proceed[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const ringing = sizzle(`ringing[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const received = sizzle(`received[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const reject = sizzle(`reject[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const accept = sizzle(`accept[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();

//             // --- INCOMING CALL: <propose> ---
//             if (propose && !isOwnCarbon) {
//                 const sid = propose.getAttribute('id');
//                 const description = sizzle('description', propose).pop();
//                 const media = description?.getAttribute('media') || 'audio';
//                 console.log(
//                     `%c [JMI INCOMING] propose from ${from} sid=${sid} media=${media} `,
//                     'background: #1e9652; color: white; padding: 2px;',
//                 );
//                 ChatHeading.handleIncomingPropose(from, sid, media);
//                 return;
//             }

//             // --- CALLER CANCELLED: <retract> ---
//             if (retract && !isOwnCarbon) {
//                 const sid = retract.getAttribute('id');
//                 console.warn(`[JMI INCOMING] retract from ${from} sid=${sid} (caller cancelled)`);
//                 ChatHeading.handleRetract(sid);
//                 return;
//             }

//             // --- CALL ENDED BY REMOTE: <finish> (XEP-0272 / Sonata extension) ---
//             const finish = sizzle(`finish[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             if (finish && !isOwnCarbon) {
//                 const sid = finish.getAttribute('id');
//                 console.warn(`[JMI] finish from ${from} sid=${sid} — remote ended call`);
//                 const t = ChatHeading.activeCall;
//                 if (t) t.terminateCall(false); // remote already ended, don't echo
//                 return;
//             }

//             if (ringing) {
//                 console.log('[JMI] ringing from', from);
//                 return;
//             }
//             if (received) {
//                 console.log('[JMI] received (delivery ack) from', from);
//                 return;
//             }
//             if (reject) {
//                 console.warn('[JMI] reject from', from, '— remote declined');
//                 const t = ChatHeading.activeCall;
//                 if (t) t.terminateCall(false);
//                 return;
//             }
//             if (accept) {
//                 console.log('[JMI] accept seen (carbon echo from another device)');
//                 return;
//             }

//             // --- OUR OUTGOING CALL WAS ACCEPTED: <proceed> ---
//             if (proceed) {
//                 console.log('=== [JMI] proceed from', from, '===');
//                 const target = ChatHeading.activeCall;
//                 if (!target) {
//                     console.warn('[ChatHeading] proceed received but no active call');
//                     return;
//                 }
//                 if (target.pc) {
//                     console.log('[ChatHeading] Already have pc, ignoring duplicate proceed');
//                     return;
//                 }
//                 console.log('=== [ChatHeading] Starting WebRTC (sendJingleInitiate) ===');
//                 const sid = proceed.getAttribute('id');
//                 target.sendJingleInitiate(from, sid);
//             }
//         });
//     }

//     /**
//      * Called from chat-head.js template buttons.
//      * @param {'audio'|'video'} media
//      */
//     async initiateCall(media = 'audio') {
//         if (!this.model) {
//             console.warn('[ChatHeading] No model, cannot initiate call');
//             return;
//         }

//         this.isVideo = media === 'video';

//         // Pre-warm media BEFORE sending <propose>.
//         try {
//             console.log(`[ChatHeading] Pre-warming media (${media})...`);
//             this.localStream = await navigator.mediaDevices.getUserMedia({
//                 audio: true,
//                 video: this.isVideo,
//             });
//         } catch (err) {
//             console.error('[ChatHeading] Media permission denied / unavailable:', err);
//             this.model.createMessage({
//                 message: `❌ Не вдалося отримати доступ до ${this.isVideo ? 'камери/мікрофона' : 'мікрофона'}`,
//                 type: 'info',
//             });
//             return;
//         }

//         const jid = this.model.get('jid');
//         const sid = crypto.randomUUID().toUpperCase();
//         const stanzaId = `jm-propose-${sid}`;
//         const myNick = _converse.xmppstatus.get('fullname') || _converse.bare_jid;

//         this.currentSid = sid;
//         ChatHeading.activeCall = this;

//         console.log(`[ChatHeading] Proposing ${media} call to ${jid}, SID: ${sid}`);

//         const propose = $msg({ to: jid, type: 'chat', id: stanzaId })
//             .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: stanzaId })
//             .up()
//             .c('propose', { xmlns: NS_JINGLE_MSG, id: sid })
//             .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//             .up();

//         if (this.isVideo) {
//             propose.c('description', { xmlns: NS_JINGLE_RTP, media: 'video' }).up();
//         }

//         propose
//             .up()
//             .c('request', { xmlns: 'urn:xmpp:receipts' })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' })
//             .up()
//             .c('x', { xmlns: 'p1:push:custom', key: 'type', value: 'call' })
//             .up()
//             .c('x', { xmlns: 'p1:push:custom', key: 'aps.mutable-content', value: '1' })
//             .up()
//             .c('customize', { xmlns: 'p1:push:customize', nick: myNick })
//             .c('body')
//             .t('Incoming call')
//             .up()
//             .up();

//         api.send(propose);
//         this.model.createMessage({
//             message: `${this.isVideo ? '📹' : '📞'} Виклик (очікування відповіді...)`,
//             type: 'info',
//         });
//         ChatHeading._showOutgoingCallPanel(this);
//     }

//     async sendJingleInitiate(fullJid, sid) {
//         console.log('[ChatHeading] >>> sendJingleInitiate START', { fullJid, sid });
//         this.iceCandidatesQueue = [];
//         this.currentSid = sid;
//         this.remoteFullJid = fullJid; // needed for terminateCall to send session-terminate

//         try {
//             // Reuse pre-warmed stream from initiateCall(). Only fall back to
//             // getUserMedia if there isn't one (e.g. incoming-direction calls
//             // that bypass our initiateCall — currently none, but safe).
//             if (!this.localStream) {
//                 console.log('[ChatHeading] No pre-warmed stream, requesting media...');
//                 this.localStream = await navigator.mediaDevices.getUserMedia({
//                     audio: true,
//                     video: this.isVideo,
//                 });
//                 console.log('[ChatHeading] Got media stream:', this.localStream);
//             } else {
//                 console.log('[ChatHeading] Reusing pre-warmed stream (isVideo:', this.isVideo, ')');
//             }

//             console.log('[ChatHeading] Creating RTCPeerConnection...');
//             const iceServers = await ChatHeading._getIceServers();
//             console.log('[ChatHeading] Using ICE servers:', JSON.stringify(iceServers));
//             this.pc = new RTCPeerConnection({
//                 iceServers,
//                 bundlePolicy: 'max-bundle',
//                 rtcpMuxPolicy: 'require',
//                 iceCandidatePoolSize: 2, // pre-gather candidates before offer
//             });
//             console.log('[ChatHeading] RTCPeerConnection created');

//             this.pc.oniceconnectionstatechange = () => {
//                 console.log(`%c [ICE] state=${this.pc.iceConnectionState} `, 'color: orange; font-weight: bold;');
//                 if (this.pc.iceConnectionState === 'failed') {
//                     console.warn('[ICE] FAILED — attempting ICE restart...');
//                     // Log which candidate pairs were tried
//                     this.pc
//                         .getStats()
//                         .then((stats) => {
//                             stats.forEach((r) => {
//                                 if (r.type === 'candidate-pair') {
//                                     console.log(
//                                         `[ICE PAIR] state=${r.state} local=${r.localCandidateId} remote=${r.remoteCandidateId} nominated=${r.nominated} bytesSent=${r.bytesSent || 0} bytesReceived=${r.bytesReceived || 0}`,
//                                     );
//                                 }
//                                 if (r.type === 'local-candidate') {
//                                     console.log(
//                                         `[ICE LOCAL] id=${r.id} type=${r.candidateType} ip=${r.address || r.ip} port=${r.port} proto=${r.protocol}`,
//                                     );
//                                 }
//                                 if (r.type === 'remote-candidate') {
//                                     console.log(
//                                         `[ICE REMOTE] id=${r.id} type=${r.candidateType} ip=${r.address || r.ip} port=${r.port}`,
//                                     );
//                                 }
//                             });
//                         })
//                         .catch(() => {});
//                     if (this.pc.signalingState === 'stable' && this.pc.restartIce) {
//                         this.pc.restartIce();
//                     }
//                 }
//                 if (this.pc.iceConnectionState === 'disconnected') {
//                     console.warn('[ICE] DISCONNECTED — will restart if not recovered in 5s');
//                     setTimeout(() => {
//                         if (this.pc && this.pc.iceConnectionState === 'disconnected') {
//                             console.warn('[ICE] Still disconnected — restarting ICE');
//                             if (this.pc.signalingState === 'stable' && this.pc.restartIce) {
//                                 this.pc.restartIce();
//                             }
//                         }
//                     }, 5000);
//                 }
//                 if (this.pc.iceConnectionState === 'connected') {
//                     console.log('%c [ICE] ✅ CONNECTED ', 'background: green; color: white;');
//                     ChatHeading._showCallPanel(this);
//                     ChatHeading._requestKeyframeAndPollVideo(this.pc);
//                 }
//             };

//             this.pc.onconnectionstatechange = () => {
//                 console.log(`[PC] connectionState=${this.pc.connectionState}`);
//             };

//             this.pc.onsignalingstatechange = () => {
//                 console.log(`[PC] signalingState=${this.pc.signalingState}`);
//             };

//             this.pc.ontrack = (event) => {
//                 console.log(
//                     `%c [TRACK] kind=${event.track.kind} streams=${event.streams.length} `,
//                     'background: #333; color: #7ec8e3; padding: 2px;',
//                 );
//                 if (event.track.kind === 'audio') {
//                     console.log('[ChatHeading] Attaching remote audio track');
//                     let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
//                     el.id = 'sonata-audio-remote';
//                     el.autoplay = true;
//                     if (!el.parentElement) document.body.appendChild(el);
//                     el.srcObject = event.streams[0];
//                 } else if (event.track.kind === 'video') {
//                     console.log('[ChatHeading] Attaching remote video track — PiP should show');
//                     ChatHeading._attachRemoteVideo(event.streams[0]);
//                 }
//             };

//             this.pc.onicecandidate = (event) => {
//                 if (event.candidate) {
//                     const c = event.candidate;
//                     console.log('[ChatHeading] Local candidate:', c.candidate);
//                     const attrs = {
//                         id: String(Math.floor(Math.random() * 4294967295)),
//                         component: String(c.component || 1),
//                         foundation: c.foundation,
//                         generation: '0',
//                         ip: c.address || c.ip,
//                         port: String(c.port),
//                         priority: String(c.priority),
//                         protocol: (c.protocol || 'udp').toLowerCase(),
//                         type: c.type,
//                     };
//                     if (c.relatedAddress) attrs['rel-addr'] = c.relatedAddress;
//                     if (c.relatedPort) attrs['rel-port'] = String(c.relatedPort);
//                     const iq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                         .c('jingle', { xmlns: NS_JINGLE, action: 'transport-info', initiator: _converse.jid, sid })
//                         .c('content', { creator: 'initiator', name: '0' })
//                         .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                         .c('candidate', attrs);
//                     api.send(iq);
//                 }
//             };

//             this.localStream.getTracks().forEach((track) => this.pc.addTrack(track, this.localStream));

//             const offer = await this.pc.createOffer();
//             await this.pc.setLocalDescription(offer);

//             const sdp = this.pc.localDescription.sdp;
//             console.log('[ChatHeading] 📋 LOCAL OFFER SDP (full):\n', sdp);
//             const ufrag = sdp.match(/a=ice-ufrag:(.*)\r/)[1];
//             const pwd = sdp.match(/a=ice-pwd:(.*)\r/)[1];
//             const fingerprint = sdp.match(/a=fingerprint:sha-256 (.*)\r/)[1];

//             console.log('[ChatHeading] Sending session-initiate (isVideo:', this.isVideo, ')...');
//             console.log(
//                 '[ChatHeading] Local tracks:',
//                 this.localStream?.getTracks().map((t) => `${t.kind}:${t.label}`),
//             );

//             // Parse video codecs from our actual offer SDP so PT numbers match.
//             // Hardcoding 96/97 doesn't work — browser assigns different PT numbers
//             // (e.g. H264 gets 103, 107, etc). iOS/Android match by PT number in the
//             // answer, so we must use whatever the browser assigned in the offer.
//             const SKIP = new Set([
//                 'rtx',
//                 'red',
//                 'ulpfec',
//                 'flexfec-03',
//                 'telephone-event',
//                 'cn',
//                 'pcmu',
//                 'pcma',
//                 'g722',
//             ]);
//             const offerVideoPayloads = [];
//             let inVid = false;
//             for (const line of sdp.split('\n')) {
//                 const l = line.trim();
//                 if (l.startsWith('m=video')) {
//                     inVid = true;
//                     continue;
//                 }
//                 if (l.startsWith('m=') && inVid) {
//                     inVid = false;
//                     break;
//                 }
//                 if (inVid && l.startsWith('a=rtpmap:')) {
//                     const m = l.match(/^a=rtpmap:(\d+) ([^/]+)\/(\d+)/);
//                     if (m && !SKIP.has(m[2].toLowerCase())) {
//                         offerVideoPayloads.push({ id: m[1], name: m[2], clockrate: m[3] });
//                     }
//                 }
//             }
//             // Reorder: H264 first (for iOS), then others
//             offerVideoPayloads.sort((a, b) => {
//                 const aH = a.name.toLowerCase().includes('h264') ? 0 : 1;
//                 const bH = b.name.toLowerCase().includes('h264') ? 0 : 1;
//                 return aH - bH;
//             });
//             console.log('[ChatHeading] Outgoing video offer payloads:', offerVideoPayloads);

//             // Build session-initiate as one unbroken chain.
//             let initiateIq;
//             if (this.isVideo) {
//                 let iq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', { xmlns: NS_JINGLE, action: 'session-initiate', initiator: _converse.jid, sid })
//                     .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                     .c('content', { name: '0' })
//                     .up()
//                     .c('content', { name: '1' })
//                     .up()
//                     .up()
//                     .c('content', { creator: 'initiator', name: '0' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                     .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                     .c('parameter', { name: 'minptime', value: '10' })
//                     .up()
//                     .c('parameter', { name: 'useinbandfec', value: '1' })
//                     .up()
//                     .up()
//                     .c('rtcp-mux')
//                     .up()
//                     .up()
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                     .t(fingerprint)
//                     .up()
//                     .up()
//                     .up()
//                     .c('content', { creator: 'initiator', name: '1' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'video' });

//                 offerVideoPayloads.forEach((p) =>
//                     iq.c('payload-type', { id: p.id, name: p.name, clockrate: p.clockrate }).up(),
//                 );

//                 iq = iq
//                     .c('rtcp-mux')
//                     .up()
//                     .up()
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                     .t(fingerprint)
//                     .up()
//                     .up()
//                     .up();

//                 initiateIq = iq;
//             } else {
//                 initiateIq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', { xmlns: NS_JINGLE, action: 'session-initiate', initiator: _converse.jid, sid })
//                     .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                     .c('content', { name: '0' })
//                     .up()
//                     .up() // </group>
//                     .c('content', { creator: 'initiator', name: '0' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                     .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                     .c('parameter', { name: 'minptime', value: '10' })
//                     .up()
//                     .c('parameter', { name: 'useinbandfec', value: '1' })
//                     .up()
//                     .up() // </payload-type>
//                     .c('rtcp-mux')
//                     .up()
//                     .up() // </description>
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                     .t(fingerprint)
//                     .up()
//                     .up() // </transport>
//                     .up(); // </content>
//             }

//             api.send(initiateIq);
//             console.log('[ChatHeading] 📤 session-initiate XML:\n', initiateIq.toString());
//             console.log('[ChatHeading] >>> sendJingleInitiate DONE (session-initiate sent)');
//         } catch (err) {
//             console.error('[ChatHeading] WebRTC Error in sendJingleInitiate:', err);
//             console.error('[ChatHeading] Stack:', err?.stack);
//         }
//     }

//     handleSessionAccept(remoteData) {
//         console.log('[ChatHeading] >>> handleSessionAccept START', remoteData);
//         if (!this.pc) {
//             console.error('[ChatHeading] handleSessionAccept: NO PC! Cannot proceed.');
//             return;
//         }
//         console.log('[ChatHeading] pc signaling state:', this.pc.signalingState);

//         // Parse the m-lines from our own offer so the answer mirrors them exactly.
//         // The WebRTC spec requires the answer to have the SAME number and order
//         // of m-lines as the offer. If we offered audio+video but build a hardcoded
//         // audio-only answer, setRemoteDescription throws "order of m-lines doesn't match".
//         const offerSdp = this.pc.localDescription?.sdp || '';
//         const offerMids = [...offerSdp.matchAll(/^a=mid:(.+)$/gm)].map((m) => m[1].trim());
//         console.log('[ChatHeading] Offer m-line mids:', offerMids);

//         // Build the BUNDLE group line to match what we offered
//         const bundleLine = offerMids.length > 0 ? `a=group:BUNDLE ${offerMids.join(' ')}` : 'a=group:BUNDLE 0';

//         // Build one m-section per mid from the offer.
//         // We only have audio ICE/DTLS params from the session-accept (Sonata sends
//         // a single transport for the BUNDLE). Apply same params to all m-lines.
//         // Parse actual video codecs+PTs from our offer SDP to build a matching answer
//         const SKIP_V = new Set(['rtx', 'red', 'ulpfec', 'flexfec-03']);
//         const offerVideoCodecs = [];
//         let inVideo = false;
//         for (const line of offerSdp.split('\n')) {
//             const l = line.trim();
//             if (l.startsWith('m=video')) {
//                 inVideo = true;
//                 continue;
//             }
//             if (l.startsWith('m=') && inVideo) {
//                 inVideo = false;
//                 break;
//             }
//             if (inVideo && l.startsWith('a=rtpmap:')) {
//                 const m = l.match(/^a=rtpmap:(\d+) ([^/]+)\/(\d+)/);
//                 if (m && !SKIP_V.has(m[2].toLowerCase())) {
//                     offerVideoCodecs.push({ id: m[1], name: m[2], clockrate: m[3] });
//                 }
//             }
//         }
//         console.log('[ChatHeading] Answer video codecs from offer:', offerVideoCodecs);

//         const videoPtIds = offerVideoCodecs.map((c) => c.id).join(' ') || '96 97';
//         const videoRtpmaps = offerVideoCodecs.map((c) => `a=rtpmap:${c.id} ${c.name}/${c.clockrate}`);

//         const mSections = offerMids.map((mid) => {
//             const isVideo = mid !== '0' && this.isVideo;
//             return [
//                 isVideo ? `m=video 9 RTP/SAVPF ${videoPtIds}` : 'm=audio 9 RTP/SAVPF 111',
//                 'c=IN IP4 0.0.0.0',
//                 `a=ice-ufrag:${remoteData.ufrag}`,
//                 `a=ice-pwd:${remoteData.pwd}`,
//                 `a=fingerprint:sha-256 ${remoteData.fingerprint}`,
//                 'a=setup:active',
//                 `a=mid:${mid}`,
//                 'a=rtcp-mux',
//                 ...(isVideo ? videoRtpmaps : ['a=rtpmap:111 opus/48000/2', 'a=fmtp:111 minptime=10;useinbandfec=1']),
//                 'a=sendrecv',
//             ].join('\r\n');
//         });

//         const remoteSdp =
//             ['v=0', 'o=- 1234567890 2 IN IP4 0.0.0.0', 's=-', 't=0 0', bundleLine, 'a=msid-semantic: WMS'].join(
//                 '\r\n',
//             ) +
//             '\r\n' +
//             mSections.join('\r\n') +
//             '\r\n';

//         console.log('[ChatHeading] Setting remote description (manual SDP)...');
//         console.log('[ChatHeading] SDP preview:\n', remoteSdp);

//         this.pc
//             .setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp: remoteSdp }))
//             .then(() => {
//                 console.log('%c ✅ BUNDLE accepted! Remote description SET. ', 'color: white; background: green;');
//                 console.log('[ChatHeading] pc signaling state after SRD:', this.pc.signalingState);
//                 console.log('[ChatHeading] Queued candidates to flush:', this.iceCandidatesQueue.length);
//                 while (this.iceCandidatesQueue.length > 0) {
//                     const cand = this.iceCandidatesQueue.shift();
//                     this.pc
//                         .addIceCandidate(cand)
//                         .then(() => console.log('[ChatHeading] Flushed candidate OK'))
//                         .catch((e) => console.warn('[ChatHeading] Flush candidate failed:', e));
//                 }
//             })
//             .catch((err) => {
//                 console.error('[ChatHeading] SDP finalize FAILED:', err);
//                 console.log('[ChatHeading] DUMP SDP FOR DEBUG:\n', remoteSdp);
//                 console.log('[ChatHeading] Offer mids were:', offerMids);
//             });
//     }

//     handleIncomingCandidates(jingle) {
//         const candidateElems = sizzle('candidate', jingle);

//         candidateElems.forEach((el) => {
//             const foundation = el.getAttribute('foundation');
//             const component = el.getAttribute('component') || '1';
//             const protocol = el.getAttribute('protocol') || 'udp';
//             const priority = el.getAttribute('priority');
//             const ip = el.getAttribute('ip');
//             const port = el.getAttribute('port');
//             const type = el.getAttribute('type') || 'host';

//             const candidateStr = `candidate:${foundation} ${component} ${protocol} ${priority} ${ip} ${port} typ ${type}`;
//             console.log('[ChatHeading] Incoming remote candidate:', candidateStr);

//             const iceCandidate = new RTCIceCandidate({
//                 candidate: candidateStr,
//                 sdpMid: '0',
//                 sdpMLineIndex: 0,
//             });

//             if (this.pc && this.pc.remoteDescription && this.pc.remoteDescription.type) {
//                 this.pc.addIceCandidate(iceCandidate).catch((e) => console.warn('AddIceCandidate error:', e));
//             } else {
//                 console.log('[ChatHeading] PC not ready, queuing candidate');
//                 this.iceCandidatesQueue.push(iceCandidate);
//             }
//         });
//     }

//     terminateCall(sendTerminate = true) {
//         // Send session-terminate + JMI <finish> if we still have an active call
//         if (sendTerminate && this.remoteFullJid && this.currentSid) {
//             const sid = this.currentSid;
//             const remote = this.remoteFullJid;
//             console.log('[ChatHeading] Sending session-terminate + finish to', remote);

//             // Jingle session-terminate IQ — fire-and-forget, no timeout
//             try {
//                 const terminateIq = $iq({ type: 'set', to: remote, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', {
//                         xmlns: NS_JINGLE,
//                         action: 'session-terminate',
//                         sid: sid,
//                     })
//                     .c('reason')
//                     .c('success');
//                 api.send(terminateIq);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not send session-terminate:', e);
//             }

//             // JMI <finish> message (Sonata extension — iOS/Android use this)
//             try {
//                 const bareRemote = remote.split('/')[0];
//                 const finishMsg = $msg({ to: bareRemote, type: 'chat', id: crypto.randomUUID() })
//                     .c('finish', { xmlns: NS_JINGLE_MSG, id: sid })
//                     .c('reason', { xmlns: NS_JINGLE })
//                     .c('success')
//                     .up()
//                     .up()
//                     .up()
//                     .c('store', { xmlns: 'urn:xmpp:hints' });
//                 api.send(finishMsg);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not send finish:', e);
//             }
//         }

//         if (this.pc) {
//             console.log('[ChatHeading] Closing PeerConnection');
//             this.pc.close();
//             this.pc = null;
//         }
//         if (this.localStream) {
//             this.localStream.getTracks().forEach((t) => t.stop());
//             this.localStream = null;
//         }
//         const el = document.getElementById('sonata-audio-remote');
//         if (el) el.srcObject = null;
//         this.currentSid = null;
//         this.isIncoming = false;
//         this.remoteFullJid = null;
//         if (ChatHeading.activeCall === this) {
//             ChatHeading.activeCall = null;
//         }
//         ChatHeading._hideCallPanel();
//         console.log('=== [ChatHeading] Call terminated ===');
//     }

//     // ========================================================================
//     // INCOMING CALL HANDLING (callee side)
//     // ========================================================================

//     /**
//      * Static: called when <propose> arrives. Shows modal asking user to accept
//      * or reject. If accepted, picks the matching ChatHeading instance (by JID)
//      * and runs accept flow. If no chat is open for that contact, falls back to
//      * using/creating a chat first.
//      */
//     static async handleIncomingPropose(fullFromJid, sid, media) {
//         const bareFrom = fullFromJid?.split('/')[0];

//         // Resolve display name — same approach as the call panel and ChatHeading template.
//         // Try roster contact first, then chatbox model, then fall back to bare JID.
//         let displayName = bareFrom;
//         try {
//             const contact = await api.contacts.get(bareFrom);
//             if (contact) {
//                 displayName = contact.get('nickname') || contact.get('fullname') || contact.get('name') || bareFrom;
//             }
//             // Also try an open chatbox model in case vcard is loaded there
//             if (displayName === bareFrom) {
//                 const chatbox = _converse.state?.chatboxes?.get(bareFrom);
//                 if (chatbox) {
//                     const fromModel = chatbox.getDisplayName?.();
//                     if (fromModel && fromModel !== bareFrom) displayName = fromModel;
//                 }
//             }
//         } catch (e) {
//             // non-fatal — fall back to bare JID
//         }

//         // If there's already an active call, ask the user.
//         if (ChatHeading.activeCall) {
//             const confirmed = window.confirm(
//                 `Вхідний дзвінок від ${bareFrom}. У вас вже триває розмова. Завершити поточну та прийняти новий?`,
//             );
//             if (!confirmed) {
//                 // Auto-reject the new call
//                 ChatHeading._sendJmiReject(fullFromJid, sid);
//                 return;
//             }
//             // Terminate the current call before accepting new
//             ChatHeading.activeCall.terminateCall();
//         }

//         // Track this pending incoming call so <retract> can cancel its modal.
//         ChatHeading._pendingIncomingSid = sid;
//         ChatHeading._pendingIncomingFrom = fullFromJid;

//         const accepted = await ChatHeading._showIncomingCallModal(displayName, fullFromJid, sid, media);

//         // Clear pending tracking
//         if (ChatHeading._pendingIncomingSid === sid) {
//             ChatHeading._pendingIncomingSid = null;
//             ChatHeading._pendingIncomingFrom = null;
//         }

//         if (!accepted) {
//             console.log('[ChatHeading] User rejected incoming call');
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         console.log('[ChatHeading] User accepted incoming call. Finding chat heading...');

//         // Find existing ChatHeading instance for this contact, or open a chat first.
//         let headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);
//         if (!headingEl) {
//             console.log('[ChatHeading] No open chat for', bareFrom, '— opening one');
//             try {
//                 await api.chats.open(bareFrom);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not open chat:', e);
//             }
//             // Wait a tick for the heading element to render
//             await new Promise((r) => setTimeout(r, 200));
//             headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);
//         }

//         if (!headingEl) {
//             console.error('[ChatHeading] Could not find/create chat heading for', bareFrom);
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         await headingEl.acceptIncomingCall(fullFromJid, sid, media);
//     }

//     /**
//      * Static: <retract> arrived — caller cancelled before we picked up.
//      * Close the modal if it's showing for this sid.
//      */
//     static handleRetract(sid) {
//         if (ChatHeading._pendingIncomingSid === sid && ChatHeading._closeIncomingModal) {
//             console.log('[ChatHeading] Closing incoming-call modal (caller retracted)');
//             ChatHeading._closeIncomingModal(false);
//         }
//     }

//     /**
//      * Static helper: send JMI <reject> message.
//      */
//     static _sendJmiReject(toFullJid, sid) {
//         const bareJid = toFullJid?.split('/')[0];
//         const msg = $msg({ to: bareJid, type: 'chat', id: crypto.randomUUID() })
//             .c('reject', { xmlns: NS_JINGLE_MSG, id: sid })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' });
//         api.send(msg);
//         console.log('[ChatHeading] Sent JMI reject for sid', sid);
//     }

//     /**
//      * Static: builds the incoming-call modal. Returns a Promise<boolean>:
//      * true=accepted, false=rejected/closed.
//      */
//     static _showIncomingCallModal(callerName, fullFromJid, sid, media) {
//         return new Promise((resolve) => {
//             // Inject CSS once
//             if (!document.getElementById('sonata-incall-style')) {
//                 const style = document.createElement('style');
//                 style.id = 'sonata-incall-style';
//                 style.textContent = `
//                     .sonata-incall-overlay {
//                         position: fixed; inset: 0; z-index: 99999;
//                         background: rgba(0,0,0,0.55);
//                         display: flex; align-items: center; justify-content: center;
//                         font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     }
//                     .sonata-incall-card {
//                         background: #fff; border-radius: 16px; padding: 28px 32px;
//                         min-width: 320px; max-width: 90vw; text-align: center;
//                         box-shadow: 0 20px 60px rgba(0,0,0,0.4);
//                         animation: sonata-incall-pop 0.25s ease-out;
//                     }
//                     @keyframes sonata-incall-pop {
//                         from { transform: scale(0.85); opacity: 0; }
//                         to { transform: scale(1); opacity: 1; }
//                     }
//                     .sonata-incall-icon {
//                         font-size: 48px; margin-bottom: 12px;
//                         animation: sonata-incall-ring 1s ease-in-out infinite;
//                     }
//                     @keyframes sonata-incall-ring {
//                         0%, 100% { transform: rotate(0); }
//                         25% { transform: rotate(-15deg); }
//                         75% { transform: rotate(15deg); }
//                     }
//                     .sonata-incall-name {
//                         font-size: 20px; font-weight: 600; color: #222; margin-bottom: 4px;
//                     }
//                     .sonata-incall-sub {
//                         font-size: 13px; color: #888; margin-bottom: 24px;
//                     }
//                     .sonata-incall-actions {
//                         display: flex; gap: 16px; justify-content: center;
//                     }
//                     .sonata-incall-btn {
//                         border: none; border-radius: 50%; width: 56px; height: 56px;
//                         font-size: 22px; cursor: pointer; color: white;
//                         display: inline-flex; align-items: center; justify-content: center;
//                         transition: transform 0.15s;
//                     }
//                     .sonata-incall-btn:hover { transform: scale(1.08); }
//                     .sonata-incall-btn.accept { background: #1e9652; }
//                     .sonata-incall-btn.reject { background: #d33; }
//                 `;
//                 document.head.appendChild(style);
//             }

//             const overlay = document.createElement('div');
//             overlay.className = 'sonata-incall-overlay';
//             overlay.innerHTML = `
//                 <div class="sonata-incall-card">
//                     <div class="sonata-incall-icon">📞</div>
//                     <div class="sonata-incall-name">${callerName}</div>
//                     <div class="sonata-incall-sub">Вхідний ${media === 'video' ? 'відео' : 'аудіо'} дзвінок</div>
//                     <div class="sonata-incall-actions">
//                         <button class="sonata-incall-btn reject" title="Відхилити">✕</button>
//                         <button class="sonata-incall-btn accept" title="Прийняти">✓</button>
//                     </div>
//                 </div>
//             `;
//             document.body.appendChild(overlay);

//             // Play ringtone via Web Audio (simple beeping). Skip if AudioContext unavailable.
//             let ringInterval = null;
//             try {
//                 const ctx = new (window.AudioContext || window.webkitAudioContext)();
//                 const beep = () => {
//                     const osc = ctx.createOscillator();
//                     const gain = ctx.createGain();
//                     osc.frequency.value = 480;
//                     gain.gain.value = 0.08;
//                     osc.connect(gain).connect(ctx.destination);
//                     osc.start();
//                     setTimeout(() => osc.stop(), 400);
//                 };
//                 beep();
//                 ringInterval = setInterval(beep, 1500);
//             } catch (e) {
//                 /* no-op */
//             }

//             const cleanup = (result) => {
//                 if (ringInterval) clearInterval(ringInterval);
//                 if (overlay.parentElement) overlay.parentElement.removeChild(overlay);
//                 ChatHeading._closeIncomingModal = null;
//                 resolve(result);
//             };

//             // Expose closer so retract can cancel the modal externally
//             ChatHeading._closeIncomingModal = cleanup;

//             overlay.querySelector('.accept').addEventListener('click', () => cleanup(true));
//             overlay.querySelector('.reject').addEventListener('click', () => cleanup(false));

//             // Auto-reject after 45s (typical ring timeout)
//             setTimeout(() => {
//                 if (overlay.parentElement) cleanup(false);
//             }, 45000);
//         });
//     }

//     /**
//      * Instance: user accepted the incoming-call modal. Pre-warm mic, send
//      * <proceed>, mark this instance as the active call, and wait for the
//      * remote's session-initiate.
//      */
//     async acceptIncomingCall(fullFromJid, sid, media) {
//         console.log('[ChatHeading] >>> acceptIncomingCall', { fullFromJid, sid, media });

//         // Pre-warm microphone BEFORE sending <proceed>.
//         // If we send proceed first, the caller immediately sends session-initiate.
//         // getUserMedia prompt can take seconds on first use — causing session-initiate
//         // to arrive before pc is created. Get mic first, then proceed.
//         const needsVideo = media === 'video';
//         try {
//             console.log(
//                 `[ChatHeading] Pre-warming media (audio${needsVideo ? '+video' : ''}) before sending proceed...`,
//             );
//             this.localStream = await navigator.mediaDevices.getUserMedia({
//                 audio: true,
//                 video: needsVideo,
//             });
//             console.log(
//                 '[ChatHeading] Media ready for incoming call, tracks:',
//                 this.localStream.getTracks().map((t) => t.kind),
//             );
//         } catch (err) {
//             console.error('[ChatHeading] Media permission denied for incoming call:', err);
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         this.isIncoming = true;
//         this.isVideo = needsVideo;
//         this.remoteFullJid = fullFromJid;
//         this.currentSid = sid;
//         ChatHeading.activeCall = this;

//         // Send JMI <proceed> to the caller's FULL JID (including resource).
//         // The original propose came from their full JID — we must reply to it.
//         // Sending to bare JID means the server can't route session-initiate back
//         // to us because the caller doesn't know which resource accepted.
//         const proceedId = crypto.randomUUID();
//         const proceedMsg = $msg({ to: fullFromJid, type: 'chat', id: proceedId })
//             .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: proceedId })
//             .up()
//             .c('proceed', { xmlns: NS_JINGLE_MSG, id: sid })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' });
//         api.send(proceedMsg);
//         console.log(
//             '[ChatHeading] Sent JMI proceed sid=',
//             sid,
//             'to FULL JID=',
//             fullFromJid,
//             '| our full JID:',
//             _converse.jid,
//         );

//         this.model?.createMessage({ message: '📞 Вхідний виклик прийнято', type: 'info' });
//         // Now we wait for session-initiate via the Strophe handler → handleSessionInitiate().
//     }

//     /**
//      * Instance: <session-initiate> arrived from remote (caller). We are the
//      * callee. Create pc, add tracks, set remote offer SDP, create answer,
//      * send session-accept.
//      */
//     async handleSessionInitiate(fullFromJid, sid, remoteData) {
//         console.log('[ChatHeading] >>> handleSessionInitiate', { fullFromJid, sid, remoteData });
//         this.iceCandidatesQueue = [];
//         this.isVideo = !!remoteData.hasVideo;

//         try {
//             if (!this.localStream) {
//                 console.log('[ChatHeading] No stream yet, getting now (isVideo:', this.isVideo, ')...');
//                 this.localStream = await navigator.mediaDevices.getUserMedia({
//                     audio: true,
//                     video: this.isVideo,
//                 });
//             }

//             const iceServers2 = await ChatHeading._getIceServers();
//             this.pc = new RTCPeerConnection({
//                 iceServers: iceServers2,
//                 bundlePolicy: 'max-bundle',
//                 rtcpMuxPolicy: 'require',
//             });

//             this.pc.oniceconnectionstatechange = () => {
//                 console.log(`%c [ICE] state=${this.pc.iceConnectionState} `, 'color: orange; font-weight: bold;');
//                 if (this.pc.iceConnectionState === 'connected') {
//                     console.log('%c [ICE] ✅ CONNECTED (incoming) ', 'background: green; color: white;');
//                     ChatHeading._showCallPanel(this);
//                     // Request keyframe from remote video sender so Chrome can start decoding.
//                     // Without a keyframe, readyState stays 0 even when packets arrive.
//                     ChatHeading._requestKeyframeAndPollVideo(this.pc);
//                 }
//             };
//             this.pc.onconnectionstatechange = () => console.log(`[PC] connectionState=${this.pc.connectionState}`);
//             this.pc.onsignalingstatechange = () => console.log(`[PC] signalingState=${this.pc.signalingState}`);

//             this.pc.ontrack = (event) => {
//                 console.log('[ChatHeading] Remote track received (incoming) kind=', event.track.kind);
//                 if (event.track.kind === 'audio') {
//                     let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
//                     el.id = 'sonata-audio-remote';
//                     el.autoplay = true;
//                     if (!el.parentElement) document.body.appendChild(el);
//                     el.srcObject = event.streams[0];
//                 } else if (event.track.kind === 'video') {
//                     ChatHeading._attachRemoteVideo(event.streams[0]);
//                 }
//             };

//             this.pc.onicecandidate = (event) => {
//                 if (event.candidate) {
//                     const c = event.candidate;
//                     // Read ufrag/pwd from our local description (set after createAnswer)
//                     const localSdp = this.pc.localDescription?.sdp || '';
//                     const localUfrag = (localSdp.match(/a=ice-ufrag:(.*)\r/) || [])[1] || '';
//                     const localPwd = (localSdp.match(/a=ice-pwd:(.*)\r/) || [])[1] || '';
//                     const attrs = {
//                         id: String(Math.floor(Math.random() * 4294967295)),
//                         component: String(c.component || 1),
//                         foundation: c.foundation,
//                         generation: '0',
//                         ip: c.address || c.ip,
//                         port: String(c.port),
//                         priority: String(c.priority),
//                         protocol: (c.protocol || 'udp').toLowerCase(),
//                         type: c.type,
//                     };
//                     if (c.relatedAddress) attrs['rel-addr'] = c.relatedAddress;
//                     if (c.relatedPort) attrs['rel-port'] = String(c.relatedPort);
//                     const iq = $iq({ type: 'set', to: fullFromJid, id: crypto.randomUUID().toLowerCase() })
//                         .c('jingle', {
//                             xmlns: NS_JINGLE,
//                             action: 'transport-info',
//                             initiator: fullFromJid,
//                             responder: _converse.jid,
//                             sid,
//                         })
//                         .c('content', { creator: 'initiator', name: '0' })
//                         .c('transport', { xmlns: NS_JINGLE_ICE, ufrag: localUfrag, pwd: localPwd })
//                         .c('candidate', attrs);
//                     api.send(iq); // fire-and-forget, no timeout
//                 }
//             };

//             this.localStream.getTracks().forEach((t) => this.pc.addTrack(t, this.localStream));

//             // Build video payload lines from what the caller offered.
//             // Filter out RTX/FEC codecs (rtx, red, ulpfec) — they require companion
//             // a=fmtp:X apt=Y lines that Jingle doesn't carry, so Chrome rejects the
//             // SDP with "Failed to set remote video description send parameters".
//             const SKIP_CODECS = new Set(['rtx', 'red', 'ulpfec', 'flexfec-03']);
//             const rawPayloads =
//                 remoteData.videoPayloads?.length > 0
//                     ? remoteData.videoPayloads
//                     : [
//                           { id: '97', name: 'H264', clockrate: '90000' },
//                           { id: '96', name: 'VP8', clockrate: '90000' },
//                       ];

//             const videoPayloads = rawPayloads.filter((p) => !SKIP_CODECS.has(p.name?.toLowerCase()));
//             // Ensure we have at least one codec
//             if (videoPayloads.length === 0) {
//                 videoPayloads.push({ id: '96', name: 'VP8', clockrate: '90000' });
//             }

//             const videoPtIds = videoPayloads.map((p) => p.id).join(' ');
//             const videoRtpmaps = [];
//             videoPayloads.forEach((p) => {
//                 videoRtpmaps.push(`a=rtpmap:${p.id} ${p.name}/${p.clockrate}`);
//                 if (p.fmtp) {
//                     // Normalize iOS non-standard fmtp parameter names
//                     let fmtp = p.fmtp
//                         .replace(/packetization_mode/g, 'packetization-mode')
//                         .replace(/level_asymmetry_allowed/g, 'level-asymmetry-allowed')
//                         .replace(/profile_level_id/g, 'profile-level-id')
//                         .replace(/=true/g, '=1')
//                         .replace(/=false/g, '=0');
//                     // Convert decimal profile-level-id to hex
//                     fmtp = fmtp.replace(/profile-level-id=(\d+)/g, (_, dec) => {
//                         const hex = parseInt(dec, 10).toString(16).padStart(6, '0');
//                         return `profile-level-id=${hex}`;
//                     });
//                     // Remove duplicate profile-level-id
//                     fmtp = fmtp.replace(/(profile-level-id=[0-9a-f]+);profile-level-id=[0-9a-f]+/gi, '$1');
//                     // CRITICAL: Replace iOS H264 level with Chrome-compatible level 3.1 (42e01f).
//                     // iOS sends level 4.1 (42e029, 640c29, etc.) but Chrome negotiates level 3.1.
//                     // level-asymmetry-allowed=1 means Chrome can still receive level 4.1 from iOS
//                     // even after negotiating 3.1, so video decoding works correctly.
//                     // Without this, profile mismatch causes readyState=0 (no frames decoded).
//                     fmtp = fmtp.replace(/profile-level-id=[0-9a-f]{4}([0-9a-f]{2})/gi, (_, level) => {
//                         // Preserve the profile bytes (first 4 hex chars), force level to 1f (3.1)
//                         // but only if level-asymmetry-allowed=1 is present
//                         return 'profile-level-id=42e01f';
//                     });
//                     console.log(`[ChatHeading] fmtp PT${p.id}: ${p.fmtp} → ${fmtp}`);
//                     videoRtpmaps.push(`a=fmtp:${p.id} ${fmtp}`);
//                 }
//             });

//             console.log('[ChatHeading] Using video payloads:', videoPayloads);

//             const lines = [
//                 'v=0',
//                 'o=- 1234567890 2 IN IP4 0.0.0.0',
//                 's=-',
//                 't=0 0',
//                 this.isVideo ? 'a=group:BUNDLE 0 1' : 'a=group:BUNDLE 0',
//                 'a=msid-semantic: WMS',
//                 'm=audio 9 RTP/SAVPF 111',
//                 'c=IN IP4 0.0.0.0',
//                 `a=ice-ufrag:${remoteData.ufrag}`,
//                 `a=ice-pwd:${remoteData.pwd}`,
//                 `a=fingerprint:sha-256 ${remoteData.fingerprint}`,
//                 `a=setup:${remoteData.setup || 'actpass'}`,
//                 'a=mid:0',
//                 'a=rtcp-mux',
//                 'a=rtpmap:111 opus/48000/2',
//                 'a=fmtp:111 minptime=10;useinbandfec=1',
//                 'a=sendrecv',
//             ];
//             if (this.isVideo) {
//                 lines.push(
//                     `m=video 9 RTP/SAVPF ${videoPtIds}`,
//                     'c=IN IP4 0.0.0.0',
//                     `a=ice-ufrag:${remoteData.ufrag}`,
//                     `a=ice-pwd:${remoteData.pwd}`,
//                     `a=fingerprint:sha-256 ${remoteData.fingerprint}`,
//                     `a=setup:${remoteData.setup || 'actpass'}`,
//                     'a=mid:1',
//                     'a=rtcp-mux',
//                     ...videoRtpmaps,
//                     'a=sendrecv',
//                 );
//             }
//             const remoteOfferSdp = lines.join('\r\n') + '\r\n';

//             console.log('[ChatHeading] Setting remote OFFER...\n', remoteOfferSdp);
//             await this.pc.setRemoteDescription(new RTCSessionDescription({ type: 'offer', sdp: remoteOfferSdp }));
//             const answer = await this.pc.createAnswer();
//             await this.pc.setLocalDescription(answer);
//             console.log('[ChatHeading] 📋 LOCAL ANSWER SDP:\n', this.pc.localDescription.sdp);

//             const sdp = this.pc.localDescription.sdp;
//             const ufrag = sdp.match(/a=ice-ufrag:(.*)\r/)[1];
//             const pwd = sdp.match(/a=ice-pwd:(.*)\r/)[1];
//             const fingerprint = sdp.match(/a=fingerprint:sha-256 (.*)\r/)[1];

//             while (this.iceCandidatesQueue.length > 0) {
//                 this.pc
//                     .addIceCandidate(this.iceCandidatesQueue.shift())
//                     .catch((e) => console.warn('Queued cand failed:', e));
//             }

//             // Build session-accept using the caller's video codecs
//             // Parse actual negotiated video codecs from our local answer SDP.
//             // The browser may drop codecs it doesn't support (e.g. H265), so we
//             // MUST use what the browser actually accepted, not the full caller list.
//             // Otherwise Android/iOS receive an accept with codecs our SDP doesn't
//             // have, causing "order of m-lines doesn't match".
//             const negotiatedVideoPayloads = [];
//             const answerLines = sdp.split('\n');
//             let inVideoSection = false;
//             for (const line of answerLines) {
//                 const l = line.trim();
//                 if (l.startsWith('m=video')) {
//                     inVideoSection = true;
//                     continue;
//                 }
//                 if (l.startsWith('m=') && inVideoSection) {
//                     inVideoSection = false;
//                     break;
//                 }
//                 if (inVideoSection && l.startsWith('a=rtpmap:')) {
//                     const m = l.match(/^a=rtpmap:(\d+) ([^/]+)\/(\d+)/);
//                     if (m) {
//                         const name = m[2];
//                         if (!['rtx', 'red', 'ulpfec', 'flexfec-03'].includes(name.toLowerCase())) {
//                             negotiatedVideoPayloads.push({ id: m[1], name, clockrate: m[3] });
//                         }
//                     }
//                 }
//             }
//             console.log('[ChatHeading] Negotiated video payloads for accept:', negotiatedVideoPayloads);

//             const finalVideoPayloads = negotiatedVideoPayloads.length > 0 ? negotiatedVideoPayloads : videoPayloads;

//             let acceptIq;
//             if (this.isVideo) {
//                 let desc = $iq({ type: 'set', to: fullFromJid, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', {
//                         xmlns: NS_JINGLE,
//                         action: 'session-accept',
//                         initiator: fullFromJid,
//                         responder: _converse.jid,
//                         sid,
//                     })
//                     .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                     .c('content', { name: '0' })
//                     .up()
//                     .c('content', { name: '1' })
//                     .up()
//                     .up()
//                     .c('content', { creator: 'initiator', name: '0' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                     .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                     .c('parameter', { name: 'minptime', value: '10' })
//                     .up()
//                     .c('parameter', { name: 'useinbandfec', value: '1' })
//                     .up()
//                     .up()
//                     .c('rtcp-mux')
//                     .up()
//                     .up()
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'active' })
//                     .t(fingerprint)
//                     .up()
//                     .up()
//                     .up()
//                     .c('content', { creator: 'initiator', name: '1' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'video' });

//                 // Use only what the browser actually negotiated
//                 finalVideoPayloads.forEach((p) =>
//                     desc.c('payload-type', { id: p.id, name: p.name, clockrate: p.clockrate }).up(),
//                 );

//                 desc = desc
//                     .c('rtcp-mux')
//                     .up()
//                     .up()
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'active' })
//                     .t(fingerprint)
//                     .up()
//                     .up()
//                     .up();

//                 acceptIq = desc;
//             } else {
//                 acceptIq = $iq({ type: 'set', to: fullFromJid, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', {
//                         xmlns: NS_JINGLE,
//                         action: 'session-accept',
//                         initiator: fullFromJid,
//                         responder: _converse.jid,
//                         sid,
//                     })
//                     .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                     .c('content', { name: '0' })
//                     .up()
//                     .up()
//                     .c('content', { creator: 'initiator', name: '0' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                     .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                     .c('parameter', { name: 'minptime', value: '10' })
//                     .up()
//                     .c('parameter', { name: 'useinbandfec', value: '1' })
//                     .up()
//                     .up()
//                     .c('rtcp-mux')
//                     .up()
//                     .up()
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'active' })
//                     .t(fingerprint)
//                     .up()
//                     .up()
//                     .up();
//             }

//             console.log('[ChatHeading] 📤 session-accept XML:\n', acceptIq.toString());
//             api.send(acceptIq);
//             console.log(
//                 '[ChatHeading] >>> handleSessionInitiate DONE (session-accept sent, isVideo:',
//                 this.isVideo,
//                 ')',
//             );
//         } catch (err) {
//             console.error('[ChatHeading] handleSessionInitiate error:', err);
//             console.error('[ChatHeading] Stack:', err?.stack);
//         }
//     }

//     // ========================================================================
//     // CALL PANEL UI
//     // ========================================================================

//     /**
//      * Static: show "calling..." panel while waiting for remote to answer.
//      * Replaced by _showCallPanel once ICE connects.
//      */
//     static _showOutgoingCallPanel(instance) {
//         ChatHeading._hideCallPanel();

//         if (!document.getElementById('sonata-callpanel-style')) {
//             // CSS will be injected by _showCallPanel when connected; inject minimal now
//             const style = document.createElement('style');
//             style.id = 'sonata-callpanel-style';
//             style.textContent = `
//                 .sonata-callpanel {
//                     position: fixed; top: 0; left: 50%; transform: translateX(-50%);
//                     z-index: 99998; background: #1a1a2e; color: #fff;
//                     border-radius: 0 0 24px 24px; padding: 12px 20px 14px 24px;
//                     display: flex; align-items: center; gap: 16px;
//                     box-shadow: 0 4px 24px rgba(0,0,0,0.45);
//                     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     animation: sonata-panel-slide 0.3s cubic-bezier(.22,.68,0,1.2);
//                     min-width: 260px;
//                 }
//                 @keyframes sonata-panel-slide {
//                     from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
//                     to   { opacity: 1; transform: translateX(-50%) translateY(0); }
//                 }
//                 .sonata-callpanel-dot {
//                     width: 10px; height: 10px; border-radius: 50%;
//                     background: #1e9652;
//                     box-shadow: 0 0 0 0 rgba(30,150,82,0.6);
//                     animation: sonata-dot-pulse 1.5s ease-out infinite;
//                     flex-shrink: 0;
//                 }
//                 @keyframes sonata-dot-pulse {
//                     0%   { box-shadow: 0 0 0 0 rgba(30,150,82,0.6); }
//                     70%  { box-shadow: 0 0 0 8px rgba(30,150,82,0); }
//                     100% { box-shadow: 0 0 0 0 rgba(30,150,82,0); }
//                 }
//                 .sonata-callpanel-info {
//                     display: flex; flex-direction: column; gap: 2px; flex: 1;
//                 }
//                 .sonata-callpanel-name {
//                     font-size: 14px; font-weight: 600; color: #fff;
//                     white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//                     max-width: 160px;
//                 }
//                 .sonata-callpanel-timer {
//                     font-size: 13px; color: #aaa; font-variant-numeric: tabular-nums;
//                     letter-spacing: 0.03em;
//                 }
//                 .sonata-callpanel-hangup {
//                     background: #e53935; border: none; border-radius: 50%;
//                     width: 40px; height: 40px; cursor: pointer; color: #fff;
//                     display: inline-flex; align-items: center; justify-content: center;
//                     font-size: 18px; flex-shrink: 0;
//                     transition: background 0.15s, transform 0.15s;
//                 }
//                 .sonata-callpanel-hangup:hover { background: #b71c1c; transform: scale(1.08); }
//             `;
//             document.head.appendChild(style);
//         }

//         const displayName = instance.model?.getDisplayName?.() || instance.model?.get('jid') || '...';

//         const panel = document.createElement('div');
//         panel.id = 'sonata-callpanel';
//         panel.className = 'sonata-callpanel';
//         panel.innerHTML = `
//             <div class="sonata-callpanel-dot" style="background:#f59e0b; box-shadow: 0 0 0 0 rgba(245,158,11,0.6);"></div>
//             <div class="sonata-callpanel-info">
//                 <div class="sonata-callpanel-name">${displayName}</div>
//                 <div class="sonata-callpanel-timer" id="sonata-callpanel-timer">Виклик...</div>
//             </div>
//             <button class="sonata-callpanel-hangup" title="Скасувати дзвінок">📵</button>
//         `;
//         document.body.appendChild(panel);

//         // Animated dots on "Виклик..."
//         const timerEl = panel.querySelector('#sonata-callpanel-timer');
//         let dots = 0;
//         ChatHeading._callTimerInterval = setInterval(() => {
//             dots = (dots + 1) % 4;
//             if (timerEl) timerEl.textContent = 'Виклик' + '.'.repeat(dots);
//         }, 600);

//         setTimeout(() => {
//             const btn = panel.querySelector('.sonata-callpanel-hangup');
//             if (btn)
//                 btn.addEventListener('click', () => {
//                     console.log('[ChatHeading] User cancelled outgoing call');
//                     const t = ChatHeading.activeCall;
//                     if (t) {
//                         const jid = t.model?.get('jid');
//                         if (jid && t.currentSid) {
//                             const retractMsg = $msg({ to: jid, type: 'chat', id: crypto.randomUUID() })
//                                 .c('retract', { xmlns: NS_JINGLE_MSG, id: t.currentSid })
//                                 .up()
//                                 .c('store', { xmlns: 'urn:xmpp:hints' });
//                             api.send(retractMsg);
//                             console.log('[ChatHeading] Sent JMI retract for sid', t.currentSid);
//                         }
//                         t.terminateCall(false);
//                     }
//                 });
//         }, 100);
//     }

//     /**
//      * Static: show active call panel with timer and hang-up button.
//      * Called when ICE reaches 'connected' state.
//      */
//     static _showCallPanel(instance) {
//         // Save any queued remote video stream before _hideCallPanel clears it
//         const savedRemoteStream = ChatHeading._pendingRemoteVideoStream;
//         ChatHeading._hideCallPanel();
//         // Restore it so PiP creation below can flush it
//         if (savedRemoteStream) {
//             ChatHeading._pendingRemoteVideoStream = savedRemoteStream;
//         }

//         if (!document.getElementById('sonata-callpanel-style')) {
//             const style = document.createElement('style');
//             style.id = 'sonata-callpanel-style';
//             style.textContent = `
//                 .sonata-callpanel {
//                     position: fixed; top: 0; left: 50%; transform: translateX(-50%);
//                     z-index: 99998; background: #1a1a2e; color: #fff;
//                     border-radius: 0 0 24px 24px; padding: 12px 20px 14px 24px;
//                     display: flex; align-items: center; gap: 16px;
//                     box-shadow: 0 4px 24px rgba(0,0,0,0.45);
//                     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     animation: sonata-panel-slide 0.3s cubic-bezier(.22,.68,0,1.2);
//                     min-width: 260px;
//                 }
//                 @keyframes sonata-panel-slide {
//                     from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
//                     to   { opacity: 1; transform: translateX(-50%) translateY(0); }
//                 }
//                 .sonata-callpanel-dot {
//                     width: 10px; height: 10px; border-radius: 50%; background: #1e9652;
//                     box-shadow: 0 0 0 0 rgba(30,150,82,0.6);
//                     animation: sonata-dot-pulse 1.5s ease-out infinite; flex-shrink: 0;
//                 }
//                 @keyframes sonata-dot-pulse {
//                     0%   { box-shadow: 0 0 0 0 rgba(30,150,82,0.6); }
//                     70%  { box-shadow: 0 0 0 8px rgba(30,150,82,0); }
//                     100% { box-shadow: 0 0 0 0 rgba(30,150,82,0); }
//                 }
//                 .sonata-callpanel-info { display: flex; flex-direction: column; gap: 2px; flex: 1; }
//                 .sonata-callpanel-name {
//                     font-size: 14px; font-weight: 600; color: #fff;
//                     white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 160px;
//                 }
//                 .sonata-callpanel-timer {
//                     font-size: 13px; color: #aaa; font-variant-numeric: tabular-nums; letter-spacing: 0.03em;
//                 }
//                 .sonata-callpanel-hangup {
//                     background: #e53935; border: none; border-radius: 50%;
//                     width: 40px; height: 40px; cursor: pointer; color: #fff;
//                     display: inline-flex; align-items: center; justify-content: center;
//                     font-size: 18px; flex-shrink: 0; transition: background 0.15s, transform 0.15s;
//                 }
//                 .sonata-callpanel-hangup:hover { background: #b71c1c; transform: scale(1.08); }
//             `;
//             document.head.appendChild(style);
//         }

//         const displayName = instance.model?.getDisplayName?.() || instance.remoteFullJid?.split('/')[0] || 'Unknown';

//         // Inject PiP CSS separately from panel CSS so it's not blocked
//         // by the outgoing call panel having already injected sonata-callpanel-style
//         if (instance.isVideo && !document.getElementById('sonata-pip-style')) {
//             const pipStyle = document.createElement('style');
//             pipStyle.id = 'sonata-pip-style';
//             pipStyle.textContent = `
//                 .sonata-video-pip {
//                     position: fixed !important; bottom: 24px !important; right: 24px !important;
//                     z-index: 999999 !important;
//                     width: 320px !important; height: 180px !important;
//                     border-radius: 16px; overflow: hidden;
//                     box-shadow: 0 8px 32px rgba(0,0,0,0.6);
//                     background: #111 !important;
//                     display: block !important; visibility: visible !important;
//                 }
//                 .sonata-video-pip video {
//                     display: block !important; visibility: visible !important;
//                 }
//                 .sonata-video-pip video#sonata-video-remote {
//                     position: absolute !important; inset: 0 !important;
//                     width: 100% !important; height: 100% !important;
//                     object-fit: cover; background: #222;
//                 }
//                 .sonata-video-pip video#sonata-video-local {
//                     position: absolute !important; bottom: 8px !important; right: 8px !important;
//                     width: 80px !important; height: 60px !important;
//                     border-radius: 8px; object-fit: cover;
//                     border: 2px solid rgba(255,255,255,0.8);
//                     background: #333; z-index: 1 !important;
//                 }
//             `;
//             document.head.appendChild(pipStyle);
//             console.log('[ChatHeading] PiP CSS injected ✅');
//         }

//         // Audio call panel (always shown at top)
//         const panel = document.createElement('div');
//         panel.id = 'sonata-callpanel';
//         panel.className = 'sonata-callpanel';
//         panel.innerHTML = `
//             <div class="sonata-callpanel-dot"></div>
//             <div class="sonata-callpanel-info">
//                 <div class="sonata-callpanel-name">${instance.isVideo ? '📹 ' : ''}${displayName}</div>
//                 <div class="sonata-callpanel-timer" id="sonata-callpanel-timer">00:00</div>
//             </div>
//             <button class="sonata-callpanel-hangup" title="Завершити дзвінок">📵</button>
//         `;
//         document.body.appendChild(panel);

//         // Video PiP overlay (only for video calls)
//         if (instance.isVideo) {
//             console.log('[ChatHeading] Creating video PiP overlay');
//             const pip = document.createElement('div');
//             pip.id = 'sonata-video-pip';
//             pip.className = 'sonata-video-pip';
//             pip.innerHTML = `
//                 <video id="sonata-video-remote" autoplay playsinline muted
//                     style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#222;display:block;visibility:visible;"></video>
//                 <video id="sonata-video-local" autoplay playsinline muted
//                     style="position:absolute;bottom:8px;right:8px;width:80px;height:60px;border-radius:8px;object-fit:cover;border:2px solid rgba(255,255,255,0.8);background:#333;z-index:1;display:block;visibility:visible;"></video>
//             `;
//             document.body.appendChild(pip);

//             // Attach local stream preview immediately
//             const localVid = pip.querySelector('#sonata-video-local');
//             if (instance.localStream) {
//                 localVid.srcObject = instance.localStream;
//                 console.log('[ChatHeading] Local video preview attached to PiP ✅');
//             } else {
//                 console.warn('[ChatHeading] No localStream available for PiP preview');
//             }

//             // Flush remote video stream if it arrived before PiP was created
//             if (ChatHeading._pendingRemoteVideoStream) {
//                 console.log('[ChatHeading] Flushing pending remote video stream to PiP ✅');
//                 const remoteVid = pip.querySelector('#sonata-video-remote');
//                 remoteVid.srcObject = ChatHeading._pendingRemoteVideoStream;
//                 ChatHeading._pendingRemoteVideoStream = null;
//                 // Diagnose after a short delay to let the element settle
//                 setTimeout(() => {
//                     const r = remoteVid.getBoundingClientRect();
//                     const cs = getComputedStyle(remoteVid);
//                     const pipR = pip.getBoundingClientRect();
//                     const pipCs = getComputedStyle(pip);
//                     console.log(
//                         `[VIDEO DEBUG] pip: ${pipR.width}x${pipR.height} at (${Math.round(pipR.left)},${Math.round(pipR.top)}) display=${pipCs.display} visibility=${pipCs.visibility} zIndex=${pipCs.zIndex}`,
//                     );
//                     console.log(
//                         `[VIDEO DEBUG] remote video: ${r.width}x${r.height} at (${Math.round(r.left)},${Math.round(r.top)}) display=${cs.display} visibility=${cs.visibility} readyState=${remoteVid.readyState} paused=${remoteVid.paused}`,
//                     );
//                     console.log(
//                         `[VIDEO DEBUG] remote video srcObject tracks:`,
//                         remoteVid.srcObject?.getTracks().map((t) => `${t.kind}:${t.readyState}`),
//                     );
//                     // Check if anything is covering the pip
//                     const topEl = document.elementFromPoint(pipR.left + pipR.width / 2, pipR.top + pipR.height / 2);
//                     console.log(
//                         `[VIDEO DEBUG] element at pip center:`,
//                         topEl?.id || topEl?.className || topEl?.tagName,
//                     );
//                     if (remoteVid.paused) {
//                         remoteVid
//                             .play()
//                             .then(() => console.log('[VIDEO DEBUG] play() succeeded after delay ✅'))
//                             .catch((e) => console.warn('[VIDEO DEBUG] play() still failed:', e));
//                     }
//                 }, 500);
//             }

//             // Make PiP draggable
//             let dragging = false,
//                 ox = 0,
//                 oy = 0;
//             pip.addEventListener('mousedown', (e) => {
//                 dragging = true;
//                 ox = e.clientX - pip.getBoundingClientRect().left;
//                 oy = e.clientY - pip.getBoundingClientRect().top;
//                 pip.style.transition = 'none';
//             });
//             document.addEventListener('mousemove', (e) => {
//                 if (!dragging) return;
//                 pip.style.right = 'auto';
//                 pip.style.bottom = 'auto';
//                 pip.style.left = `${e.clientX - ox}px`;
//                 pip.style.top = `${e.clientY - oy}px`;
//             });
//             document.addEventListener('mouseup', () => {
//                 dragging = false;
//             });
//         }

//         // Timer
//         let seconds = 0;
//         const timerEl = panel.querySelector('#sonata-callpanel-timer');
//         ChatHeading._callTimerInterval = setInterval(() => {
//             seconds++;
//             const m = String(Math.floor(seconds / 60)).padStart(2, '0');
//             const s = String(seconds % 60).padStart(2, '0');
//             if (timerEl) timerEl.textContent = `${m}:${s}`;
//         }, 1000);

//         // Defer click handler by one tick so the button can't receive
//         // a click event that was already in flight from the outgoing panel
//         // being replaced (which caused auto-terminate on ICE connect).
//         setTimeout(() => {
//             const btn = panel.querySelector('.sonata-callpanel-hangup');
//             if (btn)
//                 btn.addEventListener('click', () => {
//                     console.log('[ChatHeading] User clicked hang-up');
//                     const t = ChatHeading.activeCall;
//                     if (t) t.terminateCall(true);
//                 });
//         }, 100);
//     }

//     static _hideCallPanel() {
//         if (ChatHeading._callTimerInterval) {
//             clearInterval(ChatHeading._callTimerInterval);
//             ChatHeading._callTimerInterval = null;
//         }
//         ChatHeading._pendingRemoteVideoStream = null;
//         const panel = document.getElementById('sonata-callpanel');
//         if (panel) panel.parentElement?.removeChild(panel);
//         const pip = document.getElementById('sonata-video-pip');
//         if (pip) pip.parentElement?.removeChild(pip);
//         const pipStyle = document.getElementById('sonata-pip-style');
//         if (pipStyle) pipStyle.parentElement?.removeChild(pipStyle);
//     }

//     /**
//      * Static: attach remote video stream to the PiP overlay.
//      * Called from ontrack when a video track arrives.
//      */
//     static _attachRemoteVideo(stream) {
//         console.log('[ChatHeading] _attachRemoteVideo called, stream tracks:', stream?.getTracks().length);
//         if (stream) {
//             stream
//                 .getTracks()
//                 .forEach((t) =>
//                     console.log(
//                         `[ChatHeading] remote stream track: kind=${t.kind} enabled=${t.enabled} readyState=${t.readyState} muted=${t.muted}`,
//                     ),
//                 );
//         }
//         const pip = document.getElementById('sonata-video-pip');
//         if (!pip) {
//             console.warn('[ChatHeading] PiP not in DOM yet — queuing remote video stream');
//             ChatHeading._pendingRemoteVideoStream = stream;
//             return;
//         }
//         const vid = pip.querySelector('#sonata-video-remote');
//         vid.srcObject = stream;
//         vid.play()
//             .then(() => {
//                 console.log('[ChatHeading] Remote video playing ✅');
//                 setTimeout(() => {
//                     const r = vid.getBoundingClientRect();
//                     const cs = getComputedStyle(vid);
//                     const pipR = pip.getBoundingClientRect();
//                     console.log(
//                         `[VIDEO DEBUG] pip: ${pipR.width}x${pipR.height} at (${Math.round(pipR.left)},${Math.round(pipR.top)}) z=${getComputedStyle(pip).zIndex}`,
//                     );
//                     console.log(
//                         `[VIDEO DEBUG] video: ${r.width}x${r.height} display=${cs.display} visibility=${cs.visibility} readyState=${vid.readyState}`,
//                     );
//                 }, 300);
//             })
//             .catch((e) => {
//                 console.warn('[ChatHeading] Remote video play() failed:', e);
//             });
//         console.log('[ChatHeading] Remote video srcObject set ✅');
//     }

//     /**
//      * Static: attach local video preview to the PiP overlay local tile.
//      */
//     static _attachLocalVideo(stream) {
//         const pip = document.getElementById('sonata-video-pip');
//         if (pip) {
//             pip.querySelector('#sonata-video-local').srcObject = stream;
//         }
//     }

//     // ========================================================================
//     // END CALL PANEL UI
//     // ========================================================================

//     // ========================================================================
//     // END CALL LOGIC
//     // ========================================================================

//     /**
//      * Returns a list of objects which represent buttons for the chat's header.
//      * @emits _converse#getHeadingButtons
//      * @returns {Promise<Array.<import('./types').HeadingButtonAttributes>>}
//      */
//     async getHeadingButtons() {
//         const buttons = [
//             /** @type {import('./types').HeadingButtonAttributes} */
//             {
//                 a_class: 'show-user-details-modal',
//                 handler: /** @param {Event} ev */ (ev) => this.showUserDetailsModal(ev),
//                 i18n_text: __('Details'),
//                 i18n_title: __('See more information about this person'),
//                 icon_class: 'fa-id-card',
//                 name: 'details',
//                 standalone: false,
//             },
//         ];

//         const domain = _converse.session.get('domain');
//         if (domain && (await api.disco.supports(Strophe.NS.BLOCKING, domain))) {
//             const blocklist = await api.blocklist.get();
//             if (blocklist.get(this.model.get('jid'))) {
//                 buttons.push({
//                     a_class: 'unblock-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Unblock user'), [
//                             __('Are you sure you want to unblock this user?'),
//                         ]);
//                         if (result) {
//                             api.blocklist.remove(this.model.get('jid'));
//                         }
//                     },
//                     i18n_text: __('Unblock this user'),
//                     i18n_title: __('Allow this user to send you messages'),
//                     icon_class: 'fa-check',
//                     name: 'unblock',
//                     standalone: false,
//                 });
//             } else {
//                 buttons.push({
//                     a_class: 'block-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Block user'), [
//                             __(
//                                 'Are you sure you want to prevent %1$s from contacting you further?',
//                                 this.model.getDisplayName(),
//                             ),
//                         ]);
//                         if (result) {
//                             const jid = this.model.get('jid');
//                             api.blocklist.add(jid);
//                             api.contacts.remove(jid, true);
//                             this.model.close();
//                         }
//                     },
//                     i18n_text: __('Block this user'),
//                     i18n_title: __('Prevent this user from sending you any further messages'),
//                     icon_class: 'fa-trash',
//                     name: 'block',
//                     standalone: false,
//                 });
//             }
//         }

//         if (!api.settings.get('singleton')) {
//             buttons.push({
//                 a_class: 'close-chatbox-button',
//                 handler: /** @param {Event} ev */ (ev) => this.close(ev),
//                 i18n_text: __('Close'),
//                 i18n_title: __('Close and end this conversation'),
//                 icon_class: 'fa-times',
//                 name: 'close',
//                 standalone: api.settings.get('view_mode') === 'overlayed',
//             });
//         }
//         const { chatboxviews } = _converse.state;
//         const el = chatboxviews.get(this.getAttribute('jid'));
//         if (el) {
//             /**
//              * *Hook* which allows plugins to add more buttons to a chat's heading.
//              *
//              * Note: This hook is fired for both 1 on 1 chats and groupchats.
//              * If you only care about one, you need to add a check in your code.
//              *
//              * @event _converse#getHeadingButtons
//              * @param { HTMLElement } el
//              *      The `converse-chat` (or `converse-muc`) DOM element that represents the chat
//              * @param { Array.<import('./types').HeadingButtonAttributes> }
//              *      An array of the existing buttons. New buttons may be added,
//              *      and existing ones removed or modified.
//              * @example
//              *  api.listen.on('getHeadingButtons', (el, buttons) => {
//              *      buttons.push({
//              *          'i18n_title': __('Foo'),
//              *          'i18n_text': __('Foo Bar'),
//              *          'handler': ev => alert('Foo!'),
//              *          'a_class': 'toggle-foo',
//              *          'icon_class': 'fa-foo',
//              *          'name': 'foo'
//              *      });
//              *      return buttons;
//              *  });
//              */
//             return _converse.api.hook('getHeadingButtons', el, buttons);
//         } else {
//             return buttons; // Happens during tests
//         }
//     }
// }
//adndroid works both ways
// api.elements.define('converse-chat-heading', ChatHeading);
// import { _converse, api, converse } from '@converse/headless';
// import { CustomElement } from 'shared/components/element.js';
// import { __ } from 'i18n';
// import tplChatboxHead from './templates/chat-head.js';
// import 'shared/modals/user-details.js';

// import './styles/chat-head.scss';

// const { Strophe, $iq, $msg, sizzle } = converse.env;

// const NS_JINGLE = 'urn:xmpp:jingle:1';
// const NS_JINGLE_ICE = 'urn:xmpp:jingle:transports:ice-udp:1';
// const NS_JINGLE_RTP = 'urn:xmpp:jingle:apps:rtp:1';
// const NS_DTLS = 'urn:xmpp:jingle:apps:dtls:0';
// const NS_JINGLE_MSG = 'urn:xmpp:jingle-message:0';
// const NS_GROUPING = 'urn:xmpp:jingle:apps:grouping:0';

// const SKIP_RTP_CODECS = new Set([
//     'rtx',
//     'red',
//     'ulpfec',
//     'flexfec-03',
//     'telephone-event',
//     'cn',
//     'pcmu',
//     'pcma',
//     'g722',
// ]);

// // ─── SDP / Jingle helper functions ─────────────────────────────────────────

// function localName(el) {
//     return el?.localName || el?.nodeName?.split(':').pop();
// }
// function directChildren(el, name = null) {
//     return Array.from(el?.children || []).filter((c) => !name || localName(c) === name);
// }
// function firstDirectChild(el, name) {
//     return directChildren(el, name)[0] || null;
// }

// function getBrowserSupportedCodecNames(media) {
//     try {
//         const caps = RTCRtpReceiver.getCapabilities?.(media);
//         if (!caps?.codecs?.length) return null;
//         return new Set(caps.codecs.map((c) => c.mimeType?.split('/')[1]?.toLowerCase()).filter(Boolean));
//     } catch (e) {
//         return null;
//     }
// }

// function normalizeFmtpParam(name, value) {
//     const paramName = String(name || '')
//         .trim()
//         .replaceAll('_', '-');
//     let paramValue = value == null ? '' : String(value).trim();
//     if (paramValue === 'true') paramValue = '1';
//     if (paramValue === 'false') paramValue = '0';
//     // Decimal profile-level-id from iOS → hex (4382761 → 42e029)
//     if (paramName === 'profile-level-id' && /^\d+$/.test(paramValue)) {
//         paramValue = Number(paramValue).toString(16).padStart(6, '0').slice(-6);
//     }
//     // Force H264 level to 3.1 (42e01f) so Chrome decoder accepts the stream.
//     // level-asymmetry-allowed=1 means iOS can still send at level 4.1.
//     if (paramName === 'profile-level-id' && /^[0-9a-f]{6}$/i.test(paramValue)) {
//         paramValue = '42e01f';
//     }
//     return { name: paramName, value: paramValue };
// }

// function buildFmtpLine(payload) {
//     if (!payload.params?.length) return null;
//     const params = payload.params
//         .filter((p) => p.name && p.value != null && p.value !== '')
//         .map((p) => `${p.name}=${p.value}`);
//     if (!params.length) return null;
//     return `a=fmtp:${payload.id} ${params.join(';')}`;
// }

// function payloadsFromJingleDescription(description, media) {
//     const supported = getBrowserSupportedCodecNames(media);
//     const payloads = [];
//     for (const pt of directChildren(description, 'payload-type')) {
//         const id = pt.getAttribute('id');
//         const name = pt.getAttribute('name');
//         const clockrate = pt.getAttribute('clockrate') || (media === 'video' ? '90000' : '48000');
//         const channels = pt.getAttribute('channels');
//         if (!id || !name) continue;
//         const codec = name.toLowerCase();
//         if (SKIP_RTP_CODECS.has(codec)) continue;
//         if (codec === 'h265') continue;
//         if (supported && !supported.has(codec)) {
//             console.log('[SDP] Skipping unsupported codec:', media, name, id);
//             continue;
//         }
//         const paramsMap = new Map();
//         for (const param of directChildren(pt, 'parameter')) {
//             const rawName = param.getAttribute('name');
//             const rawValue = param.getAttribute('value');
//             if (!rawName) continue;
//             const normalized = normalizeFmtpParam(rawName, rawValue);
//             if (normalized.name) paramsMap.set(normalized.name, normalized.value);
//         }
//         payloads.push({
//             id,
//             name,
//             clockrate,
//             channels,
//             params: Array.from(paramsMap.entries()).map(([n, v]) => ({ name: n, value: v })),
//         });
//     }
//     return payloads;
// }

// function getJingleRtpContents(jingle) {
//     return directChildren(jingle, 'content').filter((c) => !!firstDirectChild(c, 'description'));
// }

// function getJingleBundleMids(jingle, contents) {
//     const group = firstDirectChild(jingle, 'group');
//     const mids = directChildren(group, 'content')
//         .map((c) => c.getAttribute('name'))
//         .filter(Boolean);
//     return mids.length ? mids : contents.map((c, i) => c.getAttribute('name') || String(i));
// }

// /**
//  * Build a WebRTC SDP string from a Jingle XML element.
//  * Works for both 'offer' (session-initiate) and 'answer' (session-accept).
//  */
// function buildSdpFromJingle(jingle, type = 'offer') {
//     const contents = getJingleRtpContents(jingle);
//     const bundleMids = getJingleBundleMids(jingle, contents);
//     const firstTransport = contents.map((c) => firstDirectChild(c, 'transport')).find(Boolean);
//     const firstFingerprint = firstTransport ? firstDirectChild(firstTransport, 'fingerprint') : null;

//     const sdpLines = [
//         'v=0',
//         'o=- 1234567890 2 IN IP4 0.0.0.0',
//         's=-',
//         't=0 0',
//         `a=group:BUNDLE ${bundleMids.join(' ')}`,
//         'a=msid-semantic: WMS',
//     ];

//     contents.forEach((content, index) => {
//         const mid = content.getAttribute('name') || String(index);
//         const description = firstDirectChild(content, 'description');
//         const media = description?.getAttribute('media');
//         if (!description || !media) return;

//         const payloads = payloadsFromJingleDescription(description, media);
//         const payloadIds = payloads.map((p) => p.id);
//         if (!payloadIds.length) {
//             console.warn('[SDP] No compatible payloads for', media, mid);
//             return;
//         }

//         const transport = firstDirectChild(content, 'transport') || firstTransport;
//         const fingerprintEl = firstDirectChild(transport, 'fingerprint') || firstFingerprint;
//         const ufrag = transport?.getAttribute('ufrag');
//         const pwd = transport?.getAttribute('pwd');
//         const fingerprint = fingerprintEl?.textContent?.trim();
//         const setup = fingerprintEl?.getAttribute('setup') || (type === 'answer' ? 'active' : 'actpass');

//         sdpLines.push(`m=${media} 9 UDP/TLS/RTP/SAVPF ${payloadIds.join(' ')}`, 'c=IN IP4 0.0.0.0');
//         if (ufrag) sdpLines.push(`a=ice-ufrag:${ufrag}`);
//         if (pwd) sdpLines.push(`a=ice-pwd:${pwd}`);
//         if (fingerprint) sdpLines.push(`a=fingerprint:sha-256 ${fingerprint}`);
//         sdpLines.push(`a=setup:${setup}`, `a=mid:${mid}`, 'a=rtcp-mux');

//         for (const payload of payloads) {
//             const ch = payload.channels ? `/${payload.channels}` : '';
//             sdpLines.push(`a=rtpmap:${payload.id} ${payload.name}/${payload.clockrate}${ch}`);
//             const fmtp = buildFmtpLine(payload);
//             if (fmtp) sdpLines.push(fmtp);
//         }
//         sdpLines.push('a=sendrecv');
//     });

//     return sdpLines.join('\r\n') + '\r\n';
// }

// function parseSdpSections(sdp) {
//     const rawLines = String(sdp || '')
//         .split(/\r?\n/)
//         .map((l) => l.trim())
//         .filter(Boolean);
//     const sessionLines = [];
//     const sections = [];
//     let current = null;
//     for (const line of rawLines) {
//         if (line.startsWith('m=')) {
//             current = {
//                 mLine: line,
//                 lines: [line],
//                 media: line.slice(2).split(/\s+/)[0],
//                 mid: null,
//                 payloadIds: line.split(/\s+/).slice(3),
//             };
//             sections.push(current);
//             continue;
//         }
//         if (!current) {
//             sessionLines.push(line);
//             continue;
//         }
//         current.lines.push(line);
//         if (line.startsWith('a=mid:')) current.mid = line.slice('a=mid:'.length).trim();
//     }
//     sections.forEach((s, i) => {
//         if (!s.mid) s.mid = String(i);
//     });
//     return { sessionLines, sections };
// }

// function getIceInfoFromSdpSection(section, sessionLines = []) {
//     const lines = [...(section?.lines || []), ...sessionLines];
//     const find = (re) => {
//         for (const l of lines) {
//             const m = l.match(re);
//             if (m) return m[1].trim();
//         }
//         return null;
//     };
//     return {
//         ufrag: find(/^a=ice-ufrag:(.+)$/),
//         pwd: find(/^a=ice-pwd:(.+)$/),
//         fingerprint: find(/^a=fingerprint:sha-256\s+(.+)$/),
//         setup: find(/^a=setup:(.+)$/),
//     };
// }

// function payloadsFromSdpSection(section) {
//     const rtpmapByPt = new Map();
//     const fmtpByPt = new Map();
//     for (const line of section.lines) {
//         let m = line.match(/^a=rtpmap:(\d+)\s+([^/]+)\/(\d+)(?:\/(\d+))?$/);
//         if (m) {
//             const [, id, name, clockrate, channels] = m;
//             rtpmapByPt.set(id, { id, name, clockrate, channels, params: [] });
//             continue;
//         }
//         m = line.match(/^a=fmtp:(\d+)\s+(.+)$/);
//         if (m) {
//             const [, id, rawFmtp] = m;
//             const params = rawFmtp
//                 .split(';')
//                 .map((p) => p.trim())
//                 .filter(Boolean)
//                 .map((p) => {
//                     const eq = p.indexOf('=');
//                     if (eq === -1) return null;
//                     return normalizeFmtpParam(p.slice(0, eq), p.slice(eq + 1));
//                 })
//                 .filter(Boolean);
//             fmtpByPt.set(id, params);
//         }
//     }
//     return section.payloadIds
//         .map((id) => {
//             const payload = rtpmapByPt.get(id);
//             if (!payload) return null;
//             const codec = payload.name.toLowerCase();
//             if (SKIP_RTP_CODECS.has(codec)) return null;
//             payload.params = fmtpByPt.get(id) || [];
//             return payload;
//         })
//         .filter(Boolean);
// }

// /**
//  * Build a Jingle IQ stanza from our local SDP (for session-initiate or session-accept).
//  */
// function buildJingleIqFromLocalSdp({
//     action,
//     to,
//     sid,
//     initiator,
//     responder,
//     localSdp,
//     contentCreatorsByMid = new Map(),
//     preferredMidOrder = null,
// }) {
//     const { sessionLines, sections } = parseSdpSections(localSdp);
//     let ordered = sections.filter((s) => s.media === 'audio' || s.media === 'video');
//     if (preferredMidOrder?.length) {
//         const byMid = new Map(ordered.map((s) => [s.mid, s]));
//         ordered = preferredMidOrder.map((mid) => byMid.get(mid)).filter(Boolean);
//     }
//     const iq = $iq({ type: 'set', to, id: crypto.randomUUID().toLowerCase() }).c('jingle', {
//         xmlns: NS_JINGLE,
//         action,
//         sid,
//         ...(initiator ? { initiator } : {}),
//         ...(responder ? { responder } : {}),
//     });
//     iq.c('group', { xmlns: NS_GROUPING, semantics: 'BUNDLE' });
//     for (const s of ordered) iq.c('content', { name: s.mid }).up();
//     iq.up();
//     for (const section of ordered) {
//         const creator = contentCreatorsByMid.get(section.mid) || 'initiator';
//         const ice = getIceInfoFromSdpSection(section, sessionLines);
//         const payloads = payloadsFromSdpSection(section);
//         iq.c('content', { creator, name: section.mid });
//         iq.c('description', { xmlns: NS_JINGLE_RTP, media: section.media });
//         for (const p of payloads) {
//             const attrs = { id: p.id, name: p.name, clockrate: p.clockrate };
//             if (p.channels) attrs.channels = p.channels;
//             iq.c('payload-type', attrs);
//             for (const param of p.params || []) {
//                 if (!param.name || param.value == null || param.value === '') continue;
//                 iq.c('parameter', { name: param.name, value: param.value }).up();
//             }
//             iq.up();
//         }
//         iq.c('rtcp-mux').up();
//         iq.up();
//         iq.c('transport', {
//             xmlns: NS_JINGLE_ICE,
//             ...(ice.ufrag ? { ufrag: ice.ufrag } : {}),
//             ...(ice.pwd ? { pwd: ice.pwd } : {}),
//         });
//         if (ice.fingerprint) {
//             iq.c('fingerprint', {
//                 xmlns: NS_DTLS,
//                 hash: 'sha-256',
//                 setup: ice.setup || (action === 'session-accept' ? 'active' : 'actpass'),
//             })
//                 .t(ice.fingerprint)
//                 .up();
//         }
//         iq.up();
//         iq.up();
//     }
//     return iq;
// }

// // ─── End SDP helpers ────────────────────────────────────────────────────────

// export default class ChatHeading extends CustomElement {
//     // Static reference to the ChatHeading instance that owns the active call.
//     // Incoming Jingle stanzas are routed here regardless of which instance's
//     // handler fires (every open chat registers its own handler).
//     static activeCall = null;

//     // Guard so the Strophe IQ handler and message listener are registered
//     // only ONCE, not per-instance. Multiple registrations cause Strophe to
//     // fire every handler per incoming stanza, breaking the pc state machine.
//     static _jingleHandlersRegistered = false;

//     // Tracks whether the Strophe-level IQ handler is currently attached.
//     // Separate from _jingleHandlersRegistered because connection lost / reconnect
//     // can detach the handler while the static-listener side stays put.
//     static _stropheHandlerAttached = false;

//     // Pending incoming call (showing modal). Used so <retract> can cancel the modal.
//     static _pendingIncomingSid = null;
//     static _pendingIncomingFrom = null;
//     // Callback set while modal is shown — call it to close the modal externally.
//     static _closeIncomingModal = null;

//     // Timer interval for the call panel
//     static _callTimerInterval = null;

//     // Remote video stream received before PiP was created — flushed in _showCallPanel
//     static _pendingRemoteVideoStream = null;

//     static _iceServersCache = null;
//     static _iceServersCacheExpiry = 0;

//     /**
//      * Request a keyframe from remote video senders and poll readyState.
//      * Chrome needs an IDR (keyframe) to start decoding H264. If iOS doesn't
//      * send one immediately, readyState stays 0 despite live tracks arriving.
//      */
//     static _requestKeyframeAndPollVideo(pc) {
//         if (!pc) return;
//         try {
//             pc.getReceivers().forEach((receiver) => {
//                 if (receiver.track?.kind === 'video') {
//                     console.log('[ChatHeading] Video receiver readyState:', receiver.track.readyState);
//                     if (typeof receiver.jitterBufferTarget !== 'undefined') {
//                         receiver.jitterBufferTarget = 0;
//                     }
//                 }
//             });
//         } catch (e) {
//             /* ignore */
//         }

//         let attempts = 0;
//         const poll = setInterval(async () => {
//             attempts++;
//             const vid = document.getElementById('sonata-video-remote');
//             if (!vid) {
//                 clearInterval(poll);
//                 return;
//             }
//             const rs = vid.readyState;
//             console.log(`[ChatHeading] Video poll ${attempts}: readyState=${rs} paused=${vid.paused}`);
//             if (rs >= 2) {
//                 console.log('%c [VIDEO] ✅ Playing! readyState=' + rs, 'background: green; color: white;');
//                 clearInterval(poll);
//                 return;
//             }
//             if (vid.paused && vid.srcObject) {
//                 vid.play().catch(() => {});
//             }
//             // At 2s: check RTP stats — are packets even arriving?
//             if (attempts === 4) {
//                 try {
//                     const stats = await pc.getStats();
//                     stats.forEach((report) => {
//                         if (report.type === 'inbound-rtp' && report.kind === 'video') {
//                             console.log(
//                                 `[VIDEO STATS] packetsReceived=${report.packetsReceived} framesReceived=${report.framesReceived || 0} framesDecoded=${report.framesDecoded || 0} framesDropped=${report.framesDropped || 0} decoderImpl=${report.decoderImplementation || '?'}`,
//                             );
//                         }
//                         if (report.type === 'codec' && report.mimeType?.toLowerCase().includes('h264')) {
//                             console.log(`[VIDEO STATS] codec: ${report.mimeType} fmtp=${report.sdpFmtpLine}`);
//                         }
//                     });
//                 } catch (e) {
//                     console.warn('[VIDEO STATS] getStats failed:', e.message);
//                 }
//             }
//             // Re-attach stream after 3s to force a new decoder init + keyframe request
//             if (attempts === 6 && rs === 0 && vid.srcObject) {
//                 console.warn('[ChatHeading] No frames after 3s — cycling srcObject to force keyframe');
//                 const stream = vid.srcObject;
//                 vid.srcObject = null;
//                 setTimeout(() => {
//                     vid.srcObject = stream;
//                     vid.play().catch(() => {});
//                 }, 150);
//             }
//             if (attempts >= 20) {
//                 clearInterval(poll);
//             }
//         }, 500);
//     }

//     /**
//      * Fetch ICE servers via XEP-0215 external service discovery.
//      * Queries the XMPP server (not the remote peer). Cached after first call.
//      */
//     static async _getIceServers() {
//         if (ChatHeading._iceServersCache && Date.now() < ChatHeading._iceServersCacheExpiry) {
//             return ChatHeading._iceServersCache;
//         }
//         const fallback = [{ urls: 'stun:stun.l.google.com:19302' }];
//         try {
//             // Always query our own server domain, never a peer JID
//             const domain =
//                 _converse.domain || (_converse.bare_jid || '').split('@')[1] || (_converse.jid || '').split('@')[1];
//             if (!domain) {
//                 console.warn('[ChatHeading] No domain for XEP-0215');
//                 return fallback;
//             }
//             console.log('[ChatHeading] Querying XEP-0215 TURN from domain:', domain);

//             let services = null;
//             for (const xmlns of ['urn:xmpp:extdisco:2', 'urn:xmpp:extdisco:1']) {
//                 try {
//                     const iq = $iq({ type: 'get', to: domain }).c('services', { xmlns });
//                     const result = await new Promise((resolve, reject) => {
//                         const timer = setTimeout(() => reject(new Error('timeout')), 5000);
//                         _converse.api
//                             .sendIQ(iq)
//                             .then((res) => {
//                                 clearTimeout(timer);
//                                 resolve(res);
//                             })
//                             .catch((err) => {
//                                 clearTimeout(timer);
//                                 reject(err);
//                             });
//                     });
//                     const found = result.querySelectorAll('service');
//                     if (found.length) {
//                         services = found;
//                         console.log(`[ChatHeading] XEP-0215 ${xmlns}: got ${found.length} services`);
//                         break;
//                     }
//                 } catch (e) {
//                     console.log(`[ChatHeading] XEP-0215 ${xmlns} failed:`, e.message);
//                 }
//             }

//             if (!services || !services.length) {
//                 console.warn('[ChatHeading] XEP-0215 returned no TURN services');
//                 ChatHeading._iceServersCache = fallback;
//                 return fallback;
//             }

//             const iceServers = [{ urls: 'stun:stun.l.google.com:19302' }];
//             services.forEach((svc) => {
//                 const type = svc.getAttribute('type');
//                 const host = svc.getAttribute('host');
//                 const port = svc.getAttribute('port');
//                 const user = svc.getAttribute('username');
//                 const pass = svc.getAttribute('password');
//                 const transport = svc.getAttribute('transport') || 'udp';
//                 if (!host) return;
//                 if (type === 'stun') {
//                     iceServers.push({ urls: `stun:${host}${port ? ':' + port : ''}` });
//                 } else if (type === 'turn') {
//                     const url = `turn:${host}${port ? ':' + port : ''}?transport=${transport}`;
//                     const entry = { urls: url };
//                     if (user) entry.username = user;
//                     if (pass) entry.credential = pass;
//                     iceServers.push(entry);
//                     console.log(`[ChatHeading] TURN: ${url} user=${user}`);
//                 }
//             });
//             console.log('[ChatHeading] ICE servers:', JSON.stringify(iceServers));
//             ChatHeading._iceServersCache = iceServers;
//             // TURN credentials expire at the timestamp in username (unix seconds).
//             // Refresh 5 minutes before expiry.
//             const turnEntry = iceServers.find((s) => s.urls?.startsWith?.('turn:') && s.username);
//             if (turnEntry) {
//                 const expireTs = parseInt(turnEntry.username.split(':')[0], 10) * 1000;
//                 ChatHeading._iceServersCacheExpiry = expireTs - 5 * 60 * 1000;
//             } else {
//                 ChatHeading._iceServersCacheExpiry = Date.now() + 3600 * 1000;
//             }
//             return iceServers;
//         } catch (e) {
//             console.warn('[ChatHeading] _getIceServers error:', e.message);
//             return fallback;
//         }
//     }

//     constructor() {
//         super();
//         this.jid = null;

//         // --- Call state (per-instance) ---
//         // NOTE: keeping these on the instance means every open chat has its own
//         // pc / localStream. If multiple chats are open and the user triggers
//         // calls in parallel, they won't interfere — but the *incoming* Jingle
//         // handlers below register once per ChatHeading instance, so every open
//         // chat will receive and try to handle every incoming Jingle stanza.
//         // That is the known bug we accepted.
//         this.pc = null;
//         this.localStream = null;
//         this.iceCandidatesQueue = [];
//         this.currentSid = null;
//         this.isIncoming = false;
//         this.remoteFullJid = null;
//         this.isVideo = false; // true when this is a video call
//     }

//     static get properties() {
//         return {
//             jid: { type: String },
//         };
//     }

//     initialize() {
//         const { chatboxes } = _converse.state;
//         this.model = chatboxes.get(this.jid);
//         this.listenTo(this.model, 'change:status', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:add', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:change', () => this.requestUpdate());
//         if (this.model.contact) {
//             this.listenTo(this.model.contact, 'destroy', () => this.requestUpdate());
//         }
//         this.model.rosterContactAdded?.then(() => {
//             this.listenTo(this.model.contact, 'change:nickname', () => this.requestUpdate());
//             this.requestUpdate();
//         });

//         // --- Wire up Jingle handlers on this instance ---
//         // BUG WARNING: registered per ChatHeading. With N open chats, every
//         // incoming Jingle IQ fires N times. Same for the 'message' (proceed)
//         // listener and the 'connected' event.
//         this._registerJingleHandlers();

//         this.requestUpdate();
//     }

//     render() {
//         return tplChatboxHead(this);
//     }

//     /**
//      * @param {Event} ev
//      */
//     showUserDetailsModal(ev) {
//         ev.preventDefault();
//         if (this.model?.contact instanceof _converse.exports.Profile) {
//             api.modal.show('converse-profile-modal', { model: this.model }, ev);
//         } else {
//             api.modal.show('converse-user-details-modal', { model: this.model }, ev);
//         }
//     }

//     /**
//      * @param {Event} ev
//      */
//     close(ev) {
//         ev.preventDefault();
//         this.model.close();
//     }

//     // ========================================================================
//     // CALL LOGIC (moved from sonata-p2p-init plugin)
//     // ========================================================================

//     _registerJingleHandlers() {
//         // Register the Strophe IQ handler and message listener EXACTLY ONCE
//         // across all ChatHeading instances. Without this guard, every open
//         // chat registers its own handler, and Strophe fires ALL of them per
//         // incoming stanza — resulting in N calls to setRemoteDescription /
//         // addIceCandidate on the same pc, which breaks the RTCPeerConnection
//         // state machine and ICE never completes.
//         if (ChatHeading._jingleHandlersRegistered) return;
//         ChatHeading._jingleHandlersRegistered = true;

//         console.log('=== [ChatHeading] Registering Jingle handlers (once globally) ===');

//         const self = this;

//         // Wait for Strophe connection, then attach raw IQ handler for Jingle.
//         // The plugin used `_converse.on('connected', ...)` which fires once at
//         // login. But ChatHeading.initialize() runs PER CHAT OPEN, which may be
//         // AFTER 'connected' has already fired (event missed). So we try all
//         // three paths: immediate (if connection exists), 'connected' listener,
//         // AND a polling fallback. Whichever wins, the static guard inside
//         // attach() prevents double-registration on Strophe.
//         const attach = () => {
//             if (ChatHeading._stropheHandlerAttached) return;
//             const connection = _converse.connection || api.connection?.get?.();
//             if (!connection || !connection.addHandler) {
//                 console.log('[ChatHeading] No Strophe connection yet, will retry');
//                 return false;
//             }

//             ChatHeading._stropheHandlerAttached = true;
//             console.log('[ChatHeading] ✓ Strophe Jingle IQ handler attached');

//             connection.addHandler(
//                 (stanza) => {
//                     const jingle = sizzle(`jingle[xmlns="${NS_JINGLE}"]`, stanza).pop();
//                     if (!jingle) return true;

//                     const action = jingle.getAttribute('action');
//                     const from = stanza.getAttribute('from');
//                     const id = stanza.getAttribute('id');
//                     const sid = jingle.getAttribute('sid');

//                     console.log(
//                         `%c [JINGLE RECEIVE] Action: ${action} from ${from} sid=${sid} `,
//                         'background: #222; color: #bada55; padding: 2px;',
//                     );

//                     // ACK the IQ immediately
//                     connection.send($iq({ type: 'result', to: from, id: id }).tree());

//                     const target = ChatHeading.activeCall;
//                     if (!target) {
//                         console.warn('[JINGLE RECEIVE] No active call; ignoring', action);
//                         return true;
//                     }
//                     if (!target.pc) {
//                         console.warn(
//                             '[JINGLE RECEIVE] Active call has no pc yet; action=' + action,
//                             '— may be timing issue',
//                         );
//                         // For transport-info we can queue. For session-initiate
//                         // (incoming call) we create the pc inside the handler.
//                         // For session-accept we can't do much without pc — skip.
//                         if (action === 'transport-info' || action === 'session-initiate') {
//                             // ok, let it through
//                         } else {
//                             return true;
//                         }
//                     }

//                     switch (action) {
//                         case 'session-initiate': {
//                             console.log('[JINGLE RECEIVE] session-initiate (we are callee)');
//                             // Pass raw jingle XML — handleSessionInitiate uses buildSdpFromJingle
//                             target.handleSessionInitiate(from, sid, jingle);
//                             break;
//                         }
//                         case 'session-accept': {
//                             // Pass raw jingle XML — handleSessionAccept uses buildSdpFromJingle
//                             target.handleSessionAccept(from, sid, jingle);
//                             break;
//                         }
//                         case 'transport-info':
//                             target.handleIncomingCandidates(jingle);
//                             break;
//                         case 'session-terminate':
//                             console.warn('[JINGLE RECEIVE] Remote terminated the call');
//                             console.warn('[JINGLE RECEIVE] session-terminate reason XML:', jingle.outerHTML);
//                             target.terminateCall(false);
//                             break;
//                         case 'session-info':
//                             // ringing / on_hold / etc — informational only
//                             console.log('[JINGLE RECEIVE] session-info (informational):', jingle.innerHTML);
//                             break;
//                         default:
//                             console.log('[JINGLE RECEIVE] Unhandled action:', action);
//                     }

//                     return true;
//                 },
//                 NS_JINGLE,
//                 'iq',
//                 'set',
//             );
//             return true;
//         };

//         // Path 1: connection already exists at registration time
//         if (_converse.connection && _converse.connection.addHandler) {
//             attach();
//         }

//         // Path 2: listen for 'connected' event (covers logout/reconnect cycles)
//         api.listen.on('connected', () => {
//             console.log('[ChatHeading] connected event fired');
//             ChatHeading._stropheHandlerAttached = false; // re-attach after reconnect
//             attach();
//         });

//         // Path 3: polling fallback. ChatHeading.initialize() may run AFTER
//         // 'connected' has already fired (because user opened a chat after
//         // login). In that case neither Path 1 nor Path 2 catches it. Poll
//         // until connection becomes available, then stop.
//         const pollInterval = setInterval(() => {
//             if (ChatHeading._stropheHandlerAttached) {
//                 clearInterval(pollInterval);
//                 return;
//             }
//             if (attach()) {
//                 clearInterval(pollInterval);
//             }
//         }, 500);
//         // Stop polling after 30s no matter what to avoid leaks
//         setTimeout(() => clearInterval(pollInterval), 30000);

//         // Listen for Jingle Message Initiation on regular messages:
//         //   <propose> — incoming call (we are callee)
//         //   <retract> — caller cancelled before we picked up
//         //   <proceed> — callee accepted our call (we are caller)
//         //   <ringing>, <received>, <reject>, <accept> — info
//         _converse.on('message', (data) => {
//             const stanza = data.stanza;
//             const from = stanza.getAttribute('from');
//             const bare_jid = _converse.bare_jid;
//             const fromBare = from?.split('/')[0];

//             // Ignore our own carbons (echoes of stanzas we sent)
//             const isOwnCarbon = fromBare === bare_jid;

//             // Look for any JMI element
//             const propose = sizzle(`propose[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const retract = sizzle(`retract[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const proceed = sizzle(`proceed[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const ringing = sizzle(`ringing[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const received = sizzle(`received[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const reject = sizzle(`reject[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const accept = sizzle(`accept[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();

//             // --- INCOMING CALL: <propose> ---
//             if (propose && !isOwnCarbon) {
//                 const sid = propose.getAttribute('id');
//                 const description = sizzle('description', propose).pop();
//                 const media = description?.getAttribute('media') || 'audio';
//                 console.log(
//                     `%c [JMI INCOMING] propose from ${from} sid=${sid} media=${media} `,
//                     'background: #1e9652; color: white; padding: 2px;',
//                 );
//                 ChatHeading.handleIncomingPropose(from, sid, media);
//                 return;
//             }

//             // --- CALLER CANCELLED: <retract> ---
//             if (retract && !isOwnCarbon) {
//                 const sid = retract.getAttribute('id');
//                 console.warn(`[JMI INCOMING] retract from ${from} sid=${sid} (caller cancelled)`);
//                 ChatHeading.handleRetract(sid);
//                 return;
//             }

//             // --- CALL ENDED BY REMOTE: <finish> (XEP-0272 / Sonata extension) ---
//             const finish = sizzle(`finish[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             if (finish && !isOwnCarbon) {
//                 const sid = finish.getAttribute('id');
//                 console.warn(`[JMI] finish from ${from} sid=${sid} — remote ended call`);
//                 const t = ChatHeading.activeCall;
//                 if (t) t.terminateCall(false); // remote already ended, don't echo
//                 return;
//             }

//             if (ringing) {
//                 console.log('[JMI] ringing from', from);
//                 return;
//             }
//             if (received) {
//                 console.log('[JMI] received (delivery ack) from', from);
//                 return;
//             }
//             if (reject) {
//                 console.warn('[JMI] reject from', from, '— remote declined');
//                 const t = ChatHeading.activeCall;
//                 if (t) t.terminateCall(false);
//                 return;
//             }
//             if (accept) {
//                 console.log('[JMI] accept seen (carbon echo from another device)');
//                 return;
//             }

//             // --- OUR OUTGOING CALL WAS ACCEPTED: <proceed> ---
//             if (proceed) {
//                 console.log('=== [JMI] proceed from', from, '===');
//                 const target = ChatHeading.activeCall;
//                 if (!target) {
//                     console.warn('[ChatHeading] proceed received but no active call');
//                     return;
//                 }
//                 if (target.pc) {
//                     console.log('[ChatHeading] Already have pc, ignoring duplicate proceed');
//                     return;
//                 }
//                 console.log('=== [ChatHeading] Starting WebRTC (sendJingleInitiate) ===');
//                 const sid = proceed.getAttribute('id');
//                 target.sendJingleInitiate(from, sid);
//             }
//         });
//     }

//     /**
//      * Called from chat-head.js template buttons.
//      * @param {'audio'|'video'} media
//      */
//     async initiateCall(media = 'audio') {
//         if (!this.model) {
//             console.warn('[ChatHeading] No model, cannot initiate call');
//             return;
//         }

//         this.isVideo = media === 'video';

//         // Pre-warm media BEFORE sending <propose>.
//         try {
//             console.log(`[ChatHeading] Pre-warming media (${media})...`);
//             this.localStream = await navigator.mediaDevices.getUserMedia({
//                 audio: true,
//                 video: this.isVideo,
//             });
//         } catch (err) {
//             console.error('[ChatHeading] Media permission denied / unavailable:', err);
//             this.model.createMessage({
//                 message: `❌ Не вдалося отримати доступ до ${this.isVideo ? 'камери/мікрофона' : 'мікрофона'}`,
//                 type: 'info',
//             });
//             return;
//         }

//         const jid = this.model.get('jid');
//         const sid = crypto.randomUUID().toUpperCase();
//         const stanzaId = `jm-propose-${sid}`;
//         const myNick = _converse.xmppstatus.get('fullname') || _converse.bare_jid;

//         this.currentSid = sid;
//         ChatHeading.activeCall = this;

//         console.log(`[ChatHeading] Proposing ${media} call to ${jid}, SID: ${sid}`);

//         const propose = $msg({ to: jid, type: 'chat', id: stanzaId })
//             .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: stanzaId })
//             .up()
//             .c('propose', { xmlns: NS_JINGLE_MSG, id: sid })
//             .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//             .up();

//         if (this.isVideo) {
//             propose.c('description', { xmlns: NS_JINGLE_RTP, media: 'video' }).up();
//         }

//         propose
//             .up()
//             .c('request', { xmlns: 'urn:xmpp:receipts' })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' })
//             .up()
//             .c('x', { xmlns: 'p1:push:custom', key: 'type', value: 'call' })
//             .up()
//             .c('x', { xmlns: 'p1:push:custom', key: 'aps.mutable-content', value: '1' })
//             .up()
//             .c('customize', { xmlns: 'p1:push:customize', nick: myNick })
//             .c('body')
//             .t('Incoming call')
//             .up()
//             .up();

//         api.send(propose);
//         this.model.createMessage({
//             message: `${this.isVideo ? '📹' : '📞'} Виклик (очікування відповіді...)`,
//             type: 'info',
//         });
//         ChatHeading._showOutgoingCallPanel(this);
//     }

//     async sendJingleInitiate(fullJid, sid) {
//         console.log('[ChatHeading] >>> sendJingleInitiate START', { fullJid, sid });
//         this.iceCandidatesQueue = [];
//         this.currentSid = sid;
//         this.remoteFullJid = fullJid; // needed for terminateCall to send session-terminate

//         try {
//             // Reuse pre-warmed stream from initiateCall(). Only fall back to
//             // getUserMedia if there isn't one (e.g. incoming-direction calls
//             // that bypass our initiateCall — currently none, but safe).
//             if (!this.localStream) {
//                 console.log('[ChatHeading] No pre-warmed stream, requesting media...');
//                 this.localStream = await navigator.mediaDevices.getUserMedia({
//                     audio: true,
//                     video: this.isVideo,
//                 });
//                 console.log('[ChatHeading] Got media stream:', this.localStream);
//             } else {
//                 console.log('[ChatHeading] Reusing pre-warmed stream (isVideo:', this.isVideo, ')');
//             }

//             console.log('[ChatHeading] Creating RTCPeerConnection...');
//             const iceServers = await ChatHeading._getIceServers();
//             console.log('[ChatHeading] Using ICE servers:', JSON.stringify(iceServers));
//             this.pc = new RTCPeerConnection({
//                 iceServers,
//                 bundlePolicy: 'max-bundle',
//                 rtcpMuxPolicy: 'require',
//                 iceCandidatePoolSize: 2, // pre-gather candidates before offer
//             });
//             console.log('[ChatHeading] RTCPeerConnection created');

//             this.pc.oniceconnectionstatechange = () => {
//                 console.log(`%c [ICE] state=${this.pc.iceConnectionState} `, 'color: orange; font-weight: bold;');
//                 if (this.pc.iceConnectionState === 'failed') {
//                     console.warn('[ICE] FAILED — attempting ICE restart...');
//                     // Log which candidate pairs were tried
//                     this.pc
//                         .getStats()
//                         .then((stats) => {
//                             stats.forEach((r) => {
//                                 if (r.type === 'candidate-pair') {
//                                     console.log(
//                                         `[ICE PAIR] state=${r.state} local=${r.localCandidateId} remote=${r.remoteCandidateId} nominated=${r.nominated} bytesSent=${r.bytesSent || 0} bytesReceived=${r.bytesReceived || 0}`,
//                                     );
//                                 }
//                                 if (r.type === 'local-candidate') {
//                                     console.log(
//                                         `[ICE LOCAL] id=${r.id} type=${r.candidateType} ip=${r.address || r.ip} port=${r.port} proto=${r.protocol}`,
//                                     );
//                                 }
//                                 if (r.type === 'remote-candidate') {
//                                     console.log(
//                                         `[ICE REMOTE] id=${r.id} type=${r.candidateType} ip=${r.address || r.ip} port=${r.port}`,
//                                     );
//                                 }
//                             });
//                         })
//                         .catch(() => {});
//                     if (this.pc.signalingState === 'stable' && this.pc.restartIce) {
//                         this.pc.restartIce();
//                     }
//                 }
//                 if (this.pc.iceConnectionState === 'disconnected') {
//                     console.warn('[ICE] DISCONNECTED — will restart if not recovered in 5s');
//                     setTimeout(() => {
//                         if (this.pc && this.pc.iceConnectionState === 'disconnected') {
//                             console.warn('[ICE] Still disconnected — restarting ICE');
//                             if (this.pc.signalingState === 'stable' && this.pc.restartIce) {
//                                 this.pc.restartIce();
//                             }
//                         }
//                     }, 5000);
//                 }
//                 if (this.pc.iceConnectionState === 'connected') {
//                     console.log('%c [ICE] ✅ CONNECTED ', 'background: green; color: white;');
//                     ChatHeading._showCallPanel(this);
//                     ChatHeading._requestKeyframeAndPollVideo(this.pc);
//                 }
//             };

//             this.pc.onconnectionstatechange = () => {
//                 console.log(`[PC] connectionState=${this.pc.connectionState}`);
//             };

//             this.pc.onsignalingstatechange = () => {
//                 console.log(`[PC] signalingState=${this.pc.signalingState}`);
//             };

//             this.pc.ontrack = (event) => {
//                 console.log(
//                     `%c [TRACK] kind=${event.track.kind} streams=${event.streams.length} `,
//                     'background: #333; color: #7ec8e3; padding: 2px;',
//                 );
//                 if (event.track.kind === 'audio') {
//                     console.log('[ChatHeading] Attaching remote audio track');
//                     let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
//                     el.id = 'sonata-audio-remote';
//                     el.autoplay = true;
//                     if (!el.parentElement) document.body.appendChild(el);
//                     el.srcObject = event.streams[0];
//                 } else if (event.track.kind === 'video') {
//                     console.log('[ChatHeading] Attaching remote video track — PiP should show');
//                     ChatHeading._attachRemoteVideo(event.streams[0]);
//                 }
//             };

//             this.pc.onicecandidate = (event) => {
//                 if (event.candidate) {
//                     const c = event.candidate;
//                     console.log('[ChatHeading] Local candidate:', c.candidate);
//                     const attrs = {
//                         id: String(Math.floor(Math.random() * 4294967295)),
//                         component: String(c.component || 1),
//                         foundation: c.foundation,
//                         generation: '0',
//                         ip: c.address || c.ip,
//                         port: String(c.port),
//                         priority: String(c.priority),
//                         protocol: (c.protocol || 'udp').toLowerCase(),
//                         type: c.type,
//                     };
//                     if (c.relatedAddress) attrs['rel-addr'] = c.relatedAddress;
//                     if (c.relatedPort) attrs['rel-port'] = String(c.relatedPort);
//                     const iq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                         .c('jingle', { xmlns: NS_JINGLE, action: 'transport-info', initiator: _converse.jid, sid })
//                         .c('content', { creator: 'initiator', name: '0' })
//                         .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                         .c('candidate', attrs);
//                     api.send(iq);
//                 }
//             };

//             this.localStream.getTracks().forEach((track) => this.pc.addTrack(track, this.localStream));

//             const offer = await this.pc.createOffer();
//             await this.pc.setLocalDescription(offer);

//             const sdp = this.pc.localDescription.sdp;
//             console.log('[ChatHeading] 📋 LOCAL OFFER SDP (full):\n', sdp);
//             const ufrag = sdp.match(/a=ice-ufrag:(.*)\r/)[1];
//             const pwd = sdp.match(/a=ice-pwd:(.*)\r/)[1];
//             const fingerprint = sdp.match(/a=fingerprint:sha-256 (.*)\r/)[1];

//             console.log('[ChatHeading] Sending session-initiate (isVideo:', this.isVideo, ')...');
//             console.log(
//                 '[ChatHeading] Local tracks:',
//                 this.localStream?.getTracks().map((t) => `${t.kind}:${t.label}`),
//             );

//             // Parse video codecs from our actual offer SDP so PT numbers match.
//             // Hardcoding 96/97 doesn't work — browser assigns different PT numbers
//             // (e.g. H264 gets 103, 107, etc). iOS/Android match by PT number in the
//             // answer, so we must use whatever the browser assigned in the offer.
//             const SKIP = new Set([
//                 'rtx',
//                 'red',
//                 'ulpfec',
//                 'flexfec-03',
//                 'telephone-event',
//                 'cn',
//                 'pcmu',
//                 'pcma',
//                 'g722',
//             ]);
//             const offerVideoPayloads = [];
//             let inVid = false;
//             for (const line of sdp.split('\n')) {
//                 const l = line.trim();
//                 if (l.startsWith('m=video')) {
//                     inVid = true;
//                     continue;
//                 }
//                 if (l.startsWith('m=') && inVid) {
//                     inVid = false;
//                     break;
//                 }
//                 if (inVid && l.startsWith('a=rtpmap:')) {
//                     const m = l.match(/^a=rtpmap:(\d+) ([^/]+)\/(\d+)/);
//                     if (m && !SKIP.has(m[2].toLowerCase())) {
//                         offerVideoPayloads.push({ id: m[1], name: m[2], clockrate: m[3] });
//                     }
//                 }
//             }
//             // Reorder: H264 first (for iOS), then others
//             offerVideoPayloads.sort((a, b) => {
//                 const aH = a.name.toLowerCase().includes('h264') ? 0 : 1;
//                 const bH = b.name.toLowerCase().includes('h264') ? 0 : 1;
//                 return aH - bH;
//             });
//             console.log('[ChatHeading] Outgoing video offer payloads:', offerVideoPayloads);

//             // Build session-initiate as one unbroken chain.
//             let initiateIq;
//             if (this.isVideo) {
//                 let iq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', { xmlns: NS_JINGLE, action: 'session-initiate', initiator: _converse.jid, sid })
//                     .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                     .c('content', { name: '0' })
//                     .up()
//                     .c('content', { name: '1' })
//                     .up()
//                     .up()
//                     .c('content', { creator: 'initiator', name: '0' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                     .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                     .c('parameter', { name: 'minptime', value: '10' })
//                     .up()
//                     .c('parameter', { name: 'useinbandfec', value: '1' })
//                     .up()
//                     .up()
//                     .c('rtcp-mux')
//                     .up()
//                     .up()
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                     .t(fingerprint)
//                     .up()
//                     .up()
//                     .up()
//                     .c('content', { creator: 'initiator', name: '1' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'video' });

//                 offerVideoPayloads.forEach((p) =>
//                     iq.c('payload-type', { id: p.id, name: p.name, clockrate: p.clockrate }).up(),
//                 );

//                 iq = iq
//                     .c('rtcp-mux')
//                     .up()
//                     .up()
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                     .t(fingerprint)
//                     .up()
//                     .up()
//                     .up();

//                 initiateIq = iq;
//             } else {
//                 initiateIq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', { xmlns: NS_JINGLE, action: 'session-initiate', initiator: _converse.jid, sid })
//                     .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                     .c('content', { name: '0' })
//                     .up()
//                     .up() // </group>
//                     .c('content', { creator: 'initiator', name: '0' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                     .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                     .c('parameter', { name: 'minptime', value: '10' })
//                     .up()
//                     .c('parameter', { name: 'useinbandfec', value: '1' })
//                     .up()
//                     .up() // </payload-type>
//                     .c('rtcp-mux')
//                     .up()
//                     .up() // </description>
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                     .t(fingerprint)
//                     .up()
//                     .up() // </transport>
//                     .up(); // </content>
//             }

//             api.send(initiateIq);
//             console.log('[ChatHeading] 📤 session-initiate XML:\n', initiateIq.toString());
//             console.log('[ChatHeading] >>> sendJingleInitiate DONE (session-initiate sent)');
//         } catch (err) {
//             console.error('[ChatHeading] WebRTC Error in sendJingleInitiate:', err);
//             console.error('[ChatHeading] Stack:', err?.stack);
//         }
//     }

//     handleSessionAccept(fromJid, sid, jingle) {
//         console.log('[ChatHeading] >>> handleSessionAccept START', { fromJid, sid });
//         if (!this.pc) {
//             console.error('[ChatHeading] handleSessionAccept: NO PC! Cannot proceed.');
//             return;
//         }
//         console.log('[ChatHeading] pc signaling state:', this.pc.signalingState);

//         try {
//             // Build remote answer SDP from Jingle XML using the same helper as session-initiate
//             const remoteAnswerSdp = buildSdpFromJingle(jingle, 'answer');
//             console.log('[ChatHeading] Setting remote ANSWER SDP:\n', remoteAnswerSdp);

//             this.pc
//                 .setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp: remoteAnswerSdp }))
//                 .then(() => {
//                     console.log('%c ✅ BUNDLE accepted! Remote description SET. ', 'color: white; background: green;');
//                     console.log('[ChatHeading] pc signaling state after SRD:', this.pc.signalingState);
//                     console.log('[ChatHeading] Queued candidates to flush:', this.iceCandidatesQueue.length);
//                     while (this.iceCandidatesQueue.length > 0) {
//                         const cand = this.iceCandidatesQueue.shift();
//                         this.pc
//                             .addIceCandidate(cand)
//                             .then(() => console.log('[ChatHeading] Flushed candidate OK'))
//                             .catch((e) => console.warn('[ChatHeading] Flush candidate failed:', e));
//                     }
//                 })
//                 .catch((err) => {
//                     console.error('[ChatHeading] setRemoteDescription FAILED:', err);
//                     console.log('[ChatHeading] DUMP answer SDP:\n', remoteAnswerSdp);
//                     console.log('[ChatHeading] Jingle XML:\n', jingle?.outerHTML);
//                 });
//         } catch (err) {
//             console.error('[ChatHeading] handleSessionAccept error:', err);
//         }
//     }

//     handleIncomingCandidates(jingle) {
//         const candidateElems = sizzle('candidate', jingle);

//         candidateElems.forEach((el) => {
//             const foundation = el.getAttribute('foundation');
//             const component = el.getAttribute('component') || '1';
//             const protocol = el.getAttribute('protocol') || 'udp';
//             const priority = el.getAttribute('priority');
//             const ip = el.getAttribute('ip');
//             const port = el.getAttribute('port');
//             const type = el.getAttribute('type') || 'host';

//             const candidateStr = `candidate:${foundation} ${component} ${protocol} ${priority} ${ip} ${port} typ ${type}`;
//             console.log('[ChatHeading] Incoming remote candidate:', candidateStr);

//             const iceCandidate = new RTCIceCandidate({
//                 candidate: candidateStr,
//                 sdpMid: '0',
//                 sdpMLineIndex: 0,
//             });

//             if (this.pc && this.pc.remoteDescription && this.pc.remoteDescription.type) {
//                 this.pc.addIceCandidate(iceCandidate).catch((e) => console.warn('AddIceCandidate error:', e));
//             } else {
//                 console.log('[ChatHeading] PC not ready, queuing candidate');
//                 this.iceCandidatesQueue.push(iceCandidate);
//             }
//         });
//     }

//     terminateCall(sendTerminate = true) {
//         // Send session-terminate + JMI <finish> if we still have an active call
//         if (sendTerminate && this.remoteFullJid && this.currentSid) {
//             const sid = this.currentSid;
//             const remote = this.remoteFullJid;
//             console.log('[ChatHeading] Sending session-terminate + finish to', remote);

//             // Jingle session-terminate IQ — fire-and-forget, no timeout
//             try {
//                 const terminateIq = $iq({ type: 'set', to: remote, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', {
//                         xmlns: NS_JINGLE,
//                         action: 'session-terminate',
//                         sid: sid,
//                     })
//                     .c('reason')
//                     .c('success');
//                 api.send(terminateIq);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not send session-terminate:', e);
//             }

//             // JMI <finish> message (Sonata extension — iOS/Android use this)
//             try {
//                 const bareRemote = remote.split('/')[0];
//                 const finishMsg = $msg({ to: bareRemote, type: 'chat', id: crypto.randomUUID() })
//                     .c('finish', { xmlns: NS_JINGLE_MSG, id: sid })
//                     .c('reason', { xmlns: NS_JINGLE })
//                     .c('success')
//                     .up()
//                     .up()
//                     .up()
//                     .c('store', { xmlns: 'urn:xmpp:hints' });
//                 api.send(finishMsg);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not send finish:', e);
//             }
//         }

//         if (this.pc) {
//             console.log('[ChatHeading] Closing PeerConnection');
//             this.pc.close();
//             this.pc = null;
//         }
//         if (this.localStream) {
//             this.localStream.getTracks().forEach((t) => t.stop());
//             this.localStream = null;
//         }
//         const el = document.getElementById('sonata-audio-remote');
//         if (el) el.srcObject = null;
//         this.currentSid = null;
//         this.isIncoming = false;
//         this.remoteFullJid = null;
//         if (ChatHeading.activeCall === this) {
//             ChatHeading.activeCall = null;
//         }
//         ChatHeading._hideCallPanel();
//         console.log('=== [ChatHeading] Call terminated ===');
//     }

//     // ========================================================================
//     // INCOMING CALL HANDLING (callee side)
//     // ========================================================================

//     /**
//      * Static: called when <propose> arrives. Shows modal asking user to accept
//      * or reject. If accepted, picks the matching ChatHeading instance (by JID)
//      * and runs accept flow. If no chat is open for that contact, falls back to
//      * using/creating a chat first.
//      */
//     static async handleIncomingPropose(fullFromJid, sid, media) {
//         const bareFrom = fullFromJid?.split('/')[0];

//         // Resolve display name — same approach as the call panel and ChatHeading template.
//         // Try roster contact first, then chatbox model, then fall back to bare JID.
//         let displayName = bareFrom;
//         try {
//             const contact = await api.contacts.get(bareFrom);
//             if (contact) {
//                 displayName = contact.get('nickname') || contact.get('fullname') || contact.get('name') || bareFrom;
//             }
//             // Also try an open chatbox model in case vcard is loaded there
//             if (displayName === bareFrom) {
//                 const chatbox = _converse.state?.chatboxes?.get(bareFrom);
//                 if (chatbox) {
//                     const fromModel = chatbox.getDisplayName?.();
//                     if (fromModel && fromModel !== bareFrom) displayName = fromModel;
//                 }
//             }
//         } catch (e) {
//             // non-fatal — fall back to bare JID
//         }

//         // If there's already an active call, ask the user.
//         if (ChatHeading.activeCall) {
//             const confirmed = window.confirm(
//                 `Вхідний дзвінок від ${bareFrom}. У вас вже триває розмова. Завершити поточну та прийняти новий?`,
//             );
//             if (!confirmed) {
//                 // Auto-reject the new call
//                 ChatHeading._sendJmiReject(fullFromJid, sid);
//                 return;
//             }
//             // Terminate the current call before accepting new
//             ChatHeading.activeCall.terminateCall();
//         }

//         // Track this pending incoming call so <retract> can cancel its modal.
//         ChatHeading._pendingIncomingSid = sid;
//         ChatHeading._pendingIncomingFrom = fullFromJid;

//         const accepted = await ChatHeading._showIncomingCallModal(displayName, fullFromJid, sid, media);

//         // Clear pending tracking
//         if (ChatHeading._pendingIncomingSid === sid) {
//             ChatHeading._pendingIncomingSid = null;
//             ChatHeading._pendingIncomingFrom = null;
//         }

//         if (!accepted) {
//             console.log('[ChatHeading] User rejected incoming call');
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         console.log('[ChatHeading] User accepted incoming call. Finding chat heading...');

//         // Find existing ChatHeading instance for this contact, or open a chat first.
//         let headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);
//         if (!headingEl) {
//             console.log('[ChatHeading] No open chat for', bareFrom, '— opening one');
//             try {
//                 await api.chats.open(bareFrom);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not open chat:', e);
//             }
//             // Wait a tick for the heading element to render
//             await new Promise((r) => setTimeout(r, 200));
//             headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);
//         }

//         if (!headingEl) {
//             console.error('[ChatHeading] Could not find/create chat heading for', bareFrom);
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         await headingEl.acceptIncomingCall(fullFromJid, sid, media);
//     }

//     /**
//      * Static: <retract> arrived — caller cancelled before we picked up.
//      * Close the modal if it's showing for this sid.
//      */
//     static handleRetract(sid) {
//         if (ChatHeading._pendingIncomingSid === sid && ChatHeading._closeIncomingModal) {
//             console.log('[ChatHeading] Closing incoming-call modal (caller retracted)');
//             ChatHeading._closeIncomingModal(false);
//         }
//     }

//     /**
//      * Static helper: send JMI <reject> message.
//      */
//     static _sendJmiReject(toFullJid, sid) {
//         const bareJid = toFullJid?.split('/')[0];
//         const msg = $msg({ to: bareJid, type: 'chat', id: crypto.randomUUID() })
//             .c('reject', { xmlns: NS_JINGLE_MSG, id: sid })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' });
//         api.send(msg);
//         console.log('[ChatHeading] Sent JMI reject for sid', sid);
//     }

//     /**
//      * Static: builds the incoming-call modal. Returns a Promise<boolean>:
//      * true=accepted, false=rejected/closed.
//      */
//     static _showIncomingCallModal(callerName, fullFromJid, sid, media) {
//         return new Promise((resolve) => {
//             // Inject CSS once
//             if (!document.getElementById('sonata-incall-style')) {
//                 const style = document.createElement('style');
//                 style.id = 'sonata-incall-style';
//                 style.textContent = `
//                     .sonata-incall-overlay {
//                         position: fixed; inset: 0; z-index: 99999;
//                         background: rgba(0,0,0,0.55);
//                         display: flex; align-items: center; justify-content: center;
//                         font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     }
//                     .sonata-incall-card {
//                         background: #fff; border-radius: 16px; padding: 28px 32px;
//                         min-width: 320px; max-width: 90vw; text-align: center;
//                         box-shadow: 0 20px 60px rgba(0,0,0,0.4);
//                         animation: sonata-incall-pop 0.25s ease-out;
//                     }
//                     @keyframes sonata-incall-pop {
//                         from { transform: scale(0.85); opacity: 0; }
//                         to { transform: scale(1); opacity: 1; }
//                     }
//                     .sonata-incall-icon {
//                         font-size: 48px; margin-bottom: 12px;
//                         animation: sonata-incall-ring 1s ease-in-out infinite;
//                     }
//                     @keyframes sonata-incall-ring {
//                         0%, 100% { transform: rotate(0); }
//                         25% { transform: rotate(-15deg); }
//                         75% { transform: rotate(15deg); }
//                     }
//                     .sonata-incall-name {
//                         font-size: 20px; font-weight: 600; color: #222; margin-bottom: 4px;
//                     }
//                     .sonata-incall-sub {
//                         font-size: 13px; color: #888; margin-bottom: 24px;
//                     }
//                     .sonata-incall-actions {
//                         display: flex; gap: 16px; justify-content: center;
//                     }
//                     .sonata-incall-btn {
//                         border: none; border-radius: 50%; width: 56px; height: 56px;
//                         font-size: 22px; cursor: pointer; color: white;
//                         display: inline-flex; align-items: center; justify-content: center;
//                         transition: transform 0.15s;
//                     }
//                     .sonata-incall-btn:hover { transform: scale(1.08); }
//                     .sonata-incall-btn.accept { background: #1e9652; }
//                     .sonata-incall-btn.reject { background: #d33; }
//                 `;
//                 document.head.appendChild(style);
//             }

//             const overlay = document.createElement('div');
//             overlay.className = 'sonata-incall-overlay';
//             overlay.innerHTML = `
//                 <div class="sonata-incall-card">
//                     <div class="sonata-incall-icon">📞</div>
//                     <div class="sonata-incall-name">${callerName}</div>
//                     <div class="sonata-incall-sub">Вхідний ${media === 'video' ? 'відео' : 'аудіо'} дзвінок</div>
//                     <div class="sonata-incall-actions">
//                         <button class="sonata-incall-btn reject" title="Відхилити">✕</button>
//                         <button class="sonata-incall-btn accept" title="Прийняти">✓</button>
//                     </div>
//                 </div>
//             `;
//             document.body.appendChild(overlay);

//             // Play ringtone via Web Audio (simple beeping). Skip if AudioContext unavailable.
//             let ringInterval = null;
//             try {
//                 const ctx = new (window.AudioContext || window.webkitAudioContext)();
//                 const beep = () => {
//                     const osc = ctx.createOscillator();
//                     const gain = ctx.createGain();
//                     osc.frequency.value = 480;
//                     gain.gain.value = 0.08;
//                     osc.connect(gain).connect(ctx.destination);
//                     osc.start();
//                     setTimeout(() => osc.stop(), 400);
//                 };
//                 beep();
//                 ringInterval = setInterval(beep, 1500);
//             } catch (e) {
//                 /* no-op */
//             }

//             const cleanup = (result) => {
//                 if (ringInterval) clearInterval(ringInterval);
//                 if (overlay.parentElement) overlay.parentElement.removeChild(overlay);
//                 ChatHeading._closeIncomingModal = null;
//                 resolve(result);
//             };

//             // Expose closer so retract can cancel the modal externally
//             ChatHeading._closeIncomingModal = cleanup;

//             overlay.querySelector('.accept').addEventListener('click', () => cleanup(true));
//             overlay.querySelector('.reject').addEventListener('click', () => cleanup(false));

//             // Auto-reject after 45s (typical ring timeout)
//             setTimeout(() => {
//                 if (overlay.parentElement) cleanup(false);
//             }, 45000);
//         });
//     }

//     /**
//      * Instance: user accepted the incoming-call modal. Pre-warm mic, send
//      * <proceed>, mark this instance as the active call, and wait for the
//      * remote's session-initiate.
//      */
//     async acceptIncomingCall(fullFromJid, sid, media) {
//         console.log('[ChatHeading] >>> acceptIncomingCall', { fullFromJid, sid, media });

//         // Pre-warm microphone BEFORE sending <proceed>.
//         // If we send proceed first, the caller immediately sends session-initiate.
//         // getUserMedia prompt can take seconds on first use — causing session-initiate
//         // to arrive before pc is created. Get mic first, then proceed.
//         const needsVideo = media === 'video';
//         try {
//             console.log(
//                 `[ChatHeading] Pre-warming media (audio${needsVideo ? '+video' : ''}) before sending proceed...`,
//             );
//             this.localStream = await navigator.mediaDevices.getUserMedia({
//                 audio: true,
//                 video: needsVideo,
//             });
//             console.log(
//                 '[ChatHeading] Media ready for incoming call, tracks:',
//                 this.localStream.getTracks().map((t) => t.kind),
//             );
//         } catch (err) {
//             console.error('[ChatHeading] Media permission denied for incoming call:', err);
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         this.isIncoming = true;
//         this.isVideo = needsVideo;
//         this.remoteFullJid = fullFromJid;
//         this.currentSid = sid;
//         ChatHeading.activeCall = this;

//         // Send JMI <proceed> to the caller's FULL JID (including resource).
//         // The original propose came from their full JID — we must reply to it.
//         // Sending to bare JID means the server can't route session-initiate back
//         // to us because the caller doesn't know which resource accepted.
//         const proceedId = crypto.randomUUID();
//         const proceedMsg = $msg({ to: fullFromJid, type: 'chat', id: proceedId })
//             .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: proceedId })
//             .up()
//             .c('proceed', { xmlns: NS_JINGLE_MSG, id: sid })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' });
//         api.send(proceedMsg);
//         console.log(
//             '[ChatHeading] Sent JMI proceed sid=',
//             sid,
//             'to FULL JID=',
//             fullFromJid,
//             '| our full JID:',
//             _converse.jid,
//         );

//         this.model?.createMessage({ message: '📞 Вхідний виклик прийнято', type: 'info' });
//         // Now we wait for session-initiate via the Strophe handler → handleSessionInitiate().
//     }

//     /**
//      * Instance: <session-initiate> arrived from remote (caller). We are the
//      * callee. Create pc, add tracks, set remote offer SDP, create answer,
//      * send session-accept.
//      */
//     async handleSessionInitiate(fullFromJid, sid, jingle) {
//         console.log('[ChatHeading] >>> handleSessionInitiate', { fullFromJid, sid });
//         this.iceCandidatesQueue = [];
//         this.remoteFullJid = fullFromJid;
//         this.currentSid = sid;
//         this.isIncoming = true;

//         // Detect video from raw Jingle XML
//         this.isVideo = getJingleRtpContents(jingle).some(
//             (c) => firstDirectChild(c, 'description')?.getAttribute('media') === 'video',
//         );

//         try {
//             if (!this.localStream) {
//                 console.log('[ChatHeading] No stream yet, requesting media (isVideo:', this.isVideo, ')...');
//                 this.localStream = await navigator.mediaDevices.getUserMedia({
//                     audio: true,
//                     video: this.isVideo,
//                 });
//             }

//             const iceServers2 = await ChatHeading._getIceServers();
//             this.pc = new RTCPeerConnection({
//                 iceServers: iceServers2,
//                 bundlePolicy: 'max-bundle',
//                 rtcpMuxPolicy: 'require',
//             });

//             this.pc.oniceconnectionstatechange = () => {
//                 console.log(`%c [ICE] state=${this.pc.iceConnectionState} `, 'color: orange; font-weight: bold;');
//                 if (this.pc.iceConnectionState === 'connected') {
//                     console.log('%c [ICE] ✅ CONNECTED (incoming) ', 'background: green; color: white;');
//                     ChatHeading._showCallPanel(this);
//                     ChatHeading._requestKeyframeAndPollVideo(this.pc);
//                 }
//             };
//             this.pc.onconnectionstatechange = () => console.log(`[PC] connectionState=${this.pc.connectionState}`);
//             this.pc.onsignalingstatechange = () => console.log(`[PC] signalingState=${this.pc.signalingState}`);

//             this.pc.ontrack = (event) => {
//                 console.log('[ChatHeading] Remote track received (incoming) kind=', event.track.kind);
//                 const stream = event.streams?.[0] || new MediaStream([event.track]);
//                 if (event.track.kind === 'audio') {
//                     let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
//                     el.id = 'sonata-audio-remote';
//                     el.autoplay = true;
//                     if (!el.parentElement) document.body.appendChild(el);
//                     el.srcObject = stream;
//                 } else if (event.track.kind === 'video') {
//                     ChatHeading._attachRemoteVideo(stream);
//                 }
//             };

//             this.pc.onicecandidate = (event) => {
//                 if (!event.candidate) return;
//                 const c = event.candidate;
//                 const localSdp = this.pc.localDescription?.sdp || '';
//                 const localUfrag = (localSdp.match(/a=ice-ufrag:(.*)\r/) || [])[1] || '';
//                 const localPwd = (localSdp.match(/a=ice-pwd:(.*)\r/) || [])[1] || '';
//                 const attrs = {
//                     id: String(Math.floor(Math.random() * 4294967295)),
//                     component: String(c.component || 1),
//                     foundation: c.foundation,
//                     generation: '0',
//                     ip: c.address || c.ip,
//                     port: String(c.port),
//                     priority: String(c.priority),
//                     protocol: (c.protocol || 'udp').toLowerCase(),
//                     type: c.type,
//                 };
//                 if (c.relatedAddress) attrs['rel-addr'] = c.relatedAddress;
//                 if (c.relatedPort) attrs['rel-port'] = String(c.relatedPort);
//                 const iq = $iq({ type: 'set', to: fullFromJid, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', {
//                         xmlns: NS_JINGLE,
//                         action: 'transport-info',
//                         initiator: fullFromJid,
//                         responder: _converse.jid,
//                         sid,
//                     })
//                     .c('content', { creator: 'initiator', name: '0' })
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag: localUfrag, pwd: localPwd })
//                     .c('candidate', attrs);
//                 api.send(iq);
//             };

//             this.localStream.getTracks().forEach((t) => this.pc.addTrack(t, this.localStream));

//             // Build remote offer SDP from Jingle XML — handles Android, iOS, all clients correctly
//             const remoteOfferSdp = buildSdpFromJingle(jingle, 'offer');
//             console.log('[ChatHeading] Setting remote OFFER SDP:\n', remoteOfferSdp);
//             await this.pc.setRemoteDescription(new RTCSessionDescription({ type: 'offer', sdp: remoteOfferSdp }));

//             const answer = await this.pc.createAnswer();
//             await this.pc.setLocalDescription(answer);
//             console.log('[ChatHeading] 📋 LOCAL ANSWER SDP:\n', this.pc.localDescription.sdp);

//             // Flush queued candidates
//             while (this.iceCandidatesQueue.length > 0) {
//                 this.pc
//                     .addIceCandidate(this.iceCandidatesQueue.shift())
//                     .catch((e) => console.warn('Queued cand failed:', e));
//             }

//             // Build session-accept IQ from our local answer SDP (mirrors what browser negotiated)
//             // Track the mid order from the remote offer so our accept uses the same order
//             const contents = getJingleRtpContents(jingle);
//             const remoteOfferMidOrder = contents.map((c, i) => c.getAttribute('name') || String(i));
//             const contentCreatorsByMid = new Map(remoteOfferMidOrder.map((mid) => [mid, 'initiator']));

//             const acceptIq = buildJingleIqFromLocalSdp({
//                 action: 'session-accept',
//                 to: fullFromJid,
//                 sid,
//                 initiator: fullFromJid,
//                 responder: _converse.jid,
//                 localSdp: this.pc.localDescription.sdp,
//                 contentCreatorsByMid,
//                 preferredMidOrder: remoteOfferMidOrder,
//             });

//             console.log('[ChatHeading] 📤 session-accept XML:\n', acceptIq.toString());
//             api.send(acceptIq);
//             console.log(
//                 '[ChatHeading] >>> handleSessionInitiate DONE (session-accept sent, isVideo:',
//                 this.isVideo,
//                 ')',
//             );
//         } catch (err) {
//             console.error('[ChatHeading] handleSessionInitiate error:', err);
//             console.error('[ChatHeading] Stack:', err?.stack);
//         }
//     }

//     // ========================================================================
//     // CALL PANEL UI
//     // ========================================================================

//     /**
//      * Static: show "calling..." panel while waiting for remote to answer.
//      * Replaced by _showCallPanel once ICE connects.
//      */
//     static _showOutgoingCallPanel(instance) {
//         ChatHeading._hideCallPanel();

//         if (!document.getElementById('sonata-callpanel-style')) {
//             // CSS will be injected by _showCallPanel when connected; inject minimal now
//             const style = document.createElement('style');
//             style.id = 'sonata-callpanel-style';
//             style.textContent = `
//                 .sonata-callpanel {
//                     position: fixed; top: 0; left: 50%; transform: translateX(-50%);
//                     z-index: 99998; background: #1a1a2e; color: #fff;
//                     border-radius: 0 0 24px 24px; padding: 12px 20px 14px 24px;
//                     display: flex; align-items: center; gap: 16px;
//                     box-shadow: 0 4px 24px rgba(0,0,0,0.45);
//                     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     animation: sonata-panel-slide 0.3s cubic-bezier(.22,.68,0,1.2);
//                     min-width: 260px;
//                 }
//                 @keyframes sonata-panel-slide {
//                     from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
//                     to   { opacity: 1; transform: translateX(-50%) translateY(0); }
//                 }
//                 .sonata-callpanel-dot {
//                     width: 10px; height: 10px; border-radius: 50%;
//                     background: #1e9652;
//                     box-shadow: 0 0 0 0 rgba(30,150,82,0.6);
//                     animation: sonata-dot-pulse 1.5s ease-out infinite;
//                     flex-shrink: 0;
//                 }
//                 @keyframes sonata-dot-pulse {
//                     0%   { box-shadow: 0 0 0 0 rgba(30,150,82,0.6); }
//                     70%  { box-shadow: 0 0 0 8px rgba(30,150,82,0); }
//                     100% { box-shadow: 0 0 0 0 rgba(30,150,82,0); }
//                 }
//                 .sonata-callpanel-info {
//                     display: flex; flex-direction: column; gap: 2px; flex: 1;
//                 }
//                 .sonata-callpanel-name {
//                     font-size: 14px; font-weight: 600; color: #fff;
//                     white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//                     max-width: 160px;
//                 }
//                 .sonata-callpanel-timer {
//                     font-size: 13px; color: #aaa; font-variant-numeric: tabular-nums;
//                     letter-spacing: 0.03em;
//                 }
//                 .sonata-callpanel-hangup {
//                     background: #e53935; border: none; border-radius: 50%;
//                     width: 40px; height: 40px; cursor: pointer; color: #fff;
//                     display: inline-flex; align-items: center; justify-content: center;
//                     font-size: 18px; flex-shrink: 0;
//                     transition: background 0.15s, transform 0.15s;
//                 }
//                 .sonata-callpanel-hangup:hover { background: #b71c1c; transform: scale(1.08); }
//             `;
//             document.head.appendChild(style);
//         }

//         const displayName = instance.model?.getDisplayName?.() || instance.model?.get('jid') || '...';

//         const panel = document.createElement('div');
//         panel.id = 'sonata-callpanel';
//         panel.className = 'sonata-callpanel';
//         panel.innerHTML = `
//             <div class="sonata-callpanel-dot" style="background:#f59e0b; box-shadow: 0 0 0 0 rgba(245,158,11,0.6);"></div>
//             <div class="sonata-callpanel-info">
//                 <div class="sonata-callpanel-name">${displayName}</div>
//                 <div class="sonata-callpanel-timer" id="sonata-callpanel-timer">Виклик...</div>
//             </div>
//             <button class="sonata-callpanel-hangup" title="Скасувати дзвінок">📵</button>
//         `;
//         document.body.appendChild(panel);

//         // Animated dots on "Виклик..."
//         const timerEl = panel.querySelector('#sonata-callpanel-timer');
//         let dots = 0;
//         ChatHeading._callTimerInterval = setInterval(() => {
//             dots = (dots + 1) % 4;
//             if (timerEl) timerEl.textContent = 'Виклик' + '.'.repeat(dots);
//         }, 600);

//         setTimeout(() => {
//             const btn = panel.querySelector('.sonata-callpanel-hangup');
//             if (btn)
//                 btn.addEventListener('click', () => {
//                     console.log('[ChatHeading] User cancelled outgoing call');
//                     const t = ChatHeading.activeCall;
//                     if (t) {
//                         const jid = t.model?.get('jid');
//                         if (jid && t.currentSid) {
//                             const retractMsg = $msg({ to: jid, type: 'chat', id: crypto.randomUUID() })
//                                 .c('retract', { xmlns: NS_JINGLE_MSG, id: t.currentSid })
//                                 .up()
//                                 .c('store', { xmlns: 'urn:xmpp:hints' });
//                             api.send(retractMsg);
//                             console.log('[ChatHeading] Sent JMI retract for sid', t.currentSid);
//                         }
//                         t.terminateCall(false);
//                     }
//                 });
//         }, 100);
//     }

//     /**
//      * Static: show active call panel with timer and hang-up button.
//      * Called when ICE reaches 'connected' state.
//      */
//     static _showCallPanel(instance) {
//         // Save any queued remote video stream before _hideCallPanel clears it
//         const savedRemoteStream = ChatHeading._pendingRemoteVideoStream;
//         ChatHeading._hideCallPanel();
//         // Restore it so PiP creation below can flush it
//         if (savedRemoteStream) {
//             ChatHeading._pendingRemoteVideoStream = savedRemoteStream;
//         }

//         if (!document.getElementById('sonata-callpanel-style')) {
//             const style = document.createElement('style');
//             style.id = 'sonata-callpanel-style';
//             style.textContent = `
//                 .sonata-callpanel {
//                     position: fixed; top: 0; left: 50%; transform: translateX(-50%);
//                     z-index: 99998; background: #1a1a2e; color: #fff;
//                     border-radius: 0 0 24px 24px; padding: 12px 20px 14px 24px;
//                     display: flex; align-items: center; gap: 16px;
//                     box-shadow: 0 4px 24px rgba(0,0,0,0.45);
//                     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     animation: sonata-panel-slide 0.3s cubic-bezier(.22,.68,0,1.2);
//                     min-width: 260px;
//                 }
//                 @keyframes sonata-panel-slide {
//                     from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
//                     to   { opacity: 1; transform: translateX(-50%) translateY(0); }
//                 }
//                 .sonata-callpanel-dot {
//                     width: 10px; height: 10px; border-radius: 50%; background: #1e9652;
//                     box-shadow: 0 0 0 0 rgba(30,150,82,0.6);
//                     animation: sonata-dot-pulse 1.5s ease-out infinite; flex-shrink: 0;
//                 }
//                 @keyframes sonata-dot-pulse {
//                     0%   { box-shadow: 0 0 0 0 rgba(30,150,82,0.6); }
//                     70%  { box-shadow: 0 0 0 8px rgba(30,150,82,0); }
//                     100% { box-shadow: 0 0 0 0 rgba(30,150,82,0); }
//                 }
//                 .sonata-callpanel-info { display: flex; flex-direction: column; gap: 2px; flex: 1; }
//                 .sonata-callpanel-name {
//                     font-size: 14px; font-weight: 600; color: #fff;
//                     white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 160px;
//                 }
//                 .sonata-callpanel-timer {
//                     font-size: 13px; color: #aaa; font-variant-numeric: tabular-nums; letter-spacing: 0.03em;
//                 }
//                 .sonata-callpanel-hangup {
//                     background: #e53935; border: none; border-radius: 50%;
//                     width: 40px; height: 40px; cursor: pointer; color: #fff;
//                     display: inline-flex; align-items: center; justify-content: center;
//                     font-size: 18px; flex-shrink: 0; transition: background 0.15s, transform 0.15s;
//                 }
//                 .sonata-callpanel-hangup:hover { background: #b71c1c; transform: scale(1.08); }
//             `;
//             document.head.appendChild(style);
//         }

//         const displayName = instance.model?.getDisplayName?.() || instance.remoteFullJid?.split('/')[0] || 'Unknown';

//         // Inject PiP CSS separately from panel CSS so it's not blocked
//         // by the outgoing call panel having already injected sonata-callpanel-style
//         if (instance.isVideo && !document.getElementById('sonata-pip-style')) {
//             const pipStyle = document.createElement('style');
//             pipStyle.id = 'sonata-pip-style';
//             pipStyle.textContent = `
//                 .sonata-video-pip {
//                     position: fixed !important; bottom: 24px !important; right: 24px !important;
//                     z-index: 999999 !important;
//                     width: 320px !important; height: 180px !important;
//                     border-radius: 16px; overflow: hidden;
//                     box-shadow: 0 8px 32px rgba(0,0,0,0.6);
//                     background: #111 !important;
//                     display: block !important; visibility: visible !important;
//                 }
//                 .sonata-video-pip video {
//                     display: block !important; visibility: visible !important;
//                 }
//                 .sonata-video-pip video#sonata-video-remote {
//                     position: absolute !important; inset: 0 !important;
//                     width: 100% !important; height: 100% !important;
//                     object-fit: cover; background: #222;
//                 }
//                 .sonata-video-pip video#sonata-video-local {
//                     position: absolute !important; bottom: 8px !important; right: 8px !important;
//                     width: 80px !important; height: 60px !important;
//                     border-radius: 8px; object-fit: cover;
//                     border: 2px solid rgba(255,255,255,0.8);
//                     background: #333; z-index: 1 !important;
//                 }
//             `;
//             document.head.appendChild(pipStyle);
//             console.log('[ChatHeading] PiP CSS injected ✅');
//         }

//         // Audio call panel (always shown at top)
//         const panel = document.createElement('div');
//         panel.id = 'sonata-callpanel';
//         panel.className = 'sonata-callpanel';
//         panel.innerHTML = `
//             <div class="sonata-callpanel-dot"></div>
//             <div class="sonata-callpanel-info">
//                 <div class="sonata-callpanel-name">${instance.isVideo ? '📹 ' : ''}${displayName}</div>
//                 <div class="sonata-callpanel-timer" id="sonata-callpanel-timer">00:00</div>
//             </div>
//             <button class="sonata-callpanel-hangup" title="Завершити дзвінок">📵</button>
//         `;
//         document.body.appendChild(panel);

//         // Video PiP overlay (only for video calls)
//         if (instance.isVideo) {
//             console.log('[ChatHeading] Creating video PiP overlay');
//             const pip = document.createElement('div');
//             pip.id = 'sonata-video-pip';
//             pip.className = 'sonata-video-pip';
//             pip.innerHTML = `
//                 <video id="sonata-video-remote" autoplay playsinline muted
//                     style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#222;display:block;visibility:visible;"></video>
//                 <video id="sonata-video-local" autoplay playsinline muted
//                     style="position:absolute;bottom:8px;right:8px;width:80px;height:60px;border-radius:8px;object-fit:cover;border:2px solid rgba(255,255,255,0.8);background:#333;z-index:1;display:block;visibility:visible;"></video>
//             `;
//             document.body.appendChild(pip);

//             // Attach local stream preview immediately
//             const localVid = pip.querySelector('#sonata-video-local');
//             if (instance.localStream) {
//                 localVid.srcObject = instance.localStream;
//                 console.log('[ChatHeading] Local video preview attached to PiP ✅');
//             } else {
//                 console.warn('[ChatHeading] No localStream available for PiP preview');
//             }

//             // Flush remote video stream if it arrived before PiP was created
//             if (ChatHeading._pendingRemoteVideoStream) {
//                 console.log('[ChatHeading] Flushing pending remote video stream to PiP ✅');
//                 const remoteVid = pip.querySelector('#sonata-video-remote');
//                 remoteVid.srcObject = ChatHeading._pendingRemoteVideoStream;
//                 ChatHeading._pendingRemoteVideoStream = null;
//                 // Diagnose after a short delay to let the element settle
//                 setTimeout(() => {
//                     const r = remoteVid.getBoundingClientRect();
//                     const cs = getComputedStyle(remoteVid);
//                     const pipR = pip.getBoundingClientRect();
//                     const pipCs = getComputedStyle(pip);
//                     console.log(
//                         `[VIDEO DEBUG] pip: ${pipR.width}x${pipR.height} at (${Math.round(pipR.left)},${Math.round(pipR.top)}) display=${pipCs.display} visibility=${pipCs.visibility} zIndex=${pipCs.zIndex}`,
//                     );
//                     console.log(
//                         `[VIDEO DEBUG] remote video: ${r.width}x${r.height} at (${Math.round(r.left)},${Math.round(r.top)}) display=${cs.display} visibility=${cs.visibility} readyState=${remoteVid.readyState} paused=${remoteVid.paused}`,
//                     );
//                     console.log(
//                         `[VIDEO DEBUG] remote video srcObject tracks:`,
//                         remoteVid.srcObject?.getTracks().map((t) => `${t.kind}:${t.readyState}`),
//                     );
//                     // Check if anything is covering the pip
//                     const topEl = document.elementFromPoint(pipR.left + pipR.width / 2, pipR.top + pipR.height / 2);
//                     console.log(
//                         `[VIDEO DEBUG] element at pip center:`,
//                         topEl?.id || topEl?.className || topEl?.tagName,
//                     );
//                     if (remoteVid.paused) {
//                         remoteVid
//                             .play()
//                             .then(() => console.log('[VIDEO DEBUG] play() succeeded after delay ✅'))
//                             .catch((e) => console.warn('[VIDEO DEBUG] play() still failed:', e));
//                     }
//                 }, 500);
//             }

//             // Make PiP draggable
//             let dragging = false,
//                 ox = 0,
//                 oy = 0;
//             pip.addEventListener('mousedown', (e) => {
//                 dragging = true;
//                 ox = e.clientX - pip.getBoundingClientRect().left;
//                 oy = e.clientY - pip.getBoundingClientRect().top;
//                 pip.style.transition = 'none';
//             });
//             document.addEventListener('mousemove', (e) => {
//                 if (!dragging) return;
//                 pip.style.right = 'auto';
//                 pip.style.bottom = 'auto';
//                 pip.style.left = `${e.clientX - ox}px`;
//                 pip.style.top = `${e.clientY - oy}px`;
//             });
//             document.addEventListener('mouseup', () => {
//                 dragging = false;
//             });
//         }

//         // Timer
//         let seconds = 0;
//         const timerEl = panel.querySelector('#sonata-callpanel-timer');
//         ChatHeading._callTimerInterval = setInterval(() => {
//             seconds++;
//             const m = String(Math.floor(seconds / 60)).padStart(2, '0');
//             const s = String(seconds % 60).padStart(2, '0');
//             if (timerEl) timerEl.textContent = `${m}:${s}`;
//         }, 1000);

//         // Defer click handler by one tick so the button can't receive
//         // a click event that was already in flight from the outgoing panel
//         // being replaced (which caused auto-terminate on ICE connect).
//         setTimeout(() => {
//             const btn = panel.querySelector('.sonata-callpanel-hangup');
//             if (btn)
//                 btn.addEventListener('click', () => {
//                     console.log('[ChatHeading] User clicked hang-up');
//                     const t = ChatHeading.activeCall;
//                     if (t) t.terminateCall(true);
//                 });
//         }, 100);
//     }

//     static _hideCallPanel() {
//         if (ChatHeading._callTimerInterval) {
//             clearInterval(ChatHeading._callTimerInterval);
//             ChatHeading._callTimerInterval = null;
//         }
//         ChatHeading._pendingRemoteVideoStream = null;
//         const panel = document.getElementById('sonata-callpanel');
//         if (panel) panel.parentElement?.removeChild(panel);
//         const pip = document.getElementById('sonata-video-pip');
//         if (pip) pip.parentElement?.removeChild(pip);
//         const pipStyle = document.getElementById('sonata-pip-style');
//         if (pipStyle) pipStyle.parentElement?.removeChild(pipStyle);
//     }

//     /**
//      * Static: attach remote video stream to the PiP overlay.
//      * Called from ontrack when a video track arrives.
//      */
//     static _attachRemoteVideo(stream) {
//         console.log('[ChatHeading] _attachRemoteVideo called, stream tracks:', stream?.getTracks().length);
//         if (stream) {
//             stream
//                 .getTracks()
//                 .forEach((t) =>
//                     console.log(
//                         `[ChatHeading] remote stream track: kind=${t.kind} enabled=${t.enabled} readyState=${t.readyState} muted=${t.muted}`,
//                     ),
//                 );
//         }
//         const pip = document.getElementById('sonata-video-pip');
//         if (!pip) {
//             console.warn('[ChatHeading] PiP not in DOM yet — queuing remote video stream');
//             ChatHeading._pendingRemoteVideoStream = stream;
//             return;
//         }
//         const vid = pip.querySelector('#sonata-video-remote');
//         vid.srcObject = stream;
//         vid.play()
//             .then(() => {
//                 console.log('[ChatHeading] Remote video playing ✅');
//                 setTimeout(() => {
//                     const r = vid.getBoundingClientRect();
//                     const cs = getComputedStyle(vid);
//                     const pipR = pip.getBoundingClientRect();
//                     console.log(
//                         `[VIDEO DEBUG] pip: ${pipR.width}x${pipR.height} at (${Math.round(pipR.left)},${Math.round(pipR.top)}) z=${getComputedStyle(pip).zIndex}`,
//                     );
//                     console.log(
//                         `[VIDEO DEBUG] video: ${r.width}x${r.height} display=${cs.display} visibility=${cs.visibility} readyState=${vid.readyState}`,
//                     );
//                 }, 300);
//             })
//             .catch((e) => {
//                 console.warn('[ChatHeading] Remote video play() failed:', e);
//             });
//         console.log('[ChatHeading] Remote video srcObject set ✅');
//     }

//     /**
//      * Static: attach local video preview to the PiP overlay local tile.
//      */
//     static _attachLocalVideo(stream) {
//         const pip = document.getElementById('sonata-video-pip');
//         if (pip) {
//             pip.querySelector('#sonata-video-local').srcObject = stream;
//         }
//     }

//     // ========================================================================
//     // END CALL PANEL UI
//     // ========================================================================

//     // ========================================================================
//     // END CALL LOGIC
//     // ========================================================================

//     /**
//      * Returns a list of objects which represent buttons for the chat's header.
//      * @emits _converse#getHeadingButtons
//      * @returns {Promise<Array.<import('./types').HeadingButtonAttributes>>}
//      */
//     async getHeadingButtons() {
//         const buttons = [
//             /** @type {import('./types').HeadingButtonAttributes} */
//             {
//                 a_class: 'show-user-details-modal',
//                 handler: /** @param {Event} ev */ (ev) => this.showUserDetailsModal(ev),
//                 i18n_text: __('Details'),
//                 i18n_title: __('See more information about this person'),
//                 icon_class: 'fa-id-card',
//                 name: 'details',
//                 standalone: false,
//             },
//         ];

//         const domain = _converse.session.get('domain');
//         if (domain && (await api.disco.supports(Strophe.NS.BLOCKING, domain))) {
//             const blocklist = await api.blocklist.get();
//             if (blocklist.get(this.model.get('jid'))) {
//                 buttons.push({
//                     a_class: 'unblock-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Unblock user'), [
//                             __('Are you sure you want to unblock this user?'),
//                         ]);
//                         if (result) {
//                             api.blocklist.remove(this.model.get('jid'));
//                         }
//                     },
//                     i18n_text: __('Unblock this user'),
//                     i18n_title: __('Allow this user to send you messages'),
//                     icon_class: 'fa-check',
//                     name: 'unblock',
//                     standalone: false,
//                 });
//             } else {
//                 buttons.push({
//                     a_class: 'block-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Block user'), [
//                             __(
//                                 'Are you sure you want to prevent %1$s from contacting you further?',
//                                 this.model.getDisplayName(),
//                             ),
//                         ]);
//                         if (result) {
//                             const jid = this.model.get('jid');
//                             api.blocklist.add(jid);
//                             api.contacts.remove(jid, true);
//                             this.model.close();
//                         }
//                     },
//                     i18n_text: __('Block this user'),
//                     i18n_title: __('Prevent this user from sending you any further messages'),
//                     icon_class: 'fa-trash',
//                     name: 'block',
//                     standalone: false,
//                 });
//             }
//         }

//         if (!api.settings.get('singleton')) {
//             buttons.push({
//                 a_class: 'close-chatbox-button',
//                 handler: /** @param {Event} ev */ (ev) => this.close(ev),
//                 i18n_text: __('Close'),
//                 i18n_title: __('Close and end this conversation'),
//                 icon_class: 'fa-times',
//                 name: 'close',
//                 standalone: api.settings.get('view_mode') === 'overlayed',
//             });
//         }
//         const { chatboxviews } = _converse.state;
//         const el = chatboxviews.get(this.getAttribute('jid'));
//         if (el) {
//             /**
//              * *Hook* which allows plugins to add more buttons to a chat's heading.
//              *
//              * Note: This hook is fired for both 1 on 1 chats and groupchats.
//              * If you only care about one, you need to add a check in your code.
//              *
//              * @event _converse#getHeadingButtons
//              * @param { HTMLElement } el
//              *      The `converse-chat` (or `converse-muc`) DOM element that represents the chat
//              * @param { Array.<import('./types').HeadingButtonAttributes> }
//              *      An array of the existing buttons. New buttons may be added,
//              *      and existing ones removed or modified.
//              * @example
//              *  api.listen.on('getHeadingButtons', (el, buttons) => {
//              *      buttons.push({
//              *          'i18n_title': __('Foo'),
//              *          'i18n_text': __('Foo Bar'),
//              *          'handler': ev => alert('Foo!'),
//              *          'a_class': 'toggle-foo',
//              *          'icon_class': 'fa-foo',
//              *          'name': 'foo'
//              *      });
//              *      return buttons;
//              *  });
//              */
//             return _converse.api.hook('getHeadingButtons', el, buttons);
//         } else {
//             return buttons; // Happens during tests
//         }
//     }
// }
//video ok
// api.elements.define('converse-chat-heading', ChatHeading);
// import { _converse, api, converse } from '@converse/headless';
// import { CustomElement } from 'shared/components/element.js';
// import { __ } from 'i18n';
// import tplChatboxHead from './templates/chat-head.js';
// import 'shared/modals/user-details.js';

// import './styles/chat-head.scss';

// const { Strophe, $iq, $msg, sizzle } = converse.env;

// const NS_JINGLE = 'urn:xmpp:jingle:1';
// const NS_JINGLE_ICE = 'urn:xmpp:jingle:transports:ice-udp:1';
// const NS_JINGLE_RTP = 'urn:xmpp:jingle:apps:rtp:1';
// const NS_DTLS = 'urn:xmpp:jingle:apps:dtls:0';
// const NS_JINGLE_MSG = 'urn:xmpp:jingle-message:0';
// const NS_GROUPING = 'urn:xmpp:jingle:apps:grouping:0';

// const SKIP_RTP_CODECS = new Set([
//     'rtx',
//     'red',
//     'ulpfec',
//     'flexfec-03',
//     'telephone-event',
//     'cn',
//     'pcmu',
//     'pcma',
//     'g722',
// ]);

// // ─── SDP / Jingle helper functions ─────────────────────────────────────────

// function localName(el) {
//     return el?.localName || el?.nodeName?.split(':').pop();
// }
// function directChildren(el, name = null) {
//     return Array.from(el?.children || []).filter((c) => !name || localName(c) === name);
// }
// function firstDirectChild(el, name) {
//     return directChildren(el, name)[0] || null;
// }

// function getBrowserSupportedCodecNames(media) {
//     try {
//         const caps = RTCRtpReceiver.getCapabilities?.(media);
//         if (!caps?.codecs?.length) return null;
//         return new Set(caps.codecs.map((c) => c.mimeType?.split('/')[1]?.toLowerCase()).filter(Boolean));
//     } catch (e) {
//         return null;
//     }
// }

// function normalizeFmtpParam(name, value) {
//     const paramName = String(name || '')
//         .trim()
//         .replaceAll('_', '-');
//     let paramValue = value == null ? '' : String(value).trim();
//     if (paramValue === 'true') paramValue = '1';
//     if (paramValue === 'false') paramValue = '0';
//     // Decimal profile-level-id from iOS → hex (4382761 → 42e029)
//     if (paramName === 'profile-level-id' && /^\d+$/.test(paramValue)) {
//         paramValue = Number(paramValue).toString(16).padStart(6, '0').slice(-6);
//     }
//     // Force H264 level to 3.1 (42e01f) so Chrome decoder accepts the stream.
//     // level-asymmetry-allowed=1 means iOS can still send at level 4.1.
//     if (paramName === 'profile-level-id' && /^[0-9a-f]{6}$/i.test(paramValue)) {
//         paramValue = '42e01f';
//     }
//     return { name: paramName, value: paramValue };
// }

// function buildFmtpLine(payload) {
//     if (!payload.params?.length) return null;
//     const params = payload.params
//         .filter((p) => p.name && p.value != null && p.value !== '')
//         .map((p) => `${p.name}=${p.value}`);
//     if (!params.length) return null;
//     return `a=fmtp:${payload.id} ${params.join(';')}`;
// }

// function payloadsFromJingleDescription(description, media) {
//     const supported = getBrowserSupportedCodecNames(media);
//     const payloads = [];
//     for (const pt of directChildren(description, 'payload-type')) {
//         const id = pt.getAttribute('id');
//         const name = pt.getAttribute('name');
//         const clockrate = pt.getAttribute('clockrate') || (media === 'video' ? '90000' : '48000');
//         const channels = pt.getAttribute('channels');
//         if (!id || !name) continue;
//         const codec = name.toLowerCase();
//         if (SKIP_RTP_CODECS.has(codec)) continue;
//         if (codec === 'h265') continue;
//         if (supported && !supported.has(codec)) {
//             console.log('[SDP] Skipping unsupported codec:', media, name, id);
//             continue;
//         }
//         const paramsMap = new Map();
//         for (const param of directChildren(pt, 'parameter')) {
//             const rawName = param.getAttribute('name');
//             const rawValue = param.getAttribute('value');
//             if (!rawName) continue;
//             const normalized = normalizeFmtpParam(rawName, rawValue);
//             if (normalized.name) paramsMap.set(normalized.name, normalized.value);
//         }
//         payloads.push({
//             id,
//             name,
//             clockrate,
//             channels,
//             params: Array.from(paramsMap.entries()).map(([n, v]) => ({ name: n, value: v })),
//         });
//     }
//     return payloads;
// }

// function getJingleRtpContents(jingle) {
//     return directChildren(jingle, 'content').filter((c) => !!firstDirectChild(c, 'description'));
// }

// function getJingleBundleMids(jingle, contents) {
//     const group = firstDirectChild(jingle, 'group');
//     const mids = directChildren(group, 'content')
//         .map((c) => c.getAttribute('name'))
//         .filter(Boolean);
//     return mids.length ? mids : contents.map((c, i) => c.getAttribute('name') || String(i));
// }

// /**
//  * Build a WebRTC SDP string from a Jingle XML element.
//  * Works for both 'offer' (session-initiate) and 'answer' (session-accept).
//  */
// function buildSdpFromJingle(jingle, type = 'offer') {
//     const contents = getJingleRtpContents(jingle);
//     const bundleMids = getJingleBundleMids(jingle, contents);
//     const firstTransport = contents.map((c) => firstDirectChild(c, 'transport')).find(Boolean);
//     const firstFingerprint = firstTransport ? firstDirectChild(firstTransport, 'fingerprint') : null;

//     const sdpLines = [
//         'v=0',
//         'o=- 1234567890 2 IN IP4 0.0.0.0',
//         's=-',
//         't=0 0',
//         `a=group:BUNDLE ${bundleMids.join(' ')}`,
//         'a=msid-semantic: WMS',
//     ];

//     contents.forEach((content, index) => {
//         const mid = content.getAttribute('name') || String(index);
//         const description = firstDirectChild(content, 'description');
//         const media = description?.getAttribute('media');
//         if (!description || !media) return;

//         const payloads = payloadsFromJingleDescription(description, media);
//         const payloadIds = payloads.map((p) => p.id);
//         if (!payloadIds.length) {
//             console.warn('[SDP] No compatible payloads for', media, mid);
//             return;
//         }

//         const transport = firstDirectChild(content, 'transport') || firstTransport;
//         const fingerprintEl = firstDirectChild(transport, 'fingerprint') || firstFingerprint;
//         const ufrag = transport?.getAttribute('ufrag');
//         const pwd = transport?.getAttribute('pwd');
//         const fingerprint = fingerprintEl?.textContent?.trim();
//         const setup = fingerprintEl?.getAttribute('setup') || (type === 'answer' ? 'active' : 'actpass');

//         sdpLines.push(`m=${media} 9 UDP/TLS/RTP/SAVPF ${payloadIds.join(' ')}`, 'c=IN IP4 0.0.0.0');
//         if (ufrag) sdpLines.push(`a=ice-ufrag:${ufrag}`);
//         if (pwd) sdpLines.push(`a=ice-pwd:${pwd}`);
//         if (fingerprint) sdpLines.push(`a=fingerprint:sha-256 ${fingerprint}`);
//         sdpLines.push(`a=setup:${setup}`, `a=mid:${mid}`, 'a=rtcp-mux');

//         for (const payload of payloads) {
//             const ch = payload.channels ? `/${payload.channels}` : '';
//             sdpLines.push(`a=rtpmap:${payload.id} ${payload.name}/${payload.clockrate}${ch}`);
//             const fmtp = buildFmtpLine(payload);
//             if (fmtp) sdpLines.push(fmtp);
//             // rtcp-fb lines are required for Chrome to send PLI/NACK/FIR feedback.
//             // Without them Chrome won't request keyframes → remote video stays frozen.
//             if (media === 'video') {
//                 sdpLines.push(
//                     `a=rtcp-fb:${payload.id} nack`,
//                     `a=rtcp-fb:${payload.id} nack pli`,
//                     `a=rtcp-fb:${payload.id} ccm fir`,
//                     `a=rtcp-fb:${payload.id} goog-remb`,
//                     `a=rtcp-fb:${payload.id} transport-cc`,
//                 );
//             }
//         }
//         sdpLines.push('a=sendrecv');
//     });

//     return sdpLines.join('\r\n') + '\r\n';
// }

// function parseSdpSections(sdp) {
//     const rawLines = String(sdp || '')
//         .split(/\r?\n/)
//         .map((l) => l.trim())
//         .filter(Boolean);
//     const sessionLines = [];
//     const sections = [];
//     let current = null;
//     for (const line of rawLines) {
//         if (line.startsWith('m=')) {
//             current = {
//                 mLine: line,
//                 lines: [line],
//                 media: line.slice(2).split(/\s+/)[0],
//                 mid: null,
//                 payloadIds: line.split(/\s+/).slice(3),
//             };
//             sections.push(current);
//             continue;
//         }
//         if (!current) {
//             sessionLines.push(line);
//             continue;
//         }
//         current.lines.push(line);
//         if (line.startsWith('a=mid:')) current.mid = line.slice('a=mid:'.length).trim();
//     }
//     sections.forEach((s, i) => {
//         if (!s.mid) s.mid = String(i);
//     });
//     return { sessionLines, sections };
// }

// function getIceInfoFromSdpSection(section, sessionLines = []) {
//     const lines = [...(section?.lines || []), ...sessionLines];
//     const find = (re) => {
//         for (const l of lines) {
//             const m = l.match(re);
//             if (m) return m[1].trim();
//         }
//         return null;
//     };
//     return {
//         ufrag: find(/^a=ice-ufrag:(.+)$/),
//         pwd: find(/^a=ice-pwd:(.+)$/),
//         fingerprint: find(/^a=fingerprint:sha-256\s+(.+)$/),
//         setup: find(/^a=setup:(.+)$/),
//     };
// }

// function payloadsFromSdpSection(section) {
//     const rtpmapByPt = new Map();
//     const fmtpByPt = new Map();
//     for (const line of section.lines) {
//         let m = line.match(/^a=rtpmap:(\d+)\s+([^/]+)\/(\d+)(?:\/(\d+))?$/);
//         if (m) {
//             const [, id, name, clockrate, channels] = m;
//             rtpmapByPt.set(id, { id, name, clockrate, channels, params: [] });
//             continue;
//         }
//         m = line.match(/^a=fmtp:(\d+)\s+(.+)$/);
//         if (m) {
//             const [, id, rawFmtp] = m;
//             const params = rawFmtp
//                 .split(';')
//                 .map((p) => p.trim())
//                 .filter(Boolean)
//                 .map((p) => {
//                     const eq = p.indexOf('=');
//                     if (eq === -1) return null;
//                     return normalizeFmtpParam(p.slice(0, eq), p.slice(eq + 1));
//                 })
//                 .filter(Boolean);
//             fmtpByPt.set(id, params);
//         }
//     }
//     return section.payloadIds
//         .map((id) => {
//             const payload = rtpmapByPt.get(id);
//             if (!payload) return null;
//             const codec = payload.name.toLowerCase();
//             if (SKIP_RTP_CODECS.has(codec)) return null;
//             payload.params = fmtpByPt.get(id) || [];
//             return payload;
//         })
//         .filter(Boolean);
// }

// /**
//  * Build a Jingle IQ stanza from our local SDP (for session-initiate or session-accept).
//  */
// function buildJingleIqFromLocalSdp({
//     action,
//     to,
//     sid,
//     initiator,
//     responder,
//     localSdp,
//     contentCreatorsByMid = new Map(),
//     preferredMidOrder = null,
// }) {
//     const { sessionLines, sections } = parseSdpSections(localSdp);
//     let ordered = sections.filter((s) => s.media === 'audio' || s.media === 'video');
//     if (preferredMidOrder?.length) {
//         const byMid = new Map(ordered.map((s) => [s.mid, s]));
//         ordered = preferredMidOrder.map((mid) => byMid.get(mid)).filter(Boolean);
//     }
//     const iq = $iq({ type: 'set', to, id: crypto.randomUUID().toLowerCase() }).c('jingle', {
//         xmlns: NS_JINGLE,
//         action,
//         sid,
//         ...(initiator ? { initiator } : {}),
//         ...(responder ? { responder } : {}),
//     });
//     iq.c('group', { xmlns: NS_GROUPING, semantics: 'BUNDLE' });
//     for (const s of ordered) iq.c('content', { name: s.mid }).up();
//     iq.up();
//     for (const section of ordered) {
//         const creator = contentCreatorsByMid.get(section.mid) || 'initiator';
//         const ice = getIceInfoFromSdpSection(section, sessionLines);
//         const payloads = payloadsFromSdpSection(section);
//         iq.c('content', { creator, name: section.mid });
//         iq.c('description', { xmlns: NS_JINGLE_RTP, media: section.media });
//         for (const p of payloads) {
//             const attrs = { id: p.id, name: p.name, clockrate: p.clockrate };
//             if (p.channels) attrs.channels = p.channels;
//             iq.c('payload-type', attrs);
//             for (const param of p.params || []) {
//                 if (!param.name || param.value == null || param.value === '') continue;
//                 iq.c('parameter', { name: param.name, value: param.value }).up();
//             }
//             iq.up();
//         }
//         iq.c('rtcp-mux').up();
//         iq.up();
//         iq.c('transport', {
//             xmlns: NS_JINGLE_ICE,
//             ...(ice.ufrag ? { ufrag: ice.ufrag } : {}),
//             ...(ice.pwd ? { pwd: ice.pwd } : {}),
//         });
//         if (ice.fingerprint) {
//             iq.c('fingerprint', {
//                 xmlns: NS_DTLS,
//                 hash: 'sha-256',
//                 setup: ice.setup || (action === 'session-accept' ? 'active' : 'actpass'),
//             })
//                 .t(ice.fingerprint)
//                 .up();
//         }
//         iq.up();
//         iq.up();
//     }
//     return iq;
// }

// // ─── End SDP helpers ────────────────────────────────────────────────────────

// export default class ChatHeading extends CustomElement {
//     // Static reference to the ChatHeading instance that owns the active call.
//     // Incoming Jingle stanzas are routed here regardless of which instance's
//     // handler fires (every open chat registers its own handler).
//     static activeCall = null;

//     // Guard so the Strophe IQ handler and message listener are registered
//     // only ONCE, not per-instance. Multiple registrations cause Strophe to
//     // fire every handler per incoming stanza, breaking the pc state machine.
//     static _jingleHandlersRegistered = false;

//     // Tracks whether the Strophe-level IQ handler is currently attached.
//     // Separate from _jingleHandlersRegistered because connection lost / reconnect
//     // can detach the handler while the static-listener side stays put.
//     static _stropheHandlerAttached = false;

//     // Pending incoming call (showing modal). Used so <retract> can cancel the modal.
//     static _pendingIncomingSid = null;
//     static _pendingIncomingFrom = null;
//     // Callback set while modal is shown — call it to close the modal externally.
//     static _closeIncomingModal = null;

//     // Timer interval for the call panel
//     static _callTimerInterval = null;

//     // Remote video stream received before PiP was created — flushed in _showCallPanel
//     static _pendingRemoteVideoStream = null;

//     static _iceServersCache = null;
//     static _iceServersCacheExpiry = 0;

//     /**
//      * Request a keyframe from remote video senders and poll readyState.
//      * Chrome needs an IDR (keyframe) to start decoding H264. If iOS doesn't
//      * send one immediately, readyState stays 0 despite live tracks arriving.
//      */
//     static _requestKeyframeAndPollVideo(pc) {
//         if (!pc) return;
//         try {
//             pc.getReceivers().forEach((receiver) => {
//                 if (receiver.track?.kind === 'video') {
//                     console.log('[ChatHeading] Video receiver readyState:', receiver.track.readyState);
//                     if (typeof receiver.jitterBufferTarget !== 'undefined') {
//                         receiver.jitterBufferTarget = 0;
//                     }
//                 }
//             });
//         } catch (e) {
//             /* ignore */
//         }

//         let attempts = 0;
//         const poll = setInterval(async () => {
//             attempts++;
//             const vid = document.getElementById('sonata-video-remote');
//             if (!vid) {
//                 clearInterval(poll);
//                 return;
//             }
//             const rs = vid.readyState;
//             console.log(`[ChatHeading] Video poll ${attempts}: readyState=${rs} paused=${vid.paused}`);
//             if (rs >= 2) {
//                 console.log('%c [VIDEO] ✅ Playing! readyState=' + rs, 'background: green; color: white;');
//                 clearInterval(poll);
//                 return;
//             }
//             if (vid.paused && vid.srcObject) {
//                 vid.play().catch(() => {});
//             }
//             // At 2s: check RTP stats — are packets even arriving?
//             if (attempts === 4) {
//                 try {
//                     const stats = await pc.getStats();
//                     stats.forEach((report) => {
//                         if (report.type === 'inbound-rtp' && report.kind === 'video') {
//                             console.log(
//                                 `[VIDEO STATS] packetsReceived=${report.packetsReceived} framesReceived=${report.framesReceived || 0} framesDecoded=${report.framesDecoded || 0} framesDropped=${report.framesDropped || 0} decoderImpl=${report.decoderImplementation || '?'}`,
//                             );
//                         }
//                         if (report.type === 'codec' && report.mimeType?.toLowerCase().includes('h264')) {
//                             console.log(`[VIDEO STATS] codec: ${report.mimeType} fmtp=${report.sdpFmtpLine}`);
//                         }
//                     });
//                 } catch (e) {
//                     console.warn('[VIDEO STATS] getStats failed:', e.message);
//                 }
//             }
//             // Re-attach stream after 3s to force a new decoder init + keyframe request
//             if (attempts === 6 && rs === 0 && vid.srcObject) {
//                 console.warn('[ChatHeading] No frames after 3s — cycling srcObject to force keyframe');
//                 const stream = vid.srcObject;
//                 vid.srcObject = null;
//                 setTimeout(() => {
//                     vid.srcObject = stream;
//                     vid.play().catch(() => {});
//                 }, 150);
//             }
//             if (attempts >= 20) {
//                 clearInterval(poll);
//             }
//         }, 500);
//     }

//     /**
//      * Fetch ICE servers via XEP-0215 external service discovery.
//      * Queries the XMPP server (not the remote peer). Cached after first call.
//      */
//     static async _getIceServers() {
//         if (ChatHeading._iceServersCache && Date.now() < ChatHeading._iceServersCacheExpiry) {
//             return ChatHeading._iceServersCache;
//         }
//         const fallback = [{ urls: 'stun:stun.l.google.com:19302' }];
//         try {
//             // Always query our own server domain, never a peer JID
//             const domain =
//                 _converse.domain || (_converse.bare_jid || '').split('@')[1] || (_converse.jid || '').split('@')[1];
//             if (!domain) {
//                 console.warn('[ChatHeading] No domain for XEP-0215');
//                 return fallback;
//             }
//             console.log('[ChatHeading] Querying XEP-0215 TURN from domain:', domain);

//             let services = null;
//             for (const xmlns of ['urn:xmpp:extdisco:2', 'urn:xmpp:extdisco:1']) {
//                 try {
//                     const iq = $iq({ type: 'get', to: domain }).c('services', { xmlns });
//                     const result = await new Promise((resolve, reject) => {
//                         const timer = setTimeout(() => reject(new Error('timeout')), 5000);
//                         _converse.api
//                             .sendIQ(iq)
//                             .then((res) => {
//                                 clearTimeout(timer);
//                                 resolve(res);
//                             })
//                             .catch((err) => {
//                                 clearTimeout(timer);
//                                 reject(err);
//                             });
//                     });
//                     const found = result.querySelectorAll('service');
//                     if (found.length) {
//                         services = found;
//                         console.log(`[ChatHeading] XEP-0215 ${xmlns}: got ${found.length} services`);
//                         break;
//                     }
//                 } catch (e) {
//                     console.log(`[ChatHeading] XEP-0215 ${xmlns} failed:`, e.message);
//                 }
//             }

//             if (!services || !services.length) {
//                 console.warn('[ChatHeading] XEP-0215 returned no TURN services');
//                 ChatHeading._iceServersCache = fallback;
//                 return fallback;
//             }

//             const iceServers = [{ urls: 'stun:stun.l.google.com:19302' }];
//             services.forEach((svc) => {
//                 const type = svc.getAttribute('type');
//                 const host = svc.getAttribute('host');
//                 const port = svc.getAttribute('port');
//                 const user = svc.getAttribute('username');
//                 const pass = svc.getAttribute('password');
//                 const transport = svc.getAttribute('transport') || 'udp';
//                 if (!host) return;
//                 if (type === 'stun') {
//                     iceServers.push({ urls: `stun:${host}${port ? ':' + port : ''}` });
//                 } else if (type === 'turn') {
//                     const url = `turn:${host}${port ? ':' + port : ''}?transport=${transport}`;
//                     const entry = { urls: url };
//                     if (user) entry.username = user;
//                     if (pass) entry.credential = pass;
//                     iceServers.push(entry);
//                     console.log(`[ChatHeading] TURN: ${url} user=${user}`);
//                 }
//             });
//             console.log('[ChatHeading] ICE servers:', JSON.stringify(iceServers));
//             ChatHeading._iceServersCache = iceServers;
//             // TURN credentials expire at the timestamp in username (unix seconds).
//             // Refresh 5 minutes before expiry.
//             const turnEntry = iceServers.find((s) => s.urls?.startsWith?.('turn:') && s.username);
//             if (turnEntry) {
//                 const expireTs = parseInt(turnEntry.username.split(':')[0], 10) * 1000;
//                 ChatHeading._iceServersCacheExpiry = expireTs - 5 * 60 * 1000;
//             } else {
//                 ChatHeading._iceServersCacheExpiry = Date.now() + 3600 * 1000;
//             }
//             return iceServers;
//         } catch (e) {
//             console.warn('[ChatHeading] _getIceServers error:', e.message);
//             return fallback;
//         }
//     }

//     constructor() {
//         super();
//         this.jid = null;

//         // --- Call state (per-instance) ---
//         // NOTE: keeping these on the instance means every open chat has its own
//         // pc / localStream. If multiple chats are open and the user triggers
//         // calls in parallel, they won't interfere — but the *incoming* Jingle
//         // handlers below register once per ChatHeading instance, so every open
//         // chat will receive and try to handle every incoming Jingle stanza.
//         // That is the known bug we accepted.
//         this.pc = null;
//         this.localStream = null;
//         this.iceCandidatesQueue = [];
//         this.currentSid = null;
//         this.isIncoming = false;
//         this.remoteFullJid = null;
//         this.isVideo = false; // true when this is a video call
//     }

//     static get properties() {
//         return {
//             jid: { type: String },
//         };
//     }

//     initialize() {
//         const { chatboxes } = _converse.state;
//         this.model = chatboxes.get(this.jid);
//         this.listenTo(this.model, 'change:status', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:add', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:change', () => this.requestUpdate());
//         if (this.model.contact) {
//             this.listenTo(this.model.contact, 'destroy', () => this.requestUpdate());
//         }
//         this.model.rosterContactAdded?.then(() => {
//             this.listenTo(this.model.contact, 'change:nickname', () => this.requestUpdate());
//             this.requestUpdate();
//         });

//         // --- Wire up Jingle handlers on this instance ---
//         // BUG WARNING: registered per ChatHeading. With N open chats, every
//         // incoming Jingle IQ fires N times. Same for the 'message' (proceed)
//         // listener and the 'connected' event.
//         this._registerJingleHandlers();

//         this.requestUpdate();
//     }

//     render() {
//         return tplChatboxHead(this);
//     }

//     /**
//      * @param {Event} ev
//      */
//     showUserDetailsModal(ev) {
//         ev.preventDefault();
//         if (this.model?.contact instanceof _converse.exports.Profile) {
//             api.modal.show('converse-profile-modal', { model: this.model }, ev);
//         } else {
//             api.modal.show('converse-user-details-modal', { model: this.model }, ev);
//         }
//     }

//     /**
//      * @param {Event} ev
//      */
//     close(ev) {
//         ev.preventDefault();
//         this.model.close();
//     }

//     // ========================================================================
//     // CALL LOGIC (moved from sonata-p2p-init plugin)
//     // ========================================================================

//     _registerJingleHandlers() {
//         // Register the Strophe IQ handler and message listener EXACTLY ONCE
//         // across all ChatHeading instances. Without this guard, every open
//         // chat registers its own handler, and Strophe fires ALL of them per
//         // incoming stanza — resulting in N calls to setRemoteDescription /
//         // addIceCandidate on the same pc, which breaks the RTCPeerConnection
//         // state machine and ICE never completes.
//         if (ChatHeading._jingleHandlersRegistered) return;
//         ChatHeading._jingleHandlersRegistered = true;

//         console.log('=== [ChatHeading] Registering Jingle handlers (once globally) ===');

//         const self = this;

//         // Wait for Strophe connection, then attach raw IQ handler for Jingle.
//         // The plugin used `_converse.on('connected', ...)` which fires once at
//         // login. But ChatHeading.initialize() runs PER CHAT OPEN, which may be
//         // AFTER 'connected' has already fired (event missed). So we try all
//         // three paths: immediate (if connection exists), 'connected' listener,
//         // AND a polling fallback. Whichever wins, the static guard inside
//         // attach() prevents double-registration on Strophe.
//         const attach = () => {
//             if (ChatHeading._stropheHandlerAttached) return;
//             const connection = _converse.connection || api.connection?.get?.();
//             if (!connection || !connection.addHandler) {
//                 console.log('[ChatHeading] No Strophe connection yet, will retry');
//                 return false;
//             }

//             ChatHeading._stropheHandlerAttached = true;
//             console.log('[ChatHeading] ✓ Strophe Jingle IQ handler attached');

//             connection.addHandler(
//                 (stanza) => {
//                     const jingle = sizzle(`jingle[xmlns="${NS_JINGLE}"]`, stanza).pop();
//                     if (!jingle) return true;

//                     const action = jingle.getAttribute('action');
//                     const from = stanza.getAttribute('from');
//                     const id = stanza.getAttribute('id');
//                     const sid = jingle.getAttribute('sid');

//                     console.log(
//                         `%c [JINGLE RECEIVE] Action: ${action} from ${from} sid=${sid} `,
//                         'background: #222; color: #bada55; padding: 2px;',
//                     );

//                     // ACK the IQ immediately
//                     connection.send($iq({ type: 'result', to: from, id: id }).tree());

//                     const target = ChatHeading.activeCall;
//                     if (!target) {
//                         console.warn('[JINGLE RECEIVE] No active call; ignoring', action);
//                         return true;
//                     }
//                     if (!target.pc) {
//                         console.warn(
//                             '[JINGLE RECEIVE] Active call has no pc yet; action=' + action,
//                             '— may be timing issue',
//                         );
//                         // For transport-info we can queue. For session-initiate
//                         // (incoming call) we create the pc inside the handler.
//                         // For session-accept we can't do much without pc — skip.
//                         if (action === 'transport-info' || action === 'session-initiate') {
//                             // ok, let it through
//                         } else {
//                             return true;
//                         }
//                     }

//                     switch (action) {
//                         case 'session-initiate': {
//                             console.log('[JINGLE RECEIVE] session-initiate (we are callee)');
//                             // Pass raw jingle XML — handleSessionInitiate uses buildSdpFromJingle
//                             target.handleSessionInitiate(from, sid, jingle);
//                             break;
//                         }
//                         case 'session-accept': {
//                             // Pass raw jingle XML — handleSessionAccept uses buildSdpFromJingle
//                             target.handleSessionAccept(from, sid, jingle);
//                             break;
//                         }
//                         case 'transport-info':
//                             target.handleIncomingCandidates(jingle);
//                             break;
//                         case 'session-terminate':
//                             console.warn('[JINGLE RECEIVE] Remote terminated the call');
//                             console.warn('[JINGLE RECEIVE] session-terminate reason XML:', jingle.outerHTML);
//                             target.terminateCall(false);
//                             break;
//                         case 'session-info':
//                             // ringing / on_hold / etc — informational only
//                             console.log('[JINGLE RECEIVE] session-info (informational):', jingle.innerHTML);
//                             break;
//                         default:
//                             console.log('[JINGLE RECEIVE] Unhandled action:', action);
//                     }

//                     return true;
//                 },
//                 NS_JINGLE,
//                 'iq',
//                 'set',
//             );
//             return true;
//         };

//         // Path 1: connection already exists at registration time
//         if (_converse.connection && _converse.connection.addHandler) {
//             attach();
//         }

//         // Path 2: listen for 'connected' event (covers logout/reconnect cycles)
//         api.listen.on('connected', () => {
//             console.log('[ChatHeading] connected event fired');
//             ChatHeading._stropheHandlerAttached = false; // re-attach after reconnect
//             attach();
//         });

//         // Path 3: polling fallback. ChatHeading.initialize() may run AFTER
//         // 'connected' has already fired (because user opened a chat after
//         // login). In that case neither Path 1 nor Path 2 catches it. Poll
//         // until connection becomes available, then stop.
//         const pollInterval = setInterval(() => {
//             if (ChatHeading._stropheHandlerAttached) {
//                 clearInterval(pollInterval);
//                 return;
//             }
//             if (attach()) {
//                 clearInterval(pollInterval);
//             }
//         }, 500);
//         // Stop polling after 30s no matter what to avoid leaks
//         setTimeout(() => clearInterval(pollInterval), 30000);

//         // Listen for Jingle Message Initiation on regular messages:
//         //   <propose> — incoming call (we are callee)
//         //   <retract> — caller cancelled before we picked up
//         //   <proceed> — callee accepted our call (we are caller)
//         //   <ringing>, <received>, <reject>, <accept> — info
//         _converse.on('message', (data) => {
//             const stanza = data.stanza;
//             const from = stanza.getAttribute('from');
//             const bare_jid = _converse.bare_jid;
//             const fromBare = from?.split('/')[0];

//             // Ignore our own carbons (echoes of stanzas we sent)
//             const isOwnCarbon = fromBare === bare_jid;

//             // Look for any JMI element
//             const propose = sizzle(`propose[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const retract = sizzle(`retract[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const proceed = sizzle(`proceed[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const ringing = sizzle(`ringing[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const received = sizzle(`received[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const reject = sizzle(`reject[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const accept = sizzle(`accept[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();

//             // --- INCOMING CALL: <propose> ---
//             if (propose && !isOwnCarbon) {
//                 const sid = propose.getAttribute('id');
//                 const description = sizzle('description', propose).pop();
//                 const media = description?.getAttribute('media') || 'audio';
//                 console.log(
//                     `%c [JMI INCOMING] propose from ${from} sid=${sid} media=${media} `,
//                     'background: #1e9652; color: white; padding: 2px;',
//                 );
//                 ChatHeading.handleIncomingPropose(from, sid, media);
//                 return;
//             }

//             // --- CALLER CANCELLED: <retract> ---
//             if (retract && !isOwnCarbon) {
//                 const sid = retract.getAttribute('id');
//                 console.warn(`[JMI INCOMING] retract from ${from} sid=${sid} (caller cancelled)`);
//                 ChatHeading.handleRetract(sid);
//                 return;
//             }

//             // --- CALL ENDED BY REMOTE: <finish> (XEP-0272 / Sonata extension) ---
//             const finish = sizzle(`finish[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             if (finish && !isOwnCarbon) {
//                 const sid = finish.getAttribute('id');
//                 console.warn(`[JMI] finish from ${from} sid=${sid} — remote ended call`);
//                 const t = ChatHeading.activeCall;
//                 if (t) t.terminateCall(false); // remote already ended, don't echo
//                 return;
//             }

//             if (ringing) {
//                 console.log('[JMI] ringing from', from);
//                 return;
//             }
//             if (received) {
//                 console.log('[JMI] received (delivery ack) from', from);
//                 return;
//             }
//             if (reject) {
//                 console.warn('[JMI] reject from', from, '— remote declined');
//                 const t = ChatHeading.activeCall;
//                 if (t) t.terminateCall(false);
//                 return;
//             }
//             if (accept) {
//                 console.log('[JMI] accept seen (carbon echo from another device)');
//                 return;
//             }

//             // --- OUR OUTGOING CALL WAS ACCEPTED: <proceed> ---
//             if (proceed) {
//                 console.log('=== [JMI] proceed from', from, '===');
//                 const target = ChatHeading.activeCall;
//                 if (!target) {
//                     console.warn('[ChatHeading] proceed received but no active call');
//                     return;
//                 }
//                 if (target.pc) {
//                     console.log('[ChatHeading] Already have pc, ignoring duplicate proceed');
//                     return;
//                 }
//                 console.log('=== [ChatHeading] Starting WebRTC (sendJingleInitiate) ===');
//                 const sid = proceed.getAttribute('id');
//                 target.sendJingleInitiate(from, sid);
//             }
//         });
//     }

//     /**
//      * Called from chat-head.js template buttons.
//      * @param {'audio'|'video'} media
//      */
//     async initiateCall(media = 'audio') {
//         if (!this.model) {
//             console.warn('[ChatHeading] No model, cannot initiate call');
//             return;
//         }

//         this.isVideo = media === 'video';

//         // Pre-warm media BEFORE sending <propose>.
//         try {
//             console.log(`[ChatHeading] Pre-warming media (${media})...`);
//             this.localStream = await navigator.mediaDevices.getUserMedia({
//                 audio: true,
//                 video: this.isVideo,
//             });
//         } catch (err) {
//             console.error('[ChatHeading] Media permission denied / unavailable:', err);
//             this.model.createMessage({
//                 message: `❌ Не вдалося отримати доступ до ${this.isVideo ? 'камери/мікрофона' : 'мікрофона'}`,
//                 type: 'info',
//             });
//             return;
//         }

//         const jid = this.model.get('jid');
//         const sid = crypto.randomUUID().toUpperCase();
//         const stanzaId = `jm-propose-${sid}`;
//         const myNick = _converse.xmppstatus.get('fullname') || _converse.bare_jid;

//         this.currentSid = sid;
//         ChatHeading.activeCall = this;

//         console.log(`[ChatHeading] Proposing ${media} call to ${jid}, SID: ${sid}`);

//         const propose = $msg({ to: jid, type: 'chat', id: stanzaId })
//             .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: stanzaId })
//             .up()
//             .c('propose', { xmlns: NS_JINGLE_MSG, id: sid })
//             .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//             .up();

//         if (this.isVideo) {
//             propose.c('description', { xmlns: NS_JINGLE_RTP, media: 'video' }).up();
//         }

//         propose
//             .up()
//             .c('request', { xmlns: 'urn:xmpp:receipts' })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' })
//             .up()
//             .c('x', { xmlns: 'p1:push:custom', key: 'type', value: 'call' })
//             .up()
//             .c('x', { xmlns: 'p1:push:custom', key: 'aps.mutable-content', value: '1' })
//             .up()
//             .c('customize', { xmlns: 'p1:push:customize', nick: myNick })
//             .c('body')
//             .t('Incoming call')
//             .up()
//             .up();

//         api.send(propose);
//         this.model.createMessage({
//             message: `${this.isVideo ? '📹' : '📞'} Виклик (очікування відповіді...)`,
//             type: 'info',
//         });
//         ChatHeading._showOutgoingCallPanel(this);
//     }

//     async sendJingleInitiate(fullJid, sid) {
//         console.log('[ChatHeading] >>> sendJingleInitiate START', { fullJid, sid });
//         this.iceCandidatesQueue = [];
//         this.currentSid = sid;
//         this.remoteFullJid = fullJid; // needed for terminateCall to send session-terminate

//         try {
//             // Reuse pre-warmed stream from initiateCall(). Only fall back to
//             // getUserMedia if there isn't one (e.g. incoming-direction calls
//             // that bypass our initiateCall — currently none, but safe).
//             if (!this.localStream) {
//                 console.log('[ChatHeading] No pre-warmed stream, requesting media...');
//                 this.localStream = await navigator.mediaDevices.getUserMedia({
//                     audio: true,
//                     video: this.isVideo,
//                 });
//                 console.log('[ChatHeading] Got media stream:', this.localStream);
//             } else {
//                 console.log('[ChatHeading] Reusing pre-warmed stream (isVideo:', this.isVideo, ')');
//             }

//             console.log('[ChatHeading] Creating RTCPeerConnection...');
//             const iceServers = await ChatHeading._getIceServers();
//             console.log('[ChatHeading] Using ICE servers:', JSON.stringify(iceServers));
//             this.pc = new RTCPeerConnection({
//                 iceServers,
//                 bundlePolicy: 'max-bundle',
//                 rtcpMuxPolicy: 'require',
//                 iceCandidatePoolSize: 2, // pre-gather candidates before offer
//             });
//             console.log('[ChatHeading] RTCPeerConnection created');

//             this.pc.oniceconnectionstatechange = () => {
//                 console.log(`%c [ICE] state=${this.pc.iceConnectionState} `, 'color: orange; font-weight: bold;');
//                 if (this.pc.iceConnectionState === 'failed') {
//                     console.warn('[ICE] FAILED — attempting ICE restart...');
//                     // Log which candidate pairs were tried
//                     this.pc
//                         .getStats()
//                         .then((stats) => {
//                             stats.forEach((r) => {
//                                 if (r.type === 'candidate-pair') {
//                                     console.log(
//                                         `[ICE PAIR] state=${r.state} local=${r.localCandidateId} remote=${r.remoteCandidateId} nominated=${r.nominated} bytesSent=${r.bytesSent || 0} bytesReceived=${r.bytesReceived || 0}`,
//                                     );
//                                 }
//                                 if (r.type === 'local-candidate') {
//                                     console.log(
//                                         `[ICE LOCAL] id=${r.id} type=${r.candidateType} ip=${r.address || r.ip} port=${r.port} proto=${r.protocol}`,
//                                     );
//                                 }
//                                 if (r.type === 'remote-candidate') {
//                                     console.log(
//                                         `[ICE REMOTE] id=${r.id} type=${r.candidateType} ip=${r.address || r.ip} port=${r.port}`,
//                                     );
//                                 }
//                             });
//                         })
//                         .catch(() => {});
//                     if (this.pc.signalingState === 'stable' && this.pc.restartIce) {
//                         this.pc.restartIce();
//                     }
//                 }
//                 if (this.pc.iceConnectionState === 'disconnected') {
//                     console.warn('[ICE] DISCONNECTED — will restart if not recovered in 5s');
//                     setTimeout(() => {
//                         if (this.pc && this.pc.iceConnectionState === 'disconnected') {
//                             console.warn('[ICE] Still disconnected — restarting ICE');
//                             if (this.pc.signalingState === 'stable' && this.pc.restartIce) {
//                                 this.pc.restartIce();
//                             }
//                         }
//                     }, 5000);
//                 }
//                 if (this.pc.iceConnectionState === 'connected') {
//                     console.log('%c [ICE] ✅ CONNECTED ', 'background: green; color: white;');
//                     ChatHeading._showCallPanel(this);
//                     ChatHeading._requestKeyframeAndPollVideo(this.pc);
//                 }
//             };

//             this.pc.onconnectionstatechange = () => {
//                 console.log(`[PC] connectionState=${this.pc.connectionState}`);
//             };

//             this.pc.onsignalingstatechange = () => {
//                 console.log(`[PC] signalingState=${this.pc.signalingState}`);
//             };

//             this.pc.ontrack = (event) => {
//                 console.log(
//                     `%c [TRACK] kind=${event.track.kind} streams=${event.streams.length} `,
//                     'background: #333; color: #7ec8e3; padding: 2px;',
//                 );
//                 if (event.track.kind === 'audio') {
//                     console.log('[ChatHeading] Attaching remote audio track');
//                     let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
//                     el.id = 'sonata-audio-remote';
//                     el.autoplay = true;
//                     if (!el.parentElement) document.body.appendChild(el);
//                     el.srcObject = event.streams[0];
//                 } else if (event.track.kind === 'video') {
//                     console.log('[ChatHeading] Attaching remote video track — PiP should show');
//                     ChatHeading._attachRemoteVideo(event.streams[0]);
//                 }
//             };

//             this.pc.onicecandidate = (event) => {
//                 if (event.candidate) {
//                     const c = event.candidate;
//                     console.log('[ChatHeading] Local candidate:', c.candidate);
//                     const attrs = {
//                         id: String(Math.floor(Math.random() * 4294967295)),
//                         component: String(c.component || 1),
//                         foundation: c.foundation,
//                         generation: '0',
//                         ip: c.address || c.ip,
//                         port: String(c.port),
//                         priority: String(c.priority),
//                         protocol: (c.protocol || 'udp').toLowerCase(),
//                         type: c.type,
//                     };
//                     if (c.relatedAddress) attrs['rel-addr'] = c.relatedAddress;
//                     if (c.relatedPort) attrs['rel-port'] = String(c.relatedPort);
//                     const iq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                         .c('jingle', { xmlns: NS_JINGLE, action: 'transport-info', initiator: _converse.jid, sid })
//                         .c('content', { creator: 'initiator', name: '0' })
//                         .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                         .c('candidate', attrs);
//                     api.send(iq);
//                 }
//             };

//             this.localStream.getTracks().forEach((track) => this.pc.addTrack(track, this.localStream));

//             const offer = await this.pc.createOffer();
//             await this.pc.setLocalDescription(offer);

//             const sdp = this.pc.localDescription.sdp;
//             console.log('[ChatHeading] 📋 LOCAL OFFER SDP (full):\n', sdp);
//             const ufrag = sdp.match(/a=ice-ufrag:(.*)\r/)[1];
//             const pwd = sdp.match(/a=ice-pwd:(.*)\r/)[1];
//             const fingerprint = sdp.match(/a=fingerprint:sha-256 (.*)\r/)[1];

//             console.log('[ChatHeading] Sending session-initiate (isVideo:', this.isVideo, ')...');
//             console.log(
//                 '[ChatHeading] Local tracks:',
//                 this.localStream?.getTracks().map((t) => `${t.kind}:${t.label}`),
//             );

//             // Parse video codecs from our actual offer SDP so PT numbers match.
//             // Hardcoding 96/97 doesn't work — browser assigns different PT numbers
//             // (e.g. H264 gets 103, 107, etc). iOS/Android match by PT number in the
//             // answer, so we must use whatever the browser assigned in the offer.
//             const SKIP = new Set([
//                 'rtx',
//                 'red',
//                 'ulpfec',
//                 'flexfec-03',
//                 'telephone-event',
//                 'cn',
//                 'pcmu',
//                 'pcma',
//                 'g722',
//             ]);
//             const offerVideoPayloads = [];
//             let inVid = false;
//             for (const line of sdp.split('\n')) {
//                 const l = line.trim();
//                 if (l.startsWith('m=video')) {
//                     inVid = true;
//                     continue;
//                 }
//                 if (l.startsWith('m=') && inVid) {
//                     inVid = false;
//                     break;
//                 }
//                 if (inVid && l.startsWith('a=rtpmap:')) {
//                     const m = l.match(/^a=rtpmap:(\d+) ([^/]+)\/(\d+)/);
//                     if (m && !SKIP.has(m[2].toLowerCase())) {
//                         offerVideoPayloads.push({ id: m[1], name: m[2], clockrate: m[3] });
//                     }
//                 }
//             }
//             // Reorder: H264 first (for iOS), then others
//             offerVideoPayloads.sort((a, b) => {
//                 const aH = a.name.toLowerCase().includes('h264') ? 0 : 1;
//                 const bH = b.name.toLowerCase().includes('h264') ? 0 : 1;
//                 return aH - bH;
//             });
//             console.log('[ChatHeading] Outgoing video offer payloads:', offerVideoPayloads);

//             // Build session-initiate as one unbroken chain.
//             let initiateIq;
//             if (this.isVideo) {
//                 let iq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', { xmlns: NS_JINGLE, action: 'session-initiate', initiator: _converse.jid, sid })
//                     .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                     .c('content', { name: '0' })
//                     .up()
//                     .c('content', { name: '1' })
//                     .up()
//                     .up()
//                     .c('content', { creator: 'initiator', name: '0' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                     .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                     .c('parameter', { name: 'minptime', value: '10' })
//                     .up()
//                     .c('parameter', { name: 'useinbandfec', value: '1' })
//                     .up()
//                     .up()
//                     .c('rtcp-mux')
//                     .up()
//                     .up()
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                     .t(fingerprint)
//                     .up()
//                     .up()
//                     .up()
//                     .c('content', { creator: 'initiator', name: '1' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'video' });

//                 offerVideoPayloads.forEach((p) =>
//                     iq.c('payload-type', { id: p.id, name: p.name, clockrate: p.clockrate }).up(),
//                 );

//                 iq = iq
//                     .c('rtcp-mux')
//                     .up()
//                     .up()
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                     .t(fingerprint)
//                     .up()
//                     .up()
//                     .up();

//                 initiateIq = iq;
//             } else {
//                 initiateIq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', { xmlns: NS_JINGLE, action: 'session-initiate', initiator: _converse.jid, sid })
//                     .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                     .c('content', { name: '0' })
//                     .up()
//                     .up() // </group>
//                     .c('content', { creator: 'initiator', name: '0' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                     .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                     .c('parameter', { name: 'minptime', value: '10' })
//                     .up()
//                     .c('parameter', { name: 'useinbandfec', value: '1' })
//                     .up()
//                     .up() // </payload-type>
//                     .c('rtcp-mux')
//                     .up()
//                     .up() // </description>
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                     .t(fingerprint)
//                     .up()
//                     .up() // </transport>
//                     .up(); // </content>
//             }

//             api.send(initiateIq);
//             console.log('[ChatHeading] 📤 session-initiate XML:\n', initiateIq.toString());
//             console.log('[ChatHeading] >>> sendJingleInitiate DONE (session-initiate sent)');
//         } catch (err) {
//             console.error('[ChatHeading] WebRTC Error in sendJingleInitiate:', err);
//             console.error('[ChatHeading] Stack:', err?.stack);
//         }
//     }

//     handleSessionAccept(fromJid, sid, jingle) {
//         console.log('[ChatHeading] >>> handleSessionAccept START', { fromJid, sid });
//         if (!this.pc) {
//             console.error('[ChatHeading] handleSessionAccept: NO PC! Cannot proceed.');
//             return;
//         }
//         console.log('[ChatHeading] pc signaling state:', this.pc.signalingState);
//         console.log('[ChatHeading] Session-accept Jingle XML:\n', jingle?.outerHTML);

//         try {
//             // The answer MUST match our offer's m-line count and order exactly.
//             // iOS sometimes sends only 1 content in session-accept even when we offered 2.
//             // buildSdpFromJingle on that would produce a 1-m-line answer → Chrome rejects it.
//             // Instead, build from our own offer mids and use ICE/DTLS from the remote accept.
//             const offerSdp = this.pc.localDescription?.sdp || '';
//             const offerMids = [...offerSdp.matchAll(/^a=mid:(.+)$/gm)].map((m) => m[1].trim());
//             console.log('[ChatHeading] Offer m-line mids:', offerMids);

//             // Read ICE/DTLS from remote accept (first transport — BUNDLE shares one)
//             const contents = getJingleRtpContents(jingle);
//             const firstContent = contents[0] || firstDirectChild(jingle, 'content');
//             const transport = firstDirectChild(firstContent, 'transport');
//             const fingerprintEl = firstDirectChild(transport, 'fingerprint');
//             const ufrag = transport?.getAttribute('ufrag');
//             const pwd = transport?.getAttribute('pwd');
//             const fingerprint = fingerprintEl?.textContent?.trim();
//             const setup = fingerprintEl?.getAttribute('setup') || 'active';
//             console.log('[ChatHeading] Remote accept ICE:', { ufrag, setup, fp: fingerprint?.slice(0, 20) + '...' });

//             // Video codecs: prefer what iOS/remote actually accepted (from Jingle XML),
//             // falling back to our offer if the accept has no payloads.
//             // This is critical — iOS accepts only H264 with specific fmtp, and Chrome
//             // must use that exact codec/PT to send video iOS can decode.
//             const acceptedPayloads = [];
//             const videoContent = contents.find(
//                 (c) => firstDirectChild(c, 'description')?.getAttribute('media') === 'video',
//             );
//             if (videoContent) {
//                 const desc = firstDirectChild(videoContent, 'description');
//                 const parsed = payloadsFromJingleDescription(desc, 'video');
//                 acceptedPayloads.push(...parsed);
//                 console.log('[ChatHeading] Accepted video payloads from iOS/remote:', acceptedPayloads);
//             }

//             // Fall back to our offer codecs if remote accept had none
//             const SKIP_V = new Set(['rtx', 'red', 'ulpfec', 'flexfec-03']);
//             let finalVideoCodecs = acceptedPayloads;
//             if (!finalVideoCodecs.length) {
//                 console.warn('[ChatHeading] No video payloads in accept, falling back to offer codecs');
//                 const offerVideoCodecs = [];
//                 let inVideo = false;
//                 for (const line of offerSdp.split('\n')) {
//                     const l = line.trim();
//                     if (l.startsWith('m=video')) {
//                         inVideo = true;
//                         continue;
//                     }
//                     if (l.startsWith('m=') && inVideo) {
//                         inVideo = false;
//                         break;
//                     }
//                     if (inVideo && l.startsWith('a=rtpmap:')) {
//                         const m = l.match(/^a=rtpmap:(\d+) ([^/]+)\/(\d+)/);
//                         if (m && !SKIP_V.has(m[2].toLowerCase())) {
//                             offerVideoCodecs.push({ id: m[1], name: m[2], clockrate: m[3] });
//                         }
//                     }
//                 }
//                 finalVideoCodecs = offerVideoCodecs;
//             }
//             console.log('[ChatHeading] Final video codecs for answer SDP:', finalVideoCodecs);

//             const videoPtIds = finalVideoCodecs.map((c) => c.id).join(' ') || '96';
//             // Build rtpmap + fmtp + rtcp-fb lines for each accepted codec
//             const videoCodecLines = [];
//             for (const c of finalVideoCodecs) {
//                 const ch = c.channels ? `/${c.channels}` : '';
//                 videoCodecLines.push(`a=rtpmap:${c.id} ${c.name}/${c.clockrate}${ch}`);
//                 const fmtp = buildFmtpLine(c);
//                 if (fmtp) videoCodecLines.push(fmtp);
//                 // rtcp-fb essential for Chrome to send PLI/NACK → remote sends keyframes
//                 videoCodecLines.push(
//                     `a=rtcp-fb:${c.id} nack`,
//                     `a=rtcp-fb:${c.id} nack pli`,
//                     `a=rtcp-fb:${c.id} ccm fir`,
//                     `a=rtcp-fb:${c.id} goog-remb`,
//                     `a=rtcp-fb:${c.id} transport-cc`,
//                 );
//             }

//             const bundleLine = offerMids.length > 0 ? `a=group:BUNDLE ${offerMids.join(' ')}` : 'a=group:BUNDLE 0';

//             const mSections = offerMids.map((mid) => {
//                 const isVid = mid !== '0' && this.isVideo;
//                 return [
//                     isVid ? `m=video 9 RTP/SAVPF ${videoPtIds}` : 'm=audio 9 RTP/SAVPF 111',
//                     'c=IN IP4 0.0.0.0',
//                     ufrag ? `a=ice-ufrag:${ufrag}` : '',
//                     pwd ? `a=ice-pwd:${pwd}` : '',
//                     fingerprint ? `a=fingerprint:sha-256 ${fingerprint}` : '',
//                     `a=setup:${setup}`,
//                     `a=mid:${mid}`,
//                     'a=rtcp-mux',
//                     ...(isVid
//                         ? videoCodecLines
//                         : [
//                               'a=rtcp-fb:111 transport-cc',
//                               'a=rtpmap:111 opus/48000/2',
//                               'a=fmtp:111 minptime=10;useinbandfec=1',
//                           ]),
//                     'a=sendrecv',
//                 ]
//                     .filter(Boolean)
//                     .join('\r\n');
//             });

//             const remoteSdp =
//                 ['v=0', 'o=- 1234567890 2 IN IP4 0.0.0.0', 's=-', 't=0 0', bundleLine, 'a=msid-semantic: WMS'].join(
//                     '\r\n',
//                 ) +
//                 '\r\n' +
//                 mSections.join('\r\n') +
//                 '\r\n';
//             console.log('[ChatHeading] Built answer SDP:\n', remoteSdp);

//             this.pc
//                 .setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp: remoteSdp }))
//                 .then(() => {
//                     console.log('%c ✅ BUNDLE accepted! Remote description SET. ', 'color: white; background: green;');
//                     console.log('[ChatHeading] Queued candidates to flush:', this.iceCandidatesQueue.length);
//                     while (this.iceCandidatesQueue.length > 0) {
//                         const cand = this.iceCandidatesQueue.shift();
//                         this.pc
//                             .addIceCandidate(cand)
//                             .then(() => console.log('[ChatHeading] Flushed candidate OK'))
//                             .catch((e) => console.warn('[ChatHeading] Flush candidate failed:', e));
//                     }
//                 })
//                 .catch((err) => {
//                     console.error('[ChatHeading] setRemoteDescription FAILED:', err);
//                     console.log('[ChatHeading] DUMP answer SDP:\n', remoteSdp);
//                     console.log('[ChatHeading] Offer mids were:', offerMids);
//                 });
//         } catch (err) {
//             console.error('[ChatHeading] handleSessionAccept error:', err);
//         }
//     }

//     handleIncomingCandidates(jingle) {
//         const candidateElems = sizzle('candidate', jingle);

//         candidateElems.forEach((el) => {
//             const foundation = el.getAttribute('foundation');
//             const component = el.getAttribute('component') || '1';
//             const protocol = el.getAttribute('protocol') || 'udp';
//             const priority = el.getAttribute('priority');
//             const ip = el.getAttribute('ip');
//             const port = el.getAttribute('port');
//             const type = el.getAttribute('type') || 'host';

//             const candidateStr = `candidate:${foundation} ${component} ${protocol} ${priority} ${ip} ${port} typ ${type}`;
//             console.log('[ChatHeading] Incoming remote candidate:', candidateStr);

//             const iceCandidate = new RTCIceCandidate({
//                 candidate: candidateStr,
//                 sdpMid: '0',
//                 sdpMLineIndex: 0,
//             });

//             if (this.pc && this.pc.remoteDescription && this.pc.remoteDescription.type) {
//                 this.pc.addIceCandidate(iceCandidate).catch((e) => console.warn('AddIceCandidate error:', e));
//             } else {
//                 console.log('[ChatHeading] PC not ready, queuing candidate');
//                 this.iceCandidatesQueue.push(iceCandidate);
//             }
//         });
//     }

//     terminateCall(sendTerminate = true) {
//         // Send session-terminate + JMI <finish> if we still have an active call
//         if (sendTerminate && this.remoteFullJid && this.currentSid) {
//             const sid = this.currentSid;
//             const remote = this.remoteFullJid;
//             console.log('[ChatHeading] Sending session-terminate + finish to', remote);

//             // Jingle session-terminate IQ — fire-and-forget, no timeout
//             try {
//                 const terminateIq = $iq({ type: 'set', to: remote, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', {
//                         xmlns: NS_JINGLE,
//                         action: 'session-terminate',
//                         sid: sid,
//                     })
//                     .c('reason')
//                     .c('success');
//                 api.send(terminateIq);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not send session-terminate:', e);
//             }

//             // JMI <finish> message (Sonata extension — iOS/Android use this)
//             try {
//                 const bareRemote = remote.split('/')[0];
//                 const finishMsg = $msg({ to: bareRemote, type: 'chat', id: crypto.randomUUID() })
//                     .c('finish', { xmlns: NS_JINGLE_MSG, id: sid })
//                     .c('reason', { xmlns: NS_JINGLE })
//                     .c('success')
//                     .up()
//                     .up()
//                     .up()
//                     .c('store', { xmlns: 'urn:xmpp:hints' });
//                 api.send(finishMsg);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not send finish:', e);
//             }
//         }

//         if (this.pc) {
//             console.log('[ChatHeading] Closing PeerConnection');
//             this.pc.close();
//             this.pc = null;
//         }
//         if (this.localStream) {
//             this.localStream.getTracks().forEach((t) => t.stop());
//             this.localStream = null;
//         }
//         const el = document.getElementById('sonata-audio-remote');
//         if (el) el.srcObject = null;
//         this.currentSid = null;
//         this.isIncoming = false;
//         this.remoteFullJid = null;
//         if (ChatHeading.activeCall === this) {
//             ChatHeading.activeCall = null;
//         }
//         ChatHeading._hideCallPanel();
//         console.log('=== [ChatHeading] Call terminated ===');
//     }

//     // ========================================================================
//     // INCOMING CALL HANDLING (callee side)
//     // ========================================================================

//     /**
//      * Static: called when <propose> arrives. Shows modal asking user to accept
//      * or reject. If accepted, picks the matching ChatHeading instance (by JID)
//      * and runs accept flow. If no chat is open for that contact, falls back to
//      * using/creating a chat first.
//      */
//     static async handleIncomingPropose(fullFromJid, sid, media) {
//         const bareFrom = fullFromJid?.split('/')[0];

//         // Resolve display name — same approach as the call panel and ChatHeading template.
//         // Try roster contact first, then chatbox model, then fall back to bare JID.
//         let displayName = bareFrom;
//         try {
//             const contact = await api.contacts.get(bareFrom);
//             if (contact) {
//                 displayName = contact.get('nickname') || contact.get('fullname') || contact.get('name') || bareFrom;
//             }
//             // Also try an open chatbox model in case vcard is loaded there
//             if (displayName === bareFrom) {
//                 const chatbox = _converse.state?.chatboxes?.get(bareFrom);
//                 if (chatbox) {
//                     const fromModel = chatbox.getDisplayName?.();
//                     if (fromModel && fromModel !== bareFrom) displayName = fromModel;
//                 }
//             }
//         } catch (e) {
//             // non-fatal — fall back to bare JID
//         }

//         // If there's already an active call, ask the user.
//         if (ChatHeading.activeCall) {
//             const confirmed = window.confirm(
//                 `Вхідний дзвінок від ${bareFrom}. У вас вже триває розмова. Завершити поточну та прийняти новий?`,
//             );
//             if (!confirmed) {
//                 // Auto-reject the new call
//                 ChatHeading._sendJmiReject(fullFromJid, sid);
//                 return;
//             }
//             // Terminate the current call before accepting new
//             ChatHeading.activeCall.terminateCall();
//         }

//         // Track this pending incoming call so <retract> can cancel its modal.
//         ChatHeading._pendingIncomingSid = sid;
//         ChatHeading._pendingIncomingFrom = fullFromJid;

//         const accepted = await ChatHeading._showIncomingCallModal(displayName, fullFromJid, sid, media);

//         // Clear pending tracking
//         if (ChatHeading._pendingIncomingSid === sid) {
//             ChatHeading._pendingIncomingSid = null;
//             ChatHeading._pendingIncomingFrom = null;
//         }

//         if (!accepted) {
//             console.log('[ChatHeading] User rejected incoming call');
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         console.log('[ChatHeading] User accepted incoming call. Finding chat heading...');

//         // Find existing ChatHeading instance for this contact, or open a chat first.
//         let headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);
//         if (!headingEl) {
//             console.log('[ChatHeading] No open chat for', bareFrom, '— opening one');
//             try {
//                 await api.chats.open(bareFrom);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not open chat:', e);
//             }
//             // Wait a tick for the heading element to render
//             await new Promise((r) => setTimeout(r, 200));
//             headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);
//         }

//         if (!headingEl) {
//             console.error('[ChatHeading] Could not find/create chat heading for', bareFrom);
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         await headingEl.acceptIncomingCall(fullFromJid, sid, media);
//     }

//     /**
//      * Static: <retract> arrived — caller cancelled before we picked up.
//      * Close the modal if it's showing for this sid.
//      */
//     static handleRetract(sid) {
//         if (ChatHeading._pendingIncomingSid === sid && ChatHeading._closeIncomingModal) {
//             console.log('[ChatHeading] Closing incoming-call modal (caller retracted)');
//             ChatHeading._closeIncomingModal(false);
//         }
//     }

//     /**
//      * Static helper: send JMI <reject> message.
//      */
//     static _sendJmiReject(toFullJid, sid) {
//         const bareJid = toFullJid?.split('/')[0];
//         const msg = $msg({ to: bareJid, type: 'chat', id: crypto.randomUUID() })
//             .c('reject', { xmlns: NS_JINGLE_MSG, id: sid })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' });
//         api.send(msg);
//         console.log('[ChatHeading] Sent JMI reject for sid', sid);
//     }

//     /**
//      * Static: builds the incoming-call modal. Returns a Promise<boolean>:
//      * true=accepted, false=rejected/closed.
//      */
//     static _showIncomingCallModal(callerName, fullFromJid, sid, media) {
//         return new Promise((resolve) => {
//             // Inject CSS once
//             if (!document.getElementById('sonata-incall-style')) {
//                 const style = document.createElement('style');
//                 style.id = 'sonata-incall-style';
//                 style.textContent = `
//                     .sonata-incall-overlay {
//                         position: fixed; inset: 0; z-index: 99999;
//                         background: rgba(0,0,0,0.55);
//                         display: flex; align-items: center; justify-content: center;
//                         font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     }
//                     .sonata-incall-card {
//                         background: #fff; border-radius: 16px; padding: 28px 32px;
//                         min-width: 320px; max-width: 90vw; text-align: center;
//                         box-shadow: 0 20px 60px rgba(0,0,0,0.4);
//                         animation: sonata-incall-pop 0.25s ease-out;
//                     }
//                     @keyframes sonata-incall-pop {
//                         from { transform: scale(0.85); opacity: 0; }
//                         to { transform: scale(1); opacity: 1; }
//                     }
//                     .sonata-incall-icon {
//                         font-size: 48px; margin-bottom: 12px;
//                         animation: sonata-incall-ring 1s ease-in-out infinite;
//                     }
//                     @keyframes sonata-incall-ring {
//                         0%, 100% { transform: rotate(0); }
//                         25% { transform: rotate(-15deg); }
//                         75% { transform: rotate(15deg); }
//                     }
//                     .sonata-incall-name {
//                         font-size: 20px; font-weight: 600; color: #222; margin-bottom: 4px;
//                     }
//                     .sonata-incall-sub {
//                         font-size: 13px; color: #888; margin-bottom: 24px;
//                     }
//                     .sonata-incall-actions {
//                         display: flex; gap: 16px; justify-content: center;
//                     }
//                     .sonata-incall-btn {
//                         border: none; border-radius: 50%; width: 56px; height: 56px;
//                         font-size: 22px; cursor: pointer; color: white;
//                         display: inline-flex; align-items: center; justify-content: center;
//                         transition: transform 0.15s;
//                     }
//                     .sonata-incall-btn:hover { transform: scale(1.08); }
//                     .sonata-incall-btn.accept { background: #1e9652; }
//                     .sonata-incall-btn.reject { background: #d33; }
//                 `;
//                 document.head.appendChild(style);
//             }

//             const overlay = document.createElement('div');
//             overlay.className = 'sonata-incall-overlay';
//             overlay.innerHTML = `
//                 <div class="sonata-incall-card">
//                     <div class="sonata-incall-icon">📞</div>
//                     <div class="sonata-incall-name">${callerName}</div>
//                     <div class="sonata-incall-sub">Вхідний ${media === 'video' ? 'відео' : 'аудіо'} дзвінок</div>
//                     <div class="sonata-incall-actions">
//                         <button class="sonata-incall-btn reject" title="Відхилити">✕</button>
//                         <button class="sonata-incall-btn accept" title="Прийняти">✓</button>
//                     </div>
//                 </div>
//             `;
//             document.body.appendChild(overlay);

//             // Play ringtone via Web Audio (simple beeping). Skip if AudioContext unavailable.
//             let ringInterval = null;
//             try {
//                 const ctx = new (window.AudioContext || window.webkitAudioContext)();
//                 const beep = () => {
//                     const osc = ctx.createOscillator();
//                     const gain = ctx.createGain();
//                     osc.frequency.value = 480;
//                     gain.gain.value = 0.08;
//                     osc.connect(gain).connect(ctx.destination);
//                     osc.start();
//                     setTimeout(() => osc.stop(), 400);
//                 };
//                 beep();
//                 ringInterval = setInterval(beep, 1500);
//             } catch (e) {
//                 /* no-op */
//             }

//             const cleanup = (result) => {
//                 if (ringInterval) clearInterval(ringInterval);
//                 if (overlay.parentElement) overlay.parentElement.removeChild(overlay);
//                 ChatHeading._closeIncomingModal = null;
//                 resolve(result);
//             };

//             // Expose closer so retract can cancel the modal externally
//             ChatHeading._closeIncomingModal = cleanup;

//             overlay.querySelector('.accept').addEventListener('click', () => cleanup(true));
//             overlay.querySelector('.reject').addEventListener('click', () => cleanup(false));

//             // Auto-reject after 45s (typical ring timeout)
//             setTimeout(() => {
//                 if (overlay.parentElement) cleanup(false);
//             }, 45000);
//         });
//     }

//     /**
//      * Instance: user accepted the incoming-call modal. Pre-warm mic, send
//      * <proceed>, mark this instance as the active call, and wait for the
//      * remote's session-initiate.
//      */
//     async acceptIncomingCall(fullFromJid, sid, media) {
//         console.log('[ChatHeading] >>> acceptIncomingCall', { fullFromJid, sid, media });

//         // Pre-warm microphone BEFORE sending <proceed>.
//         // If we send proceed first, the caller immediately sends session-initiate.
//         // getUserMedia prompt can take seconds on first use — causing session-initiate
//         // to arrive before pc is created. Get mic first, then proceed.
//         const needsVideo = media === 'video';
//         try {
//             console.log(
//                 `[ChatHeading] Pre-warming media (audio${needsVideo ? '+video' : ''}) before sending proceed...`,
//             );
//             this.localStream = await navigator.mediaDevices.getUserMedia({
//                 audio: true,
//                 video: needsVideo,
//             });
//             console.log(
//                 '[ChatHeading] Media ready for incoming call, tracks:',
//                 this.localStream.getTracks().map((t) => t.kind),
//             );
//         } catch (err) {
//             console.error('[ChatHeading] Media permission denied for incoming call:', err);
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         this.isIncoming = true;
//         this.isVideo = needsVideo;
//         this.remoteFullJid = fullFromJid;
//         this.currentSid = sid;
//         ChatHeading.activeCall = this;

//         // Send JMI <proceed> to the caller's FULL JID (including resource).
//         // The original propose came from their full JID — we must reply to it.
//         // Sending to bare JID means the server can't route session-initiate back
//         // to us because the caller doesn't know which resource accepted.
//         const proceedId = crypto.randomUUID();
//         const proceedMsg = $msg({ to: fullFromJid, type: 'chat', id: proceedId })
//             .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: proceedId })
//             .up()
//             .c('proceed', { xmlns: NS_JINGLE_MSG, id: sid })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' });
//         api.send(proceedMsg);
//         console.log(
//             '[ChatHeading] Sent JMI proceed sid=',
//             sid,
//             'to FULL JID=',
//             fullFromJid,
//             '| our full JID:',
//             _converse.jid,
//         );

//         this.model?.createMessage({ message: '📞 Вхідний виклик прийнято', type: 'info' });
//         // Now we wait for session-initiate via the Strophe handler → handleSessionInitiate().
//     }

//     /**
//      * Instance: <session-initiate> arrived from remote (caller). We are the
//      * callee. Create pc, add tracks, set remote offer SDP, create answer,
//      * send session-accept.
//      */
//     async handleSessionInitiate(fullFromJid, sid, jingle) {
//         console.log('[ChatHeading] >>> handleSessionInitiate', { fullFromJid, sid });
//         this.iceCandidatesQueue = [];
//         this.remoteFullJid = fullFromJid;
//         this.currentSid = sid;
//         this.isIncoming = true;

//         // Detect video from raw Jingle XML
//         this.isVideo = getJingleRtpContents(jingle).some(
//             (c) => firstDirectChild(c, 'description')?.getAttribute('media') === 'video',
//         );

//         try {
//             if (!this.localStream) {
//                 console.log('[ChatHeading] No stream yet, requesting media (isVideo:', this.isVideo, ')...');
//                 this.localStream = await navigator.mediaDevices.getUserMedia({
//                     audio: true,
//                     video: this.isVideo,
//                 });
//             }

//             const iceServers2 = await ChatHeading._getIceServers();
//             this.pc = new RTCPeerConnection({
//                 iceServers: iceServers2,
//                 bundlePolicy: 'max-bundle',
//                 rtcpMuxPolicy: 'require',
//             });

//             this.pc.oniceconnectionstatechange = () => {
//                 console.log(`%c [ICE] state=${this.pc.iceConnectionState} `, 'color: orange; font-weight: bold;');
//                 if (this.pc.iceConnectionState === 'connected') {
//                     console.log('%c [ICE] ✅ CONNECTED (incoming) ', 'background: green; color: white;');
//                     ChatHeading._showCallPanel(this);
//                     ChatHeading._requestKeyframeAndPollVideo(this.pc);
//                 }
//             };
//             this.pc.onconnectionstatechange = () => console.log(`[PC] connectionState=${this.pc.connectionState}`);
//             this.pc.onsignalingstatechange = () => console.log(`[PC] signalingState=${this.pc.signalingState}`);

//             this.pc.ontrack = (event) => {
//                 console.log('[ChatHeading] Remote track received (incoming) kind=', event.track.kind);
//                 const stream = event.streams?.[0] || new MediaStream([event.track]);
//                 if (event.track.kind === 'audio') {
//                     let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
//                     el.id = 'sonata-audio-remote';
//                     el.autoplay = true;
//                     if (!el.parentElement) document.body.appendChild(el);
//                     el.srcObject = stream;
//                 } else if (event.track.kind === 'video') {
//                     ChatHeading._attachRemoteVideo(stream);
//                 }
//             };

//             this.pc.onicecandidate = (event) => {
//                 if (!event.candidate) return;
//                 const c = event.candidate;
//                 const localSdp = this.pc.localDescription?.sdp || '';
//                 const localUfrag = (localSdp.match(/a=ice-ufrag:(.*)\r/) || [])[1] || '';
//                 const localPwd = (localSdp.match(/a=ice-pwd:(.*)\r/) || [])[1] || '';
//                 const attrs = {
//                     id: String(Math.floor(Math.random() * 4294967295)),
//                     component: String(c.component || 1),
//                     foundation: c.foundation,
//                     generation: '0',
//                     ip: c.address || c.ip,
//                     port: String(c.port),
//                     priority: String(c.priority),
//                     protocol: (c.protocol || 'udp').toLowerCase(),
//                     type: c.type,
//                 };
//                 if (c.relatedAddress) attrs['rel-addr'] = c.relatedAddress;
//                 if (c.relatedPort) attrs['rel-port'] = String(c.relatedPort);
//                 const iq = $iq({ type: 'set', to: fullFromJid, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', {
//                         xmlns: NS_JINGLE,
//                         action: 'transport-info',
//                         initiator: fullFromJid,
//                         responder: _converse.jid,
//                         sid,
//                     })
//                     .c('content', { creator: 'initiator', name: '0' })
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag: localUfrag, pwd: localPwd })
//                     .c('candidate', attrs);
//                 api.send(iq);
//             };

//             this.localStream.getTracks().forEach((t) => this.pc.addTrack(t, this.localStream));

//             // Build remote offer SDP from Jingle XML — handles Android, iOS, all clients correctly
//             const remoteOfferSdp = buildSdpFromJingle(jingle, 'offer');
//             console.log('[ChatHeading] Setting remote OFFER SDP:\n', remoteOfferSdp);
//             await this.pc.setRemoteDescription(new RTCSessionDescription({ type: 'offer', sdp: remoteOfferSdp }));

//             const answer = await this.pc.createAnswer();
//             await this.pc.setLocalDescription(answer);
//             console.log('[ChatHeading] 📋 LOCAL ANSWER SDP:\n', this.pc.localDescription.sdp);

//             // Flush queued candidates
//             while (this.iceCandidatesQueue.length > 0) {
//                 this.pc
//                     .addIceCandidate(this.iceCandidatesQueue.shift())
//                     .catch((e) => console.warn('Queued cand failed:', e));
//             }

//             // Build session-accept IQ from our local answer SDP (mirrors what browser negotiated)
//             // Track the mid order from the remote offer so our accept uses the same order
//             const contents = getJingleRtpContents(jingle);
//             const remoteOfferMidOrder = contents.map((c, i) => c.getAttribute('name') || String(i));
//             const contentCreatorsByMid = new Map(remoteOfferMidOrder.map((mid) => [mid, 'initiator']));

//             const acceptIq = buildJingleIqFromLocalSdp({
//                 action: 'session-accept',
//                 to: fullFromJid,
//                 sid,
//                 initiator: fullFromJid,
//                 responder: _converse.jid,
//                 localSdp: this.pc.localDescription.sdp,
//                 contentCreatorsByMid,
//                 preferredMidOrder: remoteOfferMidOrder,
//             });

//             console.log('[ChatHeading] 📤 session-accept XML:\n', acceptIq.toString());
//             api.send(acceptIq);
//             console.log(
//                 '[ChatHeading] >>> handleSessionInitiate DONE (session-accept sent, isVideo:',
//                 this.isVideo,
//                 ')',
//             );
//         } catch (err) {
//             console.error('[ChatHeading] handleSessionInitiate error:', err);
//             console.error('[ChatHeading] Stack:', err?.stack);
//         }
//     }

//     // ========================================================================
//     // CALL PANEL UI
//     // ========================================================================

//     /**
//      * Static: show "calling..." panel while waiting for remote to answer.
//      * Replaced by _showCallPanel once ICE connects.
//      */
//     static _showOutgoingCallPanel(instance) {
//         ChatHeading._hideCallPanel();

//         if (!document.getElementById('sonata-callpanel-style')) {
//             // CSS will be injected by _showCallPanel when connected; inject minimal now
//             const style = document.createElement('style');
//             style.id = 'sonata-callpanel-style';
//             style.textContent = `
//                 .sonata-callpanel {
//                     position: fixed; top: 0; left: 50%; transform: translateX(-50%);
//                     z-index: 99998; background: #1a1a2e; color: #fff;
//                     border-radius: 0 0 24px 24px; padding: 12px 20px 14px 24px;
//                     display: flex; align-items: center; gap: 16px;
//                     box-shadow: 0 4px 24px rgba(0,0,0,0.45);
//                     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     animation: sonata-panel-slide 0.3s cubic-bezier(.22,.68,0,1.2);
//                     min-width: 260px;
//                 }
//                 @keyframes sonata-panel-slide {
//                     from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
//                     to   { opacity: 1; transform: translateX(-50%) translateY(0); }
//                 }
//                 .sonata-callpanel-dot {
//                     width: 10px; height: 10px; border-radius: 50%;
//                     background: #1e9652;
//                     box-shadow: 0 0 0 0 rgba(30,150,82,0.6);
//                     animation: sonata-dot-pulse 1.5s ease-out infinite;
//                     flex-shrink: 0;
//                 }
//                 @keyframes sonata-dot-pulse {
//                     0%   { box-shadow: 0 0 0 0 rgba(30,150,82,0.6); }
//                     70%  { box-shadow: 0 0 0 8px rgba(30,150,82,0); }
//                     100% { box-shadow: 0 0 0 0 rgba(30,150,82,0); }
//                 }
//                 .sonata-callpanel-info {
//                     display: flex; flex-direction: column; gap: 2px; flex: 1;
//                 }
//                 .sonata-callpanel-name {
//                     font-size: 14px; font-weight: 600; color: #fff;
//                     white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//                     max-width: 160px;
//                 }
//                 .sonata-callpanel-timer {
//                     font-size: 13px; color: #aaa; font-variant-numeric: tabular-nums;
//                     letter-spacing: 0.03em;
//                 }
//                 .sonata-callpanel-hangup {
//                     background: #e53935; border: none; border-radius: 50%;
//                     width: 40px; height: 40px; cursor: pointer; color: #fff;
//                     display: inline-flex; align-items: center; justify-content: center;
//                     font-size: 18px; flex-shrink: 0;
//                     transition: background 0.15s, transform 0.15s;
//                 }
//                 .sonata-callpanel-hangup:hover { background: #b71c1c; transform: scale(1.08); }
//             `;
//             document.head.appendChild(style);
//         }

//         const displayName = instance.model?.getDisplayName?.() || instance.model?.get('jid') || '...';

//         const panel = document.createElement('div');
//         panel.id = 'sonata-callpanel';
//         panel.className = 'sonata-callpanel';
//         panel.innerHTML = `
//             <div class="sonata-callpanel-dot" style="background:#f59e0b; box-shadow: 0 0 0 0 rgba(245,158,11,0.6);"></div>
//             <div class="sonata-callpanel-info">
//                 <div class="sonata-callpanel-name">${displayName}</div>
//                 <div class="sonata-callpanel-timer" id="sonata-callpanel-timer">Виклик...</div>
//             </div>
//             <button class="sonata-callpanel-hangup" title="Скасувати дзвінок">📵</button>
//         `;
//         document.body.appendChild(panel);

//         // Animated dots on "Виклик..."
//         const timerEl = panel.querySelector('#sonata-callpanel-timer');
//         let dots = 0;
//         ChatHeading._callTimerInterval = setInterval(() => {
//             dots = (dots + 1) % 4;
//             if (timerEl) timerEl.textContent = 'Виклик' + '.'.repeat(dots);
//         }, 600);

//         setTimeout(() => {
//             const btn = panel.querySelector('.sonata-callpanel-hangup');
//             if (btn)
//                 btn.addEventListener('click', () => {
//                     console.log('[ChatHeading] User cancelled outgoing call');
//                     const t = ChatHeading.activeCall;
//                     if (t) {
//                         const jid = t.model?.get('jid');
//                         if (jid && t.currentSid) {
//                             const retractMsg = $msg({ to: jid, type: 'chat', id: crypto.randomUUID() })
//                                 .c('retract', { xmlns: NS_JINGLE_MSG, id: t.currentSid })
//                                 .up()
//                                 .c('store', { xmlns: 'urn:xmpp:hints' });
//                             api.send(retractMsg);
//                             console.log('[ChatHeading] Sent JMI retract for sid', t.currentSid);
//                         }
//                         t.terminateCall(false);
//                     }
//                 });
//         }, 100);
//     }

//     /**
//      * Static: show active call panel with timer and hang-up button.
//      * Called when ICE reaches 'connected' state.
//      */
//     static _showCallPanel(instance) {
//         // Save any queued remote video stream before _hideCallPanel clears it
//         const savedRemoteStream = ChatHeading._pendingRemoteVideoStream;
//         ChatHeading._hideCallPanel();
//         // Restore it so PiP creation below can flush it
//         if (savedRemoteStream) {
//             ChatHeading._pendingRemoteVideoStream = savedRemoteStream;
//         }

//         if (!document.getElementById('sonata-callpanel-style')) {
//             const style = document.createElement('style');
//             style.id = 'sonata-callpanel-style';
//             style.textContent = `
//                 .sonata-callpanel {
//                     position: fixed; top: 0; left: 50%; transform: translateX(-50%);
//                     z-index: 99998; background: #1a1a2e; color: #fff;
//                     border-radius: 0 0 24px 24px; padding: 12px 20px 14px 24px;
//                     display: flex; align-items: center; gap: 16px;
//                     box-shadow: 0 4px 24px rgba(0,0,0,0.45);
//                     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     animation: sonata-panel-slide 0.3s cubic-bezier(.22,.68,0,1.2);
//                     min-width: 260px;
//                 }
//                 @keyframes sonata-panel-slide {
//                     from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
//                     to   { opacity: 1; transform: translateX(-50%) translateY(0); }
//                 }
//                 .sonata-callpanel-dot {
//                     width: 10px; height: 10px; border-radius: 50%; background: #1e9652;
//                     box-shadow: 0 0 0 0 rgba(30,150,82,0.6);
//                     animation: sonata-dot-pulse 1.5s ease-out infinite; flex-shrink: 0;
//                 }
//                 @keyframes sonata-dot-pulse {
//                     0%   { box-shadow: 0 0 0 0 rgba(30,150,82,0.6); }
//                     70%  { box-shadow: 0 0 0 8px rgba(30,150,82,0); }
//                     100% { box-shadow: 0 0 0 0 rgba(30,150,82,0); }
//                 }
//                 .sonata-callpanel-info { display: flex; flex-direction: column; gap: 2px; flex: 1; }
//                 .sonata-callpanel-name {
//                     font-size: 14px; font-weight: 600; color: #fff;
//                     white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 160px;
//                 }
//                 .sonata-callpanel-timer {
//                     font-size: 13px; color: #aaa; font-variant-numeric: tabular-nums; letter-spacing: 0.03em;
//                 }
//                 .sonata-callpanel-hangup {
//                     background: #e53935; border: none; border-radius: 50%;
//                     width: 40px; height: 40px; cursor: pointer; color: #fff;
//                     display: inline-flex; align-items: center; justify-content: center;
//                     font-size: 18px; flex-shrink: 0; transition: background 0.15s, transform 0.15s;
//                 }
//                 .sonata-callpanel-hangup:hover { background: #b71c1c; transform: scale(1.08); }
//             `;
//             document.head.appendChild(style);
//         }

//         const displayName = instance.model?.getDisplayName?.() || instance.remoteFullJid?.split('/')[0] || 'Unknown';

//         // Inject PiP CSS separately from panel CSS so it's not blocked
//         // by the outgoing call panel having already injected sonata-callpanel-style
//         if (instance.isVideo && !document.getElementById('sonata-pip-style')) {
//             const pipStyle = document.createElement('style');
//             pipStyle.id = 'sonata-pip-style';
//             pipStyle.textContent = `
//                 .sonata-video-pip {
//                     position: fixed !important; bottom: 24px !important; right: 24px !important;
//                     z-index: 999999 !important;
//                     width: 320px !important; height: 180px !important;
//                     border-radius: 16px; overflow: hidden;
//                     box-shadow: 0 8px 32px rgba(0,0,0,0.6);
//                     background: #111 !important;
//                     display: block !important; visibility: visible !important;
//                 }
//                 .sonata-video-pip video {
//                     display: block !important; visibility: visible !important;
//                 }
//                 .sonata-video-pip video#sonata-video-remote {
//                     position: absolute !important; inset: 0 !important;
//                     width: 100% !important; height: 100% !important;
//                     object-fit: cover; background: #222;
//                 }
//                 .sonata-video-pip video#sonata-video-local {
//                     position: absolute !important; bottom: 8px !important; right: 8px !important;
//                     width: 80px !important; height: 60px !important;
//                     border-radius: 8px; object-fit: cover;
//                     border: 2px solid rgba(255,255,255,0.8);
//                     background: #333; z-index: 1 !important;
//                 }
//             `;
//             document.head.appendChild(pipStyle);
//             console.log('[ChatHeading] PiP CSS injected ✅');
//         }

//         // Audio call panel (always shown at top)
//         const panel = document.createElement('div');
//         panel.id = 'sonata-callpanel';
//         panel.className = 'sonata-callpanel';
//         panel.innerHTML = `
//             <div class="sonata-callpanel-dot"></div>
//             <div class="sonata-callpanel-info">
//                 <div class="sonata-callpanel-name">${instance.isVideo ? '📹 ' : ''}${displayName}</div>
//                 <div class="sonata-callpanel-timer" id="sonata-callpanel-timer">00:00</div>
//             </div>
//             <button class="sonata-callpanel-hangup" title="Завершити дзвінок">📵</button>
//         `;
//         document.body.appendChild(panel);

//         // Video PiP overlay (only for video calls)
//         if (instance.isVideo) {
//             console.log('[ChatHeading] Creating video PiP overlay');
//             const pip = document.createElement('div');
//             pip.id = 'sonata-video-pip';
//             pip.className = 'sonata-video-pip';
//             pip.innerHTML = `
//                 <video id="sonata-video-remote" autoplay playsinline muted
//                     style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#222;display:block;visibility:visible;"></video>
//                 <video id="sonata-video-local" autoplay playsinline muted
//                     style="position:absolute;bottom:8px;right:8px;width:80px;height:60px;border-radius:8px;object-fit:cover;border:2px solid rgba(255,255,255,0.8);background:#333;z-index:1;display:block;visibility:visible;"></video>
//             `;
//             document.body.appendChild(pip);

//             // Attach local stream preview immediately
//             const localVid = pip.querySelector('#sonata-video-local');
//             if (instance.localStream) {
//                 localVid.srcObject = instance.localStream;
//                 console.log('[ChatHeading] Local video preview attached to PiP ✅');
//             } else {
//                 console.warn('[ChatHeading] No localStream available for PiP preview');
//             }

//             // Flush remote video stream if it arrived before PiP was created
//             if (ChatHeading._pendingRemoteVideoStream) {
//                 console.log('[ChatHeading] Flushing pending remote video stream to PiP ✅');
//                 const remoteVid = pip.querySelector('#sonata-video-remote');
//                 remoteVid.srcObject = ChatHeading._pendingRemoteVideoStream;
//                 ChatHeading._pendingRemoteVideoStream = null;
//                 // Diagnose after a short delay to let the element settle
//                 setTimeout(() => {
//                     const r = remoteVid.getBoundingClientRect();
//                     const cs = getComputedStyle(remoteVid);
//                     const pipR = pip.getBoundingClientRect();
//                     const pipCs = getComputedStyle(pip);
//                     console.log(
//                         `[VIDEO DEBUG] pip: ${pipR.width}x${pipR.height} at (${Math.round(pipR.left)},${Math.round(pipR.top)}) display=${pipCs.display} visibility=${pipCs.visibility} zIndex=${pipCs.zIndex}`,
//                     );
//                     console.log(
//                         `[VIDEO DEBUG] remote video: ${r.width}x${r.height} at (${Math.round(r.left)},${Math.round(r.top)}) display=${cs.display} visibility=${cs.visibility} readyState=${remoteVid.readyState} paused=${remoteVid.paused}`,
//                     );
//                     console.log(
//                         `[VIDEO DEBUG] remote video srcObject tracks:`,
//                         remoteVid.srcObject?.getTracks().map((t) => `${t.kind}:${t.readyState}`),
//                     );
//                     // Check if anything is covering the pip
//                     const topEl = document.elementFromPoint(pipR.left + pipR.width / 2, pipR.top + pipR.height / 2);
//                     console.log(
//                         `[VIDEO DEBUG] element at pip center:`,
//                         topEl?.id || topEl?.className || topEl?.tagName,
//                     );
//                     if (remoteVid.paused) {
//                         remoteVid
//                             .play()
//                             .then(() => console.log('[VIDEO DEBUG] play() succeeded after delay ✅'))
//                             .catch((e) => console.warn('[VIDEO DEBUG] play() still failed:', e));
//                     }
//                 }, 500);
//             }

//             // Make PiP draggable
//             let dragging = false,
//                 ox = 0,
//                 oy = 0;
//             pip.addEventListener('mousedown', (e) => {
//                 dragging = true;
//                 ox = e.clientX - pip.getBoundingClientRect().left;
//                 oy = e.clientY - pip.getBoundingClientRect().top;
//                 pip.style.transition = 'none';
//             });
//             document.addEventListener('mousemove', (e) => {
//                 if (!dragging) return;
//                 pip.style.right = 'auto';
//                 pip.style.bottom = 'auto';
//                 pip.style.left = `${e.clientX - ox}px`;
//                 pip.style.top = `${e.clientY - oy}px`;
//             });
//             document.addEventListener('mouseup', () => {
//                 dragging = false;
//             });
//         }

//         // Timer
//         let seconds = 0;
//         const timerEl = panel.querySelector('#sonata-callpanel-timer');
//         ChatHeading._callTimerInterval = setInterval(() => {
//             seconds++;
//             const m = String(Math.floor(seconds / 60)).padStart(2, '0');
//             const s = String(seconds % 60).padStart(2, '0');
//             if (timerEl) timerEl.textContent = `${m}:${s}`;
//         }, 1000);

//         // Defer click handler by one tick so the button can't receive
//         // a click event that was already in flight from the outgoing panel
//         // being replaced (which caused auto-terminate on ICE connect).
//         setTimeout(() => {
//             const btn = panel.querySelector('.sonata-callpanel-hangup');
//             if (btn)
//                 btn.addEventListener('click', () => {
//                     console.log('[ChatHeading] User clicked hang-up');
//                     const t = ChatHeading.activeCall;
//                     if (t) t.terminateCall(true);
//                 });
//         }, 100);
//     }

//     static _hideCallPanel() {
//         if (ChatHeading._callTimerInterval) {
//             clearInterval(ChatHeading._callTimerInterval);
//             ChatHeading._callTimerInterval = null;
//         }
//         ChatHeading._pendingRemoteVideoStream = null;
//         const panel = document.getElementById('sonata-callpanel');
//         if (panel) panel.parentElement?.removeChild(panel);
//         const pip = document.getElementById('sonata-video-pip');
//         if (pip) pip.parentElement?.removeChild(pip);
//         const pipStyle = document.getElementById('sonata-pip-style');
//         if (pipStyle) pipStyle.parentElement?.removeChild(pipStyle);
//     }

//     /**
//      * Static: attach remote video stream to the PiP overlay.
//      * Called from ontrack when a video track arrives.
//      */
//     static _attachRemoteVideo(stream) {
//         console.log('[ChatHeading] _attachRemoteVideo called, stream tracks:', stream?.getTracks().length);
//         if (stream) {
//             stream
//                 .getTracks()
//                 .forEach((t) =>
//                     console.log(
//                         `[ChatHeading] remote stream track: kind=${t.kind} enabled=${t.enabled} readyState=${t.readyState} muted=${t.muted}`,
//                     ),
//                 );
//         }
//         const pip = document.getElementById('sonata-video-pip');
//         if (!pip) {
//             console.warn('[ChatHeading] PiP not in DOM yet — queuing remote video stream');
//             ChatHeading._pendingRemoteVideoStream = stream;
//             return;
//         }
//         const vid = pip.querySelector('#sonata-video-remote');
//         vid.srcObject = stream;
//         vid.play()
//             .then(() => {
//                 console.log('[ChatHeading] Remote video playing ✅');
//                 setTimeout(() => {
//                     const r = vid.getBoundingClientRect();
//                     const cs = getComputedStyle(vid);
//                     const pipR = pip.getBoundingClientRect();
//                     console.log(
//                         `[VIDEO DEBUG] pip: ${pipR.width}x${pipR.height} at (${Math.round(pipR.left)},${Math.round(pipR.top)}) z=${getComputedStyle(pip).zIndex}`,
//                     );
//                     console.log(
//                         `[VIDEO DEBUG] video: ${r.width}x${r.height} display=${cs.display} visibility=${cs.visibility} readyState=${vid.readyState}`,
//                     );
//                 }, 300);
//             })
//             .catch((e) => {
//                 console.warn('[ChatHeading] Remote video play() failed:', e);
//             });
//         console.log('[ChatHeading] Remote video srcObject set ✅');
//     }

//     /**
//      * Static: attach local video preview to the PiP overlay local tile.
//      */
//     static _attachLocalVideo(stream) {
//         const pip = document.getElementById('sonata-video-pip');
//         if (pip) {
//             pip.querySelector('#sonata-video-local').srcObject = stream;
//         }
//     }

//     // ========================================================================
//     // END CALL PANEL UI
//     // ========================================================================

//     // ========================================================================
//     // END CALL LOGIC
//     // ========================================================================

//     /**
//      * Returns a list of objects which represent buttons for the chat's header.
//      * @emits _converse#getHeadingButtons
//      * @returns {Promise<Array.<import('./types').HeadingButtonAttributes>>}
//      */
//     async getHeadingButtons() {
//         const buttons = [
//             /** @type {import('./types').HeadingButtonAttributes} */
//             {
//                 a_class: 'show-user-details-modal',
//                 handler: /** @param {Event} ev */ (ev) => this.showUserDetailsModal(ev),
//                 i18n_text: __('Details'),
//                 i18n_title: __('See more information about this person'),
//                 icon_class: 'fa-id-card',
//                 name: 'details',
//                 standalone: false,
//             },
//         ];

//         const domain = _converse.session.get('domain');
//         if (domain && (await api.disco.supports(Strophe.NS.BLOCKING, domain))) {
//             const blocklist = await api.blocklist.get();
//             if (blocklist.get(this.model.get('jid'))) {
//                 buttons.push({
//                     a_class: 'unblock-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Unblock user'), [
//                             __('Are you sure you want to unblock this user?'),
//                         ]);
//                         if (result) {
//                             api.blocklist.remove(this.model.get('jid'));
//                         }
//                     },
//                     i18n_text: __('Unblock this user'),
//                     i18n_title: __('Allow this user to send you messages'),
//                     icon_class: 'fa-check',
//                     name: 'unblock',
//                     standalone: false,
//                 });
//             } else {
//                 buttons.push({
//                     a_class: 'block-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Block user'), [
//                             __(
//                                 'Are you sure you want to prevent %1$s from contacting you further?',
//                                 this.model.getDisplayName(),
//                             ),
//                         ]);
//                         if (result) {
//                             const jid = this.model.get('jid');
//                             api.blocklist.add(jid);
//                             api.contacts.remove(jid, true);
//                             this.model.close();
//                         }
//                     },
//                     i18n_text: __('Block this user'),
//                     i18n_title: __('Prevent this user from sending you any further messages'),
//                     icon_class: 'fa-trash',
//                     name: 'block',
//                     standalone: false,
//                 });
//             }
//         }

//         if (!api.settings.get('singleton')) {
//             buttons.push({
//                 a_class: 'close-chatbox-button',
//                 handler: /** @param {Event} ev */ (ev) => this.close(ev),
//                 i18n_text: __('Close'),
//                 i18n_title: __('Close and end this conversation'),
//                 icon_class: 'fa-times',
//                 name: 'close',
//                 standalone: api.settings.get('view_mode') === 'overlayed',
//             });
//         }
//         const { chatboxviews } = _converse.state;
//         const el = chatboxviews.get(this.getAttribute('jid'));
//         if (el) {
//             /**
//              * *Hook* which allows plugins to add more buttons to a chat's heading.
//              *
//              * Note: This hook is fired for both 1 on 1 chats and groupchats.
//              * If you only care about one, you need to add a check in your code.
//              *
//              * @event _converse#getHeadingButtons
//              * @param { HTMLElement } el
//              *      The `converse-chat` (or `converse-muc`) DOM element that represents the chat
//              * @param { Array.<import('./types').HeadingButtonAttributes> }
//              *      An array of the existing buttons. New buttons may be added,
//              *      and existing ones removed or modified.
//              * @example
//              *  api.listen.on('getHeadingButtons', (el, buttons) => {
//              *      buttons.push({
//              *          'i18n_title': __('Foo'),
//              *          'i18n_text': __('Foo Bar'),
//              *          'handler': ev => alert('Foo!'),
//              *          'a_class': 'toggle-foo',
//              *          'icon_class': 'fa-foo',
//              *          'name': 'foo'
//              *      });
//              *      return buttons;
//              *  });
//              */
//             return _converse.api.hook('getHeadingButtons', el, buttons);
//         } else {
//             return buttons; // Happens during tests
//         }
//     }
// }


//working ios.android audio video
// import { _converse, api, converse } from '@converse/headless';
// import { CustomElement } from 'shared/components/element.js';
// import { __ } from 'i18n';
// import tplChatboxHead from './templates/chat-head.js';
// import 'shared/modals/user-details.js';

// import './styles/chat-head.scss';

// const { Strophe, $iq, $msg, sizzle } = converse.env;

// const NS_JINGLE = 'urn:xmpp:jingle:1';
// const NS_JINGLE_ICE = 'urn:xmpp:jingle:transports:ice-udp:1';
// const NS_JINGLE_RTP = 'urn:xmpp:jingle:apps:rtp:1';
// const NS_DTLS = 'urn:xmpp:jingle:apps:dtls:0';
// const NS_JINGLE_MSG = 'urn:xmpp:jingle-message:0';
// const NS_GROUPING = 'urn:xmpp:jingle:apps:grouping:0';

// /**
//  * Show a small toast notification.
//  * @param {string} message
//  * @param {'error'|'warn'|'info'} type
//  */
// function showToast(message, type = 'error') {
//     const colors = { error: '#e53935', warn: '#f59e0b', info: '#1e9652' };
//     const icons = { error: '🎙️', warn: '⚠️', info: 'ℹ️' };
//     const toast = document.createElement('div');
//     toast.style.cssText = `
//         position:fixed; bottom:80px; left:50%; transform:translateX(-50%);
//         background:${colors[type]}; color:#fff; padding:12px 20px;
//         border-radius:10px; font-size:14px; z-index:9999999;
//         box-shadow:0 4px 16px rgba(0,0,0,0.3); display:flex; align-items:center; gap:8px;
//         font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
//         animation:sonata-toast-in 0.25s ease-out;
//         max-width:90vw; text-align:center;
//     `;
//     if (!document.getElementById('sonata-toast-style')) {
//         const s = document.createElement('style');
//         s.id = 'sonata-toast-style';
//         s.textContent = `
//             @keyframes sonata-toast-in { from{opacity:0;transform:translateX(-50%) translateY(10px)} to{opacity:1;transform:translateX(-50%) translateY(0)} }
//             @keyframes sonata-toast-out { from{opacity:1} to{opacity:0} }
//         `;
//         document.head.appendChild(s);
//     }
//     toast.innerHTML = `<span>${icons[type]}</span><span>${message}</span>`;
//     document.body.appendChild(toast);
//     setTimeout(() => {
//         toast.style.animation = 'sonata-toast-out 0.3s ease-in forwards';
//         setTimeout(() => toast.parentElement?.removeChild(toast), 300);
//     }, 3500);
// }

// const SKIP_RTP_CODECS = new Set([
//     'rtx',
//     'red',
//     'ulpfec',
//     'flexfec-03',
//     'telephone-event',
//     'cn',
//     'pcmu',
//     'pcma',
//     'g722',
// ]);

// // ─── SDP / Jingle helper functions ─────────────────────────────────────────

// function localName(el) {
//     return el?.localName || el?.nodeName?.split(':').pop();
// }
// function directChildren(el, name = null) {
//     return Array.from(el?.children || []).filter((c) => !name || localName(c) === name);
// }
// function firstDirectChild(el, name) {
//     return directChildren(el, name)[0] || null;
// }

// function getBrowserSupportedCodecNames(media) {
//     try {
//         const caps = RTCRtpReceiver.getCapabilities?.(media);
//         if (!caps?.codecs?.length) return null;
//         return new Set(caps.codecs.map((c) => c.mimeType?.split('/')[1]?.toLowerCase()).filter(Boolean));
//     } catch (e) {
//         return null;
//     }
// }

// function normalizeFmtpParam(name, value) {
//     const paramName = String(name || '')
//         .trim()
//         .replaceAll('_', '-');
//     let paramValue = value == null ? '' : String(value).trim();
//     if (paramValue === 'true') paramValue = '1';
//     if (paramValue === 'false') paramValue = '0';
//     // Decimal profile-level-id from iOS → hex (4382761 → 42e029)
//     if (paramName === 'profile-level-id' && /^\d+$/.test(paramValue)) {
//         paramValue = Number(paramValue).toString(16).padStart(6, '0').slice(-6);
//     }
//     // Force H264 level to 3.1 (42e01f) so Chrome decoder accepts the stream.
//     // level-asymmetry-allowed=1 means iOS can still send at level 4.1.
//     if (paramName === 'profile-level-id' && /^[0-9a-f]{6}$/i.test(paramValue)) {
//         paramValue = '42e01f';
//     }
//     return { name: paramName, value: paramValue };
// }

// function buildFmtpLine(payload) {
//     if (!payload.params?.length) return null;
//     const params = payload.params
//         .filter((p) => p.name && p.value != null && p.value !== '')
//         .map((p) => `${p.name}=${p.value}`);
//     if (!params.length) return null;
//     return `a=fmtp:${payload.id} ${params.join(';')}`;
// }

// function payloadsFromJingleDescription(description, media) {
//     const supported = getBrowserSupportedCodecNames(media);
//     const payloads = [];
//     for (const pt of directChildren(description, 'payload-type')) {
//         const id = pt.getAttribute('id');
//         const name = pt.getAttribute('name');
//         const clockrate = pt.getAttribute('clockrate') || (media === 'video' ? '90000' : '48000');
//         const channels = pt.getAttribute('channels');
//         if (!id || !name) continue;
//         const codec = name.toLowerCase();
//         if (SKIP_RTP_CODECS.has(codec)) continue;
//         if (codec === 'h265') continue;
//         if (supported && !supported.has(codec)) {
//             console.log('[SDP] Skipping unsupported codec:', media, name, id);
//             continue;
//         }
//         const paramsMap = new Map();
//         for (const param of directChildren(pt, 'parameter')) {
//             const rawName = param.getAttribute('name');
//             const rawValue = param.getAttribute('value');
//             if (!rawName) continue;
//             const normalized = normalizeFmtpParam(rawName, rawValue);
//             if (normalized.name) paramsMap.set(normalized.name, normalized.value);
//         }
//         payloads.push({
//             id,
//             name,
//             clockrate,
//             channels,
//             params: Array.from(paramsMap.entries()).map(([n, v]) => ({ name: n, value: v })),
//         });
//     }
//     return payloads;
// }

// function getJingleRtpContents(jingle) {
//     return directChildren(jingle, 'content').filter((c) => !!firstDirectChild(c, 'description'));
// }

// function getJingleBundleMids(jingle, contents) {
//     const group = firstDirectChild(jingle, 'group');
//     const mids = directChildren(group, 'content')
//         .map((c) => c.getAttribute('name'))
//         .filter(Boolean);
//     return mids.length ? mids : contents.map((c, i) => c.getAttribute('name') || String(i));
// }

// /**
//  * Build a WebRTC SDP string from a Jingle XML element.
//  * Works for both 'offer' (session-initiate) and 'answer' (session-accept).
//  */
// function buildSdpFromJingle(jingle, type = 'offer') {
//     const contents = getJingleRtpContents(jingle);
//     const bundleMids = getJingleBundleMids(jingle, contents);
//     const firstTransport = contents.map((c) => firstDirectChild(c, 'transport')).find(Boolean);
//     const firstFingerprint = firstTransport ? firstDirectChild(firstTransport, 'fingerprint') : null;

//     const sdpLines = [
//         'v=0',
//         'o=- 1234567890 2 IN IP4 0.0.0.0',
//         's=-',
//         't=0 0',
//         `a=group:BUNDLE ${bundleMids.join(' ')}`,
//         'a=msid-semantic: WMS',
//     ];

//     contents.forEach((content, index) => {
//         const mid = content.getAttribute('name') || String(index);
//         const description = firstDirectChild(content, 'description');
//         const media = description?.getAttribute('media');
//         if (!description || !media) return;

//         const payloads = payloadsFromJingleDescription(description, media);
//         const payloadIds = payloads.map((p) => p.id);
//         if (!payloadIds.length) {
//             console.warn('[SDP] No compatible payloads for', media, mid);
//             return;
//         }

//         const transport = firstDirectChild(content, 'transport') || firstTransport;
//         const fingerprintEl = firstDirectChild(transport, 'fingerprint') || firstFingerprint;
//         const ufrag = transport?.getAttribute('ufrag');
//         const pwd = transport?.getAttribute('pwd');
//         const fingerprint = fingerprintEl?.textContent?.trim();
//         const setup = fingerprintEl?.getAttribute('setup') || (type === 'answer' ? 'active' : 'actpass');

//         sdpLines.push(`m=${media} 9 UDP/TLS/RTP/SAVPF ${payloadIds.join(' ')}`, 'c=IN IP4 0.0.0.0');
//         if (ufrag) sdpLines.push(`a=ice-ufrag:${ufrag}`);
//         if (pwd) sdpLines.push(`a=ice-pwd:${pwd}`);
//         if (fingerprint) sdpLines.push(`a=fingerprint:sha-256 ${fingerprint}`);
//         sdpLines.push(`a=setup:${setup}`, `a=mid:${mid}`, 'a=rtcp-mux');

//         for (const payload of payloads) {
//             const ch = payload.channels ? `/${payload.channels}` : '';
//             sdpLines.push(`a=rtpmap:${payload.id} ${payload.name}/${payload.clockrate}${ch}`);
//             const fmtp = buildFmtpLine(payload);
//             if (fmtp) sdpLines.push(fmtp);
//             // rtcp-fb lines are required for Chrome to send PLI/NACK/FIR feedback.
//             // Without them Chrome won't request keyframes → remote video stays frozen.
//             if (media === 'video') {
//                 sdpLines.push(
//                     `a=rtcp-fb:${payload.id} nack`,
//                     `a=rtcp-fb:${payload.id} nack pli`,
//                     `a=rtcp-fb:${payload.id} ccm fir`,
//                     `a=rtcp-fb:${payload.id} goog-remb`,
//                     `a=rtcp-fb:${payload.id} transport-cc`,
//                 );
//             }
//         }
//         sdpLines.push('a=sendrecv');
//     });

//     return sdpLines.join('\r\n') + '\r\n';
// }

// function parseSdpSections(sdp) {
//     const rawLines = String(sdp || '')
//         .split(/\r?\n/)
//         .map((l) => l.trim())
//         .filter(Boolean);
//     const sessionLines = [];
//     const sections = [];
//     let current = null;
//     for (const line of rawLines) {
//         if (line.startsWith('m=')) {
//             current = {
//                 mLine: line,
//                 lines: [line],
//                 media: line.slice(2).split(/\s+/)[0],
//                 mid: null,
//                 payloadIds: line.split(/\s+/).slice(3),
//             };
//             sections.push(current);
//             continue;
//         }
//         if (!current) {
//             sessionLines.push(line);
//             continue;
//         }
//         current.lines.push(line);
//         if (line.startsWith('a=mid:')) current.mid = line.slice('a=mid:'.length).trim();
//     }
//     sections.forEach((s, i) => {
//         if (!s.mid) s.mid = String(i);
//     });
//     return { sessionLines, sections };
// }

// function getIceInfoFromSdpSection(section, sessionLines = []) {
//     const lines = [...(section?.lines || []), ...sessionLines];
//     const find = (re) => {
//         for (const l of lines) {
//             const m = l.match(re);
//             if (m) return m[1].trim();
//         }
//         return null;
//     };
//     return {
//         ufrag: find(/^a=ice-ufrag:(.+)$/),
//         pwd: find(/^a=ice-pwd:(.+)$/),
//         fingerprint: find(/^a=fingerprint:sha-256\s+(.+)$/),
//         setup: find(/^a=setup:(.+)$/),
//     };
// }

// /**
//  * Get local ICE creds (ufrag/pwd) for a specific mid from local SDP.
//  * With bundlePolicy max-compat each m-line has its OWN ufrag/pwd.
//  */
// function getLocalIceForMid(sdp, mid) {
//     const { sessionLines, sections } = parseSdpSections(sdp);
//     const sec = sections.find((s) => s.mid === String(mid)) || sections[0];
//     return getIceInfoFromSdpSection(sec, sessionLines);
// }

// function payloadsFromSdpSection(section) {
//     const rtpmapByPt = new Map();
//     const fmtpByPt = new Map();
//     for (const line of section.lines) {
//         let m = line.match(/^a=rtpmap:(\d+)\s+([^/]+)\/(\d+)(?:\/(\d+))?$/);
//         if (m) {
//             const [, id, name, clockrate, channels] = m;
//             rtpmapByPt.set(id, { id, name, clockrate, channels, params: [] });
//             continue;
//         }
//         m = line.match(/^a=fmtp:(\d+)\s+(.+)$/);
//         if (m) {
//             const [, id, rawFmtp] = m;
//             const params = rawFmtp
//                 .split(';')
//                 .map((p) => p.trim())
//                 .filter(Boolean)
//                 .map((p) => {
//                     const eq = p.indexOf('=');
//                     if (eq === -1) return null;
//                     return normalizeFmtpParam(p.slice(0, eq), p.slice(eq + 1));
//                 })
//                 .filter(Boolean);
//             fmtpByPt.set(id, params);
//         }
//     }
//     return section.payloadIds
//         .map((id) => {
//             const payload = rtpmapByPt.get(id);
//             if (!payload) return null;
//             const codec = payload.name.toLowerCase();
//             if (SKIP_RTP_CODECS.has(codec)) return null;
//             payload.params = fmtpByPt.get(id) || [];
//             return payload;
//         })
//         .filter(Boolean);
// }

// /**
//  * Build a Jingle IQ stanza from our local SDP (for session-initiate or session-accept).
//  */
// function buildJingleIqFromLocalSdp({
//     action,
//     to,
//     sid,
//     initiator,
//     responder,
//     localSdp,
//     contentCreatorsByMid = new Map(),
//     preferredMidOrder = null,
// }) {
//     const { sessionLines, sections } = parseSdpSections(localSdp);
//     let ordered = sections.filter((s) => s.media === 'audio' || s.media === 'video');
//     if (preferredMidOrder?.length) {
//         const byMid = new Map(ordered.map((s) => [s.mid, s]));
//         ordered = preferredMidOrder.map((mid) => byMid.get(mid)).filter(Boolean);
//     }
//     const iq = $iq({ type: 'set', to, id: crypto.randomUUID().toLowerCase() }).c('jingle', {
//         xmlns: NS_JINGLE,
//         action,
//         sid,
//         ...(initiator ? { initiator } : {}),
//         ...(responder ? { responder } : {}),
//     });
//     iq.c('group', { xmlns: NS_GROUPING, semantics: 'BUNDLE' });
//     for (const s of ordered) iq.c('content', { name: s.mid }).up();
//     iq.up();
//     for (const section of ordered) {
//         const creator = contentCreatorsByMid.get(section.mid) || 'initiator';
//         const ice = getIceInfoFromSdpSection(section, sessionLines);
//         const payloads = payloadsFromSdpSection(section);
//         iq.c('content', { creator, name: section.mid });
//         iq.c('description', { xmlns: NS_JINGLE_RTP, media: section.media });
//         for (const p of payloads) {
//             const attrs = { id: p.id, name: p.name, clockrate: p.clockrate };
//             if (p.channels) attrs.channels = p.channels;
//             iq.c('payload-type', attrs);
//             for (const param of p.params || []) {
//                 if (!param.name || param.value == null || param.value === '') continue;
//                 iq.c('parameter', { name: param.name, value: param.value }).up();
//             }
//             iq.up();
//         }
//         iq.c('rtcp-mux').up();
//         iq.up();
//         iq.c('transport', {
//             xmlns: NS_JINGLE_ICE,
//             ...(ice.ufrag ? { ufrag: ice.ufrag } : {}),
//             ...(ice.pwd ? { pwd: ice.pwd } : {}),
//         });
//         if (ice.fingerprint) {
//             iq.c('fingerprint', {
//                 xmlns: NS_DTLS,
//                 hash: 'sha-256',
//                 setup: ice.setup || (action === 'session-accept' ? 'active' : 'actpass'),
//             })
//                 .t(ice.fingerprint)
//                 .up();
//         }
//         iq.up();
//         iq.up();
//     }
//     return iq;
// }

// // ─── End SDP helpers ────────────────────────────────────────────────────────

// export default class ChatHeading extends CustomElement {
//     // Static reference to the ChatHeading instance that owns the active call.
//     // Incoming Jingle stanzas are routed here regardless of which instance's
//     // handler fires (every open chat registers its own handler).
//     static activeCall = null;

//     // Guard so the Strophe IQ handler and message listener are registered
//     // only ONCE, not per-instance. Multiple registrations cause Strophe to
//     // fire every handler per incoming stanza, breaking the pc state machine.
//     static _jingleHandlersRegistered = false;

//     // Tracks whether the Strophe-level IQ handler is currently attached.
//     // Separate from _jingleHandlersRegistered because connection lost / reconnect
//     // can detach the handler while the static-listener side stays put.
//     static _stropheHandlerAttached = false;

//     // Pending incoming call (showing modal). Used so <retract> can cancel the modal.
//     static _pendingIncomingSid = null;
//     static _pendingIncomingFrom = null;
//     // Callback set while modal is shown — call it to close the modal externally.
//     static _closeIncomingModal = null;

//     // Timer interval for the call panel
//     static _callTimerInterval = null;

//     // Remote video stream received before PiP was created — flushed in _showCallPanel
//     static _pendingRemoteVideoStream = null;

//     static _iceServersCache = null;
//     static _iceServersCacheExpiry = 0;
//     static _visibilityHandlerAttached = false;

//     /**
//      * Request a keyframe from remote video senders and poll readyState.
//      * Chrome needs an IDR (keyframe) to start decoding H264. If iOS doesn't
//      * send one immediately, readyState stays 0 despite live tracks arriving.
//      */
//     static _requestKeyframeAndPollVideo(pc) {
//         if (!pc) return;
//         try {
//             pc.getReceivers().forEach((receiver) => {
//                 if (receiver.track?.kind === 'video') {
//                     console.log('[ChatHeading] Video receiver readyState:', receiver.track.readyState);
//                     if (typeof receiver.jitterBufferTarget !== 'undefined') {
//                         receiver.jitterBufferTarget = 0;
//                     }
//                 }
//             });
//         } catch (e) {
//             /* ignore */
//         }

//         let attempts = 0;
//         const poll = setInterval(async () => {
//             attempts++;
//             const vid = document.getElementById('sonata-video-remote');
//             if (!vid) {
//                 clearInterval(poll);
//                 return;
//             }
//             const rs = vid.readyState;
//             console.log(`[ChatHeading] Video poll ${attempts}: readyState=${rs} paused=${vid.paused}`);
//             if (rs >= 2) {
//                 console.log('%c [VIDEO] ✅ Playing! readyState=' + rs, 'background: green; color: white;');
//                 clearInterval(poll);
//                 return;
//             }
//             if (vid.paused && vid.srcObject) {
//                 vid.play().catch(() => {});
//             }
//             // At 2s: check RTP stats — are packets even arriving?
//             if (attempts === 4) {
//                 try {
//                     const stats = await pc.getStats();
//                     stats.forEach((report) => {
//                         if (report.type === 'inbound-rtp' && report.kind === 'video') {
//                             console.log(
//                                 `[VIDEO STATS] packetsReceived=${report.packetsReceived} framesReceived=${report.framesReceived || 0} framesDecoded=${report.framesDecoded || 0} framesDropped=${report.framesDropped || 0} decoderImpl=${report.decoderImplementation || '?'}`,
//                             );
//                         }
//                         if (report.type === 'codec' && report.mimeType?.toLowerCase().includes('h264')) {
//                             console.log(`[VIDEO STATS] codec: ${report.mimeType} fmtp=${report.sdpFmtpLine}`);
//                         }
//                     });
//                 } catch (e) {
//                     console.warn('[VIDEO STATS] getStats failed:', e.message);
//                 }
//             }
//             // Re-attach stream after 3s to force a new decoder init + keyframe request
//             if (attempts === 6 && rs === 0 && vid.srcObject) {
//                 console.warn('[ChatHeading] No frames after 3s — cycling srcObject to force keyframe');
//                 const stream = vid.srcObject;
//                 vid.srcObject = null;
//                 setTimeout(() => {
//                     vid.srcObject = stream;
//                     vid.play().catch(() => {});
//                 }, 150);
//             }
//             if (attempts >= 20) {
//                 clearInterval(poll);
//             }
//         }, 500);
//     }

//     /**
//      * Dump all ICE candidate pairs + local/remote candidates from getStats.
//      * Call on disconnected/failed to see which network paths were tried and
//      * why none succeeded (all pairs failed/in-progress = client isolation /
//      * symmetric NAT both sides / no TURN relay).
//      */
//     static _dumpIcePairs(pc, label = '') {
//         if (!pc) return;
//         pc.getStats()
//             .then((stats) => {
//                 console.log(`%c [ICE DUMP ${label}] `, 'background:#b71c1c;color:#fff;');
//                 stats.forEach((r) => {
//                     if (r.type === 'candidate-pair') {
//                         console.log(
//                             `[ICE PAIR] state=${r.state} nominated=${r.nominated} ` +
//                                 `local=${r.localCandidateId} remote=${r.remoteCandidateId} ` +
//                                 `sent=${r.bytesSent || 0} recv=${r.bytesReceived || 0} ` +
//                                 `requestsSent=${r.requestsSent || 0} responsesReceived=${r.responsesReceived || 0}`,
//                         );
//                     }
//                     if (r.type === 'local-candidate') {
//                         console.log(
//                             `[ICE LOCAL] id=${r.id} type=${r.candidateType} ${r.address || r.ip}:${r.port} ${r.protocol} netType=${r.networkType || '?'}`,
//                         );
//                     }
//                     if (r.type === 'remote-candidate') {
//                         console.log(
//                             `[ICE REMOTE] id=${r.id} type=${r.candidateType} ${r.address || r.ip}:${r.port} ${r.protocol}`,
//                         );
//                     }
//                 });
//             })
//             .catch(() => {});
//     }

//     /**
//      * Fetch ICE servers via XEP-0215 external service discovery.
//      * Queries the XMPP server (not the remote peer). Cached after first call.
//      */
//     static async _getIceServers() {
//         if (ChatHeading._iceServersCache && Date.now() < ChatHeading._iceServersCacheExpiry) {
//             return ChatHeading._iceServersCache;
//         }
//         // ── TEMPORARY TEST TURN ─────────────────────────────────────────────
//         // Public Open Relay (metered.ca) to PROVE that relay fixes calls to
//         // phones behind symmetric CGNAT. REMOVE once own coturn is deployed
//         // and advertised via XEP-0215 — do not ship to production with this.
//         const TEST_TURN = [
//             { urls: 'turn:openrelay.metered.ca:80', username: 'openrelayproject', credential: 'openrelayproject' },
//             { urls: 'turn:openrelay.metered.ca:443', username: 'openrelayproject', credential: 'openrelayproject' },
//             {
//                 urls: 'turn:openrelay.metered.ca:443?transport=tcp',
//                 username: 'openrelayproject',
//                 credential: 'openrelayproject',
//             },
//         ];
//         // ────────────────────────────────────────────────────────────────────
//         const fallback = [{ urls: 'stun:stun.l.google.com:19302' }, ...TEST_TURN];
//         try {
//             // Always query our own server domain, never a peer JID
//             const domain =
//                 _converse.domain || (_converse.bare_jid || '').split('@')[1] || (_converse.jid || '').split('@')[1];
//             if (!domain) {
//                 console.warn('[ChatHeading] No domain for XEP-0215');
//                 return fallback;
//             }
//             console.log('[ChatHeading] Querying XEP-0215 TURN from domain:', domain);

//             let services = null;
//             for (const xmlns of ['urn:xmpp:extdisco:2', 'urn:xmpp:extdisco:1']) {
//                 try {
//                     const iq = $iq({ type: 'get', to: domain }).c('services', { xmlns });
//                     const result = await new Promise((resolve, reject) => {
//                         const timer = setTimeout(() => reject(new Error('timeout')), 5000);
//                         _converse.api
//                             .sendIQ(iq)
//                             .then((res) => {
//                                 clearTimeout(timer);
//                                 resolve(res);
//                             })
//                             .catch((err) => {
//                                 clearTimeout(timer);
//                                 reject(err);
//                             });
//                     });
//                     const found = result.querySelectorAll('service');
//                     if (found.length) {
//                         services = found;
//                         console.log(`[ChatHeading] XEP-0215 ${xmlns}: got ${found.length} services`);
//                         break;
//                     }
//                 } catch (e) {
//                     console.log(`[ChatHeading] XEP-0215 ${xmlns} failed:`, e.message);
//                 }
//             }

//             if (!services || !services.length) {
//                 console.warn('[ChatHeading] XEP-0215 returned no TURN services');
//                 ChatHeading._iceServersCache = fallback;
//                 return fallback;
//             }

//             const iceServers = [{ urls: 'stun:stun.l.google.com:19302' }];
//             services.forEach((svc) => {
//                 const type = svc.getAttribute('type');
//                 const host = svc.getAttribute('host');
//                 const port = svc.getAttribute('port');
//                 const user = svc.getAttribute('username');
//                 const pass = svc.getAttribute('password');
//                 const transport = svc.getAttribute('transport') || 'udp';
//                 if (!host) return;
//                 if (type === 'stun') {
//                     iceServers.push({ urls: `stun:${host}${port ? ':' + port : ''}` });
//                 } else if (type === 'turn') {
//                     const url = `turn:${host}${port ? ':' + port : ''}?transport=${transport}`;
//                     const entry = { urls: url };
//                     if (user) entry.username = user;
//                     if (pass) entry.credential = pass;
//                     iceServers.push(entry);
//                     console.log(`[ChatHeading] TURN: ${url} user=${user}`);
//                 }
//             });
//             // TEMPORARY: append test TURN until XEP-0215 advertises a real one
//             if (!iceServers.some((s) => String(s.urls).startsWith('turn:'))) {
//                 iceServers.push(...TEST_TURN);
//                 console.log('[ChatHeading] No TURN from XEP-0215 — appended TEST_TURN (Open Relay)');
//             }
//             console.log('[ChatHeading] ICE servers:', JSON.stringify(iceServers));
//             ChatHeading._iceServersCache = iceServers;
//             // TURN credentials expire at the timestamp in username (unix seconds).
//             // Refresh 5 minutes before expiry.
//             const turnEntry = iceServers.find((s) => s.urls?.startsWith?.('turn:') && s.username);
//             if (turnEntry) {
//                 const expireTs = parseInt(turnEntry.username.split(':')[0], 10) * 1000;
//                 ChatHeading._iceServersCacheExpiry = expireTs - 5 * 60 * 1000;
//             } else {
//                 ChatHeading._iceServersCacheExpiry = Date.now() + 3600 * 1000;
//             }
//             return iceServers;
//         } catch (e) {
//             console.warn('[ChatHeading] _getIceServers error:', e.message);
//             return fallback;
//         }
//     }

//     constructor() {
//         super();
//         this.jid = null;

//         // --- Call state (per-instance) ---
//         // NOTE: keeping these on the instance means every open chat has its own
//         // pc / localStream. If multiple chats are open and the user triggers
//         // calls in parallel, they won't interfere — but the *incoming* Jingle
//         // handlers below register once per ChatHeading instance, so every open
//         // chat will receive and try to handle every incoming Jingle stanza.
//         // That is the known bug we accepted.
//         this.pc = null;
//         this.localStream = null;
//         this.iceCandidatesQueue = [];
//         this.currentSid = null;
//         this.isIncoming = false;
//         this.remoteFullJid = null;
//         this.isVideo = false; // true when this is a video call
//     }

//     static get properties() {
//         return {
//             jid: { type: String },
//         };
//     }

//     initialize() {
//         const { chatboxes } = _converse.state;
//         this.model = chatboxes.get(this.jid);
//         this.listenTo(this.model, 'change:status', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:add', () => this.requestUpdate());
//         this.listenTo(this.model, 'vcard:change', () => this.requestUpdate());
//         if (this.model.contact) {
//             this.listenTo(this.model.contact, 'destroy', () => this.requestUpdate());
//         }
//         this.model.rosterContactAdded?.then(() => {
//             this.listenTo(this.model.contact, 'change:nickname', () => this.requestUpdate());
//             this.requestUpdate();
//         });

//         // --- Wire up Jingle handlers on this instance ---
//         // BUG WARNING: registered per ChatHeading. With N open chats, every
//         // incoming Jingle IQ fires N times. Same for the 'message' (proceed)
//         // listener and the 'connected' event.
//         this._registerJingleHandlers();

//         this.requestUpdate();
//     }

//     render() {
//         return tplChatboxHead(this);
//     }

//     /**
//      * @param {Event} ev
//      */
//     showUserDetailsModal(ev) {
//         ev.preventDefault();
//         if (this.model?.contact instanceof _converse.exports.Profile) {
//             api.modal.show('converse-profile-modal', { model: this.model }, ev);
//         } else {
//             api.modal.show('converse-user-details-modal', { model: this.model }, ev);
//         }
//     }

//     /**
//      * @param {Event} ev
//      */
//     close(ev) {
//         ev.preventDefault();
//         this.model.close();
//     }

//     // ========================================================================
//     // CALL LOGIC (moved from sonata-p2p-init plugin)
//     // ========================================================================

//     _registerJingleHandlers() {
//         // Register the Strophe IQ handler and message listener EXACTLY ONCE
//         // across all ChatHeading instances. Without this guard, every open
//         // chat registers its own handler, and Strophe fires ALL of them per
//         // incoming stanza — resulting in N calls to setRemoteDescription /
//         // addIceCandidate on the same pc, which breaks the RTCPeerConnection
//         // state machine and ICE never completes.
//         if (ChatHeading._jingleHandlersRegistered) return;
//         ChatHeading._jingleHandlersRegistered = true;

//         console.log('=== [ChatHeading] Registering Jingle handlers (once globally) ===');

//         const self = this;

//         // Wait for Strophe connection, then attach raw IQ handler for Jingle.
//         // The plugin used `_converse.on('connected', ...)` which fires once at
//         // login. But ChatHeading.initialize() runs PER CHAT OPEN, which may be
//         // AFTER 'connected' has already fired (event missed). So we try all
//         // three paths: immediate (if connection exists), 'connected' listener,
//         // AND a polling fallback. Whichever wins, the static guard inside
//         // attach() prevents double-registration on Strophe.
//         const attach = () => {
//             if (ChatHeading._stropheHandlerAttached) return;
//             const connection = _converse.connection || api.connection?.get?.();
//             if (!connection || !connection.addHandler) {
//                 console.log('[ChatHeading] No Strophe connection yet, will retry');
//                 return false;
//             }

//             ChatHeading._stropheHandlerAttached = true;
//             console.log('[ChatHeading] ✓ Strophe Jingle IQ handler attached');

//             connection.addHandler(
//                 (stanza) => {
//                     const jingle = sizzle(`jingle[xmlns="${NS_JINGLE}"]`, stanza).pop();
//                     if (!jingle) return true;

//                     const action = jingle.getAttribute('action');
//                     const from = stanza.getAttribute('from');
//                     const id = stanza.getAttribute('id');
//                     const sid = jingle.getAttribute('sid');

//                     console.log(
//                         `%c [JINGLE RECEIVE] Action: ${action} from ${from} sid=${sid} `,
//                         'background: #222; color: #bada55; padding: 2px;',
//                     );

//                     // ACK the IQ immediately
//                     connection.send($iq({ type: 'result', to: from, id: id }).tree());

//                     const target = ChatHeading.activeCall;
//                     if (!target) {
//                         console.warn('[JINGLE RECEIVE] No active call; ignoring', action);
//                         return true;
//                     }
//                     if (!target.pc) {
//                         console.warn(
//                             '[JINGLE RECEIVE] Active call has no pc yet; action=' + action,
//                             '— may be timing issue',
//                         );
//                         // For transport-info we can queue. For session-initiate
//                         // (incoming call) we create the pc inside the handler.
//                         // For session-accept we can't do much without pc — skip.
//                         if (action === 'transport-info' || action === 'session-initiate') {
//                             // ok, let it through
//                         } else {
//                             return true;
//                         }
//                     }

//                     switch (action) {
//                         case 'session-initiate': {
//                             console.log('[JINGLE RECEIVE] session-initiate (we are callee)');
//                             // Pass raw jingle XML — handleSessionInitiate uses buildSdpFromJingle
//                             target.handleSessionInitiate(from, sid, jingle);
//                             break;
//                         }
//                         case 'session-accept': {
//                             // Pass raw jingle XML — handleSessionAccept uses buildSdpFromJingle
//                             target.handleSessionAccept(from, sid, jingle);
//                             break;
//                         }
//                         case 'transport-info':
//                             target.handleIncomingCandidates(jingle);
//                             break;
//                         case 'session-terminate':
//                             console.warn('[JINGLE RECEIVE] Remote terminated the call');
//                             console.warn('[JINGLE RECEIVE] session-terminate reason XML:', jingle.outerHTML);
//                             target.terminateCall(false);
//                             break;
//                         case 'session-info':
//                             // ringing / on_hold / etc — informational only
//                             console.log('[JINGLE RECEIVE] session-info (informational):', jingle.innerHTML);
//                             break;
//                         default:
//                             console.log('[JINGLE RECEIVE] Unhandled action:', action);
//                     }

//                     return true;
//                 },
//                 NS_JINGLE,
//                 'iq',
//                 'set',
//             );
//             return true;
//         };

//         // Path 1: connection already exists at registration time
//         if (_converse.connection && _converse.connection.addHandler) {
//             attach();
//         }

//         // Path 2: listen for 'connected' and 'reconnected' events
//         // Converse fires 'connected' on first login and 'reconnected' after network loss.
//         // Without catching both, the Strophe IQ handler dies after reconnect and
//         // session-accept / transport-info stanzas are silently dropped.
//         const onConnected = () => {
//             console.log('[ChatHeading] connected/reconnected event — re-registering Jingle handler');
//             ChatHeading._stropheHandlerAttached = false;
//             ChatHeading._iceServersCache = null;
//             ChatHeading._iceServersCacheExpiry = 0;
//             attach();
//         };
//         api.listen.on('connected', onConnected);
//         api.listen.on('reconnected', onConnected);

//         // Invalidate TURN cache when tab wakes from sleep/background.
//         // Browser suspend freezes the JS clock — TURN credentials expire while
//         // suspended, so the cached timestamp-based credentials are stale on wake.
//         if (!ChatHeading._visibilityHandlerAttached) {
//             ChatHeading._visibilityHandlerAttached = true;
//             document.addEventListener('visibilitychange', () => {
//                 if (document.visibilityState === 'visible') {
//                     console.log('[ChatHeading] Tab visible — invalidating TURN cache');
//                     ChatHeading._iceServersCache = null;
//                     ChatHeading._iceServersCacheExpiry = 0;
//                 }
//             });
//         }

//         // Path 3: polling fallback. ChatHeading.initialize() may run AFTER
//         // 'connected' has already fired (because user opened a chat after
//         // login). In that case neither Path 1 nor Path 2 catches it. Poll
//         // until connection becomes available, then stop.
//         const pollInterval = setInterval(() => {
//             if (ChatHeading._stropheHandlerAttached) {
//                 clearInterval(pollInterval);
//                 return;
//             }
//             if (attach()) {
//                 clearInterval(pollInterval);
//             }
//         }, 500);
//         // Stop polling after 30s no matter what to avoid leaks
//         setTimeout(() => clearInterval(pollInterval), 30000);

//         // Listen for Jingle Message Initiation on regular messages:
//         //   <propose> — incoming call (we are callee)
//         //   <retract> — caller cancelled before we picked up
//         //   <proceed> — callee accepted our call (we are caller)
//         //   <ringing>, <received>, <reject>, <accept> — info
//         _converse.on('message', (data) => {
//             const stanza = data.stanza;
//             const from = stanza.getAttribute('from');
//             const bare_jid = _converse.bare_jid;
//             const fromBare = from?.split('/')[0];

//             // Ignore our own carbons (echoes of stanzas we sent)
//             const isOwnCarbon = fromBare === bare_jid;

//             // Look for any JMI element
//             const propose = sizzle(`propose[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const retract = sizzle(`retract[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const proceed = sizzle(`proceed[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const ringing = sizzle(`ringing[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const received = sizzle(`received[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const reject = sizzle(`reject[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             const accept = sizzle(`accept[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();

//             // --- INCOMING CALL: <propose> ---
//             if (propose && !isOwnCarbon) {
//                 const sid = propose.getAttribute('id');
//                 const description = sizzle('description', propose).pop();
//                 const media = description?.getAttribute('media') || 'audio';
//                 console.log(
//                     `%c [JMI INCOMING] propose from ${from} sid=${sid} media=${media} `,
//                     'background: #1e9652; color: white; padding: 2px;',
//                 );
//                 ChatHeading.handleIncomingPropose(from, sid, media);
//                 return;
//             }

//             // --- CALLER CANCELLED: <retract> ---
//             if (retract && !isOwnCarbon) {
//                 const sid = retract.getAttribute('id');
//                 console.warn(`[JMI INCOMING] retract from ${from} sid=${sid} (caller cancelled)`);
//                 ChatHeading.handleRetract(sid);
//                 return;
//             }

//             // --- CALL ENDED BY REMOTE: <finish> (XEP-0272 / Sonata extension) ---
//             const finish = sizzle(`finish[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
//             if (finish && !isOwnCarbon) {
//                 const sid = finish.getAttribute('id');
//                 console.warn(`[JMI] finish from ${from} sid=${sid} — remote ended call`);
//                 const t = ChatHeading.activeCall;
//                 if (t) t.terminateCall(false); // remote already ended, don't echo
//                 return;
//             }

//             if (ringing) {
//                 console.log('[JMI] ringing from', from);
//                 return;
//             }
//             if (received) {
//                 console.log('[JMI] received (delivery ack) from', from);
//                 return;
//             }
//             if (reject) {
//                 console.warn('[JMI] reject from', from, '— remote declined');
//                 const t = ChatHeading.activeCall;
//                 if (t) t.terminateCall(false);
//                 return;
//             }
//             if (accept) {
//                 console.log('[JMI] accept seen (carbon echo from another device)');
//                 return;
//             }

//             // --- OUR OUTGOING CALL WAS ACCEPTED: <proceed> ---
//             if (proceed) {
//                 console.log('=== [JMI] proceed from', from, '===');
//                 const target = ChatHeading.activeCall;
//                 if (!target) {
//                     console.warn('[ChatHeading] proceed received but no active call');
//                     return;
//                 }
//                 if (target.pc) {
//                     console.log('[ChatHeading] Already have pc, ignoring duplicate proceed');
//                     return;
//                 }
//                 console.log('=== [ChatHeading] Starting WebRTC (sendJingleInitiate) ===');
//                 const sid = proceed.getAttribute('id');
//                 target.sendJingleInitiate(from, sid);
//             }
//         });
//     }

//     /**
//      * Called from chat-head.js template buttons.
//      * @param {'audio'|'video'} media
//      */
//     async initiateCall(media = 'audio') {
//         if (!this.model) {
//             console.warn('[ChatHeading] No model, cannot initiate call');
//             return;
//         }

//         this.isVideo = media === 'video';

//         // Pre-warm media BEFORE sending <propose>.
//         try {
//             console.log(`[ChatHeading] Pre-warming media (${media})...`);
//             this.localStream = await navigator.mediaDevices.getUserMedia({
//                 audio: true,
//                 video: this.isVideo,
//             });
//         } catch (err) {
//             console.error('[ChatHeading] Media permission denied / unavailable:', err);
//             // If video device not found, fall back to audio-only
//             if (
//                 this.isVideo &&
//                 (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError' || err.name === 'NotReadableError')
//             ) {
//                 console.warn('[ChatHeading] Camera not available, falling back to audio-only call');
//                 showToast('Камера не знайдена — дзвінок буде аудіо', 'warn');
//                 try {
//                     this.localStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
//                     this.isVideo = false;
//                     media = 'audio';
//                     console.log('[ChatHeading] Audio-only fallback successful');
//                 } catch (audioErr) {
//                     console.error('[ChatHeading] Audio also failed:', audioErr);
//                     showToast('Мікрофон недоступний. Перевірте підключення та дозволи.', 'error');
//                     this.model.createMessage({ message: '❌ Не вдалося отримати доступ до мікрофона', type: 'info' });
//                     return;
//                 }
//             } else if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
//                 showToast(
//                     `Доступ до ${this.isVideo ? 'камери/мікрофона' : 'мікрофона'} заборонено. Дозвольте доступ у налаштуваннях браузера.`,
//                     'error',
//                 );
//                 this.model.createMessage({
//                     message: `❌ Доступ до ${this.isVideo ? 'камери/мікрофона' : 'мікрофона'} заборонено`,
//                     type: 'info',
//                 });
//                 return;
//             } else {
//                 showToast(`Не вдалося отримати доступ до ${this.isVideo ? 'камери/мікрофона' : 'мікрофона'}`, 'error');
//                 this.model.createMessage({
//                     message: `❌ Не вдалося отримати доступ до ${this.isVideo ? 'камери/мікрофона' : 'мікрофона'}`,
//                     type: 'info',
//                 });
//                 return;
//             }
//         }

//         const jid = this.model.get('jid');
//         const sid = crypto.randomUUID().toUpperCase();
//         const stanzaId = `jm-propose-${sid}`;
//         const myNick = _converse.xmppstatus.get('fullname') || _converse.bare_jid;

//         this.currentSid = sid;
//         ChatHeading.activeCall = this;

//         console.log(`[ChatHeading] Proposing ${media} call to ${jid}, SID: ${sid}`);

//         const propose = $msg({ to: jid, type: 'chat', id: stanzaId })
//             .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: stanzaId })
//             .up()
//             .c('propose', { xmlns: NS_JINGLE_MSG, id: sid })
//             .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//             .up();

//         if (this.isVideo) {
//             propose.c('description', { xmlns: NS_JINGLE_RTP, media: 'video' }).up();
//         }

//         propose
//             .up()
//             .c('request', { xmlns: 'urn:xmpp:receipts' })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' })
//             .up()
//             .c('x', { xmlns: 'p1:push:custom', key: 'type', value: 'call' })
//             .up()
//             .c('x', { xmlns: 'p1:push:custom', key: 'aps.mutable-content', value: '1' })
//             .up()
//             .c('customize', { xmlns: 'p1:push:customize', nick: myNick })
//             .c('body')
//             .t('Incoming call')
//             .up()
//             .up();

//         api.send(propose);
//         this.model.createMessage({
//             message: `${this.isVideo ? '📹' : '📞'} Виклик (очікування відповіді...)`,
//             type: 'info',
//         });
//         ChatHeading._showOutgoingCallPanel(this);
//     }

//     async sendJingleInitiate(fullJid, sid) {
//         console.log('[ChatHeading] >>> sendJingleInitiate START', { fullJid, sid });
//         this.iceCandidatesQueue = [];
//         this.currentSid = sid;
//         this.remoteFullJid = fullJid; // needed for terminateCall to send session-terminate

//         try {
//             // Reuse pre-warmed stream from initiateCall(). Only fall back to
//             // getUserMedia if there isn't one (e.g. incoming-direction calls
//             // that bypass our initiateCall — currently none, but safe).
//             if (!this.localStream) {
//                 console.log('[ChatHeading] No pre-warmed stream, requesting media...');
//                 this.localStream = await navigator.mediaDevices.getUserMedia({
//                     audio: true,
//                     video: this.isVideo,
//                 });
//                 console.log('[ChatHeading] Got media stream:', this.localStream);
//             } else {
//                 console.log('[ChatHeading] Reusing pre-warmed stream (isVideo:', this.isVideo, ')');
//             }

//             console.log('[ChatHeading] Creating RTCPeerConnection...');
//             const iceServers = await ChatHeading._getIceServers();
//             console.log('[ChatHeading] Using ICE servers:', JSON.stringify(iceServers));
//             this.pc = new RTCPeerConnection({
//                 iceServers,
//                 // max-compat: iOS doesn't BUNDLE video (separate ICE transport per
//                 // m-line, own ufrag/pwd). max-bundle would force video onto the audio
//                 // transport that iOS never connects → no video both ways with iOS.
//                 bundlePolicy: 'max-compat',
//                 rtcpMuxPolicy: 'require',
//                 iceCandidatePoolSize: 2, // pre-gather candidates before offer
//             });
//             console.log('[ChatHeading] RTCPeerConnection created');

//             this.pc.oniceconnectionstatechange = () => {
//                 console.log(`%c [ICE] state=${this.pc.iceConnectionState} `, 'color: orange; font-weight: bold;');
//                 if (this.pc.iceConnectionState === 'failed') {
//                     console.warn('[ICE] FAILED — attempting ICE restart...');
//                     ChatHeading._dumpIcePairs(this.pc, 'failed');
//                     if (this.pc.signalingState === 'stable' && this.pc.restartIce) {
//                         this.pc.restartIce();
//                     }
//                 }
//                 if (this.pc.iceConnectionState === 'disconnected') {
//                     console.warn('[ICE] DISCONNECTED — will restart if not recovered in 5s');
//                     ChatHeading._dumpIcePairs(this.pc, 'disconnected');
//                     setTimeout(() => {
//                         if (this.pc && this.pc.iceConnectionState === 'disconnected') {
//                             console.warn('[ICE] Still disconnected — restarting ICE');
//                             if (this.pc.signalingState === 'stable' && this.pc.restartIce) {
//                                 this.pc.restartIce();
//                             }
//                         }
//                     }, 5000);
//                 }
//                 if (this.pc.iceConnectionState === 'connected') {
//                     console.log('%c [ICE] ✅ CONNECTED ', 'background: green; color: white;');
//                     ChatHeading._showCallPanel(this);
//                     ChatHeading._requestKeyframeAndPollVideo(this.pc);
//                 }
//             };

//             this.pc.onconnectionstatechange = () => {
//                 console.log(`[PC] connectionState=${this.pc.connectionState}`);
//             };

//             // Logs STUN/TURN server failures (401 bad creds, 701 timeout, etc).
//             // Without this, a dead TURN server fails silently — no relay
//             // candidates appear and nobody knows why.
//             this.pc.onicecandidateerror = (ev) => {
//                 console.warn(
//                     `[ICE ERROR] url=${ev.url} code=${ev.errorCode} text="${ev.errorText}" address=${ev.address}:${ev.port}`,
//                 );
//             };

//             this.pc.onsignalingstatechange = () => {
//                 console.log(`[PC] signalingState=${this.pc.signalingState}`);
//             };

//             this.pc.ontrack = (event) => {
//                 console.log(
//                     `%c [TRACK] kind=${event.track.kind} streams=${event.streams.length} `,
//                     'background: #333; color: #7ec8e3; padding: 2px;',
//                 );
//                 if (event.track.kind === 'audio') {
//                     console.log('[ChatHeading] Attaching remote audio track');
//                     let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
//                     el.id = 'sonata-audio-remote';
//                     el.autoplay = true;
//                     if (!el.parentElement) document.body.appendChild(el);
//                     el.srcObject = event.streams[0];
//                 } else if (event.track.kind === 'video') {
//                     console.log('[ChatHeading] Attaching remote video track — PiP should show');
//                     ChatHeading._attachRemoteVideo(event.streams[0]);
//                 }
//             };

//             this.pc.onicecandidate = (event) => {
//                 if (event.candidate) {
//                     const c = event.candidate;
//                     console.log('[ChatHeading] Local candidate:', c.candidate);
//                     const attrs = {
//                         id: String(Math.floor(Math.random() * 4294967295)),
//                         // c.component is 'rtp'/'rtcp' (string!) in WebRTC API.
//                         // XEP-0176 requires numeric "1"/"2" — iOS rejects "rtp"
//                         // with <bad-request/> and drops ALL our candidates.
//                         component: c.component === 'rtcp' ? '2' : '1',
//                         foundation: c.foundation,
//                         generation: '0',
//                         ip: c.address || c.ip,
//                         port: String(c.port),
//                         priority: String(c.priority),
//                         protocol: (c.protocol || 'udp').toLowerCase(),
//                         type: c.type,
//                     };
//                     if (c.relatedAddress) attrs['rel-addr'] = c.relatedAddress;
//                     if (c.relatedPort) attrs['rel-port'] = String(c.relatedPort);
//                     // Candidate belongs to a specific m-line (sdpMid). With max-compat
//                     // each m-line has its own transport+ufrag — send under the right
//                     // content name so iOS routes it to the correct ICE agent.
//                     const candMid = c.sdpMid != null ? String(c.sdpMid) : '0';
//                     const candIce = getLocalIceForMid(this.pc?.localDescription?.sdp || '', candMid);
//                     const iq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                         .c('jingle', { xmlns: NS_JINGLE, action: 'transport-info', initiator: _converse.jid, sid })
//                         .c('content', { creator: 'initiator', name: candMid })
//                         .c('transport', {
//                             xmlns: NS_JINGLE_ICE,
//                             ufrag: candIce.ufrag || c.usernameFragment || '',
//                             pwd: candIce.pwd || '',
//                         })
//                         .c('candidate', attrs);
//                     api.send(iq);
//                 }
//             };

//             this.localStream.getTracks().forEach((track) => this.pc.addTrack(track, this.localStream));

//             const offer = await this.pc.createOffer();
//             await this.pc.setLocalDescription(offer);

//             const sdp = this.pc.localDescription.sdp;
//             console.log('[ChatHeading] 📋 LOCAL OFFER SDP (full):\n', sdp);
//             const ufrag = sdp.match(/a=ice-ufrag:(.*)\r/)[1];
//             const pwd = sdp.match(/a=ice-pwd:(.*)\r/)[1];
//             const fingerprint = sdp.match(/a=fingerprint:sha-256 (.*)\r/)[1];

//             console.log('[ChatHeading] Sending session-initiate (isVideo:', this.isVideo, ')...');
//             console.log(
//                 '[ChatHeading] Local tracks:',
//                 this.localStream?.getTracks().map((t) => `${t.kind}:${t.label}`),
//             );

//             // Parse video codecs from our actual offer SDP so PT numbers match.
//             // Hardcoding 96/97 doesn't work — browser assigns different PT numbers
//             // (e.g. H264 gets 103, 107, etc). iOS/Android match by PT number in the
//             // answer, so we must use whatever the browser assigned in the offer.
//             const SKIP = new Set([
//                 'rtx',
//                 'red',
//                 'ulpfec',
//                 'flexfec-03',
//                 'telephone-event',
//                 'cn',
//                 'pcmu',
//                 'pcma',
//                 'g722',
//             ]);
//             const offerVideoPayloads = [];
//             let inVid = false;
//             for (const line of sdp.split('\n')) {
//                 const l = line.trim();
//                 if (l.startsWith('m=video')) {
//                     inVid = true;
//                     continue;
//                 }
//                 if (l.startsWith('m=') && inVid) {
//                     inVid = false;
//                     break;
//                 }
//                 if (inVid && l.startsWith('a=rtpmap:')) {
//                     const m = l.match(/^a=rtpmap:(\d+) ([^/]+)\/(\d+)/);
//                     if (m && !SKIP.has(m[2].toLowerCase())) {
//                         offerVideoPayloads.push({ id: m[1], name: m[2], clockrate: m[3] });
//                     }
//                 }
//             }
//             // Reorder: H264 first (for iOS), then others
//             offerVideoPayloads.sort((a, b) => {
//                 const aH = a.name.toLowerCase().includes('h264') ? 0 : 1;
//                 const bH = b.name.toLowerCase().includes('h264') ? 0 : 1;
//                 return aH - bH;
//             });
//             console.log('[ChatHeading] Outgoing video offer payloads:', offerVideoPayloads);

//             // Build session-initiate as one unbroken chain.
//             let initiateIq;
//             if (this.isVideo) {
//                 let iq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', { xmlns: NS_JINGLE, action: 'session-initiate', initiator: _converse.jid, sid })
//                     .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                     .c('content', { name: '0' })
//                     .up()
//                     .c('content', { name: '1' })
//                     .up()
//                     .up()
//                     .c('content', { creator: 'initiator', name: '0' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                     .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                     .c('parameter', { name: 'minptime', value: '10' })
//                     .up()
//                     .c('parameter', { name: 'useinbandfec', value: '1' })
//                     .up()
//                     .up()
//                     .c('rtcp-mux')
//                     .up()
//                     .up()
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                     .t(fingerprint)
//                     .up()
//                     .up()
//                     .up()
//                     .c('content', { creator: 'initiator', name: '1' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'video' });

//                 offerVideoPayloads.forEach((p) =>
//                     iq.c('payload-type', { id: p.id, name: p.name, clockrate: p.clockrate }).up(),
//                 );

//                 iq = iq
//                     .c('rtcp-mux')
//                     .up()
//                     .up()
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                     .t(fingerprint)
//                     .up()
//                     .up()
//                     .up();

//                 initiateIq = iq;
//             } else {
//                 initiateIq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', { xmlns: NS_JINGLE, action: 'session-initiate', initiator: _converse.jid, sid })
//                     .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
//                     .c('content', { name: '0' })
//                     .up()
//                     .up() // </group>
//                     .c('content', { creator: 'initiator', name: '0' })
//                     .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
//                     .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
//                     .c('parameter', { name: 'minptime', value: '10' })
//                     .up()
//                     .c('parameter', { name: 'useinbandfec', value: '1' })
//                     .up()
//                     .up() // </payload-type>
//                     .c('rtcp-mux')
//                     .up()
//                     .up() // </description>
//                     .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
//                     .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' })
//                     .t(fingerprint)
//                     .up()
//                     .up() // </transport>
//                     .up(); // </content>
//             }

//             api.send(initiateIq);
//             console.log('[ChatHeading] 📤 session-initiate XML:\n', initiateIq.toString());
//             console.log('[ChatHeading] >>> sendJingleInitiate DONE (session-initiate sent)');
//         } catch (err) {
//             console.error('[ChatHeading] WebRTC Error in sendJingleInitiate:', err);
//             console.error('[ChatHeading] Stack:', err?.stack);
//         }
//     }

//     handleSessionAccept(fromJid, sid, jingle) {
//         console.log('[ChatHeading] >>> handleSessionAccept START', { fromJid, sid });
//         if (!this.pc) {
//             console.error('[ChatHeading] handleSessionAccept: NO PC! Cannot proceed.');
//             return;
//         }
//         console.log('[ChatHeading] pc signaling state:', this.pc.signalingState);
//         console.log('[ChatHeading] Session-accept Jingle XML:\n', jingle?.outerHTML);

//         try {
//             // The answer MUST match our offer's m-line count and order exactly.
//             // iOS sometimes sends only 1 content in session-accept even when we offered 2.
//             // buildSdpFromJingle on that would produce a 1-m-line answer → Chrome rejects it.
//             // Instead, build from our own offer mids and use ICE/DTLS from the remote accept.
//             const offerSdp = this.pc.localDescription?.sdp || '';
//             const offerMids = [...offerSdp.matchAll(/^a=mid:(.+)$/gm)].map((m) => m[1].trim());
//             console.log('[ChatHeading] Offer m-line mids:', offerMids);

//             // Read ICE/DTLS PER CONTENT from the remote accept.
//             // iOS does NOT bundle video — its BUNDLE group lists only "0" and the
//             // video content carries a separate <transport> with its own ufrag/pwd.
//             // We must mirror that per-m-line, otherwise Chrome runs video over the
//             // audio bundle transport that iOS never ICE-connects for video →
//             // zero video packets in both directions.
//             const contents = getJingleRtpContents(jingle);
//             const contentByName = new Map(contents.map((c, i) => [c.getAttribute('name') || String(i), c]));
//             const firstContent = contents[0] || firstDirectChild(jingle, 'content');
//             const firstTransportEl = firstDirectChild(firstContent, 'transport');

//             const iceForMid = (mid) => {
//                 const content = contentByName.get(String(mid)) || firstContent;
//                 const transport = firstDirectChild(content, 'transport') || firstTransportEl;
//                 const fingerprintEl = firstDirectChild(transport, 'fingerprint');
//                 return {
//                     ufrag: transport?.getAttribute('ufrag'),
//                     pwd: transport?.getAttribute('pwd'),
//                     fingerprint: fingerprintEl?.textContent?.trim(),
//                     setup: fingerprintEl?.getAttribute('setup') || 'active',
//                 };
//             };

//             // Honor the remote's BUNDLE group (iOS lists only "0").
//             const remoteGroup = firstDirectChild(jingle, 'group');
//             const remoteBundleMids = directChildren(remoteGroup, 'content')
//                 .map((c) => c.getAttribute('name'))
//                 .filter(Boolean);
//             console.log(
//                 '[ChatHeading] Remote BUNDLE group mids:',
//                 remoteBundleMids,
//                 '| per-mid ICE ufrag:',
//                 offerMids.map((m) => `${m}:${iceForMid(m).ufrag}`).join(' '),
//             );

//             // Video codecs: prefer what iOS/remote actually accepted (from Jingle XML),
//             // falling back to our offer if the accept has no payloads.
//             // This is critical — iOS accepts only H264 with specific fmtp, and Chrome
//             // must use that exact codec/PT to send video iOS can decode.
//             const acceptedPayloads = [];
//             const videoContent = contents.find(
//                 (c) => firstDirectChild(c, 'description')?.getAttribute('media') === 'video',
//             );
//             if (videoContent) {
//                 const desc = firstDirectChild(videoContent, 'description');
//                 const parsed = payloadsFromJingleDescription(desc, 'video');
//                 acceptedPayloads.push(...parsed);
//                 console.log('[ChatHeading] Accepted video payloads from iOS/remote:', acceptedPayloads);
//             }

//             // Fall back to our offer codecs if remote accept had none
//             const SKIP_V = new Set(['rtx', 'red', 'ulpfec', 'flexfec-03']);
//             let finalVideoCodecs = acceptedPayloads;
//             if (!finalVideoCodecs.length) {
//                 console.warn('[ChatHeading] No video payloads in accept, falling back to offer codecs');
//                 const offerVideoCodecs = [];
//                 let inVideo = false;
//                 for (const line of offerSdp.split('\n')) {
//                     const l = line.trim();
//                     if (l.startsWith('m=video')) {
//                         inVideo = true;
//                         continue;
//                     }
//                     if (l.startsWith('m=') && inVideo) {
//                         inVideo = false;
//                         break;
//                     }
//                     if (inVideo && l.startsWith('a=rtpmap:')) {
//                         const m = l.match(/^a=rtpmap:(\d+) ([^/]+)\/(\d+)/);
//                         if (m && !SKIP_V.has(m[2].toLowerCase())) {
//                             offerVideoCodecs.push({ id: m[1], name: m[2], clockrate: m[3] });
//                         }
//                     }
//                 }
//                 finalVideoCodecs = offerVideoCodecs;
//             }
//             console.log('[ChatHeading] Final video codecs for answer SDP:', finalVideoCodecs);

//             const videoPtIds = finalVideoCodecs.map((c) => c.id).join(' ') || '96';
//             // Build rtpmap + fmtp + rtcp-fb lines for each accepted codec
//             const videoCodecLines = [];
//             for (const c of finalVideoCodecs) {
//                 const ch = c.channels ? `/${c.channels}` : '';
//                 videoCodecLines.push(`a=rtpmap:${c.id} ${c.name}/${c.clockrate}${ch}`);
//                 const fmtp = buildFmtpLine(c);
//                 if (fmtp) videoCodecLines.push(fmtp);
//                 // rtcp-fb essential for Chrome to send PLI/NACK → remote sends keyframes
//                 videoCodecLines.push(
//                     `a=rtcp-fb:${c.id} nack`,
//                     `a=rtcp-fb:${c.id} nack pli`,
//                     `a=rtcp-fb:${c.id} ccm fir`,
//                     `a=rtcp-fb:${c.id} goog-remb`,
//                     `a=rtcp-fb:${c.id} transport-cc`,
//                 );
//             }

//             // BUNDLE line mirrors what the remote actually bundles. iOS lists only
//             // "0" → video keeps its own transport (works with bundlePolicy max-compat).
//             const bundleMids = remoteBundleMids.length ? remoteBundleMids : offerMids;
//             const bundleLine = bundleMids.length > 0 ? `a=group:BUNDLE ${bundleMids.join(' ')}` : 'a=group:BUNDLE 0';

//             const mSections = offerMids.map((mid) => {
//                 const isVid = mid !== '0' && this.isVideo;
//                 // Per-mid ICE/DTLS — iOS video has its own ufrag/pwd
//                 const { ufrag, pwd, fingerprint, setup } = iceForMid(mid);
//                 return [
//                     isVid ? `m=video 9 RTP/SAVPF ${videoPtIds}` : 'm=audio 9 RTP/SAVPF 111',
//                     'c=IN IP4 0.0.0.0',
//                     ufrag ? `a=ice-ufrag:${ufrag}` : '',
//                     pwd ? `a=ice-pwd:${pwd}` : '',
//                     fingerprint ? `a=fingerprint:sha-256 ${fingerprint}` : '',
//                     `a=setup:${setup}`,
//                     `a=mid:${mid}`,
//                     'a=rtcp-mux',
//                     ...(isVid
//                         ? videoCodecLines
//                         : [
//                               'a=rtcp-fb:111 transport-cc',
//                               'a=rtpmap:111 opus/48000/2',
//                               'a=fmtp:111 minptime=10;useinbandfec=1',
//                           ]),
//                     'a=sendrecv',
//                 ]
//                     .filter(Boolean)
//                     .join('\r\n');
//             });

//             const remoteSdp =
//                 ['v=0', 'o=- 1234567890 2 IN IP4 0.0.0.0', 's=-', 't=0 0', bundleLine, 'a=msid-semantic: WMS'].join(
//                     '\r\n',
//                 ) +
//                 '\r\n' +
//                 mSections.join('\r\n') +
//                 '\r\n';
//             console.log('[ChatHeading] Built answer SDP:\n', remoteSdp);

//             this.pc
//                 .setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp: remoteSdp }))
//                 .then(() => {
//                     console.log('%c ✅ BUNDLE accepted! Remote description SET. ', 'color: white; background: green;');
//                     console.log('[ChatHeading] Queued candidates to flush:', this.iceCandidatesQueue.length);
//                     while (this.iceCandidatesQueue.length > 0) {
//                         const cand = this.iceCandidatesQueue.shift();
//                         this.pc
//                             .addIceCandidate(cand)
//                             .then(() => console.log('[ChatHeading] Flushed candidate OK'))
//                             .catch((e) => console.warn('[ChatHeading] Flush candidate failed:', e));
//                     }
//                 })
//                 .catch((err) => {
//                     console.error('[ChatHeading] setRemoteDescription FAILED:', err);
//                     console.log('[ChatHeading] DUMP answer SDP:\n', remoteSdp);
//                     console.log('[ChatHeading] Offer mids were:', offerMids);
//                 });
//         } catch (err) {
//             console.error('[ChatHeading] handleSessionAccept error:', err);
//         }
//     }

//     handleIncomingCandidates(jingle) {
//         const candidateElems = sizzle('candidate', jingle);

//         candidateElems.forEach((el) => {
//             const foundation = el.getAttribute('foundation');
//             // 'component' can be 'rtp'/'rtcp' (non-standard) or '1'/'2' (standard).
//             // Chrome only accepts numeric component values.
//             const rawComponent = el.getAttribute('component') || '1';
//             const component = rawComponent === 'rtp' ? '1' : rawComponent === 'rtcp' ? '2' : rawComponent;
//             const protocol = (el.getAttribute('protocol') || 'udp').toLowerCase();
//             const priority = el.getAttribute('priority');
//             const ip = el.getAttribute('ip');
//             const port = el.getAttribute('port');
//             const type = el.getAttribute('type') || 'host';
//             const relAddr = el.getAttribute('rel-addr');
//             const relPort = el.getAttribute('rel-port');

//             // Wrap IPv6 addresses in brackets
//             const addr = ip?.includes(':') ? `[${ip}]` : ip;

//             let candidateStr = `candidate:${foundation} ${component} ${protocol} ${priority} ${addr} ${port} typ ${type}`;
//             if ((type === 'srflx' || type === 'relay') && relAddr && relPort) {
//                 const rAddr = relAddr.includes(':') ? `[${relAddr}]` : relAddr;
//                 candidateStr += ` raddr ${rAddr} rport ${relPort}`;
//             }
//             console.log('[ChatHeading] Incoming remote candidate:', candidateStr);

//             // sdpMid should match the content name from the Jingle stanza
//             const contentEl = el.closest ? el.closest('content') : el.parentElement?.parentElement;
//             const sdpMid = contentEl?.getAttribute('name') || '0';

//             const iceCandidate = new RTCIceCandidate({
//                 candidate: candidateStr,
//                 sdpMid,
//                 sdpMLineIndex: parseInt(sdpMid, 10) || 0,
//             });

//             if (this.pc && this.pc.remoteDescription && this.pc.remoteDescription.type) {
//                 this.pc.addIceCandidate(iceCandidate).catch((e) => console.warn('AddIceCandidate error:', e.message));
//             } else {
//                 console.log('[ChatHeading] PC not ready, queuing candidate');
//                 this.iceCandidatesQueue.push(iceCandidate);
//             }
//         });
//     }

//     terminateCall(sendTerminate = true) {
//         // Send session-terminate + JMI <finish> if we still have an active call
//         if (sendTerminate && this.remoteFullJid && this.currentSid) {
//             const sid = this.currentSid;
//             const remote = this.remoteFullJid;
//             console.log('[ChatHeading] Sending session-terminate + finish to', remote);

//             // Jingle session-terminate IQ — fire-and-forget, no timeout
//             try {
//                 const terminateIq = $iq({ type: 'set', to: remote, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', {
//                         xmlns: NS_JINGLE,
//                         action: 'session-terminate',
//                         sid: sid,
//                     })
//                     .c('reason')
//                     .c('success');
//                 api.send(terminateIq);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not send session-terminate:', e);
//             }

//             // JMI <finish> message (Sonata extension — iOS/Android use this)
//             try {
//                 const bareRemote = remote.split('/')[0];
//                 const finishMsg = $msg({ to: bareRemote, type: 'chat', id: crypto.randomUUID() })
//                     .c('finish', { xmlns: NS_JINGLE_MSG, id: sid })
//                     .c('reason', { xmlns: NS_JINGLE })
//                     .c('success')
//                     .up()
//                     .up()
//                     .up()
//                     .c('store', { xmlns: 'urn:xmpp:hints' });
//                 api.send(finishMsg);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not send finish:', e);
//             }
//         }

//         if (this.pc) {
//             console.log('[ChatHeading] Closing PeerConnection');
//             this.pc.close();
//             this.pc = null;
//         }
//         if (this.localStream) {
//             this.localStream.getTracks().forEach((t) => t.stop());
//             this.localStream = null;
//         }
//         const el = document.getElementById('sonata-audio-remote');
//         if (el) el.srcObject = null;
//         this.currentSid = null;
//         this.isIncoming = false;
//         this.remoteFullJid = null;
//         if (ChatHeading.activeCall === this) {
//             ChatHeading.activeCall = null;
//         }
//         ChatHeading._hideCallPanel();
//         console.log('=== [ChatHeading] Call terminated ===');
//     }

//     // ========================================================================
//     // INCOMING CALL HANDLING (callee side)
//     // ========================================================================

//     /**
//      * Static: called when <propose> arrives. Shows modal asking user to accept
//      * or reject. If accepted, picks the matching ChatHeading instance (by JID)
//      * and runs accept flow. If no chat is open for that contact, falls back to
//      * using/creating a chat first.
//      */
//     static async handleIncomingPropose(fullFromJid, sid, media) {
//         const bareFrom = fullFromJid?.split('/')[0];

//         // Resolve display name — same approach as the call panel and ChatHeading template.
//         // Try roster contact first, then chatbox model, then fall back to bare JID.
//         let displayName = bareFrom;
//         try {
//             const contact = await api.contacts.get(bareFrom);
//             if (contact) {
//                 displayName = contact.get('nickname') || contact.get('fullname') || contact.get('name') || bareFrom;
//             }
//             // Also try an open chatbox model in case vcard is loaded there
//             if (displayName === bareFrom) {
//                 const chatbox = _converse.state?.chatboxes?.get(bareFrom);
//                 if (chatbox) {
//                     const fromModel = chatbox.getDisplayName?.();
//                     if (fromModel && fromModel !== bareFrom) displayName = fromModel;
//                 }
//             }
//         } catch (e) {
//             // non-fatal — fall back to bare JID
//         }

//         // If there's already an active call, ask the user.
//         if (ChatHeading.activeCall) {
//             const confirmed = window.confirm(
//                 `Вхідний дзвінок від ${bareFrom}. У вас вже триває розмова. Завершити поточну та прийняти новий?`,
//             );
//             if (!confirmed) {
//                 // Auto-reject the new call
//                 ChatHeading._sendJmiReject(fullFromJid, sid);
//                 return;
//             }
//             // Terminate the current call before accepting new
//             ChatHeading.activeCall.terminateCall();
//         }

//         // Track this pending incoming call so <retract> can cancel its modal.
//         ChatHeading._pendingIncomingSid = sid;
//         ChatHeading._pendingIncomingFrom = fullFromJid;

//         const accepted = await ChatHeading._showIncomingCallModal(displayName, fullFromJid, sid, media);

//         // Clear pending tracking
//         if (ChatHeading._pendingIncomingSid === sid) {
//             ChatHeading._pendingIncomingSid = null;
//             ChatHeading._pendingIncomingFrom = null;
//         }

//         if (!accepted) {
//             console.log('[ChatHeading] User rejected incoming call');
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         console.log('[ChatHeading] User accepted incoming call. Finding chat heading...');

//         // Prefer an already-open chat heading in the DOM.
//         let headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);

//         if (!headingEl) {
//             console.log('[ChatHeading] No open chat for', bareFrom, '— opening one');
//             try {
//                 await api.chats.open(bareFrom);
//                 await new Promise((r) => setTimeout(r, 200));
//                 headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);
//             } catch (e) {
//                 console.warn('[ChatHeading] Could not open chat:', e);
//             }
//         }

//         if (!headingEl) {
//             // No DOM element — create a detached ghost instance so the call works
//             // regardless of which chat window is currently open.
//             console.log('[ChatHeading] Using ghost ChatHeading instance for call (no DOM heading)');
//             headingEl = new ChatHeading();
//             headingEl.jid = bareFrom;
//             try {
//                 const chatbox = _converse.state?.chatboxes?.get(bareFrom);
//                 if (chatbox) headingEl.model = chatbox;
//             } catch (_) {}
//         }

//         await headingEl.acceptIncomingCall(fullFromJid, sid, media);
//     }

//     /**
//      * Static: <retract> arrived — caller cancelled before we picked up.
//      * Close the modal if it's showing for this sid.
//      */
//     static handleRetract(sid) {
//         if (ChatHeading._pendingIncomingSid === sid && ChatHeading._closeIncomingModal) {
//             console.log('[ChatHeading] Closing incoming-call modal (caller retracted)');
//             ChatHeading._closeIncomingModal(false);
//         }
//     }

//     /**
//      * Static helper: send JMI <reject> message.
//      */
//     static _sendJmiReject(toFullJid, sid) {
//         const bareJid = toFullJid?.split('/')[0];
//         const msg = $msg({ to: bareJid, type: 'chat', id: crypto.randomUUID() })
//             .c('reject', { xmlns: NS_JINGLE_MSG, id: sid })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' });
//         api.send(msg);
//         console.log('[ChatHeading] Sent JMI reject for sid', sid);
//     }

//     /**
//      * Static: builds the incoming-call modal. Returns a Promise<boolean>:
//      * true=accepted, false=rejected/closed.
//      */
//     static _showIncomingCallModal(callerName, fullFromJid, sid, media) {
//         return new Promise((resolve) => {
//             // Inject CSS once
//             if (!document.getElementById('sonata-incall-style')) {
//                 const style = document.createElement('style');
//                 style.id = 'sonata-incall-style';
//                 style.textContent = `
//                     .sonata-incall-overlay {
//                         position: fixed; inset: 0; z-index: 99999;
//                         background: rgba(0,0,0,0.55);
//                         display: flex; align-items: center; justify-content: center;
//                         font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     }
//                     .sonata-incall-card {
//                         background: #fff; border-radius: 16px; padding: 28px 32px;
//                         min-width: 320px; max-width: 90vw; text-align: center;
//                         box-shadow: 0 20px 60px rgba(0,0,0,0.4);
//                         animation: sonata-incall-pop 0.25s ease-out;
//                     }
//                     @keyframes sonata-incall-pop {
//                         from { transform: scale(0.85); opacity: 0; }
//                         to { transform: scale(1); opacity: 1; }
//                     }
//                     .sonata-incall-icon {
//                         font-size: 48px; margin-bottom: 12px;
//                         animation: sonata-incall-ring 1s ease-in-out infinite;
//                     }
//                     @keyframes sonata-incall-ring {
//                         0%, 100% { transform: rotate(0); }
//                         25% { transform: rotate(-15deg); }
//                         75% { transform: rotate(15deg); }
//                     }
//                     .sonata-incall-name {
//                         font-size: 20px; font-weight: 600; color: #222; margin-bottom: 4px;
//                     }
//                     .sonata-incall-sub {
//                         font-size: 13px; color: #888; margin-bottom: 24px;
//                     }
//                     .sonata-incall-actions {
//                         display: flex; gap: 16px; justify-content: center;
//                     }
//                     .sonata-incall-btn {
//                         border: none; border-radius: 50%; width: 56px; height: 56px;
//                         font-size: 22px; cursor: pointer; color: white;
//                         display: inline-flex; align-items: center; justify-content: center;
//                         transition: transform 0.15s;
//                     }
//                     .sonata-incall-btn:hover { transform: scale(1.08); }
//                     .sonata-incall-btn.accept { background: #1e9652; }
//                     .sonata-incall-btn.reject { background: #d33; }
//                 `;
//                 document.head.appendChild(style);
//             }

//             const overlay = document.createElement('div');
//             overlay.className = 'sonata-incall-overlay';
//             overlay.innerHTML = `
//                 <div class="sonata-incall-card">
//                     <div class="sonata-incall-icon">📞</div>
//                     <div class="sonata-incall-name">${callerName}</div>
//                     <div class="sonata-incall-sub">Вхідний ${media === 'video' ? 'відео' : 'аудіо'} дзвінок</div>
//                     <div class="sonata-incall-actions">
//                         <button class="sonata-incall-btn reject" title="Відхилити">✕</button>
//                         <button class="sonata-incall-btn accept" title="Прийняти">✓</button>
//                     </div>
//                 </div>
//             `;
//             document.body.appendChild(overlay);

//             // Play ringtone via Web Audio (simple beeping). Skip if AudioContext unavailable.
//             let ringInterval = null;
//             try {
//                 const ctx = new (window.AudioContext || window.webkitAudioContext)();
//                 const beep = () => {
//                     const osc = ctx.createOscillator();
//                     const gain = ctx.createGain();
//                     osc.frequency.value = 480;
//                     gain.gain.value = 0.08;
//                     osc.connect(gain).connect(ctx.destination);
//                     osc.start();
//                     setTimeout(() => osc.stop(), 400);
//                 };
//                 beep();
//                 ringInterval = setInterval(beep, 1500);
//             } catch (e) {
//                 /* no-op */
//             }

//             const cleanup = (result) => {
//                 if (ringInterval) clearInterval(ringInterval);
//                 if (overlay.parentElement) overlay.parentElement.removeChild(overlay);
//                 ChatHeading._closeIncomingModal = null;
//                 resolve(result);
//             };

//             // Expose closer so retract can cancel the modal externally
//             ChatHeading._closeIncomingModal = cleanup;

//             overlay.querySelector('.accept').addEventListener('click', () => cleanup(true));
//             overlay.querySelector('.reject').addEventListener('click', () => cleanup(false));

//             // Auto-reject after 45s (typical ring timeout)
//             setTimeout(() => {
//                 if (overlay.parentElement) cleanup(false);
//             }, 45000);
//         });
//     }

//     /**
//      * Instance: user accepted the incoming-call modal. Pre-warm mic, send
//      * <proceed>, mark this instance as the active call, and wait for the
//      * remote's session-initiate.
//      */
//     async acceptIncomingCall(fullFromJid, sid, media) {
//         console.log('[ChatHeading] >>> acceptIncomingCall', { fullFromJid, sid, media });

//         // Pre-warm microphone BEFORE sending <proceed>.
//         // If we send proceed first, the caller immediately sends session-initiate.
//         // getUserMedia prompt can take seconds on first use — causing session-initiate
//         // to arrive before pc is created. Get mic first, then proceed.
//         const needsVideo = media === 'video';
//         try {
//             console.log(
//                 `[ChatHeading] Pre-warming media (audio${needsVideo ? '+video' : ''}) before sending proceed...`,
//             );
//             this.localStream = await navigator.mediaDevices.getUserMedia({
//                 audio: true,
//                 video: needsVideo,
//             });
//             console.log(
//                 '[ChatHeading] Media ready for incoming call, tracks:',
//                 this.localStream.getTracks().map((t) => t.kind),
//             );
//         } catch (err) {
//             console.error('[ChatHeading] Media permission denied for incoming call:', err);
//             if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
//                 showToast(`Доступ до ${needsVideo ? 'камери/мікрофона' : 'мікрофона'} заборонено`, 'error');
//             } else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
//                 showToast(`${needsVideo ? 'Камера або мікрофон' : 'Мікрофон'} не знайдено`, 'error');
//             } else {
//                 showToast('Не вдалося отримати доступ до медіапристроїв', 'error');
//             }
//             ChatHeading._sendJmiReject(fullFromJid, sid);
//             return;
//         }

//         this.isIncoming = true;
//         this.isVideo = needsVideo;
//         this.remoteFullJid = fullFromJid;
//         this.currentSid = sid;
//         ChatHeading.activeCall = this;

//         // Send JMI <proceed> to the caller's FULL JID (including resource).
//         // The original propose came from their full JID — we must reply to it.
//         // Sending to bare JID means the server can't route session-initiate back
//         // to us because the caller doesn't know which resource accepted.
//         const proceedId = crypto.randomUUID();
//         const proceedMsg = $msg({ to: fullFromJid, type: 'chat', id: proceedId })
//             .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: proceedId })
//             .up()
//             .c('proceed', { xmlns: NS_JINGLE_MSG, id: sid })
//             .up()
//             .c('store', { xmlns: 'urn:xmpp:hints' });
//         api.send(proceedMsg);
//         console.log(
//             '[ChatHeading] Sent JMI proceed sid=',
//             sid,
//             'to FULL JID=',
//             fullFromJid,
//             '| our full JID:',
//             _converse.jid,
//         );

//         this.model?.createMessage({ message: '📞 Вхідний виклик прийнято', type: 'info' });
//         // Now we wait for session-initiate via the Strophe handler → handleSessionInitiate().
//     }

//     /**
//      * Instance: <session-initiate> arrived from remote (caller). We are the
//      * callee. Create pc, add tracks, set remote offer SDP, create answer,
//      * send session-accept.
//      */
//     async handleSessionInitiate(fullFromJid, sid, jingle) {
//         console.log('[ChatHeading] >>> handleSessionInitiate', { fullFromJid, sid });
//         this.iceCandidatesQueue = [];
//         this.remoteFullJid = fullFromJid;
//         this.currentSid = sid;
//         this.isIncoming = true;

//         // Detect video from raw Jingle XML
//         this.isVideo = getJingleRtpContents(jingle).some(
//             (c) => firstDirectChild(c, 'description')?.getAttribute('media') === 'video',
//         );

//         try {
//             if (!this.localStream) {
//                 console.log('[ChatHeading] No stream yet, requesting media (isVideo:', this.isVideo, ')...');
//                 this.localStream = await navigator.mediaDevices.getUserMedia({
//                     audio: true,
//                     video: this.isVideo,
//                 });
//             }

//             const iceServers2 = await ChatHeading._getIceServers();
//             this.pc = new RTCPeerConnection({
//                 iceServers: iceServers2,
//                 bundlePolicy: 'max-compat',
//                 rtcpMuxPolicy: 'require',
//             });

//             this.pc.oniceconnectionstatechange = () => {
//                 console.log(`%c [ICE] state=${this.pc.iceConnectionState} `, 'color: orange; font-weight: bold;');
//                 if (this.pc.iceConnectionState === 'failed' || this.pc.iceConnectionState === 'disconnected') {
//                     ChatHeading._dumpIcePairs(this.pc, this.pc.iceConnectionState + ' (incoming)');
//                     if (
//                         this.pc.iceConnectionState === 'failed' &&
//                         this.pc.signalingState === 'stable' &&
//                         this.pc.restartIce
//                     ) {
//                         this.pc.restartIce();
//                     }
//                 }
//                 if (this.pc.iceConnectionState === 'connected') {
//                     console.log('%c [ICE] ✅ CONNECTED (incoming) ', 'background: green; color: white;');
//                     ChatHeading._showCallPanel(this);
//                     ChatHeading._requestKeyframeAndPollVideo(this.pc);
//                 }
//             };
//             this.pc.onconnectionstatechange = () => console.log(`[PC] connectionState=${this.pc.connectionState}`);
//             this.pc.onicecandidateerror = (ev) => {
//                 console.warn(
//                     `[ICE ERROR] url=${ev.url} code=${ev.errorCode} text="${ev.errorText}" address=${ev.address}:${ev.port}`,
//                 );
//             };
//             this.pc.onsignalingstatechange = () => console.log(`[PC] signalingState=${this.pc.signalingState}`);

//             this.pc.ontrack = (event) => {
//                 console.log('[ChatHeading] Remote track received (incoming) kind=', event.track.kind);
//                 const stream = event.streams?.[0] || new MediaStream([event.track]);
//                 if (event.track.kind === 'audio') {
//                     let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
//                     el.id = 'sonata-audio-remote';
//                     el.autoplay = true;
//                     if (!el.parentElement) document.body.appendChild(el);
//                     el.srcObject = stream;
//                 } else if (event.track.kind === 'video') {
//                     ChatHeading._attachRemoteVideo(stream);
//                 }
//             };

//             this.pc.onicecandidate = (event) => {
//                 if (!event.candidate) return;
//                 const c = event.candidate;
//                 const localSdp = this.pc.localDescription?.sdp || '';
//                 const localUfrag = (localSdp.match(/a=ice-ufrag:(.*)\r/) || [])[1] || '';
//                 const localPwd = (localSdp.match(/a=ice-pwd:(.*)\r/) || [])[1] || '';
//                 const attrs = {
//                     id: String(Math.floor(Math.random() * 4294967295)),
//                     // 'rtp'/'rtcp' → numeric per XEP-0176 (iOS rejects "rtp")
//                     component: c.component === 'rtcp' ? '2' : '1',
//                     foundation: c.foundation,
//                     generation: '0',
//                     ip: c.address || c.ip,
//                     port: String(c.port),
//                     priority: String(c.priority),
//                     protocol: (c.protocol || 'udp').toLowerCase(),
//                     type: c.type,
//                 };
//                 if (c.relatedAddress) attrs['rel-addr'] = c.relatedAddress;
//                 if (c.relatedPort) attrs['rel-port'] = String(c.relatedPort);
//                 // Per-mid content name + creds (max-compat: own transport per m-line)
//                 const candMid = c.sdpMid != null ? String(c.sdpMid) : '0';
//                 const candIce = getLocalIceForMid(localSdp, candMid);
//                 const iq = $iq({ type: 'set', to: fullFromJid, id: crypto.randomUUID().toLowerCase() })
//                     .c('jingle', {
//                         xmlns: NS_JINGLE,
//                         action: 'transport-info',
//                         initiator: fullFromJid,
//                         responder: _converse.jid,
//                         sid,
//                     })
//                     .c('content', { creator: 'initiator', name: candMid })
//                     .c('transport', {
//                         xmlns: NS_JINGLE_ICE,
//                         ufrag: candIce.ufrag || localUfrag || c.usernameFragment || '',
//                         pwd: candIce.pwd || localPwd || '',
//                     })
//                     .c('candidate', attrs);
//                 api.send(iq);
//             };

//             this.localStream.getTracks().forEach((t) => this.pc.addTrack(t, this.localStream));

//             // Build remote offer SDP from Jingle XML — handles Android, iOS, all clients correctly
//             const remoteOfferSdp = buildSdpFromJingle(jingle, 'offer');
//             console.log('[ChatHeading] Setting remote OFFER SDP:\n', remoteOfferSdp);
//             await this.pc.setRemoteDescription(new RTCSessionDescription({ type: 'offer', sdp: remoteOfferSdp }));

//             const answer = await this.pc.createAnswer();
//             await this.pc.setLocalDescription(answer);
//             console.log('[ChatHeading] 📋 LOCAL ANSWER SDP:\n', this.pc.localDescription.sdp);

//             // Flush queued candidates
//             while (this.iceCandidatesQueue.length > 0) {
//                 this.pc
//                     .addIceCandidate(this.iceCandidatesQueue.shift())
//                     .catch((e) => console.warn('Queued cand failed:', e));
//             }

//             // Build session-accept IQ from our local answer SDP (mirrors what browser negotiated)
//             // Track the mid order from the remote offer so our accept uses the same order
//             const contents = getJingleRtpContents(jingle);
//             const remoteOfferMidOrder = contents.map((c, i) => c.getAttribute('name') || String(i));
//             const contentCreatorsByMid = new Map(remoteOfferMidOrder.map((mid) => [mid, 'initiator']));

//             const acceptIq = buildJingleIqFromLocalSdp({
//                 action: 'session-accept',
//                 to: fullFromJid,
//                 sid,
//                 initiator: fullFromJid,
//                 responder: _converse.jid,
//                 localSdp: this.pc.localDescription.sdp,
//                 contentCreatorsByMid,
//                 preferredMidOrder: remoteOfferMidOrder,
//             });

//             console.log('[ChatHeading] 📤 session-accept XML:\n', acceptIq.toString());
//             api.send(acceptIq);
//             console.log(
//                 '[ChatHeading] >>> handleSessionInitiate DONE (session-accept sent, isVideo:',
//                 this.isVideo,
//                 ')',
//             );
//         } catch (err) {
//             console.error('[ChatHeading] handleSessionInitiate error:', err);
//             console.error('[ChatHeading] Stack:', err?.stack);
//         }
//     }

//     // ========================================================================
//     // CALL PANEL UI
//     // ========================================================================

//     /**
//      * Static: show "calling..." panel while waiting for remote to answer.
//      * Replaced by _showCallPanel once ICE connects.
//      */
//     static _showOutgoingCallPanel(instance) {
//         ChatHeading._hideCallPanel();

//         if (!document.getElementById('sonata-callpanel-style')) {
//             // CSS will be injected by _showCallPanel when connected; inject minimal now
//             const style = document.createElement('style');
//             style.id = 'sonata-callpanel-style';
//             style.textContent = `
//                 .sonata-callpanel {
//                     position: fixed; top: 0; left: 50%; transform: translateX(-50%);
//                     z-index: 99998; background: #1a1a2e; color: #fff;
//                     border-radius: 0 0 24px 24px; padding: 12px 20px 14px 24px;
//                     display: flex; align-items: center; gap: 16px;
//                     box-shadow: 0 4px 24px rgba(0,0,0,0.45);
//                     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     animation: sonata-panel-slide 0.3s cubic-bezier(.22,.68,0,1.2);
//                     min-width: 260px;
//                 }
//                 @keyframes sonata-panel-slide {
//                     from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
//                     to   { opacity: 1; transform: translateX(-50%) translateY(0); }
//                 }
//                 .sonata-callpanel-dot {
//                     width: 10px; height: 10px; border-radius: 50%;
//                     background: #1e9652;
//                     box-shadow: 0 0 0 0 rgba(30,150,82,0.6);
//                     animation: sonata-dot-pulse 1.5s ease-out infinite;
//                     flex-shrink: 0;
//                 }
//                 @keyframes sonata-dot-pulse {
//                     0%   { box-shadow: 0 0 0 0 rgba(30,150,82,0.6); }
//                     70%  { box-shadow: 0 0 0 8px rgba(30,150,82,0); }
//                     100% { box-shadow: 0 0 0 0 rgba(30,150,82,0); }
//                 }
//                 .sonata-callpanel-info {
//                     display: flex; flex-direction: column; gap: 2px; flex: 1;
//                 }
//                 .sonata-callpanel-name {
//                     font-size: 14px; font-weight: 600; color: #fff;
//                     white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//                     max-width: 160px;
//                 }
//                 .sonata-callpanel-timer {
//                     font-size: 13px; color: #aaa; font-variant-numeric: tabular-nums;
//                     letter-spacing: 0.03em;
//                 }
//                 .sonata-callpanel-hangup {
//                     background: #e53935; border: none; border-radius: 50%;
//                     width: 40px; height: 40px; cursor: pointer; color: #fff;
//                     display: inline-flex; align-items: center; justify-content: center;
//                     font-size: 18px; flex-shrink: 0;
//                     transition: background 0.15s, transform 0.15s;
//                 }
//                 .sonata-callpanel-hangup:hover { background: #b71c1c; transform: scale(1.08); }
//             `;
//             document.head.appendChild(style);
//         }

//         const displayName = instance.model?.getDisplayName?.() || instance.model?.get('jid') || '...';

//         const panel = document.createElement('div');
//         panel.id = 'sonata-callpanel';
//         panel.className = 'sonata-callpanel';
//         panel.innerHTML = `
//             <div class="sonata-callpanel-dot" style="background:#f59e0b; box-shadow: 0 0 0 0 rgba(245,158,11,0.6);"></div>
//             <div class="sonata-callpanel-info">
//                 <div class="sonata-callpanel-name">${displayName}</div>
//                 <div class="sonata-callpanel-timer" id="sonata-callpanel-timer">Виклик...</div>
//             </div>
//             <button class="sonata-callpanel-hangup" title="Скасувати дзвінок">📵</button>
//         `;
//         document.body.appendChild(panel);

//         // Animated dots on "Виклик..."
//         const timerEl = panel.querySelector('#sonata-callpanel-timer');
//         let dots = 0;
//         ChatHeading._callTimerInterval = setInterval(() => {
//             dots = (dots + 1) % 4;
//             if (timerEl) timerEl.textContent = 'Виклик' + '.'.repeat(dots);
//         }, 600);

//         setTimeout(() => {
//             const btn = panel.querySelector('.sonata-callpanel-hangup');
//             if (btn)
//                 btn.addEventListener('click', () => {
//                     console.log('[ChatHeading] User cancelled outgoing call');
//                     const t = ChatHeading.activeCall;
//                     if (t) {
//                         const jid = t.model?.get('jid');
//                         if (jid && t.currentSid) {
//                             const retractMsg = $msg({ to: jid, type: 'chat', id: crypto.randomUUID() })
//                                 .c('retract', { xmlns: NS_JINGLE_MSG, id: t.currentSid })
//                                 .up()
//                                 .c('store', { xmlns: 'urn:xmpp:hints' });
//                             api.send(retractMsg);
//                             console.log('[ChatHeading] Sent JMI retract for sid', t.currentSid);
//                         }
//                         t.terminateCall(false);
//                     }
//                 });
//         }, 100);
//     }

//     /**
//      * Static: show active call panel with timer and hang-up button.
//      * Called when ICE reaches 'connected' state.
//      */
//     static _showCallPanel(instance) {
//         // Save any queued remote video stream before _hideCallPanel clears it
//         const savedRemoteStream = ChatHeading._pendingRemoteVideoStream;
//         ChatHeading._hideCallPanel();
//         // Restore it so PiP creation below can flush it
//         if (savedRemoteStream) {
//             ChatHeading._pendingRemoteVideoStream = savedRemoteStream;
//         }

//         if (!document.getElementById('sonata-callpanel-style')) {
//             const style = document.createElement('style');
//             style.id = 'sonata-callpanel-style';
//             style.textContent = `
//                 .sonata-callpanel {
//                     position: fixed; top: 0; left: 50%; transform: translateX(-50%);
//                     z-index: 99998; background: #1a1a2e; color: #fff;
//                     border-radius: 0 0 24px 24px; padding: 12px 20px 14px 24px;
//                     display: flex; align-items: center; gap: 16px;
//                     box-shadow: 0 4px 24px rgba(0,0,0,0.45);
//                     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
//                     animation: sonata-panel-slide 0.3s cubic-bezier(.22,.68,0,1.2);
//                     min-width: 260px;
//                 }
//                 @keyframes sonata-panel-slide {
//                     from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
//                     to   { opacity: 1; transform: translateX(-50%) translateY(0); }
//                 }
//                 .sonata-callpanel-dot {
//                     width: 10px; height: 10px; border-radius: 50%; background: #1e9652;
//                     box-shadow: 0 0 0 0 rgba(30,150,82,0.6);
//                     animation: sonata-dot-pulse 1.5s ease-out infinite; flex-shrink: 0;
//                 }
//                 @keyframes sonata-dot-pulse {
//                     0%   { box-shadow: 0 0 0 0 rgba(30,150,82,0.6); }
//                     70%  { box-shadow: 0 0 0 8px rgba(30,150,82,0); }
//                     100% { box-shadow: 0 0 0 0 rgba(30,150,82,0); }
//                 }
//                 .sonata-callpanel-info { display: flex; flex-direction: column; gap: 2px; flex: 1; }
//                 .sonata-callpanel-name {
//                     font-size: 14px; font-weight: 600; color: #fff;
//                     white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 160px;
//                 }
//                 .sonata-callpanel-timer {
//                     font-size: 13px; color: #aaa; font-variant-numeric: tabular-nums; letter-spacing: 0.03em;
//                 }
//                 .sonata-callpanel-hangup {
//                     background: #e53935; border: none; border-radius: 50%;
//                     width: 40px; height: 40px; cursor: pointer; color: #fff;
//                     display: inline-flex; align-items: center; justify-content: center;
//                     font-size: 18px; flex-shrink: 0; transition: background 0.15s, transform 0.15s;
//                 }
//                 .sonata-callpanel-hangup:hover { background: #b71c1c; transform: scale(1.08); }
//             `;
//             document.head.appendChild(style);
//         }

//         const displayName = instance.model?.getDisplayName?.() || instance.remoteFullJid?.split('/')[0] || 'Unknown';

//         // Inject PiP CSS separately from panel CSS so it's not blocked
//         // by the outgoing call panel having already injected sonata-callpanel-style
//         if (instance.isVideo && !document.getElementById('sonata-pip-style')) {
//             const pipStyle = document.createElement('style');
//             pipStyle.id = 'sonata-pip-style';
//             pipStyle.textContent = `
//                 .sonata-video-pip {
//                     position: fixed !important; bottom: 24px !important; right: 24px !important;
//                     z-index: 999999 !important;
//                     width: 320px !important; height: 180px !important;
//                     border-radius: 16px; overflow: hidden;
//                     box-shadow: 0 8px 32px rgba(0,0,0,0.6);
//                     background: #111 !important;
//                     display: block !important; visibility: visible !important;
//                 }
//                 .sonata-video-pip video {
//                     display: block !important; visibility: visible !important;
//                 }
//                 .sonata-video-pip video#sonata-video-remote {
//                     position: absolute !important; inset: 0 !important;
//                     width: 100% !important; height: 100% !important;
//                     object-fit: cover; background: #222;
//                 }
//                 .sonata-video-pip video#sonata-video-local {
//                     position: absolute !important; bottom: 8px !important; right: 8px !important;
//                     width: 80px !important; height: 60px !important;
//                     border-radius: 8px; object-fit: cover;
//                     border: 2px solid rgba(255,255,255,0.8);
//                     background: #333; z-index: 1 !important;
//                 }
//             `;
//             document.head.appendChild(pipStyle);
//             console.log('[ChatHeading] PiP CSS injected ✅');
//         }

//         // Audio call panel (always shown at top)
//         const panel = document.createElement('div');
//         panel.id = 'sonata-callpanel';
//         panel.className = 'sonata-callpanel';
//         panel.innerHTML = `
//             <div class="sonata-callpanel-dot"></div>
//             <div class="sonata-callpanel-info">
//                 <div class="sonata-callpanel-name">${instance.isVideo ? '📹 ' : ''}${displayName}</div>
//                 <div class="sonata-callpanel-timer" id="sonata-callpanel-timer">00:00</div>
//             </div>
//             <button class="sonata-callpanel-hangup" title="Завершити дзвінок">📵</button>
//         `;
//         document.body.appendChild(panel);

//         // Video PiP overlay (only for video calls)
//         if (instance.isVideo) {
//             console.log('[ChatHeading] Creating video PiP overlay');
//             const pip = document.createElement('div');
//             pip.id = 'sonata-video-pip';
//             pip.className = 'sonata-video-pip';
//             pip.innerHTML = `
//                 <video id="sonata-video-remote" autoplay playsinline muted
//                     style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#222;display:block;visibility:visible;"></video>
//                 <video id="sonata-video-local" autoplay playsinline muted
//                     style="position:absolute;bottom:8px;right:8px;width:80px;height:60px;border-radius:8px;object-fit:cover;border:2px solid rgba(255,255,255,0.8);background:#333;z-index:1;display:block;visibility:visible;"></video>
//             `;
//             document.body.appendChild(pip);

//             // Attach local stream preview immediately
//             const localVid = pip.querySelector('#sonata-video-local');
//             if (instance.localStream) {
//                 localVid.srcObject = instance.localStream;
//                 console.log('[ChatHeading] Local video preview attached to PiP ✅');
//             } else {
//                 console.warn('[ChatHeading] No localStream available for PiP preview');
//             }

//             // Flush remote video stream if it arrived before PiP was created
//             if (ChatHeading._pendingRemoteVideoStream) {
//                 console.log('[ChatHeading] Flushing pending remote video stream to PiP ✅');
//                 const remoteVid = pip.querySelector('#sonata-video-remote');
//                 remoteVid.srcObject = ChatHeading._pendingRemoteVideoStream;
//                 ChatHeading._pendingRemoteVideoStream = null;
//                 // Diagnose after a short delay to let the element settle
//                 setTimeout(() => {
//                     const r = remoteVid.getBoundingClientRect();
//                     const cs = getComputedStyle(remoteVid);
//                     const pipR = pip.getBoundingClientRect();
//                     const pipCs = getComputedStyle(pip);
//                     console.log(
//                         `[VIDEO DEBUG] pip: ${pipR.width}x${pipR.height} at (${Math.round(pipR.left)},${Math.round(pipR.top)}) display=${pipCs.display} visibility=${pipCs.visibility} zIndex=${pipCs.zIndex}`,
//                     );
//                     console.log(
//                         `[VIDEO DEBUG] remote video: ${r.width}x${r.height} at (${Math.round(r.left)},${Math.round(r.top)}) display=${cs.display} visibility=${cs.visibility} readyState=${remoteVid.readyState} paused=${remoteVid.paused}`,
//                     );
//                     console.log(
//                         `[VIDEO DEBUG] remote video srcObject tracks:`,
//                         remoteVid.srcObject?.getTracks().map((t) => `${t.kind}:${t.readyState}`),
//                     );
//                     // Check if anything is covering the pip
//                     const topEl = document.elementFromPoint(pipR.left + pipR.width / 2, pipR.top + pipR.height / 2);
//                     console.log(
//                         `[VIDEO DEBUG] element at pip center:`,
//                         topEl?.id || topEl?.className || topEl?.tagName,
//                     );
//                     if (remoteVid.paused) {
//                         remoteVid
//                             .play()
//                             .then(() => console.log('[VIDEO DEBUG] play() succeeded after delay ✅'))
//                             .catch((e) => console.warn('[VIDEO DEBUG] play() still failed:', e));
//                     }
//                 }, 500);
//             }

//             // Make PiP draggable
//             let dragging = false,
//                 ox = 0,
//                 oy = 0;
//             pip.addEventListener('mousedown', (e) => {
//                 dragging = true;
//                 ox = e.clientX - pip.getBoundingClientRect().left;
//                 oy = e.clientY - pip.getBoundingClientRect().top;
//                 pip.style.transition = 'none';
//             });
//             document.addEventListener('mousemove', (e) => {
//                 if (!dragging) return;
//                 pip.style.right = 'auto';
//                 pip.style.bottom = 'auto';
//                 pip.style.left = `${e.clientX - ox}px`;
//                 pip.style.top = `${e.clientY - oy}px`;
//             });
//             document.addEventListener('mouseup', () => {
//                 dragging = false;
//             });
//         }

//         // Timer
//         let seconds = 0;
//         const timerEl = panel.querySelector('#sonata-callpanel-timer');
//         ChatHeading._callTimerInterval = setInterval(() => {
//             seconds++;
//             const m = String(Math.floor(seconds / 60)).padStart(2, '0');
//             const s = String(seconds % 60).padStart(2, '0');
//             if (timerEl) timerEl.textContent = `${m}:${s}`;
//         }, 1000);

//         // Defer click handler by one tick so the button can't receive
//         // a click event that was already in flight from the outgoing panel
//         // being replaced (which caused auto-terminate on ICE connect).
//         setTimeout(() => {
//             const btn = panel.querySelector('.sonata-callpanel-hangup');
//             if (btn)
//                 btn.addEventListener('click', () => {
//                     console.log('[ChatHeading] User clicked hang-up');
//                     const t = ChatHeading.activeCall;
//                     if (t) t.terminateCall(true);
//                 });
//         }, 100);
//     }

//     static _hideCallPanel() {
//         if (ChatHeading._callTimerInterval) {
//             clearInterval(ChatHeading._callTimerInterval);
//             ChatHeading._callTimerInterval = null;
//         }
//         ChatHeading._pendingRemoteVideoStream = null;
//         const panel = document.getElementById('sonata-callpanel');
//         if (panel) panel.parentElement?.removeChild(panel);
//         const pip = document.getElementById('sonata-video-pip');
//         if (pip) pip.parentElement?.removeChild(pip);
//         const pipStyle = document.getElementById('sonata-pip-style');
//         if (pipStyle) pipStyle.parentElement?.removeChild(pipStyle);
//     }

//     /**
//      * Static: attach remote video stream to the PiP overlay.
//      * Called from ontrack when a video track arrives.
//      */
//     static _attachRemoteVideo(stream) {
//         console.log('[ChatHeading] _attachRemoteVideo called, stream tracks:', stream?.getTracks().length);
//         if (stream) {
//             stream
//                 .getTracks()
//                 .forEach((t) =>
//                     console.log(
//                         `[ChatHeading] remote stream track: kind=${t.kind} enabled=${t.enabled} readyState=${t.readyState} muted=${t.muted}`,
//                     ),
//                 );
//         }
//         const pip = document.getElementById('sonata-video-pip');
//         if (!pip) {
//             console.warn('[ChatHeading] PiP not in DOM yet — queuing remote video stream');
//             ChatHeading._pendingRemoteVideoStream = stream;
//             return;
//         }
//         const vid = pip.querySelector('#sonata-video-remote');
//         vid.srcObject = stream;
//         vid.play()
//             .then(() => {
//                 console.log('[ChatHeading] Remote video playing ✅');
//                 setTimeout(() => {
//                     const r = vid.getBoundingClientRect();
//                     const cs = getComputedStyle(vid);
//                     const pipR = pip.getBoundingClientRect();
//                     console.log(
//                         `[VIDEO DEBUG] pip: ${pipR.width}x${pipR.height} at (${Math.round(pipR.left)},${Math.round(pipR.top)}) z=${getComputedStyle(pip).zIndex}`,
//                     );
//                     console.log(
//                         `[VIDEO DEBUG] video: ${r.width}x${r.height} display=${cs.display} visibility=${cs.visibility} readyState=${vid.readyState}`,
//                     );
//                 }, 300);
//             })
//             .catch((e) => {
//                 console.warn('[ChatHeading] Remote video play() failed:', e);
//             });
//         console.log('[ChatHeading] Remote video srcObject set ✅');
//     }

//     /**
//      * Static: attach local video preview to the PiP overlay local tile.
//      */
//     static _attachLocalVideo(stream) {
//         const pip = document.getElementById('sonata-video-pip');
//         if (pip) {
//             pip.querySelector('#sonata-video-local').srcObject = stream;
//         }
//     }

//     // ========================================================================
//     // END CALL PANEL UI
//     // ========================================================================

//     // ========================================================================
//     // END CALL LOGIC
//     // ========================================================================

//     /**
//      * Returns a list of objects which represent buttons for the chat's header.
//      * @emits _converse#getHeadingButtons
//      * @returns {Promise<Array.<import('./types').HeadingButtonAttributes>>}
//      */
//     async getHeadingButtons() {
//         const buttons = [
//             /** @type {import('./types').HeadingButtonAttributes} */
//             {
//                 a_class: 'show-user-details-modal',
//                 handler: /** @param {Event} ev */ (ev) => this.showUserDetailsModal(ev),
//                 i18n_text: __('Details'),
//                 i18n_title: __('See more information about this person'),
//                 icon_class: 'fa-id-card',
//                 name: 'details',
//                 standalone: false,
//             },
//         ];

//         const domain = _converse.session.get('domain');
//         if (domain && (await api.disco.supports(Strophe.NS.BLOCKING, domain))) {
//             const blocklist = await api.blocklist.get();
//             if (blocklist.get(this.model.get('jid'))) {
//                 buttons.push({
//                     a_class: 'unblock-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Unblock user'), [
//                             __('Are you sure you want to unblock this user?'),
//                         ]);
//                         if (result) {
//                             api.blocklist.remove(this.model.get('jid'));
//                         }
//                     },
//                     i18n_text: __('Unblock this user'),
//                     i18n_title: __('Allow this user to send you messages'),
//                     icon_class: 'fa-check',
//                     name: 'unblock',
//                     standalone: false,
//                 });
//             } else {
//                 buttons.push({
//                     a_class: 'block-user',
//                     handler: /** @param {Event} ev */ async (ev) => {
//                         ev.preventDefault();
//                         const result = await api.confirm(__('Block user'), [
//                             __(
//                                 'Are you sure you want to prevent %1$s from contacting you further?',
//                                 this.model.getDisplayName(),
//                             ),
//                         ]);
//                         if (result) {
//                             const jid = this.model.get('jid');
//                             api.blocklist.add(jid);
//                             api.contacts.remove(jid, true);
//                             this.model.close();
//                         }
//                     },
//                     i18n_text: __('Block this user'),
//                     i18n_title: __('Prevent this user from sending you any further messages'),
//                     icon_class: 'fa-trash',
//                     name: 'block',
//                     standalone: false,
//                 });
//             }
//         }

//         if (!api.settings.get('singleton')) {
//             buttons.push({
//                 a_class: 'close-chatbox-button',
//                 handler: /** @param {Event} ev */ (ev) => this.close(ev),
//                 i18n_text: __('Close'),
//                 i18n_title: __('Close and end this conversation'),
//                 icon_class: 'fa-times',
//                 name: 'close',
//                 standalone: api.settings.get('view_mode') === 'overlayed',
//             });
//         }
//         const { chatboxviews } = _converse.state;
//         const el = chatboxviews.get(this.getAttribute('jid'));
//         if (el) {
//             /**
//              * *Hook* which allows plugins to add more buttons to a chat's heading.
//              *
//              * Note: This hook is fired for both 1 on 1 chats and groupchats.
//              * If you only care about one, you need to add a check in your code.
//              *
//              * @event _converse#getHeadingButtons
//              * @param { HTMLElement } el
//              *      The `converse-chat` (or `converse-muc`) DOM element that represents the chat
//              * @param { Array.<import('./types').HeadingButtonAttributes> }
//              *      An array of the existing buttons. New buttons may be added,
//              *      and existing ones removed or modified.
//              * @example
//              *  api.listen.on('getHeadingButtons', (el, buttons) => {
//              *      buttons.push({
//              *          'i18n_title': __('Foo'),
//              *          'i18n_text': __('Foo Bar'),
//              *          'handler': ev => alert('Foo!'),
//              *          'a_class': 'toggle-foo',
//              *          'icon_class': 'fa-foo',
//              *          'name': 'foo'
//              *      });
//              *      return buttons;
//              *  });
//              */
//             return _converse.api.hook('getHeadingButtons', el, buttons);
//         } else {
//             return buttons; // Happens during tests
//         }
//     }
// }

// api.elements.define('converse-chat-heading', ChatHeading);
import { _converse, api, converse } from '@converse/headless';
import { CustomElement } from 'shared/components/element.js';
import { __ } from 'i18n';
import tplChatboxHead from './templates/chat-head.js';
import 'shared/modals/user-details.js';

import './styles/chat-head.scss';

const { Strophe, $iq, $msg, sizzle } = converse.env;

const NS_JINGLE = 'urn:xmpp:jingle:1';
const NS_JINGLE_ICE = 'urn:xmpp:jingle:transports:ice-udp:1';
const NS_JINGLE_RTP = 'urn:xmpp:jingle:apps:rtp:1';
const NS_DTLS = 'urn:xmpp:jingle:apps:dtls:0';
const NS_JINGLE_MSG = 'urn:xmpp:jingle-message:0';
const NS_GROUPING = 'urn:xmpp:jingle:apps:grouping:0';

// Matches a Bluetooth headset's device label (Windows/macOS typically expose
// the paired device's own name, e.g. "Headset (AirPods Євгена)"). Used to
// auto-prefer a connected headset over the OS "default" device for calls --
// see _getUserMediaDefaultAudio and _showCallPanel's speaker auto-select.
const HEADSET_LABEL_RE = /airpods|bluetooth|hands-?free|headset/i;

// ─── Call-panel icon buttons (64x48 capsule, Figma-sourced) ────────────────

const ICON_HANGUP_SVG = `<svg width="64" height="48" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="64" height="48" rx="24" fill="#FF4C4C"/>
<path d="M37.6381 17.2336C37.9495 16.9221 38.455 16.9221 38.7664 17.2336C39.0779 17.545 39.0779 18.0505 38.7664 18.3619L33.1283 24L38.7664 29.6381C39.0779 29.9495 39.0779 30.455 38.7664 30.7664C38.455 31.0779 37.9495 31.0779 37.6381 30.7664L32 25.1283L26.3619 30.7664C26.0505 31.0779 25.545 31.0779 25.2336 30.7664C24.9221 30.455 24.9221 29.9495 25.2336 29.6381L30.8717 24L25.2336 18.3619C24.9221 18.0505 24.9221 17.545 25.2336 17.2336C25.545 16.9221 26.0505 16.9221 26.3619 17.2336L32 22.8717L37.6381 17.2336Z" fill="#E8F0FF"/>
</svg>`;

const ICON_SPEAKER_SVG = `<svg width="64" height="48" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 24C0 10.7452 10.7452 0 24 0H40C53.2548 0 64 10.7452 64 24C64 37.2548 53.2548 48 40 48H24C10.7452 48 0 37.2548 0 24Z" fill="#253E75"/>
<path d="M26.9421 20.4211C26.7934 20.5737 26.6291 20.7509 26.4249 20.8793C26.2609 20.9823 26.0818 21.0577 25.8948 21.1037C25.662 21.161 25.4237 21.1558 25.2134 21.1558H23.4439C23.1459 21.1558 22.971 21.1562 22.8421 21.167C22.7821 21.172 22.75 21.1781 22.7367 21.1813L22.689 21.217C22.6747 21.2316 22.6627 21.2485 22.6532 21.267C22.6633 21.2451 22.6496 21.256 22.6402 21.3731C22.6297 21.5054 22.6293 21.6853 22.6293 21.9914V27.0075C22.6293 27.3132 22.6297 27.4926 22.6402 27.6248C22.6497 27.7435 22.6639 27.7538 22.6532 27.7309C22.6727 27.7691 22.7032 27.8 22.7407 27.8197C22.7158 27.8067 22.723 27.8209 22.8421 27.8309C22.971 27.8417 23.1458 27.8431 23.4439 27.8431H25.2134C25.4237 27.8431 25.662 27.8379 25.8948 27.8952C26.0818 27.9412 26.2609 28.0166 26.4249 28.1197C26.6291 28.248 26.7934 28.4252 26.9421 28.5778L30.1668 31.8847V17.1142L26.9421 20.4211ZM41.3707 24.4995C41.3707 21.9509 40.5774 19.5944 39.2302 17.6733C38.9676 17.2987 39.0503 16.7767 39.4152 16.5071C39.7805 16.2375 40.2903 16.3231 40.5531 16.6979C42.093 18.8938 43 21.5892 43 24.4995C43 27.4097 42.093 30.1051 40.5531 32.301C40.2903 32.6758 39.7805 32.7614 39.4152 32.4919C39.0502 32.2223 38.9677 31.7002 39.2302 31.3256C40.5774 29.4045 41.3707 27.048 41.3707 24.4995ZM36.2781 24.4995C36.2781 23.1221 35.8593 21.8476 35.1461 20.7986C34.8887 20.42 34.9799 19.8985 35.349 19.6344C35.718 19.3707 36.2255 19.4632 36.483 19.8416C37.3808 21.162 37.9073 22.769 37.9073 24.4995C37.9073 26.2298 37.3808 27.837 36.483 29.1574C36.2255 29.5356 35.718 29.6282 35.349 29.3645C34.9799 29.1004 34.8887 28.5789 35.1461 28.2003C35.8594 27.1513 36.278 25.8769 36.2781 24.4995ZM31.7961 31.8847C31.7961 32.1845 31.7974 32.4665 31.7782 32.6888C31.7614 32.8836 31.7185 33.2355 31.4788 33.5234C31.2036 33.8539 30.7912 34.0298 30.3688 33.9958C30.0009 33.9662 29.7283 33.748 29.582 33.6224C29.4151 33.4791 29.2208 33.2794 29.014 33.0673L25.7903 29.7594C25.6975 29.6642 25.6462 29.6121 25.6063 29.5747C25.5719 29.5425 25.5659 29.5403 25.5735 29.5451C25.5554 29.5337 25.5354 29.5257 25.5148 29.5206C25.5093 29.5199 25.4959 29.5187 25.471 29.5175C25.417 29.515 25.3447 29.5145 25.2134 29.5145H23.4439C23.1723 29.5145 22.9195 29.5148 22.7089 29.4971C22.4887 29.4787 22.2435 29.4363 22.0007 29.3094C21.6559 29.1291 21.3757 28.8416 21.1999 28.488C21.0762 28.2388 21.0339 27.9874 21.0159 27.7615C20.9987 27.5455 21 27.2861 21 27.0075V21.9914C21 21.7128 20.9987 21.4535 21.0159 21.2374C21.0339 21.0115 21.0762 20.7601 21.1999 20.5109C21.3757 20.1572 21.6559 19.8698 22.0007 19.6895C22.2436 19.5626 22.4886 19.5192 22.7089 19.5008C22.9195 19.4831 23.1723 19.4844 23.4439 19.4844H25.2134C25.3447 19.4844 25.417 19.4839 25.471 19.4814C25.517 19.4792 25.523 19.4763 25.5148 19.4783C25.5354 19.4732 25.5554 19.4652 25.5735 19.4538C25.566 19.4586 25.572 19.4564 25.6063 19.4242C25.6463 19.3868 25.6975 19.3348 25.7903 19.2396L29.014 15.9316C29.2208 15.7195 29.4151 15.5198 29.582 15.3765C29.7282 15.2509 30.0009 15.0328 30.3688 15.0031L30.5259 15C30.8395 15.013 31.1386 15.14 31.3694 15.3581L31.4788 15.4745L31.5604 15.5857C31.729 15.8483 31.7635 16.1386 31.7782 16.3091C31.7974 16.5315 31.7961 16.8142 31.7961 17.1142V31.8847Z" fill="#9AB9FF"/>
</svg>`;

const ICON_MIC_SVG = `<svg width="64" height="48" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 24C0 10.7452 10.7452 0 24 0H40C53.2548 0 64 10.7452 64 24C64 37.2548 53.2548 48 40 48H24C10.7452 48 0 37.2548 0 24Z" fill="#253E75"/>
<path d="M34.2567 17.6943C34.2567 16.513 33.2462 15.5552 32 15.5552C30.7538 15.5552 29.7433 16.513 29.7433 17.6943V23.5278C29.7433 24.7091 30.7538 25.6669 32 25.6669C33.2462 25.6669 34.2567 24.7091 34.2567 23.5278V17.6943ZM35.8973 23.5278C35.8973 25.5682 34.1525 27.2221 32 27.2221C29.8475 27.2221 28.1027 25.5682 28.1027 23.5278V17.6943C28.1027 15.6539 29.8475 14 32 14C34.1525 14 35.8973 15.6539 35.8973 17.6943V23.5278Z" fill="#9AB9FF"/>
<path d="M24 23.5278V22.5555C24 22.126 24.3672 21.7779 24.8203 21.7779C25.2735 21.7779 25.6407 22.126 25.6407 22.5555V23.5278C25.6407 25.1265 26.3111 26.6594 27.5037 27.7899C28.6963 28.9203 30.3135 29.5558 32 29.5558C33.6865 29.5558 35.3037 28.9203 36.4963 27.7899C37.6143 26.7301 38.2733 25.3166 38.3513 23.8268L38.3593 23.5278V22.5555C38.3593 22.126 38.7265 21.7779 39.1797 21.7779C39.6328 21.7779 40 22.126 40 22.5555V23.5278C40 25.539 39.1575 27.4681 37.6572 28.8903C36.3515 30.1279 34.6407 30.8924 32.8203 31.0702V33.4448H35.077C35.5302 33.4448 35.8973 33.7928 35.8973 34.2224C35.8973 34.652 35.5302 35 35.077 35H28.923C28.4698 35 28.1027 34.652 28.1027 34.2224C28.1027 33.7928 28.4698 33.4448 28.923 33.4448H31.1797V31.0702C29.3593 30.8924 27.6485 30.1279 26.3428 28.8903C24.8425 27.4681 24 25.539 24 23.5278Z" fill="#9AB9FF"/>
</svg>`;

const ICON_MIC_MUTED_SVG = `<svg width="64" height="48" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="64" height="48" rx="24" fill="#3B6BFF"/>
<path d="M22.2391 15.2584C22.5579 14.9399 23.0743 14.9399 23.3931 15.2584L41.7609 33.6082C42.0797 33.9267 42.0797 34.4426 41.7609 34.7611C41.4421 35.0796 40.9257 35.0796 40.6069 34.7611L32.6318 26.7937C32.2038 26.8644 31.7661 26.8653 31.3363 26.7907C30.7398 26.6872 30.1753 26.4454 29.6891 26.0849C29.2028 25.7244 28.8082 25.2544 28.5361 24.714C28.2641 24.1738 28.1224 23.5776 28.1225 22.9728V22.2889L22.2391 16.4112C21.9203 16.0927 21.9203 15.5769 22.2391 15.2584ZM34.2452 22.9708V17.8737C34.2452 17.2788 34.0085 16.7084 33.5875 16.2878C33.1664 15.8672 32.5954 15.6307 32 15.6307C31.4046 15.6307 30.8336 15.8672 30.4125 16.2878C29.9915 16.7084 29.7548 17.2788 29.7548 17.8737C29.7548 18.3241 29.3896 18.689 28.9387 18.689C28.4878 18.689 28.1225 18.3241 28.1225 17.8737C28.1225 16.8462 28.5314 15.8614 29.2586 15.1349C29.9858 14.4084 30.9716 14 32 14C33.0284 14 34.0142 14.4084 34.7414 15.1349C35.4686 15.8614 35.8775 16.8462 35.8775 17.8737V22.9708L35.8675 23.2566C35.8464 23.5422 35.7937 23.8253 35.71 24.0998C35.5786 24.5305 35.1218 24.7735 34.6906 24.6424C34.2594 24.5111 34.0162 24.0547 34.1475 23.6239C34.212 23.4122 34.2452 23.1921 34.2452 22.9708Z" fill="#E8F0FF"/>
<path d="M24.0408 22.9708C24.0409 22.5205 24.4062 22.1555 24.857 22.1555C25.3078 22.1556 25.6731 22.5205 25.6731 22.9708C25.6729 24.1114 25.982 25.2308 26.567 26.2103C27.152 27.1899 27.9916 27.9934 28.9965 28.5349C30.0014 29.0764 31.1344 29.3362 32.275 29.2866C33.4157 29.237 34.5219 28.8799 35.4759 28.2532C35.8525 28.0058 36.3592 28.1099 36.6069 28.4862C36.8546 28.8625 36.7494 29.3686 36.3727 29.6161C35.3041 30.318 34.0838 30.7499 32.8161 30.8804V33.3693H36.0817C36.5326 33.3693 36.8979 33.7342 36.8979 34.1847C36.8979 34.6351 36.5326 35 36.0817 35H27.9183C27.4674 35 27.1021 34.6351 27.1021 34.1847C27.1021 33.7342 27.4674 33.3693 27.9183 33.3693H31.1839V30.8804C30.15 30.7739 29.1426 30.467 28.2212 29.9705C26.957 29.2893 25.9009 28.2789 25.1649 27.0466C24.4288 25.8143 24.0406 24.4059 24.0408 22.9708ZM39.1401 22.1555C39.5907 22.155 39.9564 22.5196 39.9572 22.9698C39.9598 24.5251 39.504 26.0471 38.6468 27.3453C38.3984 27.7209 37.8919 27.8242 37.5157 27.5762C37.1396 27.3281 37.0363 26.8222 37.2845 26.4463C37.9651 25.4154 38.327 24.2067 38.3249 22.9718C38.3243 22.5216 38.6893 22.1563 39.1401 22.1555Z" fill="#E8F0FF"/>
</svg>`;

const ICON_ACCEPT_SVG = `<svg width="64" height="48" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="64" height="48" rx="24" fill="#1e9652"/>
<path d="M22 24.5L28.5 31L42 18" stroke="#E8F0FF" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
</svg>`;

// ─── Video PiP expand/collapse corner button icons ─────────────────────────

const ICON_PIP_EXPAND_SVG = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 3H21V9" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 21H3V15" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21 3L14 10" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3 21L10 14" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const ICON_PIP_COLLAPSE_SVG = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 14H10V20" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20 10H14V4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 10L21 3" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 14L3 21" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

/**
 * Show a small toast notification.
 * @param {string} message
 * @param {'error'|'warn'|'info'} type
 */
function showToast(message, type = 'error') {
    const colors = { error: '#e53935', warn: '#f59e0b', info: '#1e9652' };
    const icons = { error: '🎙️', warn: '⚠️', info: 'ℹ️' };
    const toast = document.createElement('div');
    toast.style.cssText = `
        position:fixed; bottom:80px; left:50%; transform:translateX(-50%);
        background:${colors[type]}; color:#fff; padding:12px 20px;
        border-radius:10px; font-size:14px; z-index:9999999;
        box-shadow:0 4px 16px rgba(0,0,0,0.3); display:flex; align-items:center; gap:8px;
        font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        animation:sonata-toast-in 0.25s ease-out;
        max-width:90vw; text-align:center;
    `;
    if (!document.getElementById('sonata-toast-style')) {
        const s = document.createElement('style');
        s.id = 'sonata-toast-style';
        s.textContent = `
            @keyframes sonata-toast-in { from{opacity:0;transform:translateX(-50%) translateY(10px)} to{opacity:1;transform:translateX(-50%) translateY(0)} }
            @keyframes sonata-toast-out { from{opacity:1} to{opacity:0} }
        `;
        document.head.appendChild(s);
    }
    toast.innerHTML = `<span>${icons[type]}</span><span>${message}</span>`;
    document.body.appendChild(toast);
    setTimeout(() => {
        toast.style.animation = 'sonata-toast-out 0.3s ease-in forwards';
        setTimeout(() => toast.parentElement?.removeChild(toast), 300);
    }, 3500);
}

const SKIP_RTP_CODECS = new Set(['rtx', 'red', 'ulpfec', 'flexfec-03', 'telephone-event', 'cn', 'pcmu', 'pcma', 'g722']);

// ─── SDP / Jingle helper functions ─────────────────────────────────────────

function localName(el) { return el?.localName || el?.nodeName?.split(':').pop(); }
function directChildren(el, name = null) {
    return Array.from(el?.children || []).filter(c => !name || localName(c) === name);
}
function firstDirectChild(el, name) { return directChildren(el, name)[0] || null; }

function getBrowserSupportedCodecNames(media) {
    try {
        const caps = RTCRtpReceiver.getCapabilities?.(media);
        if (!caps?.codecs?.length) return null;
        return new Set(caps.codecs.map(c => c.mimeType?.split('/')[1]?.toLowerCase()).filter(Boolean));
    } catch (e) { return null; }
}

function normalizeFmtpParam(name, value) {
    const paramName = String(name || '').trim().replaceAll('_', '-');
    let paramValue = value == null ? '' : String(value).trim();
    if (paramValue === 'true') paramValue = '1';
    if (paramValue === 'false') paramValue = '0';
    // Decimal profile-level-id from iOS → hex (4382761 → 42e029)
    if (paramName === 'profile-level-id' && /^\d+$/.test(paramValue)) {
        paramValue = Number(paramValue).toString(16).padStart(6, '0').slice(-6);
    }
    // Force H264 level to 3.1 (42e01f) so Chrome decoder accepts the stream.
    // level-asymmetry-allowed=1 means iOS can still send at level 4.1.
    if (paramName === 'profile-level-id' && /^[0-9a-f]{6}$/i.test(paramValue)) {
        paramValue = '42e01f';
    }
    return { name: paramName, value: paramValue };
}

function buildFmtpLine(payload) {
    if (!payload.params?.length) return null;
    const params = payload.params
        .filter(p => p.name && p.value != null && p.value !== '')
        .map(p => `${p.name}=${p.value}`);
    if (!params.length) return null;
    return `a=fmtp:${payload.id} ${params.join(';')}`;
}

function payloadsFromJingleDescription(description, media) {
    const supported = getBrowserSupportedCodecNames(media);
    const payloads = [];
    for (const pt of directChildren(description, 'payload-type')) {
        const id = pt.getAttribute('id');
        const name = pt.getAttribute('name');
        const clockrate = pt.getAttribute('clockrate') || (media === 'video' ? '90000' : '48000');
        const channels = pt.getAttribute('channels');
        if (!id || !name) continue;
        const codec = name.toLowerCase();
        if (SKIP_RTP_CODECS.has(codec)) continue;
        if (codec === 'h265') continue;
        if (supported && !supported.has(codec)) {
            console.log('[SDP] Skipping unsupported codec:', media, name, id);
            continue;
        }
        const paramsMap = new Map();
        for (const param of directChildren(pt, 'parameter')) {
            const rawName = param.getAttribute('name');
            const rawValue = param.getAttribute('value');
            if (!rawName) continue;
            const normalized = normalizeFmtpParam(rawName, rawValue);
            if (normalized.name) paramsMap.set(normalized.name, normalized.value);
        }
        payloads.push({ id, name, clockrate, channels,
            params: Array.from(paramsMap.entries()).map(([n, v]) => ({ name: n, value: v })) });
    }
    return payloads;
}

function getJingleRtpContents(jingle) {
    return directChildren(jingle, 'content').filter(c => !!firstDirectChild(c, 'description'));
}

function getJingleBundleMids(jingle, contents) {
    const group = firstDirectChild(jingle, 'group');
    const mids = directChildren(group, 'content').map(c => c.getAttribute('name')).filter(Boolean);
    return mids.length ? mids : contents.map((c, i) => c.getAttribute('name') || String(i));
}

/**
 * Build a WebRTC SDP string from a Jingle XML element.
 * Works for both 'offer' (session-initiate) and 'answer' (session-accept).
 */
function buildSdpFromJingle(jingle, type = 'offer') {
    const contents = getJingleRtpContents(jingle);
    const bundleMids = getJingleBundleMids(jingle, contents);
    const firstTransport = contents.map(c => firstDirectChild(c, 'transport')).find(Boolean);
    const firstFingerprint = firstTransport ? firstDirectChild(firstTransport, 'fingerprint') : null;

    const sdpLines = [
        'v=0', 'o=- 1234567890 2 IN IP4 0.0.0.0', 's=-', 't=0 0',
        `a=group:BUNDLE ${bundleMids.join(' ')}`,
        'a=msid-semantic: WMS',
    ];

    contents.forEach((content, index) => {
        const mid = content.getAttribute('name') || String(index);
        const description = firstDirectChild(content, 'description');
        const media = description?.getAttribute('media');
        if (!description || !media) return;

        const payloads = payloadsFromJingleDescription(description, media);
        const payloadIds = payloads.map(p => p.id);
        if (!payloadIds.length) { console.warn('[SDP] No compatible payloads for', media, mid); return; }

        const transport = firstDirectChild(content, 'transport') || firstTransport;
        const fingerprintEl = firstDirectChild(transport, 'fingerprint') || firstFingerprint;
        const ufrag = transport?.getAttribute('ufrag');
        const pwd = transport?.getAttribute('pwd');
        const fingerprint = fingerprintEl?.textContent?.trim();
        const setup = fingerprintEl?.getAttribute('setup') || (type === 'answer' ? 'active' : 'actpass');

        sdpLines.push(`m=${media} 9 UDP/TLS/RTP/SAVPF ${payloadIds.join(' ')}`, 'c=IN IP4 0.0.0.0');
        if (ufrag) sdpLines.push(`a=ice-ufrag:${ufrag}`);
        if (pwd) sdpLines.push(`a=ice-pwd:${pwd}`);
        if (fingerprint) sdpLines.push(`a=fingerprint:sha-256 ${fingerprint}`);
        sdpLines.push(`a=setup:${setup}`, `a=mid:${mid}`, 'a=rtcp-mux');

        for (const payload of payloads) {
            const ch = payload.channels ? `/${payload.channels}` : '';
            sdpLines.push(`a=rtpmap:${payload.id} ${payload.name}/${payload.clockrate}${ch}`);
            const fmtp = buildFmtpLine(payload);
            if (fmtp) sdpLines.push(fmtp);
            // rtcp-fb lines are required for Chrome to send PLI/NACK/FIR feedback.
            // Without them Chrome won't request keyframes → remote video stays frozen.
            if (media === 'video') {
                sdpLines.push(
                    `a=rtcp-fb:${payload.id} nack`,
                    `a=rtcp-fb:${payload.id} nack pli`,
                    `a=rtcp-fb:${payload.id} ccm fir`,
                    `a=rtcp-fb:${payload.id} goog-remb`,
                    `a=rtcp-fb:${payload.id} transport-cc`,
                );
            }
        }
        sdpLines.push('a=sendrecv');
    });

    return sdpLines.join('\r\n') + '\r\n';
}

function parseSdpSections(sdp) {
    const rawLines = String(sdp || '').split(/\r?\n/).map(l => l.trim()).filter(Boolean);
    const sessionLines = [];
    const sections = [];
    let current = null;
    for (const line of rawLines) {
        if (line.startsWith('m=')) {
            current = { mLine: line, lines: [line], media: line.slice(2).split(/\s+/)[0], mid: null,
                payloadIds: line.split(/\s+/).slice(3) };
            sections.push(current); continue;
        }
        if (!current) { sessionLines.push(line); continue; }
        current.lines.push(line);
        if (line.startsWith('a=mid:')) current.mid = line.slice('a=mid:'.length).trim();
    }
    sections.forEach((s, i) => { if (!s.mid) s.mid = String(i); });
    return { sessionLines, sections };
}

function getIceInfoFromSdpSection(section, sessionLines = []) {
    const lines = [...(section?.lines || []), ...sessionLines];
    const find = (re) => { for (const l of lines) { const m = l.match(re); if (m) return m[1].trim(); } return null; };
    return {
        ufrag: find(/^a=ice-ufrag:(.+)$/),
        pwd: find(/^a=ice-pwd:(.+)$/),
        fingerprint: find(/^a=fingerprint:sha-256\s+(.+)$/),
        setup: find(/^a=setup:(.+)$/),
    };
}

/**
 * Get local ICE creds (ufrag/pwd) for a specific mid from local SDP.
 * With bundlePolicy max-compat each m-line has its OWN ufrag/pwd.
 */
function getLocalIceForMid(sdp, mid) {
    const { sessionLines, sections } = parseSdpSections(sdp);
    const sec = sections.find((s) => s.mid === String(mid)) || sections[0];
    return getIceInfoFromSdpSection(sec, sessionLines);
}

function payloadsFromSdpSection(section) {
    const rtpmapByPt = new Map();
    const fmtpByPt = new Map();
    for (const line of section.lines) {
        let m = line.match(/^a=rtpmap:(\d+)\s+([^/]+)\/(\d+)(?:\/(\d+))?$/);
        if (m) { const [, id, name, clockrate, channels] = m; rtpmapByPt.set(id, { id, name, clockrate, channels, params: [] }); continue; }
        m = line.match(/^a=fmtp:(\d+)\s+(.+)$/);
        if (m) {
            const [, id, rawFmtp] = m;
            const params = rawFmtp.split(';').map(p => p.trim()).filter(Boolean).map(p => {
                const eq = p.indexOf('='); if (eq === -1) return null;
                return normalizeFmtpParam(p.slice(0, eq), p.slice(eq + 1));
            }).filter(Boolean);
            fmtpByPt.set(id, params);
        }
    }
    return section.payloadIds.map(id => {
        const payload = rtpmapByPt.get(id);
        if (!payload) return null;
        const codec = payload.name.toLowerCase();
        if (SKIP_RTP_CODECS.has(codec)) return null;
        payload.params = fmtpByPt.get(id) || [];
        return payload;
    }).filter(Boolean);
}

/**
 * Build a Jingle IQ stanza from our local SDP (for session-initiate or session-accept).
 */
function buildJingleIqFromLocalSdp({ action, to, sid, initiator, responder, localSdp, contentCreatorsByMid = new Map(), preferredMidOrder = null }) {
    const { sessionLines, sections } = parseSdpSections(localSdp);
    let ordered = sections.filter(s => s.media === 'audio' || s.media === 'video');
    if (preferredMidOrder?.length) {
        const byMid = new Map(ordered.map(s => [s.mid, s]));
        ordered = preferredMidOrder.map(mid => byMid.get(mid)).filter(Boolean);
    }
    const iq = $iq({ type: 'set', to, id: crypto.randomUUID().toLowerCase() })
        .c('jingle', { xmlns: NS_JINGLE, action, sid,
            ...(initiator ? { initiator } : {}), ...(responder ? { responder } : {}) });
    iq.c('group', { xmlns: NS_GROUPING, semantics: 'BUNDLE' });
    for (const s of ordered) iq.c('content', { name: s.mid }).up();
    iq.up();
    for (const section of ordered) {
        const creator = contentCreatorsByMid.get(section.mid) || 'initiator';
        const ice = getIceInfoFromSdpSection(section, sessionLines);
        const payloads = payloadsFromSdpSection(section);
        iq.c('content', { creator, name: section.mid });
        iq.c('description', { xmlns: NS_JINGLE_RTP, media: section.media });
        for (const p of payloads) {
            const attrs = { id: p.id, name: p.name, clockrate: p.clockrate };
            if (p.channels) attrs.channels = p.channels;
            iq.c('payload-type', attrs);
            for (const param of p.params || []) {
                if (!param.name || param.value == null || param.value === '') continue;
                iq.c('parameter', { name: param.name, value: param.value }).up();
            }
            iq.up();
        }
        iq.c('rtcp-mux').up(); iq.up();
        iq.c('transport', { xmlns: NS_JINGLE_ICE, ...(ice.ufrag ? { ufrag: ice.ufrag } : {}), ...(ice.pwd ? { pwd: ice.pwd } : {}) });
        if (ice.fingerprint) {
            iq.c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256',
                setup: ice.setup || (action === 'session-accept' ? 'active' : 'actpass') })
                .t(ice.fingerprint).up();
        }
        iq.up(); iq.up();
    }
    return iq;
}

// ─── End SDP helpers ────────────────────────────────────────────────────────

/**
 * Set ChatHeading.activeCall and update the callActive reactive property
 * on every open converse-chat-heading element so Lit re-renders buttons.
 */
function setActiveCall(instance) {
    ChatHeading.activeCall = instance;
    document.querySelectorAll('converse-chat-heading').forEach((el) => {
        el.callActive = !!instance;
    });
    // Also update the instance that owns the call (may not be in DOM if ghost)
    if (instance) instance.callActive = true;
}

export default class ChatHeading extends CustomElement {
    // Static reference to the ChatHeading instance that owns the active call.
    // Incoming Jingle stanzas are routed here regardless of which instance's
    // handler fires (every open chat registers its own handler).
    static activeCall = null;

    // Guard so the Strophe IQ handler and message listener are registered
    // only ONCE, not per-instance. Multiple registrations cause Strophe to
    // fire every handler per incoming stanza, breaking the pc state machine.
    static _jingleHandlersRegistered = false;

    // Tracks whether the Strophe-level IQ handler is currently attached.
    // Separate from _jingleHandlersRegistered because connection lost / reconnect
    // can detach the handler while the static-listener side stays put.
    static _stropheHandlerAttached = false;

    // Pending incoming call (showing modal). Used so <retract> can cancel the modal.
    static _pendingIncomingSid = null;
    static _pendingIncomingFrom = null;
    // Callback set while modal is shown — call it to close the modal externally.
    static _closeIncomingModal = null;

    // Stanza ids of JMI messages already processed this session (see the
    // dedup check in the message listener). A server-side resend-storm bug
    // observed in production redelivers the exact same stanza id dozens of
    // times a second; some copies carried XEP-0203 <delay> (handled
    // separately) but it can't be assumed every redelivered copy does, so
    // this id-based dedup is the backstop that holds regardless. Capped and
    // trimmed oldest-first so a very long session doesn't grow this forever.
    static _seenJmiStanzaIds = new Set();

    // Timer interval for the call panel
    static _callTimerInterval = null;
    // Ringback tone interval (outgoing call waiting)
    static _ringbackInterval = null;
    // Auto-hangup timeout (no answer from callee)
    static _autoHangupTimer = null;

    // Web Audio nodes + rAF handle driving the connected-call status dot's
    // mic-level glow (see _startMicVisualizer). Separate from the timers
    // above since it needs its own teardown (closing the AudioContext).
    static _micVisualizer = null;
    static _micVisualizerRaf = null;

    // Remote video stream received before PiP was created — flushed in _showCallPanel
    static _pendingRemoteVideoStream = null;

    static _iceServersCache = null;
    static _iceServersCacheExpiry = 0;
    static _visibilityHandlerAttached = false;

    /**
     * Request a keyframe from remote video senders and poll readyState.
     * Chrome needs an IDR (keyframe) to start decoding H264. If iOS doesn't
     * send one immediately, readyState stays 0 despite live tracks arriving.
     */
    static _requestKeyframeAndPollVideo(pc) {
        if (!pc) return;
        try {
            pc.getReceivers().forEach(receiver => {
                if (receiver.track?.kind === 'video') {
                    console.log('[ChatHeading] Video receiver readyState:', receiver.track.readyState);
                    if (typeof receiver.jitterBufferTarget !== 'undefined') {
                        receiver.jitterBufferTarget = 0;
                    }
                }
            });
        } catch(e) { /* ignore */ }

        let attempts = 0;
        const poll = setInterval(async () => {
            attempts++;
            const vid = document.getElementById('sonata-video-remote');
            if (!vid) { clearInterval(poll); return; }
            const rs = vid.readyState;
            console.log(`[ChatHeading] Video poll ${attempts}: readyState=${rs} paused=${vid.paused}`);
            if (rs >= 2) {
                console.log('%c [VIDEO] ✅ Playing! readyState=' + rs, 'background: green; color: white;');
                clearInterval(poll);
                return;
            }
            if (vid.paused && vid.srcObject) {
                vid.play().catch(() => {});
            }
            // At 2s: check RTP stats — are packets even arriving?
            if (attempts === 4) {
                try {
                    const stats = await pc.getStats();
                    stats.forEach(report => {
                        if (report.type === 'inbound-rtp' && report.kind === 'video') {
                            console.log(`[VIDEO STATS] packetsReceived=${report.packetsReceived} framesReceived=${report.framesReceived||0} framesDecoded=${report.framesDecoded||0} framesDropped=${report.framesDropped||0} decoderImpl=${report.decoderImplementation||'?'}`);
                        }
                        if (report.type === 'codec' && report.mimeType?.toLowerCase().includes('h264')) {
                            console.log(`[VIDEO STATS] codec: ${report.mimeType} fmtp=${report.sdpFmtpLine}`);
                        }
                    });
                } catch(e) { console.warn('[VIDEO STATS] getStats failed:', e.message); }
            }
            // Re-attach stream after 3s to force a new decoder init + keyframe request
            if (attempts === 6 && rs === 0 && vid.srcObject) {
                console.warn('[ChatHeading] No frames after 3s — cycling srcObject to force keyframe');
                const stream = vid.srcObject;
                vid.srcObject = null;
                setTimeout(() => { vid.srcObject = stream; vid.play().catch(() => {}); }, 150);
            }
            if (attempts >= 20) { clearInterval(poll); }
        }, 500);
    }

    /**
     * Dump all ICE candidate pairs + local/remote candidates from getStats.
     * Call on disconnected/failed to see which network paths were tried and
     * why none succeeded (all pairs failed/in-progress = client isolation /
     * symmetric NAT both sides / no TURN relay).
     */
    static _dumpIcePairs(pc, label = '') {
        if (!pc) return;
        pc.getStats()
            .then((stats) => {
                console.log(`%c [ICE DUMP ${label}] `, 'background:#b71c1c;color:#fff;');
                stats.forEach((r) => {
                    if (r.type === 'candidate-pair') {
                        console.log(
                            `[ICE PAIR] state=${r.state} nominated=${r.nominated} ` +
                                `local=${r.localCandidateId} remote=${r.remoteCandidateId} ` +
                                `sent=${r.bytesSent || 0} recv=${r.bytesReceived || 0} ` +
                                `requestsSent=${r.requestsSent || 0} responsesReceived=${r.responsesReceived || 0}`,
                        );
                    }
                    if (r.type === 'local-candidate') {
                        console.log(`[ICE LOCAL] id=${r.id} type=${r.candidateType} ${r.address || r.ip}:${r.port} ${r.protocol} netType=${r.networkType || '?'}`);
                    }
                    if (r.type === 'remote-candidate') {
                        console.log(`[ICE REMOTE] id=${r.id} type=${r.candidateType} ${r.address || r.ip}:${r.port} ${r.protocol}`);
                    }
                });
            })
            .catch(() => {});
    }

    /**
     * Request the microphone via the OS-default device, bypassing Chromium's
     * per-origin "remembered last picked device" behavior. Once
     * _switchMicrophone() (below) requests an exact deviceId even once,
     * Chromium starts preferring that device for ALL later unconstrained
     * getUserMedia({audio:true}) calls on this origin too — so an unrelated
     * automatic call can silently pick the wrong (possibly stale/
     * disconnected, e.g. re-paired Bluetooth) mic. Explicitly requesting
     * deviceId 'default' bypasses that memory. Falls back to an
     * unconstrained request on engines without the 'default' sentinel
     * (e.g. Firefox).
     * @param {boolean} video
     */
    static async _getUserMediaDefaultAudio(video) {
        // macOS Electron: have the main process trigger the system mic/camera
        // consent dialog first -- renderer getUserMedia alone doesn't reliably
        // show it (TCC silently denies). If access is denied the main process
        // shows a dialog deep-linking to System Settings; we still fall
        // through to getUserMedia below so its normal error path (toast +
        // info message) runs. No-op in a plain browser / on other platforms.
        try {
            await /** @type {any} */ (window).electronApp?.ensureMediaAccess?.(!!video);
        } catch (e) {
            console.warn('[ChatHeading] ensureMediaAccess IPC failed:', e);
        }

        const request = async (audioConstraint) => {
            try {
                return await navigator.mediaDevices.getUserMedia({ audio: audioConstraint, video });
            } catch (err) {
                if (err.name === 'OverconstrainedError' || err.name === 'ConstraintNotSatisfiedError') {
                    return navigator.mediaDevices.getUserMedia({ audio: true, video });
                }
                throw err;
            }
        };

        // Reported: a Bluetooth headset (AirPods) connected and paired, but
        // calls didn't automatically use it. Confirmed by testing (device
        // picker, live call): the generic "Default - AirPods..." device
        // entry is *silent* -- Windows' plain default-device role doesn't
        // reliably stay live through a Bluetooth HFP profile handoff -- but
        // the "Communications - AirPods..." entry works correctly, and the
        // call panel's own picker (_switchMicrophone) is only ever invoked
        // with an exact deviceId, same pattern as here. So: target the
        // Communications-role entry for a connected headset directly,
        // before even requesting 'default' at all -- waiting to inspect what
        // 'default' resolves to first would lose the race against that same
        // HFP handoff, which doesn't necessarily complete before 'default'
        // resolves. Re-enumerates fresh every call rather than remembering a
        // choice across calls/sessions, so it can't reintroduce the stale-
        // device bug the 'default' sentinel exists to dodge (that bug was
        // Chromium persisting an *exact* deviceId choice indefinitely, even
        // after that device disconnects/reconnects -- this instead only
        // ever acts on what's enumerated as present right now). Device
        // labels are only populated once mic permission has been granted at
        // least once in this origin, so this is a harmless no-op (falls
        // through to 'default' below) on a first-ever call.
        try {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const headsetInputs = devices.filter((d) => d.kind === 'audioinput' && HEADSET_LABEL_RE.test(d.label));
            // Chromium's "default"/"communications" pseudo-devices are
            // identified by their deviceId sentinels, NOT by label: the
            // "Default - " / "Communications - " label prefix is localized
            // (seen in production on a Russian-locale Windows: "По умолчанию
            // - AirPods..." / "Оборудование - AirPods..."), so a label-only
            // regex silently never matched there and the pick below only
            // worked by luck of enumeration order. Label is kept as a
            // fallback for engines that don't use the sentinels.
            const isDefaultEntry = (d) => d.deviceId === 'default' || /^default - /i.test(d.label);
            const isCommsEntry = (d) => d.deviceId === 'communications' || /^communications - /i.test(d.label);
            const headset =
                headsetInputs.find(isCommsEntry) ||
                headsetInputs.find((d) => !isDefaultEntry(d) && !isCommsEntry(d));
            if (headset) {
                console.log('[ChatHeading] Targeting connected headset mic directly:', headset.label);
                const headsetStream = await request({ deviceId: { exact: headset.deviceId } });
                // Bluetooth-specific: even with the right device selected,
                // getUserMedia resolving only means the OS granted a logical
                // capture path -- it says nothing about whether the
                // underlying Bluetooth link has finished switching from
                // A2DP to HFP yet (reported: device correctly selected, call
                // still inaudible to the other party). No web-platform event
                // exists for that handoff completing (unlike native
                // AVAudioSession route-change notifications), so poll for
                // real signal instead of guessing a fixed delay.
                await ChatHeading._waitForMicSignal(headsetStream);
                return headsetStream;
            }
        } catch (e) {
            console.warn('[ChatHeading] Headset mic pre-check failed, falling back to OS default:', e);
        }

        return await request({ deviceId: 'default' });
    }

    /**
     * Windows + Bluetooth headset (AirPods): route the call's remote audio to
     * the Hands-Free (HFP, "AG Audio") output of the SAME device the mic is
     * using. Opening the headset's mic switches it from A2DP to the HFP
     * profile, which takes the "AirPods Stereo" output endpoint away -- the
     * OS/Chromium default output still points at it, so the call is silent
     * or garbled until the user manually picks "...Hands-Free AG Audio" in
     * the call panel's speaker menu (reported, with screenshots).
     *
     * History -- read before changing: an earlier automatic setSinkId here was
     * removed after a user reported other tabs (YouTube) staying silent on the
     * headphones after hanging up, and it didn't happen after Zoom/Teams
     * calls. The most likely cause is the <audio> element staying bound to the
     * Hands-Free endpoint after the call (it used to be reused, never
     * removed), which keeps the headset in call mode. terminateCall() now
     * fully releases the element to counter that; this has NOT been proven to
     * be the cause, so it is Windows-only, only acts when the call mic itself
     * is a Hands-Free endpoint, and can be switched off per browser with
     * localStorage.setItem('sonata_auto_headset_speaker', '0').
     *
     * Always resolves (never rejects, bounded by a timeout) so the caller can
     * safely chain remote-audio attachment onto it.
     * @param {HTMLMediaElement} el
     * @param {MediaStream|null} localStream
     */
    static async _applyHeadsetSink(el, localStream) {
        const work = async () => {
            if (!/Windows/i.test(navigator.userAgent)) return;
            if (typeof el.setSinkId !== 'function') return;
            try {
                if (localStorage.getItem('sonata_auto_headset_speaker') === '0') return;
            } catch (_) { /* storage unavailable: carry on */ }

            const micLabel = localStream?.getAudioTracks?.()[0]?.label || '';
            if (!/hands-?free/i.test(micLabel)) return;

            // "Communications - X" / "По умолчанию - X" -> "X" (prefix is short
            // and localized; a real device name won't have " - " this early).
            const core = (label) => {
                const i = label.indexOf(' - ');
                return i > 0 && i < 24 ? label.slice(i + 3) : label;
            };
            const devices = await navigator.mediaDevices.enumerateDevices();
            const outputs = devices.filter(
                (d) => d.kind === 'audiooutput' && /hands-?free/i.test(d.label) && core(d.label) === core(micLabel)
            );
            const out =
                outputs.find((d) => d.deviceId === 'communications') ||
                outputs.find((d) => d.deviceId !== 'default');
            if (!out) return;
            await el.setSinkId(out.deviceId);
            console.log('[ChatHeading] Remote audio routed to headset Hands-Free output:', out.label);
        };
        try {
            await Promise.race([work(), new Promise((resolve) => setTimeout(resolve, 1500))]);
        } catch (e) {
            console.warn('[ChatHeading] Could not route audio to headset output, using default:', e);
        }
    }

    /**
     * Polls a freshly-acquired stream's audio track for genuine (non-silent)
     * signal -- used to wait out a Bluetooth A2DP->HFP profile handoff before
     * the call starts actually transmitting. A mid-handoff track reads as
     * exact digital silence (flat zero), not just quiet, so this only needs
     * to clear a tiny noise-floor epsilon -- it does NOT require the user to
     * be actively talking, just that the hardware is delivering live samples
     * (room/mic self-noise alone clears this). Resolves as soon as it sees
     * that, or after `timeoutMs` regardless, so a genuinely silent room (or
     * a muted track) never hangs call setup.
     * @param {MediaStream} stream
     * @param {number} [timeoutMs]
     */
    static async _waitForMicSignal(stream, timeoutMs = 1200) {
        const track = stream.getAudioTracks()[0];
        if (!track) return;
        let ctx;
        try {
            ctx = new (window.AudioContext || window.webkitAudioContext)();
            const source = ctx.createMediaStreamSource(stream);
            const analyser = ctx.createAnalyser();
            analyser.fftSize = 256;
            source.connect(analyser);
            const data = new Uint8Array(analyser.frequencyBinCount);
            const SILENCE_EPSILON = 0.0008;
            const start = performance.now();
            while (performance.now() - start < timeoutMs) {
                analyser.getByteTimeDomainData(data);
                let sumSq = 0;
                for (let i = 0; i < data.length; i++) {
                    const v = (data[i] - 128) / 128;
                    sumSq += v * v;
                }
                const rms = Math.sqrt(sumSq / data.length);
                if (rms > SILENCE_EPSILON) {
                    console.log('[ChatHeading] Mic signal confirmed after', Math.round(performance.now() - start), 'ms');
                    return;
                }
                await new Promise((r) => setTimeout(r, 50));
            }
            console.warn('[ChatHeading] Mic still reads silent after', timeoutMs, 'ms -- proceeding anyway');
        } catch (e) {
            console.warn('[ChatHeading] Mic signal check failed, proceeding without it:', e);
        } finally {
            try { ctx?.close(); } catch (_) { /* no-op */ }
        }
    }

    /**
     * Fetch ICE servers via XEP-0215 external service discovery.
     * Queries the XMPP server (not the remote peer). Cached after first call.
     */
    static async _getIceServers() {
        if (ChatHeading._iceServersCache && Date.now() < ChatHeading._iceServersCacheExpiry) {
            return ChatHeading._iceServersCache;
        }
        // ── TEMPORARY TEST TURN ─────────────────────────────────────────────
        // Public Open Relay (metered.ca) to PROVE that relay fixes calls to
        // phones behind symmetric CGNAT. REMOVE once own coturn is deployed
        // and advertised via XEP-0215 — do not ship to production with this.
        const TEST_TURN = [
            { urls: 'turn:openrelay.metered.ca:80', username: 'openrelayproject', credential: 'openrelayproject' },
            { urls: 'turn:openrelay.metered.ca:443', username: 'openrelayproject', credential: 'openrelayproject' },
            { urls: 'turn:openrelay.metered.ca:443?transport=tcp', username: 'openrelayproject', credential: 'openrelayproject' },
        ];
        // ────────────────────────────────────────────────────────────────────
        const fallback = [{ urls: 'stun:stun.l.google.com:19302' }, ...TEST_TURN];
        try {
            // Always query our own server domain, never a peer JID
            const domain = _converse.domain
                || (_converse.bare_jid || '').split('@')[1]
                || (_converse.jid || '').split('@')[1];
            if (!domain) { console.warn('[ChatHeading] No domain for XEP-0215'); return fallback; }
            console.log('[ChatHeading] Querying XEP-0215 TURN from domain:', domain);

            let services = null;
            for (const xmlns of ['urn:xmpp:extdisco:2', 'urn:xmpp:extdisco:1']) {
                try {
                    const iq = $iq({ type: 'get', to: domain }).c('services', { xmlns });
                    const result = await new Promise((resolve, reject) => {
                        const timer = setTimeout(() => reject(new Error('timeout')), 5000);
                        _converse.api.sendIQ(iq)
                            .then(res => { clearTimeout(timer); resolve(res); })
                            .catch(err => { clearTimeout(timer); reject(err); });
                    });
                    const found = result.querySelectorAll('service');
                    if (found.length) { services = found; console.log(`[ChatHeading] XEP-0215 ${xmlns}: got ${found.length} services`); break; }
                } catch (e) {
                    console.log(`[ChatHeading] XEP-0215 ${xmlns} failed:`, e.message);
                }
            }

            if (!services || !services.length) {
                console.warn('[ChatHeading] XEP-0215 returned no TURN services');
                ChatHeading._iceServersCache = fallback;
                return fallback;
            }

            const iceServers = [{ urls: 'stun:stun.l.google.com:19302' }];
            services.forEach(svc => {
                const type = svc.getAttribute('type');
                const host = svc.getAttribute('host');
                const port = svc.getAttribute('port');
                const user = svc.getAttribute('username');
                const pass = svc.getAttribute('password');
                const transport = svc.getAttribute('transport') || 'udp';
                if (!host) return;
                if (type === 'stun') {
                    iceServers.push({ urls: `stun:${host}${port ? ':' + port : ''}` });
                } else if (type === 'turn') {
                    const url = `turn:${host}${port ? ':' + port : ''}?transport=${transport}`;
                    const entry = { urls: url };
                    if (user) entry.username = user;
                    if (pass) entry.credential = pass;
                    iceServers.push(entry);
                    console.log(`[ChatHeading] TURN: ${url} user=${user}`);
                }
            });
            // TEMPORARY: append test TURN until XEP-0215 advertises a real one
            if (!iceServers.some((s) => String(s.urls).startsWith('turn:'))) {
                iceServers.push(...TEST_TURN);
                console.log('[ChatHeading] No TURN from XEP-0215 — appended TEST_TURN (Open Relay)');
            }
            console.log('[ChatHeading] ICE servers:', JSON.stringify(iceServers));
            ChatHeading._iceServersCache = iceServers;
            // TURN credentials expire at the timestamp in username (unix seconds).
            // Refresh 5 minutes before expiry.
            const turnEntry = iceServers.find(s => s.urls?.startsWith?.('turn:') && s.username);
            if (turnEntry) {
                const expireTs = parseInt(turnEntry.username.split(':')[0], 10) * 1000;
                ChatHeading._iceServersCacheExpiry = expireTs - 5 * 60 * 1000;
            } else {
                ChatHeading._iceServersCacheExpiry = Date.now() + 3600 * 1000;
            }
            return iceServers;
        } catch (e) {
            console.warn('[ChatHeading] _getIceServers error:', e.message);
            return fallback;
        }
    }

    constructor() {
        super();
        this.jid = null;

        // --- Call state (per-instance) ---
        // NOTE: keeping these on the instance means every open chat has its own
        // pc / localStream. If multiple chats are open and the user triggers
        // calls in parallel, they won't interfere — but the *incoming* Jingle
        // handlers below register once per ChatHeading instance, so every open
        // chat will receive and try to handle every incoming Jingle stanza.
        // That is the known bug we accepted.
        this.pc = null;
        this.localStream = null;
        this.iceCandidatesQueue = [];
        this.currentSid = null;
        this.isIncoming = false;
        this.remoteFullJid = null;
        this.isVideo = false; // true when this is a video call
        this.callActive = false; // mirrors ChatHeading.activeCall for Lit reactivity
        // Call-history bookkeeping (see terminateCall): when the call
        // actually connected (for duration), and whether an explicit
        // <reject> was the reason it ended (vs. a plain timeout).
        this._connectedAt = null;
        this._declinedByRemote = false;
        // Set once the initial offer/answer exchange completes, so a later
        // onnegotiationneeded (fired by restartIce() after a mid-call ICE
        // disconnect) is distinguishable from the very first negotiation,
        // which sendJingleInitiate/handleSessionInitiate already drive
        // manually and must not be renegotiated on top of.
        this._negotiatedOnce = false;
        // Guards against overlapping ICE-restart renegotiations if
        // restartIce() is called again before the in-flight transport-replace
        // round-trip (transport-replace -> transport-accept) has completed.
        this._iceRestartInFlight = false;
    }

    static get properties() {
        return {
            jid: { type: String },
            // Reactive flag — true while a call is active or pending.
            // Used by chat-head.js template to disable call buttons.
            callActive: { type: Boolean },
        };
    }

    initialize() {
        const { chatboxes } = _converse.state;
        this.model = chatboxes.get(this.jid);
        this.listenTo(this.model, 'change:status', () => this.requestUpdate());
        this.listenTo(this.model, 'vcard:add', () => this.requestUpdate());
        this.listenTo(this.model, 'vcard:change', () => this.requestUpdate());
        if (this.model.contact) {
            this.listenTo(this.model.contact, 'destroy', () => this.requestUpdate());
        }
        this.model.rosterContactAdded?.then(() => {
            this.listenTo(this.model.contact, 'change:nickname', () => this.requestUpdate());
            this.requestUpdate();
        });

        // --- Wire up Jingle handlers on this instance ---
        // BUG WARNING: registered per ChatHeading. With N open chats, every
        // incoming Jingle IQ fires N times. Same for the 'message' (proceed)
        // listener and the 'connected' event.
        this._registerJingleHandlers();

        // Pre-inject the call-UI stylesheet now, well before any call starts.
        // Injecting it lazily (only when a call begins) caused the freshly
        // inserted <style> tag to still be mid-parse when the ringing bar's
        // classes were assigned, so the bar briefly rendered with the wrong
        // size/position for about a second until the stylesheet caught up.
        ChatHeading._ensureCallStyles();

        this.requestUpdate();
    }

    render() {
        return tplChatboxHead(this);
    }

    /**
     * @param {Event} ev
     */
    showUserDetailsModal(ev) {
        ev.preventDefault();
        if (this.model?.contact instanceof _converse.exports.Profile) {
            api.modal.show('converse-profile-modal', { model: this.model }, ev);
        } else {
            api.modal.show('converse-user-details-modal', { model: this.model }, ev);
        }
    }

    /**
     * @param {Event} ev
     */
    close(ev) {
        ev.preventDefault();
        this.model.close();
    }

    // ========================================================================
    // CALL LOGIC (moved from sonata-p2p-init plugin)
    // ========================================================================

    _registerJingleHandlers() {
        // Register the Strophe IQ handler and message listener EXACTLY ONCE
        // across all ChatHeading instances. Without this guard, every open
        // chat registers its own handler, and Strophe fires ALL of them per
        // incoming stanza — resulting in N calls to setRemoteDescription /
        // addIceCandidate on the same pc, which breaks the RTCPeerConnection
        // state machine and ICE never completes.
        if (ChatHeading._jingleHandlersRegistered) return;
        ChatHeading._jingleHandlersRegistered = true;

        console.log('=== [ChatHeading] Registering Jingle handlers (once globally) ===');

        const self = this;

        // Wait for Strophe connection, then attach raw IQ handler for Jingle.
        // The plugin used `_converse.on('connected', ...)` which fires once at
        // login. But ChatHeading.initialize() runs PER CHAT OPEN, which may be
        // AFTER 'connected' has already fired (event missed). So we try all
        // three paths: immediate (if connection exists), 'connected' listener,
        // AND a polling fallback. Whichever wins, the static guard inside
        // attach() prevents double-registration on Strophe.
        const attach = () => {
            if (ChatHeading._stropheHandlerAttached) return;
            const connection = _converse.connection || api.connection?.get?.();
            if (!connection || !connection.addHandler) {
                console.log('[ChatHeading] No Strophe connection yet, will retry');
                return false;
            }

            ChatHeading._stropheHandlerAttached = true;
            console.log('[ChatHeading] ✓ Strophe Jingle IQ handler attached');

            connection.addHandler(
                (stanza) => {
                    const jingle = sizzle(`jingle[xmlns="${NS_JINGLE}"]`, stanza).pop();
                    if (!jingle) return true;

                    const action = jingle.getAttribute('action');
                    const from = stanza.getAttribute('from');
                    const id = stanza.getAttribute('id');
                    const sid = jingle.getAttribute('sid');

                    console.log(
                        `%c [JINGLE RECEIVE] Action: ${action} from ${from} sid=${sid} `,
                        'background: #222; color: #bada55; padding: 2px;',
                    );

                    // ACK the IQ immediately
                    connection.send($iq({ type: 'result', to: from, id: id }).tree());

                    const target = ChatHeading.activeCall;
                    if (!target) {
                        console.warn('[JINGLE RECEIVE] No active call; ignoring', action);
                        return true;
                    }
                    if (!target.pc) {
                        console.warn(
                            '[JINGLE RECEIVE] Active call has no pc yet; action=' + action,
                            '— may be timing issue',
                        );
                        // For transport-info we can queue. For session-initiate
                        // (incoming call) we create the pc inside the handler.
                        // For session-accept we can't do much without pc — skip.
                        if (action === 'transport-info' || action === 'session-initiate') {
                            // ok, let it through
                        } else {
                            return true;
                        }
                    }

                    switch (action) {
                        case 'session-initiate': {
                            console.log('[JINGLE RECEIVE] session-initiate (we are callee)');
                            // Pass raw jingle XML — handleSessionInitiate uses buildSdpFromJingle
                            target.handleSessionInitiate(from, sid, jingle);
                            break;
                        }
                        case 'session-accept': {
                            // Pass raw jingle XML — handleSessionAccept uses buildSdpFromJingle
                            target.handleSessionAccept(from, sid, jingle);
                            break;
                        }
                        case 'transport-info':
                            target.handleIncomingCandidates(jingle);
                            break;
                        case 'transport-replace':
                            // Peer's restartIce() completed and it's telling us
                            // its new ICE credentials (see _renegotiateIceRestart).
                            target.handleTransportReplace(from, sid, jingle);
                            break;
                        case 'transport-accept':
                            // Peer acked the transport-replace we sent.
                            target.handleTransportAccept(from, sid, jingle);
                            break;
                        case 'session-terminate':
                            console.warn('[JINGLE RECEIVE] Remote terminated the call');
                            console.warn('[JINGLE RECEIVE] session-terminate reason XML:', jingle.outerHTML);
                            target.terminateCall(false);
                            break;
                        case 'session-info':
                            // ringing / on_hold / etc — informational only
                            console.log('[JINGLE RECEIVE] session-info (informational):', jingle.innerHTML);
                            break;
                        default:
                            console.log('[JINGLE RECEIVE] Unhandled action:', action);
                    }

                    return true;
                },
                NS_JINGLE,
                'iq',
                'set',
            );
            return true;
        };

        // Path 1: connection already exists at registration time
        if (_converse.connection && _converse.connection.addHandler) {
            attach();
        }

        // Path 2: listen for 'connected' and 'reconnected' events
        // Converse fires 'connected' on first login and 'reconnected' after network loss.
        // Without catching both, the Strophe IQ handler dies after reconnect and
        // session-accept / transport-info stanzas are silently dropped.
        const onConnected = () => {
            console.log('[ChatHeading] connected/reconnected event — re-registering Jingle handler');
            ChatHeading._stropheHandlerAttached = false;
            ChatHeading._iceServersCache = null;
            ChatHeading._iceServersCacheExpiry = 0;
            attach();
        };
        api.listen.on('connected', onConnected);
        api.listen.on('reconnected', onConnected);

        // Invalidate TURN cache when tab wakes from sleep/background.
        // Browser suspend freezes the JS clock — TURN credentials expire while
        // suspended, so the cached timestamp-based credentials are stale on wake.
        if (!ChatHeading._visibilityHandlerAttached) {
            ChatHeading._visibilityHandlerAttached = true;
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    console.log('[ChatHeading] Tab visible — invalidating TURN cache');
                    ChatHeading._iceServersCache = null;
                    ChatHeading._iceServersCacheExpiry = 0;
                }
            });
        }

        // Path 3: polling fallback. ChatHeading.initialize() may run AFTER
        // 'connected' has already fired (because user opened a chat after
        // login). In that case neither Path 1 nor Path 2 catches it. Poll
        // until connection becomes available, then stop.
        const pollInterval = setInterval(() => {
            if (ChatHeading._stropheHandlerAttached) {
                clearInterval(pollInterval);
                return;
            }
            if (attach()) {
                clearInterval(pollInterval);
            }
        }, 500);
        // Stop polling after 30s no matter what to avoid leaks
        setTimeout(() => clearInterval(pollInterval), 30000);

        // Listen for Jingle Message Initiation on regular messages:
        //   <propose> — incoming call (we are callee)
        //   <retract> — caller cancelled before we picked up
        //   <proceed> — callee accepted our call (we are caller)
        //   <ringing>, <received>, <reject>, <accept> — info
        _converse.on('message', (data) => {
            const stanza = data.stanza;
            const from = stanza.getAttribute('from');
            const bare_jid = _converse.bare_jid;
            const fromBare = from?.split('/')[0];

            // Ignore our own carbons (echoes of stanzas we sent)
            const isOwnCarbon = fromBare === bare_jid;

            // Look for any JMI element
            const propose = sizzle(`propose[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
            const retract = sizzle(`retract[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
            const proceed = sizzle(`proceed[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
            const ringing = sizzle(`ringing[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
            const received = sizzle(`received[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
            const reject = sizzle(`reject[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
            const accept = sizzle(`accept[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
            const finish = sizzle(`finish[xmlns="${NS_JINGLE_MSG}"]`, stanza).pop();
            const hasJmiElement = !!(propose || retract || proceed || ringing || received || reject || accept || finish);

            // Dedup by stanza id, independent of the <delay> check below.
            // A production resend-storm bug has been observed blasting the
            // exact same stanza id (same JMI payload) dozens of times a
            // second; the <delay> guard covers copies the server marks as
            // resent, but a broken ack-tracking loop might just as easily
            // re-send from its unacked queue without adding <delay> at all,
            // looking identical to a fresh delivery. This dedup holds either
            // way. Stanza ids are UUIDs here, so collision across genuinely
            // different real calls isn't a concern.
            if (hasJmiElement) {
                const stanzaId = stanza.getAttribute('id');
                if (stanzaId) {
                    if (ChatHeading._seenJmiStanzaIds.has(stanzaId)) {
                        console.log('[JMI] Ignoring duplicate redelivery of stanza id', stanzaId);
                        return;
                    }
                    ChatHeading._seenJmiStanzaIds.add(stanzaId);
                    if (ChatHeading._seenJmiStanzaIds.size > 500) {
                        const oldest = ChatHeading._seenJmiStanzaIds.values().next().value;
                        ChatHeading._seenJmiStanzaIds.delete(oldest);
                    }
                }
            }

            // Ignore replayed/historical delivery for ALL call signaling.
            // XEP-0203 <delay> marks a message as not delivered live -- MAM
            // catch-up and the server's offline-queue resend on reconnect
            // both use it. None of propose/retract/accept/proceed/reject/
            // finish make sense minutes or hours after the fact: observed a
            // MAM-resent self-<accept> from a finished call surfacing a
            // live-looking "Incoming call" notification + ring on reconnect
            // (the JMI handler had no concept of "this already happened").
            // Bail out before any of the branches below act on it.
            if (hasJmiElement && sizzle(`delay[xmlns="urn:xmpp:delay"]`, stanza).pop()) {
                console.log('[JMI] Ignoring delayed/replayed JMI stanza (MAM catch-up or reconnect resend)');
                return;
            }

            // --- INCOMING CALL: <propose> ---
            if (propose && !isOwnCarbon) {
                const sid = propose.getAttribute('id');
                const description = sizzle('description', propose).pop();
                const media = description?.getAttribute('media') || 'audio';
                console.log(
                    `%c [JMI INCOMING] propose from ${from} sid=${sid} media=${media} `,
                    'background: #1e9652; color: white; padding: 2px;',
                );
                ChatHeading.handleIncomingPropose(from, sid, media);
                return;
            }

            // --- CALLER CANCELLED: <retract> ---
            if (retract && !isOwnCarbon) {
                const sid = retract.getAttribute('id');
                console.warn(`[JMI INCOMING] retract from ${from} sid=${sid} (caller cancelled)`);
                ChatHeading.handleRetract(sid);
                return;
            }

            // --- CALL ENDED BY REMOTE: <finish> (XEP-0272 / Sonata extension) ---
            if (finish && !isOwnCarbon) {
                const sid = finish.getAttribute('id');
                console.warn(`[JMI] finish from ${from} sid=${sid} — remote ended call`);
                const t = ChatHeading.activeCall;
                if (t) t.terminateCall(false); // remote already ended, don't echo
                return;
            }

            if (ringing) {
                console.log('[JMI] ringing from', from);
                return;
            }
            if (received) {
                console.log('[JMI] received (delivery ack) from', from);
                return;
            }
            if (reject) {
                console.warn('[JMI] reject from', from, '— remote declined');
                const t = ChatHeading.activeCall;
                if (t) {
                    t._declinedByRemote = true;
                    t.terminateCall(false);
                }
                return;
            }
            if (accept) {
                // Sent by whichever of our own resources answers a call (see
                // acceptIncomingCall), addressed to our own bare JID so every
                // other resource (e.g. web, while desktop answered) learns
                // the call was handled and stops ringing.
                const sid = accept.getAttribute('id');
                console.log('[JMI] accept from', from, 'sid=', sid, '— answered on another device');
                ChatHeading.handleAcceptedElsewhere(sid);
                return;
            }

            // --- OUR OUTGOING CALL WAS ACCEPTED: <proceed> ---
            if (proceed) {
                const sidForProceed = proceed.getAttribute('id');

                // A Carbons (XEP-0280) copy of a <proceed> one of our OWN
                // other resources sent to the caller -- e.g. desktop answered
                // and the server echoed that outgoing stanza to us (web) as a
                // "sent" carbon. This is a more universal signal than our own
                // self-addressed <accept> (handleAcceptedElsewhere below):
                // it requires no special support from the answering client,
                // just Carbons, which is already enabled here. Only acts if
                // we actually have a pending incoming-call modal for this
                // sid -- harmless no-op otherwise (e.g. on the caller's own
                // other resources getting a "received" carbon of a genuine
                // reply from the real callee).
                if (isOwnCarbon) {
                    console.log('[JMI] proceed carbon from own resource, sid=', sidForProceed, '— answered elsewhere');
                    ChatHeading.handleAcceptedElsewhere(sidForProceed);
                    return;
                }

                console.log('=== [JMI] proceed from', from, '===');
                const target = ChatHeading.activeCall;
                if (!target) {
                    console.warn('[ChatHeading] proceed received but no active call');
                    return;
                }
                if (target.pc) {
                    console.log('[ChatHeading] Already have pc, ignoring duplicate proceed');
                    return;
                }
                console.log('=== [ChatHeading] Starting WebRTC (sendJingleInitiate) ===');
                target.sendJingleInitiate(from, sidForProceed);
            }
        });
    }

    /**
     * Called from chat-head.js template buttons.
     * @param {'audio'|'video'} media
     */
    async initiateCall(media = 'audio') {
        if (!this.model) {
            console.warn('[ChatHeading] No model, cannot initiate call');
            return;
        }

        // BUG 3: block new call if one is already active or pending
        if (ChatHeading.activeCall) {
            console.warn('[ChatHeading] Call already active — ignoring new initiateCall');
            showToast('Дзвінок вже активний. Завершіть поточний перед новим.', 'warn');
            return;
        }

        this.isVideo = media === 'video';

        // Pre-warm media BEFORE sending <propose>.
        try {
            console.log(`[ChatHeading] Pre-warming media (${media})...`);
            this.localStream = await ChatHeading._getUserMediaDefaultAudio(this.isVideo);
        } catch (err) {
            console.error('[ChatHeading] Media permission denied / unavailable:', err);
            // If video device not found, fall back to audio-only
            if (this.isVideo && (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError' || err.name === 'NotReadableError')) {
                console.warn('[ChatHeading] Camera not available, falling back to audio-only call');
                showToast('Камера не знайдена — дзвінок буде аудіо', 'warn');
                try {
                    this.localStream = await ChatHeading._getUserMediaDefaultAudio(false);
                    this.isVideo = false;
                    media = 'audio';
                    console.log('[ChatHeading] Audio-only fallback successful');
                } catch (audioErr) {
                    console.error('[ChatHeading] Audio also failed:', audioErr);
                    showToast('Мікрофон недоступний. Перевірте підключення та дозволи.', 'error');
                    this.model.createMessage({ message: '❌ Не вдалося отримати доступ до мікрофона', type: 'info' });
                    return;
                }
            } else if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
                showToast(`Доступ до ${this.isVideo ? 'камери/мікрофона' : 'мікрофона'} заборонено. Дозвольте доступ у налаштуваннях браузера.`, 'error');
                this.model.createMessage({ message: `❌ Доступ до ${this.isVideo ? 'камери/мікрофона' : 'мікрофона'} заборонено`, type: 'info' });
                return;
            } else {
                showToast(`Не вдалося отримати доступ до ${this.isVideo ? 'камери/мікрофона' : 'мікрофона'}`, 'error');
                this.model.createMessage({
                    message: `❌ Не вдалося отримати доступ до ${this.isVideo ? 'камери/мікрофона' : 'мікрофона'}`,
                    type: 'info',
                });
                return;
            }
        }

        const jid = this.model.get('jid');
        const sid = crypto.randomUUID().toUpperCase();
        const stanzaId = `jm-propose-${sid}`;
        const myNick = _converse.xmppstatus.get('fullname') || _converse.bare_jid;

        this.currentSid = sid;
        setActiveCall(this);

        console.log(`[ChatHeading] Proposing ${media} call to ${jid}, SID: ${sid}`);

        const propose = $msg({ to: jid, type: 'chat', id: stanzaId })
            .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: stanzaId })
            .up()
            .c('propose', { xmlns: NS_JINGLE_MSG, id: sid })
            .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
            .up();

        if (this.isVideo) {
            propose.c('description', { xmlns: NS_JINGLE_RTP, media: 'video' }).up();
        }

        propose
            .up()
            .c('request', { xmlns: 'urn:xmpp:receipts' })
            .up()
            .c('store', { xmlns: 'urn:xmpp:hints' })
            .up()
            .c('x', { xmlns: 'p1:push:custom', key: 'type', value: 'call' })
            .up()
            .c('x', { xmlns: 'p1:push:custom', key: 'aps.mutable-content', value: '1' })
            .up()
            .c('customize', { xmlns: 'p1:push:customize', nick: myNick })
            .c('body')
            .t('Incoming call')
            .up()
            .up();

        api.send(propose);
        // No interim "calling..." chat message -- like Telegram/WhatsApp,
        // the outgoing-call panel itself shows the ringing state; the chat
        // log only gets a single entry once the call's outcome is known
        // (see terminateCall).
        ChatHeading._showOutgoingCallPanel(this);

        // Auto-retract after 60s if callee doesn't answer.
        // Sync with mobile team if they use a different timeout.
        ChatHeading._autoHangupTimer = setTimeout(() => {
            if (ChatHeading.activeCall === this && !this.pc) {
                console.warn('[ChatHeading] No answer after 60s — auto-retracting');
                if (jid && this.currentSid) {
                    const retractMsg = $msg({ to: jid, type: 'chat', id: crypto.randomUUID() })
                        .c('retract', { xmlns: NS_JINGLE_MSG, id: this.currentSid })
                        .up()
                        .c('store', { xmlns: 'urn:xmpp:hints' });
                    api.send(retractMsg);
                }
                this.terminateCall(false);
                showToast('Абонент не відповідає', 'warn');
            }
        }, 60000);
    }

    async sendJingleInitiate(fullJid, sid) {
        console.log('[ChatHeading] >>> sendJingleInitiate START', { fullJid, sid });
        this.iceCandidatesQueue = [];
        this.currentSid = sid;
        this.remoteFullJid = fullJid; // needed for terminateCall to send session-terminate

        try {
            // Reuse pre-warmed stream from initiateCall(). Only fall back to
            // getUserMedia if there isn't one (e.g. incoming-direction calls
            // that bypass our initiateCall — currently none, but safe).
            if (!this.localStream) {
                console.log('[ChatHeading] No pre-warmed stream, requesting media...');
                this.localStream = await ChatHeading._getUserMediaDefaultAudio(this.isVideo);
                console.log('[ChatHeading] Got media stream:', this.localStream);
            } else {
                console.log('[ChatHeading] Reusing pre-warmed stream (isVideo:', this.isVideo, ')');
            }

            console.log('[ChatHeading] Creating RTCPeerConnection...');
            const iceServers = await ChatHeading._getIceServers();
            console.log('[ChatHeading] Using ICE servers:', JSON.stringify(iceServers));
            this.pc = new RTCPeerConnection({
                iceServers,
                // max-compat: iOS doesn't BUNDLE video (separate ICE transport per
                // m-line, own ufrag/pwd). max-bundle would force video onto the audio
                // transport that iOS never connects → no video both ways with iOS.
                bundlePolicy: 'max-compat',
                rtcpMuxPolicy: 'require',
                iceCandidatePoolSize: 2, // pre-gather candidates before offer
            });
            console.log('[ChatHeading] RTCPeerConnection created');

            this.pc.oniceconnectionstatechange = () => {
                console.log(
                    `%c [ICE] state=${this.pc.iceConnectionState} `,
                    'color: orange; font-weight: bold;',
                );
                if (this.pc.iceConnectionState === 'failed') {
                    console.warn('[ICE] FAILED — attempting ICE restart...');
                    ChatHeading._dumpIcePairs(this.pc, 'failed');
                    if (this.pc.signalingState === 'stable' && this.pc.restartIce) {
                        this.pc.restartIce();
                    }
                }
                if (this.pc.iceConnectionState === 'disconnected') {
                    console.warn('[ICE] DISCONNECTED — will restart if not recovered in 5s');
                    ChatHeading._dumpIcePairs(this.pc, 'disconnected');
                    setTimeout(() => {
                        if (this.pc && this.pc.iceConnectionState === 'disconnected') {
                            console.warn('[ICE] Still disconnected — restarting ICE');
                            if (this.pc.signalingState === 'stable' && this.pc.restartIce) {
                                this.pc.restartIce();
                            }
                        }
                    }, 5000);
                }
                if (this.pc.iceConnectionState === 'connected') {
                    console.log('%c [ICE] ✅ CONNECTED ', 'background: green; color: white;');
                    ChatHeading._showCallPanel(this);
                    ChatHeading._requestKeyframeAndPollVideo(this.pc);
                }
            };

            this.pc.onconnectionstatechange = () => {
                console.log(`[PC] connectionState=${this.pc.connectionState}`);
            };

            // Logs STUN/TURN server failures (401 bad creds, 701 timeout, etc).
            // Without this, a dead TURN server fails silently — no relay
            // candidates appear and nobody knows why.
            this.pc.onicecandidateerror = (ev) => {
                console.warn(
                    `[ICE ERROR] url=${ev.url} code=${ev.errorCode} text="${ev.errorText}" address=${ev.address}:${ev.port}`,
                );
            };

            this.pc.onsignalingstatechange = () => {
                console.log(`[PC] signalingState=${this.pc.signalingState}`);
            };

            // Fires after restartIce() (called above on ICE failed/disconnected)
            // regenerates our local ICE credentials. Ignored during the very
            // first negotiation (that offer is built manually below) — only
            // acts once a session is actually established.
            this.pc.onnegotiationneeded = () => this._renegotiateIceRestart();

            this.pc.ontrack = (event) => {
                console.log(
                    `%c [TRACK] kind=${event.track.kind} streams=${event.streams.length} `,
                    'background: #333; color: #7ec8e3; padding: 2px;',
                );
                if (event.track.kind === 'audio') {
                    console.log('[ChatHeading] Attaching remote audio track');
                    let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
                    el.id = 'sonata-audio-remote';
                    el.autoplay = true;
                    if (!el.parentElement) document.body.appendChild(el);
                    // Pick the headset's Hands-Free output first (no-op unless
                    // Windows + a Hands-Free mic), then start playback.
                    const remoteStream = event.streams[0];
                    ChatHeading._applyHeadsetSink(el, this.localStream).then(() => {
                        el.srcObject = remoteStream;
                    });
                } else if (event.track.kind === 'video') {
                    console.log('[ChatHeading] Attaching remote video track — PiP should show');
                    ChatHeading._attachRemoteVideo(event.streams[0]);
                }
            };

            this.pc.onicecandidate = (event) => {
                if (event.candidate) {
                    const c = event.candidate;
                    console.log('[ChatHeading] Local candidate:', c.candidate);
                    const attrs = {
                        id: String(Math.floor(Math.random() * 4294967295)),
                        // c.component is 'rtp'/'rtcp' (string!) in WebRTC API.
                        // XEP-0176 requires numeric "1"/"2" — iOS rejects "rtp"
                        // with <bad-request/> and drops ALL our candidates.
                        component: c.component === 'rtcp' ? '2' : '1',
                        foundation: c.foundation,
                        generation: '0',
                        ip: c.address || c.ip,
                        port: String(c.port),
                        priority: String(c.priority),
                        protocol: (c.protocol || 'udp').toLowerCase(),
                        type: c.type,
                    };
                    if (c.relatedAddress) attrs['rel-addr'] = c.relatedAddress;
                    if (c.relatedPort) attrs['rel-port'] = String(c.relatedPort);
                    // Candidate belongs to a specific m-line (sdpMid). With max-compat
                    // each m-line has its own transport+ufrag — send under the right
                    // content name so iOS routes it to the correct ICE agent.
                    const candMid = c.sdpMid != null ? String(c.sdpMid) : '0';
                    const candIce = getLocalIceForMid(this.pc?.localDescription?.sdp || '', candMid);
                    const iq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
                        .c('jingle', { xmlns: NS_JINGLE, action: 'transport-info', initiator: _converse.jid, sid })
                        .c('content', { creator: 'initiator', name: candMid })
                        .c('transport', {
                            xmlns: NS_JINGLE_ICE,
                            ufrag: candIce.ufrag || c.usernameFragment || '',
                            pwd: candIce.pwd || '',
                        })
                        .c('candidate', attrs);
                    api.send(iq);
                }
            };

            this.localStream.getTracks().forEach((track) => this.pc.addTrack(track, this.localStream));

            // BUG 4: monitor audio track for browser mic revoke.
            // When user disables mic in browser tab permissions, the track ends.
            // If they re-enable, we must get a new track and replace it in pc.
            const _monitorMic = () => {
                const audioTrack = this.localStream?.getAudioTracks()[0];
                if (!audioTrack) return;
                audioTrack.addEventListener('ended', async () => {
                    console.warn('[ChatHeading] Audio track ended (mic revoked) — will try to restore on re-grant');
                    // Poll until user re-grants mic access
                    const _tryRestore = async () => {
                        if (!this.pc || this.pc.connectionState === 'closed') return;
                        try {
                            const newStream = await ChatHeading._getUserMediaDefaultAudio(false);
                            const newTrack = newStream.getAudioTracks()[0];
                            if (!newTrack) return;
                            const sender = this.pc.getSenders().find((s) => s.track?.kind === 'audio');
                            if (sender) {
                                await sender.replaceTrack(newTrack);
                                console.log('[ChatHeading] ✅ Audio track restored after mic re-grant');
                                showToast('Мікрофон знову підключено', 'info');
                                // Re-monitor the new track
                                this.localStream = newStream;
                                _monitorMic();
                            }
                        } catch (e) {
                            // Still no access — retry in 2s
                            setTimeout(_tryRestore, 2000);
                        }
                    };
                    setTimeout(_tryRestore, 500);
                });
            };
            _monitorMic();

            const offer = await this.pc.createOffer();
            await this.pc.setLocalDescription(offer);

            const sdp = this.pc.localDescription.sdp;
            console.log('[ChatHeading] 📋 LOCAL OFFER SDP (full):\n', sdp);
            const ufrag = sdp.match(/a=ice-ufrag:(.*)\r/)[1];
            const pwd = sdp.match(/a=ice-pwd:(.*)\r/)[1];
            const fingerprint = sdp.match(/a=fingerprint:sha-256 (.*)\r/)[1];

            console.log('[ChatHeading] Sending session-initiate (isVideo:', this.isVideo, ')...');
            console.log('[ChatHeading] Local tracks:', this.localStream?.getTracks().map(t => `${t.kind}:${t.label}`));

            // Parse video codecs from our actual offer SDP so PT numbers match.
            // Hardcoding 96/97 doesn't work — browser assigns different PT numbers
            // (e.g. H264 gets 103, 107, etc). iOS/Android match by PT number in the
            // answer, so we must use whatever the browser assigned in the offer.
            const SKIP = new Set(['rtx','red','ulpfec','flexfec-03','telephone-event','cn','pcmu','pcma','g722']);
            const offerVideoPayloads = [];
            let inVid = false;
            for (const line of sdp.split('\n')) {
                const l = line.trim();
                if (l.startsWith('m=video')) { inVid = true; continue; }
                if (l.startsWith('m=') && inVid) { inVid = false; break; }
                if (inVid && l.startsWith('a=rtpmap:')) {
                    const m = l.match(/^a=rtpmap:(\d+) ([^/]+)\/(\d+)/);
                    if (m && !SKIP.has(m[2].toLowerCase())) {
                        offerVideoPayloads.push({ id: m[1], name: m[2], clockrate: m[3] });
                    }
                }
            }
            // Reorder: H264 first (for iOS), then others
            offerVideoPayloads.sort((a, b) => {
                const aH = a.name.toLowerCase().includes('h264') ? 0 : 1;
                const bH = b.name.toLowerCase().includes('h264') ? 0 : 1;
                return aH - bH;
            });
            console.log('[ChatHeading] Outgoing video offer payloads:', offerVideoPayloads);

            // Build session-initiate as one unbroken chain.
            let initiateIq;
            if (this.isVideo) {
                let iq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
                    .c('jingle', { xmlns: NS_JINGLE, action: 'session-initiate', initiator: _converse.jid, sid })
                    .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
                    .c('content', { name: '0' }).up()
                    .c('content', { name: '1' }).up()
                    .up()
                    .c('content', { creator: 'initiator', name: '0' })
                        .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
                            .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
                                .c('parameter', { name: 'minptime', value: '10' }).up()
                                .c('parameter', { name: 'useinbandfec', value: '1' }).up()
                            .up()
                            .c('rtcp-mux').up()
                        .up()
                        .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
                            .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' }).t(fingerprint).up()
                        .up()
                    .up()
                    .c('content', { creator: 'initiator', name: '1' })
                        .c('description', { xmlns: NS_JINGLE_RTP, media: 'video' });

                offerVideoPayloads.forEach(p => iq.c('payload-type', { id: p.id, name: p.name, clockrate: p.clockrate }).up());

                iq = iq
                        .c('rtcp-mux').up()
                    .up()
                    .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
                        .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' }).t(fingerprint).up()
                    .up()
                .up();

                initiateIq = iq;
            } else {
                initiateIq = $iq({ type: 'set', to: fullJid, id: crypto.randomUUID().toLowerCase() })
                    .c('jingle', { xmlns: NS_JINGLE, action: 'session-initiate', initiator: _converse.jid, sid })
                    .c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: 'BUNDLE' })
                    .c('content', { name: '0' }).up()
                    .up() // </group>
                    .c('content', { creator: 'initiator', name: '0' })
                        .c('description', { xmlns: NS_JINGLE_RTP, media: 'audio' })
                            .c('payload-type', { id: '111', name: 'opus', clockrate: '48000', channels: '2' })
                                .c('parameter', { name: 'minptime', value: '10' }).up()
                                .c('parameter', { name: 'useinbandfec', value: '1' }).up()
                            .up() // </payload-type>
                            .c('rtcp-mux').up()
                        .up() // </description>
                        .c('transport', { xmlns: NS_JINGLE_ICE, ufrag, pwd })
                            .c('fingerprint', { xmlns: NS_DTLS, hash: 'sha-256', setup: 'actpass' }).t(fingerprint).up()
                        .up() // </transport>
                    .up(); // </content>
            }

            api.send(initiateIq);
            console.log('[ChatHeading] 📤 session-initiate XML:\n', initiateIq.toString());
            console.log('[ChatHeading] >>> sendJingleInitiate DONE (session-initiate sent)');
        } catch (err) {
            console.error('[ChatHeading] WebRTC Error in sendJingleInitiate:', err);
            console.error('[ChatHeading] Stack:', err?.stack);
        }
    }

    handleSessionAccept(fromJid, sid, jingle) {
        console.log('[ChatHeading] >>> handleSessionAccept START', { fromJid, sid });
        if (!this.pc) {
            console.error('[ChatHeading] handleSessionAccept: NO PC! Cannot proceed.');
            return;
        }
        console.log('[ChatHeading] pc signaling state:', this.pc.signalingState);
        console.log('[ChatHeading] Session-accept Jingle XML:\n', jingle?.outerHTML);

        try {
            // The answer MUST match our offer's m-line count and order exactly.
            // iOS sometimes sends only 1 content in session-accept even when we offered 2.
            // buildSdpFromJingle on that would produce a 1-m-line answer → Chrome rejects it.
            // Instead, build from our own offer mids and use ICE/DTLS from the remote accept.
            const offerSdp = this.pc.localDescription?.sdp || '';
            const offerMids = [...offerSdp.matchAll(/^a=mid:(.+)$/gm)].map(m => m[1].trim());
            console.log('[ChatHeading] Offer m-line mids:', offerMids);

            // Read ICE/DTLS PER CONTENT from the remote accept.
            // iOS does NOT bundle video — its BUNDLE group lists only "0" and the
            // video content carries a separate <transport> with its own ufrag/pwd.
            // We must mirror that per-m-line, otherwise Chrome runs video over the
            // audio bundle transport that iOS never ICE-connects for video →
            // zero video packets in both directions.
            const contents = getJingleRtpContents(jingle);
            const contentByName = new Map(
                contents.map((c, i) => [c.getAttribute('name') || String(i), c]),
            );
            const firstContent = contents[0] || firstDirectChild(jingle, 'content');
            const firstTransportEl = firstDirectChild(firstContent, 'transport');

            const iceForMid = (mid) => {
                const content = contentByName.get(String(mid)) || firstContent;
                const transport = firstDirectChild(content, 'transport') || firstTransportEl;
                const fingerprintEl = firstDirectChild(transport, 'fingerprint');
                return {
                    ufrag: transport?.getAttribute('ufrag'),
                    pwd: transport?.getAttribute('pwd'),
                    fingerprint: fingerprintEl?.textContent?.trim(),
                    setup: fingerprintEl?.getAttribute('setup') || 'active',
                };
            };

            // Honor the remote's BUNDLE group (iOS lists only "0").
            const remoteGroup = firstDirectChild(jingle, 'group');
            const remoteBundleMids = directChildren(remoteGroup, 'content')
                .map((c) => c.getAttribute('name'))
                .filter(Boolean);
            console.log('[ChatHeading] Remote BUNDLE group mids:', remoteBundleMids,
                '| per-mid ICE ufrag:', offerMids.map((m) => `${m}:${iceForMid(m).ufrag}`).join(' '));

            // Video codecs: prefer what iOS/remote actually accepted (from Jingle XML),
            // falling back to our offer if the accept has no payloads.
            // This is critical — iOS accepts only H264 with specific fmtp, and Chrome
            // must use that exact codec/PT to send video iOS can decode.
            const acceptedPayloads = [];
            const videoContent = contents.find(c =>
                firstDirectChild(c, 'description')?.getAttribute('media') === 'video'
            );
            if (videoContent) {
                const desc = firstDirectChild(videoContent, 'description');
                const parsed = payloadsFromJingleDescription(desc, 'video');
                acceptedPayloads.push(...parsed);
                console.log('[ChatHeading] Accepted video payloads from iOS/remote:', acceptedPayloads);
            }

            // Fall back to our offer codecs if remote accept had none
            const SKIP_V = new Set(['rtx','red','ulpfec','flexfec-03']);
            let finalVideoCodecs = acceptedPayloads;
            if (!finalVideoCodecs.length) {
                console.warn('[ChatHeading] No video payloads in accept, falling back to offer codecs');
                const offerVideoCodecs = [];
                let inVideo = false;
                for (const line of offerSdp.split('\n')) {
                    const l = line.trim();
                    if (l.startsWith('m=video')) { inVideo = true; continue; }
                    if (l.startsWith('m=') && inVideo) { inVideo = false; break; }
                    if (inVideo && l.startsWith('a=rtpmap:')) {
                        const m = l.match(/^a=rtpmap:(\d+) ([^/]+)\/(\d+)/);
                        if (m && !SKIP_V.has(m[2].toLowerCase())) {
                            offerVideoCodecs.push({ id: m[1], name: m[2], clockrate: m[3] });
                        }
                    }
                }
                finalVideoCodecs = offerVideoCodecs;
            }
            console.log('[ChatHeading] Final video codecs for answer SDP:', finalVideoCodecs);

            const videoPtIds = finalVideoCodecs.map(c => c.id).join(' ') || '96';
            // Build rtpmap + fmtp + rtcp-fb lines for each accepted codec
            const videoCodecLines = [];
            for (const c of finalVideoCodecs) {
                const ch = c.channels ? `/${c.channels}` : '';
                videoCodecLines.push(`a=rtpmap:${c.id} ${c.name}/${c.clockrate}${ch}`);
                const fmtp = buildFmtpLine(c);
                if (fmtp) videoCodecLines.push(fmtp);
                // rtcp-fb essential for Chrome to send PLI/NACK → remote sends keyframes
                videoCodecLines.push(
                    `a=rtcp-fb:${c.id} nack`,
                    `a=rtcp-fb:${c.id} nack pli`,
                    `a=rtcp-fb:${c.id} ccm fir`,
                    `a=rtcp-fb:${c.id} goog-remb`,
                    `a=rtcp-fb:${c.id} transport-cc`,
                );
            }

            // BUNDLE line mirrors what the remote actually bundles. iOS lists only
            // "0" → video keeps its own transport (works with bundlePolicy max-compat).
            const bundleMids = remoteBundleMids.length ? remoteBundleMids : offerMids;
            const bundleLine = bundleMids.length > 0 ? `a=group:BUNDLE ${bundleMids.join(' ')}` : 'a=group:BUNDLE 0';

            const mSections = offerMids.map(mid => {
                const isVid = mid !== '0' && this.isVideo;
                // Per-mid ICE/DTLS — iOS video has its own ufrag/pwd
                const { ufrag, pwd, fingerprint, setup } = iceForMid(mid);
                return [
                    isVid ? `m=video 9 RTP/SAVPF ${videoPtIds}` : 'm=audio 9 RTP/SAVPF 111',
                    'c=IN IP4 0.0.0.0',
                    ufrag ? `a=ice-ufrag:${ufrag}` : '',
                    pwd ? `a=ice-pwd:${pwd}` : '',
                    fingerprint ? `a=fingerprint:sha-256 ${fingerprint}` : '',
                    `a=setup:${setup}`,
                    `a=mid:${mid}`,
                    'a=rtcp-mux',
                    ...(isVid ? videoCodecLines : [
                        'a=rtcp-fb:111 transport-cc',
                        'a=rtpmap:111 opus/48000/2',
                        'a=fmtp:111 minptime=10;useinbandfec=1',
                    ]),
                    'a=sendrecv',
                ].filter(Boolean).join('\r\n');
            });

            const remoteSdp = [
                'v=0','o=- 1234567890 2 IN IP4 0.0.0.0','s=-','t=0 0', bundleLine, 'a=msid-semantic: WMS',
            ].join('\r\n') + '\r\n' + mSections.join('\r\n') + '\r\n';
            console.log('[ChatHeading] Built answer SDP:\n', remoteSdp);

            this.pc.setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp: remoteSdp }))
                .then(() => {
                    console.log('%c ✅ BUNDLE accepted! Remote description SET. ', 'color: white; background: green;');
                    // Initial offer/answer is done — a later onnegotiationneeded
                    // (from restartIce() after a mid-call ICE disconnect) is now
                    // safe to act on.
                    this._negotiatedOnce = true;
                    console.log('[ChatHeading] Queued candidates to flush:', this.iceCandidatesQueue.length);
                    while (this.iceCandidatesQueue.length > 0) {
                        const cand = this.iceCandidatesQueue.shift();
                        this.pc.addIceCandidate(cand)
                            .then(() => console.log('[ChatHeading] Flushed candidate OK'))
                            .catch(e => console.warn('[ChatHeading] Flush candidate failed:', e));
                    }
                })
                .catch(err => {
                    console.error('[ChatHeading] setRemoteDescription FAILED:', err);
                    console.log('[ChatHeading] DUMP answer SDP:\n', remoteSdp);
                    console.log('[ChatHeading] Offer mids were:', offerMids);
                });
        } catch (err) {
            console.error('[ChatHeading] handleSessionAccept error:', err);
        }
    }

    /**
     * Renegotiates the PeerConnection after restartIce() (called from the
     * oniceconnectionstatechange handlers on DISCONNECTED/FAILED) regenerated
     * our local ICE credentials. restartIce() only updates the *local* ICE
     * agent — without telling the peer about the new ufrag/pwd via signaling,
     * their ICE agent keeps checking our incoming STUN requests against the
     * OLD credentials and rejects them, so the call can never actually
     * recover from a mid-call ICE disconnect (every restart attempt just
     * times out again). This sends the new local offer to the peer as a
     * `transport-replace` (XEP-0176 ss 6.3); handleTransportAccept below
     * applies their reply.
     */
    async _renegotiateIceRestart() {
        if (!this._negotiatedOnce || !this.pc || this.pc.signalingState !== 'stable') {
            return; // initial offer/answer isn't done yet — that path builds its own offer
        }
        if (!this.remoteFullJid || !this.currentSid) {
            console.warn('[ChatHeading] onnegotiationneeded fired with no active session, ignoring');
            return;
        }
        if (this._iceRestartInFlight) {
            console.log('[ChatHeading] ICE restart already in flight, skipping duplicate negotiationneeded');
            return;
        }
        this._iceRestartInFlight = true;
        try {
            console.log('[ChatHeading] Renegotiating after ICE restart — building new offer...');
            const offer = await this.pc.createOffer();
            await this.pc.setLocalDescription(offer);
            console.log('[ChatHeading] 📋 ICE-restart LOCAL OFFER SDP:\n', this.pc.localDescription.sdp);

            // initiator/responder identify the ORIGINAL session roles (fixed
            // for its whole lifetime), not who happens to send this restart —
            // mirrors how transport-info is addressed elsewhere in this file.
            const initiator = this.isIncoming ? this.remoteFullJid : _converse.jid;
            const responder = this.isIncoming ? _converse.jid : this.remoteFullJid;

            const replaceIq = buildJingleIqFromLocalSdp({
                action: 'transport-replace',
                to: this.remoteFullJid,
                sid: this.currentSid,
                initiator,
                responder,
                localSdp: this.pc.localDescription.sdp,
            });
            console.log('[ChatHeading] 📤 transport-replace XML:\n', replaceIq.toString());
            api.send(replaceIq);

            // Self-clears even without a reply: an older peer build (mixed
            // rollout) won't recognize transport-replace and will never send
            // transport-accept back, which would otherwise leave this flag
            // stuck true and block every later restart attempt for the rest
            // of the call.
            const sidAtRequest = this.currentSid;
            setTimeout(() => {
                if (this.currentSid === sidAtRequest) this._iceRestartInFlight = false;
            }, 10000);
        } catch (err) {
            console.error('[ChatHeading] ICE-restart renegotiation failed:', err);
            this._iceRestartInFlight = false;
        }
        // Otherwise left true on success until handleTransportAccept clears it
        // (or the timeout above does) — a second restartIce() firing while
        // we're still waiting on the peer's reply would otherwise build a
        // second offer on top of the first, unstabilizing signalingState.
    }

    /**
     * Peer's own restartIce() completed and it sent us its new ICE
     * credentials as a transport-replace. Apply as a fresh remote offer,
     * answer normally (our own transport is unchanged — only the peer
     * restarted), and send transport-accept back.
     */
    async handleTransportReplace(fromJid, sid, jingle) {
        console.log('[ChatHeading] >>> handleTransportReplace (peer ICE-restarted)', { fromJid, sid });
        if (!this.pc) {
            console.warn('[ChatHeading] handleTransportReplace: no active pc, ignoring');
            return;
        }
        try {
            const remoteOfferSdp = buildSdpFromJingle(jingle, 'offer');
            console.log('[ChatHeading] Applying restarted remote OFFER SDP:\n', remoteOfferSdp);
            await this.pc.setRemoteDescription(new RTCSessionDescription({ type: 'offer', sdp: remoteOfferSdp }));

            const answer = await this.pc.createAnswer();
            await this.pc.setLocalDescription(answer);
            console.log('[ChatHeading] 📋 transport-accept LOCAL ANSWER SDP:\n', this.pc.localDescription.sdp);

            const contents = getJingleRtpContents(jingle);
            const remoteMidOrder = contents.map((c, i) => c.getAttribute('name') || String(i));
            const contentCreatorsByMid = new Map(remoteMidOrder.map((mid) => [mid, 'initiator']));
            const initiator = this.isIncoming ? this.remoteFullJid : _converse.jid;
            const responder = this.isIncoming ? _converse.jid : this.remoteFullJid;

            const acceptIq = buildJingleIqFromLocalSdp({
                action: 'transport-accept',
                to: fromJid,
                sid,
                initiator,
                responder,
                localSdp: this.pc.localDescription.sdp,
                contentCreatorsByMid,
                preferredMidOrder: remoteMidOrder,
            });
            console.log('[ChatHeading] 📤 transport-accept XML:\n', acceptIq.toString());
            api.send(acceptIq);
        } catch (err) {
            console.error('[ChatHeading] handleTransportReplace error:', err);
        }
    }

    /**
     * Peer acked the transport-replace we sent from _renegotiateIceRestart —
     * apply their answer so our own restarted ICE agent has their (unchanged)
     * remote credentials confirmed and signalingState settles back to stable.
     */
    async handleTransportAccept(fromJid, sid, jingle) {
        console.log('[ChatHeading] >>> handleTransportAccept (peer acked our ICE restart)', { fromJid, sid });
        if (!this.pc) {
            console.warn('[ChatHeading] handleTransportAccept: no active pc, ignoring');
            return;
        }
        try {
            const remoteAnswerSdp = buildSdpFromJingle(jingle, 'answer');
            console.log('[ChatHeading] Applying transport-accept remote ANSWER SDP:\n', remoteAnswerSdp);
            await this.pc.setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp: remoteAnswerSdp }));
        } catch (err) {
            console.error('[ChatHeading] handleTransportAccept error:', err);
        } finally {
            this._iceRestartInFlight = false;
        }
    }

    handleIncomingCandidates(jingle) {
        const candidateElems = sizzle('candidate', jingle);

        candidateElems.forEach((el) => {
            const foundation = el.getAttribute('foundation');
            // 'component' can be 'rtp'/'rtcp' (non-standard) or '1'/'2' (standard).
            // Chrome only accepts numeric component values.
            const rawComponent = el.getAttribute('component') || '1';
            const component = rawComponent === 'rtp' ? '1' : rawComponent === 'rtcp' ? '2' : rawComponent;
            const protocol = (el.getAttribute('protocol') || 'udp').toLowerCase();
            const priority = el.getAttribute('priority');
            const ip = el.getAttribute('ip');
            const port = el.getAttribute('port');
            const type = el.getAttribute('type') || 'host';
            const relAddr = el.getAttribute('rel-addr');
            const relPort = el.getAttribute('rel-port');

            // Wrap IPv6 addresses in brackets
            const addr = ip?.includes(':') ? `[${ip}]` : ip;

            let candidateStr = `candidate:${foundation} ${component} ${protocol} ${priority} ${addr} ${port} typ ${type}`;
            if ((type === 'srflx' || type === 'relay') && relAddr && relPort) {
                const rAddr = relAddr.includes(':') ? `[${relAddr}]` : relAddr;
                candidateStr += ` raddr ${rAddr} rport ${relPort}`;
            }
            console.log('[ChatHeading] Incoming remote candidate:', candidateStr);

            // sdpMid should match the content name from the Jingle stanza
            const contentEl = el.closest ? el.closest('content') : el.parentElement?.parentElement;
            const sdpMid = contentEl?.getAttribute('name') || '0';

            const iceCandidate = new RTCIceCandidate({
                candidate: candidateStr,
                sdpMid,
                sdpMLineIndex: parseInt(sdpMid, 10) || 0,
            });

            if (this.pc && this.pc.remoteDescription && this.pc.remoteDescription.type) {
                this.pc.addIceCandidate(iceCandidate).catch((e) => console.warn('AddIceCandidate error:', e.message));
            } else {
                console.log('[ChatHeading] PC not ready, queuing candidate');
                this.iceCandidatesQueue.push(iceCandidate);
            }
        });
    }

    terminateCall(sendTerminate = true) {
        // Write exactly one call-history entry summarizing the outcome, the
        // way Telegram/WhatsApp do -- never a running log of ringing/
        // accepted states (those interim messages were removed from
        // initiateCall/acceptIncomingCall), just the final result once the
        // call is actually over. Must read this.isIncoming/_connectedAt
        // etc. before they get reset below. Guarded on there having been an
        // active call at all, so a second/redundant terminateCall() on an
        // already-cleaned-up instance can't write a phantom duplicate entry.
        const hadActiveCall = !!(this.currentSid || this.remoteFullJid || this._connectedAt);
        if (hadActiveCall) try {
            const icon = this.isVideo ? '📹' : '📞';
            let text;
            if (this._connectedAt) {
                const duration = ChatHeading._formatCallDuration(Date.now() - this._connectedAt);
                text = `${icon} ${this.isIncoming ? 'Вхідний' : 'Вихідний'} дзвінок · ${duration}`;
            } else if (!this.isIncoming) {
                text = this._declinedByRemote ? `${icon} Виклик відхилено` : `${icon} Немає відповіді`;
            } else {
                // Incoming but never reached _showCallPanel -- accepted, then
                // failed before actually connecting (e.g. ICE failure).
                // Straightforward declines/timeouts on the incoming side are
                // written at their own call sites (handleIncomingPropose,
                // _writeMissedCallMessage) since terminateCall is never
                // reached there at all.
                text = `${icon} Пропущений виклик`;
            }
            this.model?.createMessage({ message: text, type: 'info' });
        } catch (e) {
            console.warn('[ChatHeading] Could not write call-history entry:', e);
        }
        this._connectedAt = null;
        this._declinedByRemote = false;

        // Send session-terminate + JMI <finish> if we still have an active call
        if (sendTerminate && this.remoteFullJid && this.currentSid) {
            const sid = this.currentSid;
            const remote = this.remoteFullJid;
            console.log('[ChatHeading] Sending session-terminate + finish to', remote);

            // Jingle session-terminate IQ — fire-and-forget, no timeout
            try {
                const terminateIq = $iq({ type: 'set', to: remote, id: crypto.randomUUID().toLowerCase() })
                    .c('jingle', {
                        xmlns: NS_JINGLE,
                        action: 'session-terminate',
                        sid: sid,
                    })
                    .c('reason')
                    .c('success');
                api.send(terminateIq);
            } catch (e) {
                console.warn('[ChatHeading] Could not send session-terminate:', e);
            }

            // JMI <finish> message (Sonata extension — iOS/Android use this)
            try {
                const bareRemote = remote.split('/')[0];
                const finishMsg = $msg({ to: bareRemote, type: 'chat', id: crypto.randomUUID() })
                    .c('finish', { xmlns: NS_JINGLE_MSG, id: sid })
                    .c('reason', { xmlns: NS_JINGLE })
                    .c('success')
                    .up()
                    .up()
                    .up()
                    .c('store', { xmlns: 'urn:xmpp:hints' });
                api.send(finishMsg);
            } catch (e) {
                console.warn('[ChatHeading] Could not send finish:', e);
            }
        }

        if (this.pc) {
            console.log('[ChatHeading] Closing PeerConnection');
            this.pc.close();
            this.pc = null;
        }
        if (this.localStream) {
            this.localStream.getTracks().forEach((t) => t.stop());
            this.localStream = null;
        }
        const el = document.getElementById('sonata-audio-remote');
        if (el) {
            try { el.pause(); } catch (_) { /* no-op */ }
            el.srcObject = null;
            // A manual _switchSpeaker() pick (or the automatic headset
            // Hands-Free routing, _applyHeadsetSink) must not carry over into
            // the next call even if the OS default output changed meanwhile.
            // '' is the spec-defined "system default".
            if (typeof el.setSinkId === 'function') {
                el.setSinkId('').catch(() => {});
            }
            // Then drop the element itself. It used to be kept and reused
            // across calls; an <audio> still bound to a Bluetooth Hands-Free
            // output endpoint can keep the headset in call (HFP) mode after
            // hangup, so other tabs' stereo playback (YouTube) stays silent.
            // Destroying it releases the output stream; the next call's
            // ontrack handler creates a fresh one.
            try { el.remove(); } catch (_) { /* no-op */ }
        }
        this.currentSid = null;
        this.isIncoming = false;
        this.remoteFullJid = null;
        this._negotiatedOnce = false;
        this._iceRestartInFlight = false;
        if (ChatHeading.activeCall === this) {
            setActiveCall(null);
        }
        ChatHeading._hideCallPanel();
        console.log('=== [ChatHeading] Call terminated ===');
    }

    // ========================================================================
    // INCOMING CALL HANDLING (callee side)
    // ========================================================================

    /**
     * Static: called when <propose> arrives. Shows modal asking user to accept
     * or reject. If accepted, picks the matching ChatHeading instance (by JID)
     * and runs accept flow. If no chat is open for that contact, falls back to
     * using/creating a chat first.
     */
    static async handleIncomingPropose(fullFromJid, sid, media) {
        const bareFrom = fullFromJid?.split('/')[0];

        // Resolve display name — same approach as the call panel and ChatHeading template.
        // Try roster contact first, then chatbox model, then fall back to bare JID.
        let displayName = bareFrom;
        try {
            const contact = await api.contacts.get(bareFrom);
            if (contact) {
                displayName =
                    contact.get('nickname') ||
                    contact.get('fullname') ||
                    contact.get('name') ||
                    bareFrom;
            }
            // Also try an open chatbox model in case vcard is loaded there
            if (displayName === bareFrom) {
                const chatbox = _converse.state?.chatboxes?.get(bareFrom);
                if (chatbox) {
                    const fromModel = chatbox.getDisplayName?.();
                    if (fromModel && fromModel !== bareFrom) displayName = fromModel;
                }
            }
        } catch (e) {
            // non-fatal — fall back to bare JID
        }

        // The JMI <propose> stanza's human-readable text is nested inside a
        // push-notification payload, invisible to attrs.body (see
        // notifications/utils.js's handleIncomingCallNotification for why),
        // so the generic message-notification pipeline silently treats every
        // call invite as an empty message and never shows a desktop
        // notification for it -- even though this ringing modal (driven by
        // the raw stanza) displays fine. Trigger it directly here instead.
        api.trigger('incomingCall', { callerName: displayName, jid: bareFrom });

        // If there's already an active call, ask the user.
        if (ChatHeading.activeCall) {
            const confirmed = window.confirm(
                `Вхідний дзвінок від ${bareFrom}. У вас вже триває розмова. Завершити поточну та прийняти новий?`,
            );
            if (!confirmed) {
                // Auto-reject the new call. This branch never shows the
                // incoming-call modal (_showIncomingCallModal), which is the
                // only other place that fires 'incomingCallEnded' -- without
                // this, the notification triggered above (for every propose,
                // unconditionally) would never get dismissed, leaking a stuck
                // native notification every time a second call arrives while
                // one is already active.
                ChatHeading._sendJmiReject(fullFromJid, sid);
                api.trigger('incomingCallEnded');
                ChatHeading._writeMissedCallMessage(bareFrom);
                return;
            }
            // Terminate the current call before accepting new
            ChatHeading.activeCall.terminateCall();
        }

        // Track this pending incoming call so <retract> can cancel its modal.
        ChatHeading._pendingIncomingSid = sid;
        ChatHeading._pendingIncomingFrom = fullFromJid;

        const accepted = await ChatHeading._showIncomingCallModal(displayName, fullFromJid, sid, media);

        // Clear pending tracking
        if (ChatHeading._pendingIncomingSid === sid) {
            ChatHeading._pendingIncomingSid = null;
            ChatHeading._pendingIncomingFrom = null;
        }

        if (accepted === 'handled-elsewhere') {
            // Another of our own resources already answered (detected via
            // the Carbons copy of its <proceed>) -- don't send <reject>,
            // that would terminate the call that resource just proceeded
            // with. This resource's own chat history still gets an entry
            // though: we have definitive proof of what happened (that
            // Carbons copy), so there's no reason to leave this device's
            // history silently missing the call entirely just because it
            // wasn't the one that handled it.
            console.log('[ChatHeading] Call answered on another device — not sending reject');
            ChatHeading._writeCallHistoryEntry(bareFrom, '📞 Дзвінок прийнято на іншому пристрої');
            return;
        }

        if (!accepted) {
            console.log('[ChatHeading] User rejected incoming call');
            ChatHeading._sendJmiReject(fullFromJid, sid);
            // Covers both an explicit decline click and the modal's own 45s
            // timeout -- same convention as WhatsApp/Telegram, which don't
            // visually distinguish "you declined" from "you didn't answer in
            // time" on the receiving end, both just read as a missed call.
            ChatHeading._writeMissedCallMessage(bareFrom);
            return;
        }

        console.log('[ChatHeading] User accepted incoming call. Finding chat heading...');

        // Prefer an already-open chat heading in the DOM.
        let headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);

        if (!headingEl) {
            console.log('[ChatHeading] No open chat for', bareFrom, '— opening one');
            try {
                await api.chats.open(bareFrom);
                await new Promise((r) => setTimeout(r, 200));
                headingEl = document.querySelector(`converse-chat-heading[jid="${bareFrom}"]`);
            } catch (e) {
                console.warn('[ChatHeading] Could not open chat:', e);
            }
        }

        if (!headingEl) {
            // No DOM element — create a detached ghost instance so the call works
            // regardless of which chat window is currently open.
            console.log('[ChatHeading] Using ghost ChatHeading instance for call (no DOM heading)');
            headingEl = new ChatHeading();
            headingEl.jid = bareFrom;
            try {
                const chatbox = _converse.state?.chatboxes?.get(bareFrom);
                if (chatbox) headingEl.model = chatbox;
            } catch (_) {}
        }

        await headingEl.acceptIncomingCall(fullFromJid, sid, media);
    }

    /**
     * Formats a call duration like other messengers: M:SS, or H:MM:SS past
     * an hour.
     * @param {number} ms
     */
    static _formatCallDuration(ms) {
        const totalSeconds = Math.max(0, Math.round(ms / 1000));
        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = totalSeconds % 60;
        const mm = h > 0 ? String(m).padStart(2, '0') : String(m);
        const ss = String(s).padStart(2, '0');
        return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
    }

    /**
     * Writes a single "Пропущений виклик" (missed call) entry -- covers
     * every incoming-call outcome where we never actually connected:
     * explicit decline, the modal's own 45s timeout, the caller retracting
     * first (resolves the same modal promise to false, converging on the
     * same call site), and auto-rejecting a second call while already busy.
     * Matches WhatsApp/Telegram's convention of a single call-history entry
     * per call rather than a running log of ringing/accepted states, and of
     * not visually distinguishing "declined" from "didn't answer in time"
     * on the receiving end. Opens the chat if it isn't already, same as the
     * accepted path, so a missed call surfaces in the chat list even with
     * no prior conversation -- matching how every mainstream messenger
     * handles this.
     * @param {string} bareFrom
     */
    static async _writeMissedCallMessage(bareFrom) {
        await ChatHeading._writeCallHistoryEntry(bareFrom, '📞 Пропущений виклик');
    }

    /**
     * Writes an arbitrary call-history entry to the chat with bareFrom,
     * opening it first if it isn't already (so a call that's the first-ever
     * contact with someone still surfaces in the chat list, matching
     * standard messenger behavior). Shared by _writeMissedCallMessage and
     * the "answered on another of your own devices" case.
     * @param {string} bareFrom
     * @param {string} message
     */
    static async _writeCallHistoryEntry(bareFrom, message) {
        try {
            let chatbox = _converse.state?.chatboxes?.get(bareFrom);
            if (!chatbox) {
                await api.chats.open(bareFrom);
                chatbox = _converse.state?.chatboxes?.get(bareFrom);
            }
            chatbox?.createMessage({ message, type: 'info' });
        } catch (e) {
            console.warn('[ChatHeading] Could not write call-history entry:', e);
        }
    }

    /**
     * Static: <retract> arrived — caller cancelled before we picked up.
     * Close the modal if it's showing for this sid.
     */
    static handleRetract(sid) {
        if (ChatHeading._pendingIncomingSid === sid && ChatHeading._closeIncomingModal) {
            console.log('[ChatHeading] Closing incoming-call modal (caller retracted)');
            ChatHeading._closeIncomingModal(false);
        }
    }

    /**
     * Static: <accept> arrived from one of our own other resources -- it
     * already answered this call (see acceptIncomingCall's self-addressed
     * <accept> send). Close the modal WITHOUT sending <reject>, since the
     * call is proceeding on that resource and a reject here would terminate
     * it for the caller.
     */
    static handleAcceptedElsewhere(sid) {
        if (ChatHeading._pendingIncomingSid === sid && ChatHeading._closeIncomingModal) {
            console.log('[ChatHeading] Closing incoming-call modal (answered on another device)');
            ChatHeading._closeIncomingModal('handled-elsewhere');
        }
    }

    /**
     * Static helper: send JMI <reject> message.
     */
    static _sendJmiReject(toFullJid, sid) {
        // Same reasoning as <proceed> below: the propose came from the
        // caller's specific FULL JID (resource), and per XEP-0353 our
        // response needs to go back to that same resource -- sending to the
        // bare JID lets the server fan it out to (or land on) any resource
        // of theirs, not necessarily the one that's actually ringing/waiting.
        const msg = $msg({ to: toFullJid, type: 'chat', id: crypto.randomUUID() })
            .c('reject', { xmlns: NS_JINGLE_MSG, id: sid })
            .up()
            .c('store', { xmlns: 'urn:xmpp:hints' });
        api.send(msg);
        console.log('[ChatHeading] Sent JMI reject for sid', sid, 'to FULL JID=', toFullJid);
    }

    /**
     * Static: builds the incoming-call modal. Returns a Promise<boolean>:
     * true=accepted, false=rejected/closed.
     */
    static _showIncomingCallModal(callerName, fullFromJid, sid, media) {
        return new Promise((resolve) => {
            ChatHeading._ensureCallStyles();

            const overlay = document.createElement('div');
            overlay.id = 'sonata-callpanel';
            overlay.className = 'sonata-callpanel';
            overlay.innerHTML = `
                <div class="sonata-callpanel-info">
                    <div class="sonata-callpanel-dot sonata-callpanel-dot--ringing"></div>
                    <div class="sonata-callpanel-text">
                        <div class="sonata-callpanel-name">${callerName}</div>
                        <div class="sonata-callpanel-timer">Вхідний ${media === 'video' ? 'відео' : 'аудіо'} дзвінок</div>
                    </div>
                </div>
                <div class="sonata-callpanel-controls">
                    <div class="sonata-callpanel-btn-group">
                        <button class="sonata-callpanel-iconbtn" id="sonata-incoming-reject"
                            title="Відхилити">${ICON_HANGUP_SVG}</button>
                        <span class="sonata-callpanel-btn-label">Відхилити</span>
                    </div>
                    <div class="sonata-callpanel-btn-group">
                        <button class="sonata-callpanel-iconbtn" id="sonata-incoming-accept"
                            title="Прийняти">${ICON_ACCEPT_SVG}</button>
                        <span class="sonata-callpanel-btn-label">Прийняти</span>
                    </div>
                </div>
            `;
            document.body.appendChild(overlay);

            // Play ringtone via Web Audio (simple beeping). Skip if AudioContext unavailable.
            let ringInterval = null;
            try {
                const ctx = new (window.AudioContext || window.webkitAudioContext)();
                const beep = () => {
                    const osc = ctx.createOscillator();
                    const gain = ctx.createGain();
                    osc.frequency.value = 480;
                    gain.gain.value = 0.08;
                    osc.connect(gain).connect(ctx.destination);
                    osc.start();
                    setTimeout(() => osc.stop(), 400);
                };
                beep();
                ringInterval = setInterval(beep, 1500);
            } catch { /* no-op */ }

            const cleanup = (result) => {
                if (ringInterval) clearInterval(ringInterval);
                if (overlay.parentElement) overlay.parentElement.removeChild(overlay);
                ChatHeading._closeIncomingModal = null;
                // Single chokepoint for every way this modal can close (user
                // accepted/rejected, caller retracted, answered on another
                // device, or the 45s auto-reject) -- also dismiss the native
                // OS notification (see notifications/utils.js), which
                // otherwise stays stuck ("requireInteraction: true") and was
                // observed stacking into multiple phantom "Incoming call"
                // toasts across repeated calls.
                api.trigger('incomingCallEnded');
                resolve(result);
            };

            // Expose closer so retract can cancel the modal externally
            ChatHeading._closeIncomingModal = cleanup;

            document.getElementById('sonata-incoming-accept').addEventListener('click', () => cleanup(true));
            document.getElementById('sonata-incoming-reject').addEventListener('click', () => cleanup(false));

            // Auto-reject after 45s (typical ring timeout)
            setTimeout(() => {
                if (overlay.parentElement) cleanup(false);
            }, 45000);
        });
    }

    /**
     * Instance: user accepted the incoming-call modal. Pre-warm mic, send
     * <proceed>, mark this instance as the active call, and wait for the
     * remote's session-initiate.
     */
    async acceptIncomingCall(fullFromJid, sid, media) {
        console.log('[ChatHeading] >>> acceptIncomingCall', { fullFromJid, sid, media });

        // Pre-warm microphone BEFORE sending <proceed>.
        // If we send proceed first, the caller immediately sends session-initiate.
        // getUserMedia prompt can take seconds on first use — causing session-initiate
        // to arrive before pc is created. Get mic first, then proceed.
        const needsVideo = media === 'video';
        try {
            console.log(`[ChatHeading] Pre-warming media (audio${needsVideo ? '+video' : ''}) before sending proceed...`);
            this.localStream = await ChatHeading._getUserMediaDefaultAudio(needsVideo);
            console.log('[ChatHeading] Media ready for incoming call, tracks:', this.localStream.getTracks().map(t => t.kind));
        } catch (err) {
            console.error('[ChatHeading] Media permission denied for incoming call:', err);
            if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
                showToast(`Доступ до ${needsVideo ? 'камери/мікрофона' : 'мікрофона'} заборонено`, 'error');
            } else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
                showToast(`${needsVideo ? 'Камера або мікрофон' : 'Мікрофон'} не знайдено`, 'error');
            } else {
                showToast('Не вдалося отримати доступ до медіапристроїв', 'error');
            }
            ChatHeading._sendJmiReject(fullFromJid, sid);
            return;
        }

        this.isIncoming = true;
        this.isVideo = needsVideo;
        this.remoteFullJid = fullFromJid;
        this.currentSid = sid;
        setActiveCall(this);

        // Send JMI <proceed> to the caller's FULL JID (including resource).
        // The original propose came from their full JID — we must reply to it.
        // Sending to bare JID means the server can't route session-initiate back
        // to us because the caller doesn't know which resource accepted.
        const proceedId = crypto.randomUUID();
        const proceedMsg = $msg({ to: fullFromJid, type: 'chat', id: proceedId })
            .c('origin-id', { xmlns: 'urn:xmpp:sid:0', id: proceedId })
            .up()
            .c('proceed', { xmlns: NS_JINGLE_MSG, id: sid })
            .up()
            .c('store', { xmlns: 'urn:xmpp:hints' });
        api.send(proceedMsg);
        console.log('[ChatHeading] Sent JMI proceed sid=', sid,
            'to FULL JID=', fullFromJid,
            '| our full JID:', _converse.jid);

        // NOTE: a self-addressed <accept> used to be sent here as well, to
        // tell our own other resources to stop ringing. Removed -- it was
        // redundant (the isOwnCarbon + <proceed> detection in the message
        // listener below already covers the same case via this server's
        // existing Carbons support, independently verified working) and it
        // was the only genuinely new wire-level message type introduced by
        // the multi-resource-ringing fix: a message addressed to one's own
        // bare JID, which is exactly the kind of edge case some XMPP server
        // ack-tracking/offline-queue implementations handle poorly. Observed
        // this exact self-<accept> stanza caught up in a server-side resend
        // storm (the same loop was also resending unrelated chat-state
        // stanzas, so the storm itself isn't call-specific) -- removing the
        // one new self-message type this feature added is the safest
        // response available without server-side visibility, and costs
        // nothing functionally since the carbon-based path already handles
        // this on its own. If the storm persists after this, it's
        // conclusively unrelated to anything this call feature sends.
        // (Incoming <accept> is still handled by handleAcceptedElsewhere
        // below, for compat with any other client/platform that does send
        // it per XEP-0353 -- only our own sending of it is removed.)

        // No interim "accepted" chat message -- see initiateCall's matching
        // comment; the chat log only gets one entry once the call's outcome
        // (duration, or missed) is known, in terminateCall.
        // Now we wait for session-initiate via the Strophe handler → handleSessionInitiate().
    }

    /**
     * Instance: <session-initiate> arrived from remote (caller). We are the
     * callee. Create pc, add tracks, set remote offer SDP, create answer,
     * send session-accept.
     */
    async handleSessionInitiate(fullFromJid, sid, jingle) {
        console.log('[ChatHeading] >>> handleSessionInitiate', { fullFromJid, sid });
        this.iceCandidatesQueue = [];
        this.remoteFullJid = fullFromJid;
        this.currentSid = sid;
        this.isIncoming = true;

        // Detect video from raw Jingle XML
        this.isVideo = getJingleRtpContents(jingle).some(c =>
            firstDirectChild(c, 'description')?.getAttribute('media') === 'video'
        );

        try {
            if (!this.localStream) {
                console.log('[ChatHeading] No stream yet, requesting media (isVideo:', this.isVideo, ')...');
                this.localStream = await ChatHeading._getUserMediaDefaultAudio(this.isVideo);
            }

            const iceServers2 = await ChatHeading._getIceServers();
            this.pc = new RTCPeerConnection({ iceServers: iceServers2, bundlePolicy: 'max-compat', rtcpMuxPolicy: 'require' });

            this.pc.oniceconnectionstatechange = () => {
                console.log(`%c [ICE] state=${this.pc.iceConnectionState} `, 'color: orange; font-weight: bold;');
                if (this.pc.iceConnectionState === 'failed' || this.pc.iceConnectionState === 'disconnected') {
                    ChatHeading._dumpIcePairs(this.pc, this.pc.iceConnectionState + ' (incoming)');
                    if (this.pc.iceConnectionState === 'failed' && this.pc.signalingState === 'stable' && this.pc.restartIce) {
                        this.pc.restartIce();
                    }
                }
                if (this.pc.iceConnectionState === 'connected') {
                    console.log('%c [ICE] ✅ CONNECTED (incoming) ', 'background: green; color: white;');
                    ChatHeading._showCallPanel(this);
                    ChatHeading._requestKeyframeAndPollVideo(this.pc);
                }
            };
            this.pc.onconnectionstatechange = () => console.log(`[PC] connectionState=${this.pc.connectionState}`);
            this.pc.onicecandidateerror = (ev) => {
                console.warn(`[ICE ERROR] url=${ev.url} code=${ev.errorCode} text="${ev.errorText}" address=${ev.address}:${ev.port}`);
            };
            this.pc.onsignalingstatechange = () => console.log(`[PC] signalingState=${this.pc.signalingState}`);

            // See sendJingleInitiate's identical wiring for why this is a no-op
            // until the initial offer/answer (below) has completed.
            this.pc.onnegotiationneeded = () => this._renegotiateIceRestart();

            this.pc.ontrack = (event) => {
                console.log('[ChatHeading] Remote track received (incoming) kind=', event.track.kind);
                const stream = event.streams?.[0] || new MediaStream([event.track]);
                if (event.track.kind === 'audio') {
                    let el = document.getElementById('sonata-audio-remote') || document.createElement('audio');
                    el.id = 'sonata-audio-remote'; el.autoplay = true;
                    if (!el.parentElement) document.body.appendChild(el);
                    // Pick the headset's Hands-Free output first (no-op unless
                    // Windows + a Hands-Free mic), then start playback.
                    ChatHeading._applyHeadsetSink(el, this.localStream).then(() => {
                        el.srcObject = stream;
                    });
                } else if (event.track.kind === 'video') {
                    ChatHeading._attachRemoteVideo(stream);
                }
            };

            this.pc.onicecandidate = (event) => {
                if (!event.candidate) return;
                const c = event.candidate;
                const localSdp = this.pc.localDescription?.sdp || '';
                const localUfrag = (localSdp.match(/a=ice-ufrag:(.*)\r/) || [])[1] || '';
                const localPwd = (localSdp.match(/a=ice-pwd:(.*)\r/) || [])[1] || '';
                const attrs = {
                    id: String(Math.floor(Math.random() * 4294967295)),
                    // 'rtp'/'rtcp' → numeric per XEP-0176 (iOS rejects "rtp")
                    component: c.component === 'rtcp' ? '2' : '1', foundation: c.foundation,
                    generation: '0', ip: c.address || c.ip, port: String(c.port),
                    priority: String(c.priority), protocol: (c.protocol || 'udp').toLowerCase(), type: c.type,
                };
                if (c.relatedAddress) attrs['rel-addr'] = c.relatedAddress;
                if (c.relatedPort) attrs['rel-port'] = String(c.relatedPort);
                // Per-mid content name + creds (max-compat: own transport per m-line)
                const candMid = c.sdpMid != null ? String(c.sdpMid) : '0';
                const candIce = getLocalIceForMid(localSdp, candMid);
                const iq = $iq({ type: 'set', to: fullFromJid, id: crypto.randomUUID().toLowerCase() })
                    .c('jingle', { xmlns: NS_JINGLE, action: 'transport-info', initiator: fullFromJid, responder: _converse.jid, sid })
                    .c('content', { creator: 'initiator', name: candMid })
                    .c('transport', {
                        xmlns: NS_JINGLE_ICE,
                        ufrag: candIce.ufrag || localUfrag || c.usernameFragment || '',
                        pwd: candIce.pwd || localPwd || '',
                    })
                    .c('candidate', attrs);
                api.send(iq);
            };

            this.localStream.getTracks().forEach(t => this.pc.addTrack(t, this.localStream));

            // Build remote offer SDP from Jingle XML — handles Android, iOS, all clients correctly
            const remoteOfferSdp = buildSdpFromJingle(jingle, 'offer');
            console.log('[ChatHeading] Setting remote OFFER SDP:\n', remoteOfferSdp);
            await this.pc.setRemoteDescription(new RTCSessionDescription({ type: 'offer', sdp: remoteOfferSdp }));

            const answer = await this.pc.createAnswer();
            await this.pc.setLocalDescription(answer);
            console.log('[ChatHeading] 📋 LOCAL ANSWER SDP:\n', this.pc.localDescription.sdp);

            // Flush queued candidates
            while (this.iceCandidatesQueue.length > 0) {
                this.pc.addIceCandidate(this.iceCandidatesQueue.shift()).catch(e => console.warn('Queued cand failed:', e));
            }

            // Build session-accept IQ from our local answer SDP (mirrors what browser negotiated)
            // Track the mid order from the remote offer so our accept uses the same order
            const contents = getJingleRtpContents(jingle);
            const remoteOfferMidOrder = contents.map((c, i) => c.getAttribute('name') || String(i));
            const contentCreatorsByMid = new Map(remoteOfferMidOrder.map(mid => [mid, 'initiator']));

            const acceptIq = buildJingleIqFromLocalSdp({
                action: 'session-accept',
                to: fullFromJid, sid,
                initiator: fullFromJid, responder: _converse.jid,
                localSdp: this.pc.localDescription.sdp,
                contentCreatorsByMid,
                preferredMidOrder: remoteOfferMidOrder,
            });

            console.log('[ChatHeading] 📤 session-accept XML:\n', acceptIq.toString());
            api.send(acceptIq);
            // Initial offer/answer is done — a later onnegotiationneeded (from
            // restartIce() after a mid-call ICE disconnect) is now safe to act on.
            this._negotiatedOnce = true;
            console.log('[ChatHeading] >>> handleSessionInitiate DONE (session-accept sent, isVideo:', this.isVideo, ')');
        } catch (err) {
            console.error('[ChatHeading] handleSessionInitiate error:', err);
            console.error('[ChatHeading] Stack:', err?.stack);
        }
    }


        // ========================================================================
    // CALL PANEL UI
    // ========================================================================

    /**
     * Static: show "calling..." panel while waiting for remote to answer.
     * Replaced by _showCallPanel once ICE connects.
     */
    /**
     * Inject the shared call-UI stylesheet (ringing overlays + the connected
     * status bar) exactly once. All call surfaces call this instead of each
     * injecting their own <style id="..."> — previously the outgoing panel
     * and the connected bar both guarded on the same tag id, so whichever
     * ran first "won" and the other's CSS silently never applied.
     */
    static _ensureCallStyles() {
        if (document.getElementById('sonata-call-style')) return;
        const style = document.createElement('style');
        style.id = 'sonata-call-style';
        style.textContent = `
            @keyframes sonata-fade-in { from { opacity: 0; } to { opacity: 1; } }
            @keyframes sonata-panel-slide {
                from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
                to   { opacity: 1; transform: translateX(-50%) translateY(0); }
            }
            @keyframes sonata-dot-pulse {
                0%   { box-shadow: 0 0 0 0 rgba(30,150,82,0.6); }
                70%  { box-shadow: 0 0 0 8px rgba(30,150,82,0); }
                100% { box-shadow: 0 0 0 0 rgba(30,150,82,0); }
            }
            @keyframes sonata-dot-pulse-ringing {
                0%   { box-shadow: 0 0 0 0 rgba(245,158,11,0.6); }
                70%  { box-shadow: 0 0 0 8px rgba(245,158,11,0); }
                100% { box-shadow: 0 0 0 0 rgba(245,158,11,0); }
            }

            /* Call status bar — shared by the connected call and the
               outgoing/incoming ringing state: 70% width, centered, floating
               from the header. */
            .sonata-callpanel {
                position: fixed; top: 0; left: 50%; width: 70%; transform: translateX(-50%);
                box-sizing: border-box;
                z-index: 99998; background: #101A33; color: #E8F0FF;
                padding: 8px 24px;
                display: flex; align-items: center; justify-content: space-between; gap: 16px;
                box-shadow: 0 4px 24px rgba(0,0,0,0.45);
                border-radius: 0 0 20px 20px;
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
                animation: sonata-panel-slide 0.3s cubic-bezier(.22,.68,0,1.2);
            }
            .sonata-callpanel-dot {
                width: 10px; height: 10px; border-radius: 50%; background: #1e9652;
                box-shadow: 0 0 0 0 rgba(30,150,82,0.6);
                animation: sonata-dot-pulse 1.5s ease-out infinite; flex-shrink: 0;
            }
            .sonata-callpanel-dot--ringing {
                background: #f59e0b; animation-name: sonata-dot-pulse-ringing;
            }
            .sonata-callpanel-info { display: flex; align-items: center; gap: 10px; min-width: 0; flex: 1; }
            .sonata-callpanel-text { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
            .sonata-callpanel-name-row { display: flex; align-items: center; gap: 14px; min-width: 0; }
            .sonata-callpanel-name {
                font-size: 14px; font-weight: 600; color: #E8F0FF;
                white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px;
            }
            /* Small voice-reactive equalizer next to the name, driven frame-
               by-frame by _startMicVisualizer once the call is connected
               (see there) -- styled after Telegram/music-app playback bars,
               not the call's status dot (which stays a plain static
               indicator). Hidden until JS adds --active, so it's invisible
               if the visualizer can't start (e.g. no mic track yet). Sits
               near-flat at rest and only becomes clearly lively once actual
               sound crosses the silence threshold in _startMicVisualizer. */
            .sonata-callpanel-eq {
                display: none; align-items: flex-end; gap: 3px; height: 22px; flex-shrink: 0;
                margin-left: 2px;
            }
            .sonata-callpanel-eq.sonata-callpanel-eq--active { display: inline-flex; }
            .sonata-callpanel-eq-bar {
                width: 4px; min-height: 2px; border-radius: 2px;
                background: rgb(154 185 255);
                transition: height 0.12s ease-out, box-shadow 0.25s ease-out;
            }
            .sonata-callpanel-eq.sonata-callpanel-eq--talking .sonata-callpanel-eq-bar {
                box-shadow: 0 0 5px rgba(154, 185, 255, 0.85);
            }
            .sonata-callpanel-timer {
                font-size: 13px; color: #B0CBFF; font-variant-numeric: tabular-nums; letter-spacing: 0.03em;
            }
            .sonata-callpanel-controls { display: flex; align-items: center; gap: 16px; flex-shrink: 0; }
            .sonata-callpanel-btn-group {
                position: relative; display: flex; flex-direction: column; align-items: center; gap: 4px;
            }
            .sonata-callpanel-btn-label {
                font-size: 11px; color: #B0CBFF; cursor: pointer; user-select: none; white-space: nowrap;
            }
            .sonata-callpanel-btn-label:hover { color: #E8F0FF; }
            .sonata-callpanel-iconbtn {
                background: none; border: none; padding: 0; margin: 0; cursor: pointer;
                display: inline-flex; line-height: 0; flex-shrink: 0;
                transition: transform 0.15s;
            }
            .sonata-callpanel-iconbtn:hover { transform: scale(1.05); }
            .sonata-callpanel-iconbtn svg { display: block; }
            .sonata-callpanel-menu {
                position: absolute; top: calc(100% + 8px); left: 50%; transform: translateX(-50%);
                background: #1b2a4d; border-radius: 10px; padding: 6px; min-width: 220px;
                box-shadow: 0 4px 20px rgba(0,0,0,0.5); z-index: 100000;
            }
            .sonata-callpanel-menu-item {
                padding: 8px 10px; border-radius: 6px; font-size: 13px; color: #E8F0FF;
                cursor: pointer; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
            }
            .sonata-callpanel-menu-item:hover { background: rgba(154,185,255,0.12); }
            .sonata-callpanel-menu-item {
                display: flex; align-items: center; gap: 8px;
            }
            .sonata-callpanel-menu-item__check {
                flex: 0 0 auto; width: 1em; color: #9AB9FF; font-weight: bold;
            }
            .sonata-callpanel-menu-item--active {
                background: rgba(154,185,255,0.08); font-weight: 600;
            }
        `;
        document.head.appendChild(style);
    }

    static _showOutgoingCallPanel(instance) {
        ChatHeading._hideCallPanel();
        ChatHeading._ensureCallStyles();

        const displayName = instance.model?.getDisplayName?.() ||
            instance.model?.get('jid') || '...';

        const panel = document.createElement('div');
        panel.id = 'sonata-callpanel';
        panel.className = 'sonata-callpanel';
        panel.innerHTML = `
            <div class="sonata-callpanel-info">
                <div class="sonata-callpanel-dot sonata-callpanel-dot--ringing"></div>
                <div class="sonata-callpanel-text">
                    <div class="sonata-callpanel-name">${displayName}</div>
                    <div class="sonata-callpanel-timer" id="sonata-callpanel-timer">Виклик</div>
                </div>
            </div>
            <div class="sonata-callpanel-controls">
                <div class="sonata-callpanel-btn-group">
                    <button class="sonata-callpanel-iconbtn" id="sonata-callpanel-mute"
                        title="Вимкнути мікрофон">${ICON_MIC_SVG}</button>
                    <span class="sonata-callpanel-btn-label" id="sonata-callpanel-mic-label">Мікрофон</span>
                    <div class="sonata-callpanel-menu" id="sonata-callpanel-mic-menu" hidden></div>
                </div>
                <div class="sonata-callpanel-btn-group">
                    <button class="sonata-callpanel-iconbtn" id="sonata-callpanel-speaker-btn"
                        title="Змінити динамік">${ICON_SPEAKER_SVG}</button>
                    <span class="sonata-callpanel-btn-label" id="sonata-callpanel-speaker-label">Динамік</span>
                    <div class="sonata-callpanel-menu" id="sonata-callpanel-speaker-menu" hidden></div>
                </div>
                <div class="sonata-callpanel-btn-group">
                    <button class="sonata-callpanel-iconbtn" id="sonata-ringing-cancel"
                        title="Скасувати дзвінок">${ICON_HANGUP_SVG}</button>
                    <span class="sonata-callpanel-btn-label" id="sonata-ringing-cancel-label">Скасувати</span>
                </div>
            </div>
        `;
        document.body.appendChild(panel);

        // Animated dots on "Виклик..." + ringback tone (bi-bi every 4s, like UA PSTN)
        const timerEl = panel.querySelector('#sonata-callpanel-timer');
        let dots = 0;
        ChatHeading._callTimerInterval = setInterval(() => {
            dots = (dots + 1) % 4;
            if (timerEl) timerEl.textContent = 'Виклик' + '.'.repeat(dots);
        }, 600);

        // Ringback: two short 440Hz beeps every 4 seconds
        let _ringCtx = null;
        try { _ringCtx = new (window.AudioContext || window.webkitAudioContext)(); } catch { /* no audio */ }
        const _playRingback = () => {
            if (!_ringCtx || !document.getElementById('sonata-callpanel')) return;
            const beep = (offset) => {
                const osc = _ringCtx.createOscillator();
                const g = _ringCtx.createGain();
                osc.frequency.value = 440;
                g.gain.value = 0.06;
                osc.connect(g).connect(_ringCtx.destination);
                osc.start(_ringCtx.currentTime + offset);
                osc.stop(_ringCtx.currentTime + offset + 0.4);
            };
            beep(0); beep(0.6);
        };
        _playRingback();
        ChatHeading._ringbackInterval = setInterval(_playRingback, 4000);

        setTimeout(() => {
            const muteBtn = panel.querySelector('#sonata-callpanel-mute');
            if (muteBtn) muteBtn.addEventListener('click', () => ChatHeading._toggleMute(instance));

            const micLabel = panel.querySelector('#sonata-callpanel-mic-label');
            const micMenu = document.getElementById('sonata-callpanel-mic-menu');
            const speakerBtn = panel.querySelector('#sonata-callpanel-speaker-btn');
            const speakerLabel = panel.querySelector('#sonata-callpanel-speaker-label');
            const speakerMenu = document.getElementById('sonata-callpanel-speaker-menu');

            const toggleMenu = async (menuEl, otherMenuEl, kind, onSelect) => {
                const opening = menuEl.hidden;
                if (otherMenuEl) otherMenuEl.hidden = true;
                if (opening) await ChatHeading._populateDeviceMenu(menuEl, kind, onSelect);
                menuEl.hidden = !opening;
            };

            if (micLabel && micMenu) {
                micLabel.addEventListener('click', (ev) => {
                    ev.stopPropagation();
                    toggleMenu(micMenu, speakerMenu, 'audioinput',
                        (deviceId) => ChatHeading._switchMicrophone(instance, deviceId));
                });
            }

            if (speakerMenu) {
                const openSpeakerMenu = (ev) => {
                    ev.stopPropagation();
                    toggleMenu(speakerMenu, micMenu, 'audiooutput',
                        (deviceId) => ChatHeading._switchSpeaker(deviceId));
                };
                speakerBtn?.addEventListener('click', openSpeakerMenu);
                speakerLabel?.addEventListener('click', openSpeakerMenu);
            }

            document.addEventListener('click', () => {
                if (micMenu) micMenu.hidden = true;
                if (speakerMenu) speakerMenu.hidden = true;
            });

            const doCancel = () => {
                console.log('[ChatHeading] User cancelled outgoing call');
                const t = ChatHeading.activeCall;
                if (t) {
                    const jid = t.model?.get('jid');
                    if (jid && t.currentSid) {
                        const retractMsg = $msg({ to: jid, type: 'chat', id: crypto.randomUUID() })
                            .c('retract', { xmlns: NS_JINGLE_MSG, id: t.currentSid })
                            .up()
                            .c('store', { xmlns: 'urn:xmpp:hints' });
                        api.send(retractMsg);
                        console.log('[ChatHeading] Sent JMI retract for sid', t.currentSid);
                    }
                    t.terminateCall(false);
                }
            };
            panel.querySelector('#sonata-ringing-cancel')?.addEventListener('click', doCancel);
            panel.querySelector('#sonata-ringing-cancel-label')?.addEventListener('click', doCancel);
        }, 100);
    }

    /**
     * Static: show active call panel with timer and hang-up button.
     * Called when ICE reaches 'connected' state.
     */
    static _showCallPanel(instance) {
        // Marks the call as having actually connected -- terminateCall uses
        // this to decide between a duration-based outcome message and a
        // missed/no-answer/declined one. Only set once (ICE can reconnect
        // after a transient drop without this re-firing _showCallPanel from
        // scratch in the normal case, but guard anyway since re-entering
        // here should never reset an already-ticking call's duration).
        if (!instance._connectedAt) instance._connectedAt = Date.now();

        // Save any queued remote video stream before _hideCallPanel clears it
        const savedRemoteStream = ChatHeading._pendingRemoteVideoStream;
        ChatHeading._hideCallPanel();
        // Restore it so PiP creation below can flush it
        if (savedRemoteStream) {
            ChatHeading._pendingRemoteVideoStream = savedRemoteStream;
        }

        ChatHeading._ensureCallStyles();

        // NOTE: an output-side mirror of the mic auto-preference below (auto
        // setSinkId to a connected Bluetooth headset) was tried here and
        // reverted -- confirmed (user tested Zoom/Teams/Discord as a control
        // and got a clean "no") that it caused other tabs/apps to lose audio
        // on these headphones after a Sonata call ended, while the same
        // headphones were unaffected after calls in those other apps.
        // Chromium's audio service is shared across all tabs in one browser
        // process; explicitly routing our one <audio> element to a specific
        // physical output device is far more likely to contend with another
        // tab's playback on that same device than the mic side is, since
        // getUserMedia capture is exclusive to our own stream and never
        // shares a device with another tab's rendering path the way output
        // sink selection does. Manual speaker switching (the existing device
        // picker in the call panel) is unaffected -- only the automatic
        // on-connect preference is removed.

        const displayName = instance.model?.getDisplayName?.() ||
            instance.remoteFullJid?.split('/')[0] || 'Unknown';

        // Inject PiP CSS separately from panel CSS so it's not blocked
        // by the outgoing call panel having already injected sonata-callpanel-style
        if (instance.isVideo && !document.getElementById('sonata-pip-style')) {
            const pipStyle = document.createElement('style');
            pipStyle.id = 'sonata-pip-style';
            pipStyle.textContent = `
                .sonata-video-pip {
                    position: fixed !important; bottom: 24px !important; right: 24px !important;
                    z-index: 999999 !important;
                    width: 320px !important; height: 180px !important;
                    border-radius: 16px; overflow: hidden;
                    box-shadow: 0 8px 32px rgba(0,0,0,0.6);
                    background: #111 !important;
                    display: block !important; visibility: visible !important;
                }
                .sonata-video-pip video {
                    display: block !important; visibility: visible !important;
                }
                .sonata-video-pip video#sonata-video-remote {
                    position: absolute !important; inset: 0 !important;
                    width: 100% !important; height: 100% !important;
                    object-fit: cover; background: #222;
                }
                .sonata-video-pip video#sonata-video-local {
                    position: absolute !important; bottom: 8px !important; right: 8px !important;
                    width: 80px !important; height: 60px !important;
                    border-radius: 8px; object-fit: cover;
                    border: 2px solid rgba(255,255,255,0.8);
                    background: #333; z-index: 1 !important;
                }
                .sonata-video-pip.sonata-video-pip--expanded {
                    width: 640px !important; height: 360px !important;
                    max-width: min(640px, 92vw) !important;
                    max-height: min(360px, 80vh) !important;
                }
                .sonata-video-pip.sonata-video-pip--expanded video#sonata-video-local {
                    width: 160px !important; height: 120px !important;
                    bottom: 16px !important; right: 16px !important;
                }
                .sonata-pip-expand-btn {
                    position: absolute !important; top: 8px !important; right: 8px !important;
                    width: 28px !important; height: 28px !important;
                    border-radius: 50% !important; border: none !important;
                    background: rgba(0,0,0,0.55) !important;
                    display: flex !important; align-items: center !important; justify-content: center !important;
                    cursor: pointer !important; padding: 0 !important; z-index: 2 !important;
                    transition: background 0.15s ease;
                }
                .sonata-pip-expand-btn:hover { background: rgba(0,0,0,0.75) !important; }
                .sonata-pip-expand-btn svg {
                    width: 16px !important; height: 16px !important; display: block !important;
                }
            `;
            document.head.appendChild(pipStyle);
            console.log('[ChatHeading] PiP CSS injected ✅');
        }

        // Audio call panel (always shown at top)
        const panel = document.createElement('div');
        panel.id = 'sonata-callpanel';
        panel.className = 'sonata-callpanel';
        panel.innerHTML = `
            <div class="sonata-callpanel-info">
                <div class="sonata-callpanel-dot"></div>
                <div class="sonata-callpanel-text">
                    <div class="sonata-callpanel-name-row">
                        <div class="sonata-callpanel-name">${instance.isVideo ? '📹 ' : ''}${displayName}</div>
                        <span class="sonata-callpanel-eq" id="sonata-callpanel-eq">
                            <span class="sonata-callpanel-eq-bar"></span><span class="sonata-callpanel-eq-bar"></span><span class="sonata-callpanel-eq-bar"></span><span class="sonata-callpanel-eq-bar"></span>
                        </span>
                    </div>
                    <div class="sonata-callpanel-timer" id="sonata-callpanel-timer">00:00</div>
                </div>
            </div>
            <div class="sonata-callpanel-controls">
                <div class="sonata-callpanel-btn-group">
                    <button class="sonata-callpanel-iconbtn" id="sonata-callpanel-mute"
                        title="Вимкнути мікрофон">${ICON_MIC_SVG}</button>
                    <span class="sonata-callpanel-btn-label" id="sonata-callpanel-mic-label">Мікрофон</span>
                    <div class="sonata-callpanel-menu" id="sonata-callpanel-mic-menu" hidden></div>
                </div>
                <div class="sonata-callpanel-btn-group">
                    <button class="sonata-callpanel-iconbtn" id="sonata-callpanel-speaker-btn"
                        title="Змінити динамік">${ICON_SPEAKER_SVG}</button>
                    <span class="sonata-callpanel-btn-label" id="sonata-callpanel-speaker-label">Динамік</span>
                    <div class="sonata-callpanel-menu" id="sonata-callpanel-speaker-menu" hidden></div>
                </div>
                <div class="sonata-callpanel-btn-group">
                    <button class="sonata-callpanel-iconbtn" id="sonata-callpanel-hangup"
                        title="Завершити дзвінок">${ICON_HANGUP_SVG}</button>
                    <span class="sonata-callpanel-btn-label" id="sonata-callpanel-hangup-label">Завершити</span>
                </div>
            </div>
        `;
        document.body.appendChild(panel);

        // Glow the status dot with real mic input level instead of the
        // fixed-period idle pulse, now that there's an actual call to react to.
        ChatHeading._startMicVisualizer(instance);

        // Video PiP overlay (only for video calls)
        if (instance.isVideo) {
            console.log('[ChatHeading] Creating video PiP overlay');
            const pip = document.createElement('div');
            pip.id = 'sonata-video-pip';
            pip.className = 'sonata-video-pip';
            pip.innerHTML = `
                <video id="sonata-video-remote" autoplay playsinline muted
                    style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#222;display:block;visibility:visible;"></video>
                <video id="sonata-video-local" autoplay playsinline muted
                    style="position:absolute;bottom:8px;right:8px;width:80px;height:60px;border-radius:8px;object-fit:cover;border:2px solid rgba(255,255,255,0.8);background:#333;z-index:1;display:block;visibility:visible;"></video>
                <button type="button" class="sonata-pip-expand-btn" id="sonata-video-pip-expand"
                    title="Розгорнути">${ICON_PIP_EXPAND_SVG}</button>
            `;
            document.body.appendChild(pip);

            // Expand/collapse the PiP to a larger preset size (no free resizing)
            const expandBtn = pip.querySelector('#sonata-video-pip-expand');
            expandBtn?.addEventListener('click', (e) => {
                e.stopPropagation();
                const expanded = pip.classList.toggle('sonata-video-pip--expanded');
                expandBtn.innerHTML = expanded ? ICON_PIP_COLLAPSE_SVG : ICON_PIP_EXPAND_SVG;
                expandBtn.title = expanded ? 'Згорнути' : 'Розгорнути';
            });

            // Attach local stream preview immediately
            const localVid = pip.querySelector('#sonata-video-local');
            if (instance.localStream) {
                localVid.srcObject = instance.localStream;
                console.log('[ChatHeading] Local video preview attached to PiP ✅');
            } else {
                console.warn('[ChatHeading] No localStream available for PiP preview');
            }

            // Flush remote video stream if it arrived before PiP was created
            if (ChatHeading._pendingRemoteVideoStream) {
                console.log('[ChatHeading] Flushing pending remote video stream to PiP ✅');
                const remoteVid = pip.querySelector('#sonata-video-remote');
                remoteVid.srcObject = ChatHeading._pendingRemoteVideoStream;
                ChatHeading._pendingRemoteVideoStream = null;
                // Diagnose after a short delay to let the element settle
                setTimeout(() => {
                    const r = remoteVid.getBoundingClientRect();
                    const cs = getComputedStyle(remoteVid);
                    const pipR = pip.getBoundingClientRect();
                    const pipCs = getComputedStyle(pip);
                    console.log(`[VIDEO DEBUG] pip: ${pipR.width}x${pipR.height} at (${Math.round(pipR.left)},${Math.round(pipR.top)}) display=${pipCs.display} visibility=${pipCs.visibility} zIndex=${pipCs.zIndex}`);
                    console.log(`[VIDEO DEBUG] remote video: ${r.width}x${r.height} at (${Math.round(r.left)},${Math.round(r.top)}) display=${cs.display} visibility=${cs.visibility} readyState=${remoteVid.readyState} paused=${remoteVid.paused}`);
                    console.log(`[VIDEO DEBUG] remote video srcObject tracks:`, remoteVid.srcObject?.getTracks().map(t=>`${t.kind}:${t.readyState}`));
                    // Check if anything is covering the pip
                    const topEl = document.elementFromPoint(pipR.left + pipR.width/2, pipR.top + pipR.height/2);
                    console.log(`[VIDEO DEBUG] element at pip center:`, topEl?.id || topEl?.className || topEl?.tagName);
                    if (remoteVid.paused) {
                        remoteVid.play().then(() => console.log('[VIDEO DEBUG] play() succeeded after delay ✅'))
                            .catch(e => console.warn('[VIDEO DEBUG] play() still failed:', e));
                    }
                }, 500);
            }

            // Make PiP draggable
            let dragging = false, ox = 0, oy = 0;
            pip.addEventListener('mousedown', (e) => {
                if (e.target.closest('.sonata-pip-expand-btn')) return;
                dragging = true;
                ox = e.clientX - pip.getBoundingClientRect().left;
                oy = e.clientY - pip.getBoundingClientRect().top;
                pip.style.transition = 'none';
            });
            document.addEventListener('mousemove', (e) => {
                if (!dragging) return;
                pip.style.right = 'auto';
                pip.style.bottom = 'auto';
                pip.style.left = `${e.clientX - ox}px`;
                pip.style.top = `${e.clientY - oy}px`;
            });
            document.addEventListener('mouseup', () => { dragging = false; });
        }

        // Timer
        let seconds = 0;
        const timerEl = panel.querySelector('#sonata-callpanel-timer');
        ChatHeading._callTimerInterval = setInterval(() => {
            seconds++;
            const m = String(Math.floor(seconds / 60)).padStart(2, '0');
            const s = String(seconds % 60).padStart(2, '0');
            if (timerEl) timerEl.textContent = `${m}:${s}`;
        }, 1000);

        // Defer click handler by one tick so the button can't receive
        // a click event that was already in flight from the outgoing panel
        // being replaced (which caused auto-terminate on ICE connect).
        setTimeout(() => {
            const hangUp = () => {
                console.log('[ChatHeading] User clicked hang-up');
                const t = ChatHeading.activeCall;
                if (t) t.terminateCall(true);
            };
            panel.querySelector('#sonata-callpanel-hangup')?.addEventListener('click', hangUp);
            panel.querySelector('#sonata-callpanel-hangup-label')?.addEventListener('click', hangUp);

            const muteBtn = panel.querySelector('#sonata-callpanel-mute');
            if (muteBtn) muteBtn.addEventListener('click', () => ChatHeading._toggleMute(instance));

            const micLabel = panel.querySelector('#sonata-callpanel-mic-label');
            const micMenu = panel.querySelector('#sonata-callpanel-mic-menu');
            const speakerBtn = panel.querySelector('#sonata-callpanel-speaker-btn');
            const speakerLabel = panel.querySelector('#sonata-callpanel-speaker-label');
            const speakerMenu = panel.querySelector('#sonata-callpanel-speaker-menu');

            const toggleMenu = async (menuEl, otherMenuEl, kind, onSelect) => {
                const opening = menuEl.hidden;
                if (otherMenuEl) otherMenuEl.hidden = true;
                if (opening) await ChatHeading._populateDeviceMenu(menuEl, kind, onSelect);
                menuEl.hidden = !opening;
            };

            if (micLabel && micMenu) {
                micLabel.addEventListener('click', (ev) => {
                    ev.stopPropagation();
                    toggleMenu(micMenu, speakerMenu, 'audioinput',
                        (deviceId) => ChatHeading._switchMicrophone(instance, deviceId));
                });
            }

            if (speakerMenu) {
                const openSpeakerMenu = (ev) => {
                    ev.stopPropagation();
                    toggleMenu(speakerMenu, micMenu, 'audiooutput',
                        (deviceId) => ChatHeading._switchSpeaker(deviceId));
                };
                speakerBtn?.addEventListener('click', openSpeakerMenu);
                speakerLabel?.addEventListener('click', openSpeakerMenu);
            }

            document.addEventListener('click', () => {
                if (micMenu) micMenu.hidden = true;
                if (speakerMenu) speakerMenu.hidden = true;
            });
        }, 100);
    }

    static _hideCallPanel() {
        if (ChatHeading._callTimerInterval) {
            clearInterval(ChatHeading._callTimerInterval);
            ChatHeading._callTimerInterval = null;
        }
        if (ChatHeading._ringbackInterval) {
            clearInterval(ChatHeading._ringbackInterval);
            ChatHeading._ringbackInterval = null;
        }
        if (ChatHeading._autoHangupTimer) {
            clearTimeout(ChatHeading._autoHangupTimer);
            ChatHeading._autoHangupTimer = null;
        }
        ChatHeading._stopMicVisualizer();
        ChatHeading._pendingRemoteVideoStream = null;
        const panel = document.getElementById('sonata-callpanel');
        if (panel) panel.parentElement?.removeChild(panel);
        const pip = document.getElementById('sonata-video-pip');
        if (pip) pip.parentElement?.removeChild(pip);
        const pipStyle = document.getElementById('sonata-pip-style');
        if (pipStyle) pipStyle.parentElement?.removeChild(pipStyle);
    }

    /**
     * Drives the small 4-bar equalizer next to the caller name (see the
     * .sonata-callpanel-eq markup in _showCallPanel) off whichever side is
     * currently making sound -- the local mic OR the incoming remote audio
     * (#sonata-audio-remote) -- like Telegram/music-app voice waveforms.
     * The status dot itself is left alone -- a plain, static indicator; the
     * reactive feedback lives entirely in these bars. Muting the mic
     * (track.enabled = false) naturally reads as near-zero here per the
     * WebRTC spec (a disabled track outputs silence to every consumer, not
     * just the peer connection), so the bars settle to resting height on
     * their own -- no extra mute-state wiring needed.
     *
     * The remote tap uses createMediaStreamSource on the element's
     * srcObject, which reads the stream in parallel without touching the
     * element's own playback graph -- unlike createMediaElementSource
     * (reroutes the element's actual output through whatever you connect
     * it to, and silences it if you forget to reconnect to destination),
     * this can't affect what's actually heard. It's attached lazily since
     * ontrack may set srcObject slightly after this first runs, and rebuilt
     * if the stream object ever changes (e.g. an ICE restart).
     *
     * Safe to call again (e.g. after switching microphones mid-call, from
     * _switchMicrophone) -- it tears down any previous instance first so the
     * analysers are rebuilt against the current live tracks.
     * @param {ChatHeading} instance
     */
    static _startMicVisualizer(instance) {
        ChatHeading._stopMicVisualizer();
        // Excludes the ringing panel deliberately: the outgoing-call panel
        // reuses the same #sonata-callpanel-timer structure while still just
        // ringing (no .sonata-callpanel-eq there at all), and this must only
        // ever run once the call is actually connected.
        const eqEl = document.querySelector('#sonata-callpanel .sonata-callpanel-eq');
        const barEls = eqEl ? Array.from(eqEl.querySelectorAll('.sonata-callpanel-eq-bar')) : [];
        const track = instance?.localStream?.getAudioTracks?.()?.[0];
        if (!eqEl || !barEls.length || !track) return;

        try {
            const ctx = new (window.AudioContext || window.webkitAudioContext)();
            const localSource = ctx.createMediaStreamSource(instance.localStream);
            const localAnalyser = ctx.createAnalyser();
            localAnalyser.fftSize = 256;
            localSource.connect(localAnalyser);
            const localData = new Uint8Array(localAnalyser.frequencyBinCount);

            const audioEl = document.getElementById('sonata-audio-remote');
            let remoteAnalyser = null, remoteData = null, remoteStreamRef = null;
            const ensureRemoteAnalyser = () => {
                const stream = audioEl?.srcObject;
                if (!stream || stream === remoteStreamRef || !stream.getAudioTracks?.().length) return;
                try {
                    const remoteSource = ctx.createMediaStreamSource(stream);
                    remoteAnalyser = ctx.createAnalyser();
                    remoteAnalyser.fftSize = 256;
                    remoteSource.connect(remoteAnalyser);
                    remoteData = new Uint8Array(remoteAnalyser.frequencyBinCount);
                    remoteStreamRef = stream;
                } catch (e) {
                    // Transient -- srcObject can flicker during renegotiation
                }
            };
            ensureRemoteAnalyser();

            eqEl.classList.add('sonata-callpanel-eq--active');

            const rmsOf = (analyser, data) => {
                analyser.getByteTimeDomainData(data);
                let sumSq = 0;
                for (let i = 0; i < data.length; i++) {
                    const v = (data[i] - 128) / 128;
                    sumSq += v * v;
                }
                return Math.sqrt(sumSq / data.length);
            };

            // Phase-shifted per bar so they don't move in perfect lockstep
            // (which reads as an obviously fake sync pulse) -- true per-
            // frequency-bin analysis looked noisier than useful at a size
            // this small, so this fakes the classic multi-band wobble by
            // modulating a shared voice-level envelope with an offset sine
            // per bar instead.
            const BAR_PHASES = [0, 1.3, 2.6, 4.1];
            const barSmoothed = new Array(barEls.length).fill(0);
            // Below this, treat it as silence and let the bars go fully
            // flat/dormant rather than idly wobbling all the time -- the
            // point is a clear quiet-vs-talking contrast, not constant
            // background motion.
            const SILENCE_THRESHOLD = 0.08;
            let isTalking = false;
            const tick = () => {
                ensureRemoteAnalyser();
                const localRms = rmsOf(localAnalyser, localData);
                const remoteRms = remoteAnalyser ? rmsOf(remoteAnalyser, remoteData) : 0;
                // Either side making sound drives the same bars -- a single
                // "someone's talking" indicator, not separate local/remote
                // meters, matching the "nice small" scope of this feature.
                const rms = Math.max(localRms, remoteRms);
                // Normal speech RMS on this scale is small (observed ~0.02-0.1
                // in practice on a live deployment) -- square-root the raw
                // level before scaling so quiet speech gets pulled up
                // disproportionately (perceived loudness is roughly
                // logarithmic, not linear).
                const boosted = Math.min(1, Math.sqrt(rms) * 2.8);
                const talking = boosted > SILENCE_THRESHOLD;
                if (talking !== isTalking) {
                    isTalking = talking;
                    eqEl.classList.toggle('sonata-callpanel-eq--talking', isTalking);
                }
                const now = performance.now();

                barEls.forEach((bar, i) => {
                    // Silent: no wobble, bars sink straight to flat. Talking:
                    // per-bar phase-shifted wobble around the shared voice-
                    // level envelope, pushed noticeably higher than before so
                    // it reads as clearly "active" rather than a faint twitch.
                    // Slower sine (was /130) and gentler attack/decay so the
                    // underlying values themselves ease rather than jump --
                    // the CSS transition above only smooths on top of that.
                    const wobble = talking ? (0.45 + 0.55 * Math.sin(now / 170 + BAR_PHASES[i])) : 0;
                    const target = talking ? Math.max(0.3, boosted * wobble) : 0;
                    const attack = 0.45, decay = talking ? 0.12 : 0.2;
                    barSmoothed[i] += (target - barSmoothed[i]) * (target > barSmoothed[i] ? attack : decay);
                    bar.style.height = `${(2 + barSmoothed[i] * 20).toFixed(1)}px`;
                });

                ChatHeading._micVisualizerRaf = requestAnimationFrame(tick);
            };
            ChatHeading._micVisualizerRaf = requestAnimationFrame(tick);
            ChatHeading._micVisualizer = { ctx, source: localSource, eqEl };
        } catch (e) {
            // No-op on failure (e.g. AudioContext blocked) -- the eq bars
            // just stay hidden (display:none until --active is added).
            console.warn('[ChatHeading] Mic visualizer unavailable:', e);
        }
    }

    /**
     * Tears down the analyser/animation loop started by _startMicVisualizer.
     * Safe to call even when nothing is running.
     */
    static _stopMicVisualizer() {
        if (ChatHeading._micVisualizerRaf) {
            cancelAnimationFrame(ChatHeading._micVisualizerRaf);
            ChatHeading._micVisualizerRaf = null;
        }
        if (ChatHeading._micVisualizer) {
            try { ChatHeading._micVisualizer.source.disconnect(); } catch (_) { /* no-op */ }
            try { ChatHeading._micVisualizer.ctx.close(); } catch (_) { /* no-op */ }
            ChatHeading._micVisualizer = null;
        }
    }

    /**
     * Toggle the local microphone on/off for the given call instance by
     * disabling the outgoing audio track(s), and reflect the state on the
     * mute button in the call panel.
     * @param {ChatHeading} instance
     */
    static _toggleMute(instance) {
        const audioTracks = instance?.localStream?.getAudioTracks() || [];
        if (!audioTracks.length) return;
        const newEnabled = !audioTracks[0].enabled;
        audioTracks.forEach((track) => { track.enabled = newEnabled; });
        const btn = document.getElementById('sonata-callpanel-mute');
        if (!btn) return;
        btn.innerHTML = newEnabled ? ICON_MIC_SVG : ICON_MIC_MUTED_SVG;
        btn.title = newEnabled ? 'Вимкнути мікрофон' : 'Увімкнути мікрофон';
    }

    /**
     * Fill a device-picker menu with the available devices of the given kind
     * and wire up selection.
     * @param {HTMLElement} menuEl
     * @param {'audioinput'|'audiooutput'} kind
     * @param {(deviceId: string) => void} onSelect
     */
    static async _populateDeviceMenu(menuEl, kind, onSelect) {
        menuEl.innerHTML = '<div class="sonata-callpanel-menu-item" style="color:#888;cursor:default;">Завантаження…</div>';
        try {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const filtered = devices.filter((d) => d.kind === kind);
            if (!filtered.length) {
                menuEl.innerHTML = '<div class="sonata-callpanel-menu-item" style="color:#888;cursor:default;">Пристрої не знайдено</div>';
                return;
            }
            // Figure out which device is actually in use right now, so the
            // menu can mark it -- previously every entry looked identical
            // and there was no way to tell which one was selected.
            let currentId;
            if (kind === 'audiooutput') {
                const audioEl = document.getElementById('sonata-audio-remote');
                // sinkId reads '' until setSinkId() has been called with a
                // specific device, which is also how the synthetic "Default"
                // entry's own deviceId is spelled.
                currentId = audioEl?.sinkId || 'default';
            } else {
                const track = ChatHeading.activeCall?.localStream?.getAudioTracks?.()?.[0];
                currentId = track?.getSettings?.().deviceId || 'default';
            }

            const fallbackLabel = kind === 'audioinput' ? 'Мікрофон' : 'Динамік';
            menuEl.innerHTML = filtered.map((d) => {
                const label = d.label || fallbackLabel;
                const selected = d.deviceId === currentId;
                return `<div class="sonata-callpanel-menu-item${selected ? ' sonata-callpanel-menu-item--active' : ''}" data-device-id="${d.deviceId}"><span class="sonata-callpanel-menu-item__check">${selected ? '✓' : ''}</span>${label}</div>`;
            }).join('');
            menuEl.querySelectorAll('.sonata-callpanel-menu-item[data-device-id]').forEach((item) => {
                item.addEventListener('click', () => {
                    onSelect(item.getAttribute('data-device-id'));
                    menuEl.hidden = true;
                });
            });
        } catch (e) {
            console.warn('[ChatHeading] Could not enumerate devices:', e);
            menuEl.innerHTML = '<div class="sonata-callpanel-menu-item" style="color:#888;cursor:default;">Не вдалося отримати пристрої</div>';
        }
    }

    /**
     * Switch the microphone used for the active call's outgoing audio track,
     * preserving the current mute state and any existing video track.
     * @param {ChatHeading} instance
     * @param {string} deviceId
     */
    static async _switchMicrophone(instance, deviceId) {
        if (!instance?.localStream) return;
        try {
            const wasEnabled = instance.localStream.getAudioTracks()[0]?.enabled !== false;
            const newStream = await navigator.mediaDevices.getUserMedia({
                audio: { deviceId: { exact: deviceId } },
                video: false,
            });
            const newTrack = newStream.getAudioTracks()[0];
            if (!newTrack) return;
            newTrack.enabled = wasEnabled;

            // Before the peer connection exists (still ringing), there's no
            // sender to replace — the new track just needs to already be on
            // localStream so sendJingleInitiate() picks it up when it later
            // calls pc.addTrack() for every track on that stream.
            if (instance.pc) {
                const sender = instance.pc.getSenders().find((s) => s.track?.kind === 'audio');
                if (sender) await sender.replaceTrack(newTrack);
            }

            // Mutate localStream in place so any existing video track survives.
            instance.localStream.getAudioTracks().forEach((track) => {
                instance.localStream.removeTrack(track);
                track.stop();
            });
            instance.localStream.addTrack(newTrack);
            console.log('[ChatHeading] ✅ Microphone switched');

            // The old track was just stop()'d, so the analyser built against
            // it in _startMicVisualizer is now reading a dead source --
            // rebuild it against the stream's current (new) track. A no-op
            // if the call isn't connected yet (_startMicVisualizer's own
            // dot lookup excludes the ringing panel).
            ChatHeading._startMicVisualizer(instance);
        } catch (e) {
            console.warn('[ChatHeading] Could not switch microphone:', e);
            showToast('Не вдалося змінити мікрофон', 'error');
        }
    }

    /**
     * Switch the audio output (speaker) device for the remote audio element.
     * Requires HTMLMediaElement.setSinkId, unsupported in some browsers (e.g. Firefox).
     * @param {string} deviceId
     */
    static async _switchSpeaker(deviceId) {
        const audioEl = document.getElementById('sonata-audio-remote');
        if (!audioEl || typeof audioEl.setSinkId !== 'function') {
            showToast('Зміна динаміка не підтримується цим браузером', 'warn');
            return;
        }
        try {
            await audioEl.setSinkId(deviceId);
            console.log('[ChatHeading] ✅ Speaker switched');
        } catch (e) {
            console.warn('[ChatHeading] Could not switch speaker:', e);
            showToast('Не вдалося змінити динамік', 'error');
        }
    }

    /**
     * Static: attach remote video stream to the PiP overlay.
     * Called from ontrack when a video track arrives.
     */
    static _attachRemoteVideo(stream) {
        console.log('[ChatHeading] _attachRemoteVideo called, stream tracks:', stream?.getTracks().length);
        if (stream) {
            stream.getTracks().forEach(t => console.log(`[ChatHeading] remote stream track: kind=${t.kind} enabled=${t.enabled} readyState=${t.readyState} muted=${t.muted}`));
        }
        const pip = document.getElementById('sonata-video-pip');
        if (!pip) {
            console.warn('[ChatHeading] PiP not in DOM yet — queuing remote video stream');
            ChatHeading._pendingRemoteVideoStream = stream;
            return;
        }
        const vid = pip.querySelector('#sonata-video-remote');
        vid.srcObject = stream;
        vid.play().then(() => {
            console.log('[ChatHeading] Remote video playing ✅');
            setTimeout(() => {
                const r = vid.getBoundingClientRect();
                const cs = getComputedStyle(vid);
                const pipR = pip.getBoundingClientRect();
                console.log(`[VIDEO DEBUG] pip: ${pipR.width}x${pipR.height} at (${Math.round(pipR.left)},${Math.round(pipR.top)}) z=${getComputedStyle(pip).zIndex}`);
                console.log(`[VIDEO DEBUG] video: ${r.width}x${r.height} display=${cs.display} visibility=${cs.visibility} readyState=${vid.readyState}`);
            }, 300);
        }).catch(e => {
            console.warn('[ChatHeading] Remote video play() failed:', e);
        });
        console.log('[ChatHeading] Remote video srcObject set ✅');
    }

    /**
     * Static: attach local video preview to the PiP overlay local tile.
     */
    static _attachLocalVideo(stream) {
        const pip = document.getElementById('sonata-video-pip');
        if (pip) {
            pip.querySelector('#sonata-video-local').srcObject = stream;
        }
    }

    // ========================================================================
    // END CALL PANEL UI
    // ========================================================================

    // ========================================================================
    // END CALL LOGIC
    // ========================================================================

    /**
     * Returns a list of objects which represent buttons for the chat's header.
     * @emits _converse#getHeadingButtons
     * @returns {Promise<Array.<import('./types').HeadingButtonAttributes>>}
     */
    async getHeadingButtons() {
        const buttons = [
            /** @type {import('./types').HeadingButtonAttributes} */
            {
                a_class: 'show-user-details-modal',
                handler: /** @param {Event} ev */ (ev) => this.showUserDetailsModal(ev),
                i18n_text: __('Details'),
                i18n_title: __('See more information about this person'),
                icon_class: 'fa-id-card',
                name: 'details',
                standalone: false,
            },
        ];

        const domain = _converse.session.get('domain');
        if (domain && (await api.disco.supports(Strophe.NS.BLOCKING, domain))) {
            const blocklist = await api.blocklist.get();
            if (blocklist.get(this.model.get('jid'))) {
                buttons.push({
                    a_class: 'unblock-user',
                    handler: /** @param {Event} ev */ async (ev) => {
                        ev.preventDefault();
                        const result = await api.confirm(__('Unblock user'), [
                            __('Are you sure you want to unblock this user?'),
                        ]);
                        if (result) {
                            api.blocklist.remove(this.model.get('jid'));
                        }
                    },
                    i18n_text: __('Unblock this user'),
                    i18n_title: __('Allow this user to send you messages'),
                    icon_class: 'fa-check',
                    name: 'unblock',
                    standalone: false,
                });
            } else {
                buttons.push({
                    a_class: 'block-user',
                    handler: /** @param {Event} ev */ async (ev) => {
                        ev.preventDefault();
                        const result = await api.confirm(__('Block user'), [
                            __(
                                'Are you sure you want to prevent %1$s from contacting you further?',
                                this.model.getDisplayName(),
                            ),
                        ]);
                        if (result) {
                            const jid = this.model.get('jid');
                            api.blocklist.add(jid);
                            api.contacts.remove(jid, true);
                            this.model.close();
                        }
                    },
                    i18n_text: __('Block this user'),
                    i18n_title: __('Prevent this user from sending you any further messages'),
                    icon_class: 'fa-trash',
                    name: 'block',
                    standalone: false,
                });
            }
        }

        if (!api.settings.get('singleton')) {
            buttons.push({
                a_class: 'close-chatbox-button',
                handler: /** @param {Event} ev */ (ev) => this.close(ev),
                i18n_text: __('Close'),
                i18n_title: __('Close and end this conversation'),
                icon_class: 'fa-times',
                name: 'close',
                standalone: api.settings.get('view_mode') === 'overlayed',
            });
        }
        const { chatboxviews } = _converse.state;
        const el = chatboxviews.get(this.getAttribute('jid'));
        if (el) {
            /**
             * *Hook* which allows plugins to add more buttons to a chat's heading.
             *
             * Note: This hook is fired for both 1 on 1 chats and groupchats.
             * If you only care about one, you need to add a check in your code.
             *
             * @event _converse#getHeadingButtons
             * @param { HTMLElement } el
             *      The `converse-chat` (or `converse-muc`) DOM element that represents the chat
             * @param { Array.<import('./types').HeadingButtonAttributes> }
             *      An array of the existing buttons. New buttons may be added,
             *      and existing ones removed or modified.
             * @example
             *  api.listen.on('getHeadingButtons', (el, buttons) => {
             *      buttons.push({
             *          'i18n_title': __('Foo'),
             *          'i18n_text': __('Foo Bar'),
             *          'handler': ev => alert('Foo!'),
             *          'a_class': 'toggle-foo',
             *          'icon_class': 'fa-foo',
             *          'name': 'foo'
             *      });
             *      return buttons;
             *  });
             */
            return _converse.api.hook('getHeadingButtons', el, buttons);
        } else {
            return buttons; // Happens during tests
        }
    }
}

api.elements.define('converse-chat-heading', ChatHeading);